

import { v4 as uuidv4 } from "uuid";

import {
  FeatureSource,
  NumberFeature,
  FeatureBase,
  Feature,
  StringsFeature,
  StringFeature,
  IStringNumHash,
  ModelBase,
  FloatingFeature,
  UpsertableBase,
  ReusableString,
  OptionalFeatureBase,
  User,
  DisablableOption,
} from "@models"
import {
  Selectable,
  CharacterRoll,
  AbilityScores,
  Advantage,
  CharacterAdvantage,
  Bonus,
  BonusSpells,
  Campaign,
  CharacterAbility,
  CharacterASIBaseFeature,
  CharacterEldritchInvocation,
  CharacterFeat,
  CharacterFeature,
  CharacterFeatureBase,
  CharacterFightingStyle,
  CharacterWeapon,
  CharacterLanguageFeature,
  CharacterPactBoon,
  CharacterRace,
  CharacterSubrace,
  CharacterResourceWithUsed,
  CharacterSense,
  CharacterSlot,
  CharacterSpecialFeature,
  // ConditionFeature,
  CharacterSpell,
  CharacterProficiency,
  Condition,
  DamageMultiplier,
  DamageMultiplierSimple,
  EldritchInvocation,
  FightingStyle,
  HitDiceWithUsed,
  Modifier,
  Reroll,
  Skill,
  Spell,
  Spellbook,
  SpellcastingFeature,
  SpellModifier,
  SpellSlotType,
  WeaponKeyword,
  Attack,
  RollPlus,
  CharacterSpellbook,
  CharacterAction,
  Ability,
  CharacterBackground,
  Item,
  BasicItem,
  MagicItemKeyword,
  PseudoItem,
  Feat,
  Armor,
  Weapon,
  CharacterClass,
  CharacterSubclass,
  GameClass,
  Subclass,
  CharacterFeatureSource,
  CharacterGift,
  Gift,
  Background,
  PactBoon,
  Race,
  Subrace,
  CharacterArmor,
  CharacterItem,
  CharacterLimitation,
  ResourceFeature,
  SenseFeature,
  BasicCreatureInstance,
  Creature,
  CharacterBasicItem,
  SummonInstance, 
  Proficiency,
  ProficiencySimple,
  FeatFeature,
  UnarmedStrikesFeature,
  ReplaceAbilityScoreFeature,
  RangeBonus,
  AttackUpgradeFeature,
  BonusActionAttackFeature,
  SpellsFromList,
  Resource,
  MinimumRoll,
  SuggestedSpells,
  LightAttackAddDamageMod,
  SummonUpgradeFeature,
  ActionTypeUpgrade,
  ExtraEffectsFeature,
  ExtraEffectTypeFeature,
  ExtraEffectsOfTypeFeature,
  Encounter,
  CreatureSpellAsAbility,
  ExtraSpellLists,
  CharacterMagicItemKeyword,
  SubclassFeature,
  SkillAsAbility,
  CharacteristicFeature,
  CharacterOrg,
  Organization,
  OrgPosition,
  // OrgInstance,
  CharacterBaseItem,
  // CharacterMagicItem,
  Customization,
  SpecialFeature,
  SFMergeFeature,
  Character,
  Potence,
  CharacterCustomItem,
  CharacterContainer,
  Ammunition,
  CharacterAmmunition,
  // MagicItem,
  CharacterSheetInterface,
  UpgradableNumberValueProps,
  UpgradableNumber,
  AbilityScoresUpgradable,
  HitDiceUpgradable,
  RollPlusUpgradable,
  Transform,
  TransformInstance,
  OverridableNumber,
  OverridableAbilityScores,
  Tool,
  TransformInterface,
  TransformUpgradeFeature,
  // AdaptationInstance,
  // Adaptation,
  AbilityEffect,
  CreatureTransform,
  CreaturePotence,
  CreatureAbility,
  SpellLimitation,
  WeaponMasteryProperty,
  EldritchInvocationsFeature,
  CharacterWeaponMastery,
  WeaponMasteryFeature,
  SkillAbilityOverrideFeature,
  SFFeature,
  PactBoonFeature,
  Limitations,
  KnowledgeFeature,
  WeaponDamageUpgradeFeature,
  WeaponKeywordUpgradeFeature,
  ItemLimitation,
  CharacterExtraEffects,
  CreatureLimitation,
  SummonOption2,
  SpellDamageOptions,
  SpellbookModifier,
  CharacterSpellbookModifier,
  AlternateConditionFeature,
  RolledValue,
  RollValue,
  WeaponKeywordUpgradeFeature2,
  WeaponLimitation,
  DisableActionsFeature,
  AbilityLimitation,
  MinionAbility,
  TableBase,
  UpgradableNumberFeature,
  ASIBaseFeature,
  IgnoreStealthDisadvantage,
  WeaponMasteryMasterFeature,
  CharacterWeaponMasteryMaster,
  SizeOptions,
  GreaterAdvantage,
  CharacterBonusSpells,
  StandardFeatures,
  FeatureBaseWithRules,
  CharacterStandardFeatures,
  FeatureAncestry,
  LimitSpoofFeature,
  CharacterAbilityModifier,
  StoredSpell,
  DandDFeatureSource,
  ACTION_TYPES,
  LANGUAGES,
  SENSES,
  SKILLS,
  WEAPON_KEYWORDS,
  CharacterReceivable,
  BonusSpellsUpgrade,
  CharacterDrawnCard,
  BastionAbility,
  CharacterBastionFacility,
  CharacterCondition,
  SpellsFromListWithCosts,
  CreatureTypeFeature,
  ComplexCreatureInstance,
  CCIFeatureSource,
  Summon,
  SummonFeature,
  CampaignChar,
} from "@dndModels";
import {
  ABILITY_SCORES,
  ABILITY_SCORES_NAMES,
  ALL_DRAGONS,
  CHARACTER_LIMITATION_TYPES_SANS_VARIANT_SPECIFIC,
  CHARACTER_PIECES_v1,
  CHARACTER_PIECES_v2,
  CHARACTER_PIECES_v3,
  CREATURE_TYPES,
  DAMAGE_TYPES,
  DATA_TYPE_INFO,
  DRACONIC_DAMAGE_TYPES,
  DURATION_NUMBER_MAP,
  HIT_DICE_SIZE_MAP,
  PALETTE,
  SOURCE_BOOK_TYPES,
  SPEED_MAP,
  TRANSFORM_FEATURE_TYPES
} from "@dndModels/Constants";
import { 
  CharacterKnowledge, 
} from "@dndModels/character_feature_source/CharacterKnowledge";
import { 
  AbilityScoreExpandedType, 
  AbilityScoreType, 
  AttackType, 
  DamageType, 
  isDamageType, 
  isStatType, 
  SelectableType, 
  SizeType, 
  SpellLevel
} from "@dndModels/Types";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";
import DataUtilities from "./data_utilities";
import CharConnectUtilities from "./char_connect_utilities";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();
const data_util = DataUtilities.getInstance();
const connect_util = CharConnectUtilities.getInstance();

const log_find_string = "Monk's Focus";

const DRACONIC_DAMAGE_TYPES_ANY = (DRACONIC_DAMAGE_TYPES as { [key: string]: DamageType });

export class DandDCharacterUtilitiesClass {
  using_character: CharacterSheetInterface | Campaign | undefined = undefined;
  
  /**
   * This gets a full character, including all its pieces, 
   * and stitches them together.  
   * The regular method for getting objects works for getting basic char data,
   * but when loading a character's edit or details pages, you need a lot of
   * additional info, and this needs to be transported in pieces to avoid 
   * API errors.
   * @param id _id of the character
   * @returns 
   */
  getCharacter = async ({ 
    id, 
    campaign,
    onProgress,
    onError
  }: { 
    id: string, 
    campaign?: Campaign,
    onProgress?: ((data_type: string, percentage: number ) => void),
    onError?: ((message: string) => void) 
  }) => {
    // debugger;
    let char: Character | null = null;
    if (api.online) {
      const time_number = common_util.get_time_number();
      // console.log(id);
      
      const res = await api.getObjectFromAPI<Character>({ data_type: "character", id });
      // console.log(res);
      if (res) {
        char = res;
        if (char && !char.connected) {
          // First get the pieces and attach them.
          const pieces = (char.piece_version === 1 ? CHARACTER_PIECES_v1 : (char.piece_version === 2 ? CHARACTER_PIECES_v2 : CHARACTER_PIECES_v3)).filter(o => o !== "main");
          for (let i = 0; i < pieces.length; ++i) {
            const piece = pieces[i];

            const response = await api.fetchData({
              path: `/getCharacterPiece/${piece}/${id}/${time_number}`,
              system: "D&D"
            });
            if (typeof(response) === "string" && response === "Offline") {
              api.online = false;
              break;
            } else {
              const body = response;
              // console.log(body);
              char.apply_piece(piece, body);
            }
          }
        }
      }
      if (char) {
        char.cookie_saved = char.last_saved;
      }
    }
    if (char) {
      if (campaign) {
        const char_id = char._id;
        const c_char = campaign.c_chars.find(o => o.char_id === char_id);
        if (c_char) {
          c_char.char = char;
          char.c_char = c_char;
        } else {
          const c_npc = campaign.npcs.find(o => o.char_id === char_id);
          char.c_npc = c_npc;
        }
      } 
      this.using_character = char;
      // console.log(char.connected);
      if (!char.connected) {
        await connect_util.connectCharacter(char, onProgress);
        // The purpose of this is to make it so when it recalculates it will await, 
        // that way it won't say it's done loading until it's finished recalculating.
        await this.repopulateCharFeatureBases(char);
        if (!char.campaign) {
          if (!char.c_char) {
            char.c_char = await api.getCampaignObject<CampaignChar>({ data_type: "campaign_char", filter: { char_id: char._id }});
          }
          if (char.c_char) {
            char.c_char.campaign = await api.getCampaign({ campaign_id: char.c_char.campaign_id, include: ["players","characters"] });
          }
        }
        if (char.campaign && char.campaign.last_updated !== char.last_campaign_update) {
          // Update the character to match the latest options from the campaign.
          char.last_campaign_update = char.campaign.last_updated;
          await this.enforceOptions(char, char.campaign);
          await api.updateCharacter(char, ["all"]);
        }
        await this.getReceivables({ char });
      }
      return char;
    }
  };
  getSharedCharacter = async ({ 
    id, 
    // load_from_db = false,
    onProgress,
    onError
  }: { 
    id: string, 
    // load_from_db?: boolean, 
    onProgress?: ((data_type: string, percentage: number ) => void),
    onError?: ((message: string) => void) 
  }) => {
    const res = await api.getObjectsFromAPI2({ data_type: "character", filter: { shared_id: id }});
    if (res && res && res.length > 0) {
      const char_id = res[0]._id;
      return this.getCharacter({ id: char_id, onProgress, onError });
    }
    return null;
  };
  getCCI = async ({ 
    id, 
    load_from_db = false,
    onProgress,
    onError
  }: { 
    id: string, 
    load_from_db?: boolean, 
    onProgress?: ((data_type: string, percentage: number ) => void),
    onError?: ((message: string) => void) 
  }) => {
    // debugger;
    let char: ComplexCreatureInstance | null = null;
    if (!load_from_db) {
      char = await this.getCCIFromCookie(id);
      if (char === null) {
        load_from_db = true;
      }
    }
    if (load_from_db && api.online) {
      const time_number = common_util.get_time_number();
      // console.log(id);
      
      const res = await api.getObjectFromAPI<ComplexCreatureInstance>({ data_type: "complex_creature", id });
      // console.log(res);
      if (res) {
        char = res;
        if (char && !char.connected) {
          // First get the pieces and attach them.
          const pieces = CHARACTER_PIECES_v3;
          for (let i = 0; i < pieces.length; ++i) {
            const piece = pieces[i];

            const response = await api.fetchData({
              path: `/getCharacterPiece/${piece}/${id}/${time_number}`,
              system: "D&D"
            });
            if (typeof(response) === "string" && response === "Offline") {
              api.online = false;
              break;
            } else {
              const body = response;
              // console.log(body);
              char.apply_piece(piece, body);
            }
          }
        }
      }
      // if (char) {
      //   char.cookie_saved = char.last_saved;
      // }
    }
    if (char) {
      this.using_character = char;
      // console.log(char.connected);
      if (!char.connected) {
        // await this.loadData({ char, onProgress, onError });
        await connect_util.connectCharacter(char, onProgress);
        // The purpose of this is to make it so when it recalculates it will await, 
        // that way it won't say it's done loading until it's finished recalculating.
        await this.repopulateCharFeatureBases(char);
        // if (char.campaign && char.campaign.last_updated !== char.last_campaign_update) {
        //   // Update the character to match the latest options from the campaign.
        //   char.last_campaign_update = char.campaign.last_updated;
        //   await this.enforceOptions(char, char.campaign);
        //   await api.updateCharacter(char, ["all"], true);
        // }
        await api.updateCharacter(char, ["all"]);
        // await this.getReceivables({ char });
      }
      return char;
    }
  };
  getCCIFromCookie = async (id: string) => {
    const cookie_str = localStorage.getItem(`character_${id}`);
    if (cookie_str) {
      const cookie_json = JSON.parse(cookie_str);
      const char = new ComplexCreatureInstance(cookie_json.body);
      const pieces = CHARACTER_PIECES_v3;
      for (const piece of pieces) {
        // if (piece === "race") {
        //   debugger;
        // }
        const bad = this.applyCCIPieceFromCookie(char, piece);
        if (bad.length > 0) {
          return null;
        }
      }
      // if (api.online) {
      //   const res = await api.getObjectFromAPI<ComplexCreatureInstance>({ data_type: "character", id });
      //   if (res) {
      //     char.last_saved = res.last_saved;
      //   }
      // }
      return char;
    }
    return null;
  }
  applyCCIPieceFromCookie = (char: ComplexCreatureInstance, piece_name: string) => {
    const cookie_str = localStorage.getItem(`character_${char._id}_${piece_name}`);
    if (cookie_str) {
      const cookie_json = JSON.parse(cookie_str);
      const body = cookie_json.body;
      const bad = char.apply_piece(piece_name, body);
      if (bad.length > 0) {
        return bad;
      }
    }
    return "";
  }
  getReceivables = async ({ char }: { char: Character }) => {
    const res = await api.getPlayerObjects({ 
      data_type: "character_receivable", 
      filter: { char_id: char._id }
    });
    if (res && res.length > 0) {
      char.receivables = res as CharacterReceivable[];
    }
  }
  getDrawnCards = async ({ char }: { char: Character }) => {
    const res = await api.getPlayerObjects({ 
      data_type: "character_drawn_card", 
      filter: { char_id: char._id }
    });
    return res as CharacterDrawnCard[];
  }

  getSpellsForLimit({
    char, 
    limit, 
    source_true_id, 
    ancestries,
    log_it = false
  }: {
    char?: CharacterSheetInterface, 
    limit: SpellLimitation, 
    source_true_id?: string, 
    ancestries?: FeatureAncestry[],
    log_it?: boolean
  }): Spell[] {
    let spells = data_util.spells;
    spells = spells.filter(obj => this.fitCharSpellLimit({ char, obj, limit, source_true_id, ancestries, log_it })); // : obj.name === "Animate Dead"
    return spells;
  }

  getCharSpells(char: Character, limitation: SpellLimitation): (CharacterSpell | CharacterAbility)[] {
    const char_spells = char.mind.spells.filter(o => 
      this.fitCharSpellLimit({ char, obj: o, limit: limitation, source_true_id: o.source_true_id }) // , log_it: o.name.includes("Eldritch")
    );
    const char_spell_abilities = char.mind.spell_as_abilities.filter(o => this.fitCharSpellLimit({ char, obj: o, limit: limitation, source_true_id: o.source_true_id}));
    return [...char_spells,...char_spell_abilities];
  }

  getCreatures = async ({
    limitation, 
    char,
    log_it = false
  }: {
    limitation?: CreatureLimitation, 
    char: Character | BasicCreatureInstance | ComplexCreatureInstance,
    log_it?: boolean
  }) => {
    let creatures = await api.getObjects<Creature>({ data_type: "creature", c_options: char instanceof Character ? char.c_options : undefined });
    if (log_it) {
      console.log(...creatures);
    }
    creatures = limitation ? creatures.filter(o => api.fitCreatureLimit(o, limitation)) : creatures;
    if (log_it) {
      console.log(...creatures);
    }
    creatures = data_util.getAllDominants(creatures);
    if (log_it) {
      console.log(...creatures);
    }
    return creatures;
  }
  
  getCreatureGiftsForCreature = async (creature: BasicCreatureInstance) => {
    const creature_gifts = await data_util.getCreatureGifts();
    for (const cg of creature_gifts) {
      await data_util.loadObject(cg);
    }
    return creature_gifts.filter(o => !o.enhance_creature && this.fitCreatureLimit(creature, o.limit) || creature.creature_gifts.filter(o2 => o2.gift_id === o._id).length > 0);
  }

  fitCreatureLimit(ci: BasicCreatureInstance | Creature | SummonInstance | TransformInstance | ComplexCreatureInstance, limit: CreatureLimitation, log_it = false): boolean {
    // log_it = item.name.includes("Holding"); // true;
    if (log_it) {
      console.log(limit);
    }
    if (limit.creature_ids.length > 0) {
      if (ci instanceof Creature) {
        return limit.creature_ids.includes(ci._id);
      } else {
        return limit.creature_ids.includes(ci.creature_id);
      }
    } 
    let good = true;
    if (good && limit.creature_types.length > 0) {
      good = limit.creature_types.includes(ci.creature_type);
    } 
    if (good && limit.subtypes.length > 0) {
      good = common_util.anyOverlaps(limit.subtypes, ci.subtypes);
    } 
    if (good && limit.tags.length > 0) {
      good = common_util.anyOverlaps(limit.tags, ci.tags);
    }
    if (good && limit.age_categories.length > 0) {
      good = limit.age_categories.includes(ci.age_category);
    } 
    if (good && limit.size_nums.length > 0) {
      good = limit.size_nums.includes(ci.size_num);
    } 
    if (good && limit.min_challenge_rating > -1) {
      good = limit.min_challenge_rating <= ci.challenge_rating;
    } 
    if (good && limit.max_challenge_rating > -1) {
      good = limit.max_challenge_rating >= ci.challenge_rating;
    } 
    if (good && !limit.allow_flight) {
      good = !ci.flying;
    }
    if (good && !limit.allow_swimming) {
      good = !ci.swimming;
    }
    return good;
  }

  getSummonOption2s = async (char: Character | BasicCreatureInstance | ComplexCreatureInstance, potence: Potence, log_it = false) => {
    let options: SummonOption2[] = [];
    if (potence.summon_options.length > 0) {
      for (const option of potence.summon_options) {
        if (option.summon_type === "Custom") {
          if (option.custom_stat_block) {
            const opt = new SummonOption2(); 
            opt.custom_stat_block = option.custom_stat_block;
            opt.count = option.count;
            options.push(opt);
          }
        } else {
          // debugger;
          const transforms = await data_util.getTransforms();
          const transform = option.transform_id === "" ? undefined : transforms.find(o => o._id === option.transform_id);
          if (log_it) {
            debugger;
          }
          const creatures = await this.getCreatures({ limitation: option.creature_limit, char, log_it });
          for (const creature of creatures) {
            const opt = new SummonOption2();
            opt.creature = creature;
            opt.count = option.count;
            if (transform) {
              opt.transform = transform;
            }
            options.push(opt);
          }
        }
      }
    }
    const good_options: SummonOption2[] = [];
    while (options.length > 0) {
      const option = options[0];
      const the_options = options.filter(o => o._id === option._id);
      
      const opt = new SummonOption2();
      opt.creature = option.creature;
      opt.transform = option.transform;
      opt.custom_stat_block = option.custom_stat_block;
      opt.count = the_options.reduce((accumulator: number, opt2: SummonOption2) => {
        return Math.max(accumulator, opt2.count);
      }, 0);
      good_options.push(opt);
      options = options.filter(o => o._id !== option._id);
    }
    return good_options.sort((a,b) => { 
      if (a.challenge_rating === b.challenge_rating) {
        return a.name < b.name ? -1 : 1;
      }
      return a.challenge_rating - b.challenge_rating; 
    });
  }

  getPseudoItems({ limitation, no_nesting = false, no_extras = false, pseudo_item_ids }: { limitation?: ItemLimitation, no_nesting?: boolean, no_extras?: boolean, pseudo_item_ids?: string[] }): PseudoItem[] {
    if (limitation) {
      if (!limitation.isEmpty()) {
        if (no_nesting) {
          if (limitation.pseudo_item_ids.length > 0) {
            return this.getPseudoItems({ pseudo_item_ids: limitation.pseudo_item_ids, no_extras });
          } else {
            let items = data_util.base_pseudo_items;
            if (limitation.item_ids.length > 0) {
              items = items.filter(o => limitation.item_ids.includes(o.base_item?._id??""));
            }
            if (limitation.attack_types.length > 0 || limitation.damage_types.length > 0) {
              items = items.filter(o => o.item_type === "Weapon");
              if (limitation.attack_types.length > 0) {
                items = items.filter(o => common_util.anyOverlaps(o.the_attack_types, limitation.attack_types));
              }
            }
            if (limitation.magical === false) {
              if (limitation.damage_types.length > 0) {
                items = items.filter(o => common_util.anyOverlaps(o.the_effect_types, limitation.damage_types));
              }
              return items.map(o => new PseudoItem(o));
            }
            let pseudo_items = items.flatMap(o => this.getPseudoItemsForItem({ pseudo_item: o, limitation, no_extras }));

            if (limitation.damage_types.length > 0) {
              pseudo_items = pseudo_items.filter(o => common_util.anyOverlaps(o.the_effect_types, limitation.damage_types));
            }
            return pseudo_items; 
          }
        } else {
          // debugger;
          const pseudo_items = this.getPseudoItems({ limitation, no_nesting: true, no_extras });
          if (limitation.nested.length > 0) {
            for (const n of limitation.nested) {
              if (n instanceof ItemLimitation) {
                const new_pseudo_items = this.getPseudoItems({ limitation: n, no_nesting: true, no_extras });
                pseudo_items.push(...new_pseudo_items);
              }
            }
          }
          const results: PseudoItem[] = [];
          for (const pi of pseudo_items) {
            // if (pi.name.includes("Alchemy")) {
            //   debugger;
            // }
            if (results.filter(o => o.id === pi.id).length === 0 && pi.base_item) {
              // Check to see if the only difference is that one has rarity and one doesn't
              if (pi.id.includes(",R:") && pi.use_selected_rarity === pi.base_item.min_rarity) {
                // It has the rarity in the id, but it's the min_rarity, 
                // making it the same as one without the rarity.
                // This makes it check for one without the rarity.
                const adjusted = pi.id.replace(",R:" + pi.use_selected_rarity,"");
                if (results.filter(o => o.id === adjusted).length === 0) {
                  results.push(pi);
                }
              } else if (pi.id.includes(",R:")) {
                // It's not the default rarity, so an equivalent will have the rarity in the id
                results.push(pi);
              } else {
                // It doesn't have the rarity in the id, 
                // so check to make sure there isn't one that does
                const adjusted = pi.id + ",R:" + pi.use_selected_rarity;
                if (results.filter(o => o.id === adjusted).length === 0) {
                  results.push(pi);
                }
              }
            }
          }
          return results;
        }
      }
    } else if (pseudo_item_ids) {
      const pseudo_items = pseudo_item_ids.map(o => this.getPseudoItem(o)).filter(o => o !== undefined) as PseudoItem[];
      return pseudo_items;
    }
    return [];
  }

  getPseudoItemsForItem(
    { 
      pseudo_item, 
      limitation,
      no_extras
    }: { 
      pseudo_item: PseudoItem, 
      limitation?: ItemLimitation,
      no_extras?: boolean
    }): PseudoItem[] {
    const pseudo_items: PseudoItem[] = [];
    pseudo_items.push(new PseudoItem(pseudo_item));
    const item = pseudo_item.base_item;
    if (item) {
      const miks = data_util.magic_item_keywords.filter(o => 
        item.possible_mik_ids.includes(o._id) && 
        o.min_rarity > -1
      );
      for (const mik of miks) {
        // const current_pseudo_items = [...pseudo_items];
        // for (const pseudo_item of current_pseudo_items) {
        if (mik.name.includes("+") && pseudo_item.name.includes("+")) {
          continue;
        } else if (mik.min_rarity + pseudo_item.rarity > 4) {
          continue;
        } else if (mik.extra_base_type !== "None" && pseudo_item.extra !== "") {
          continue;
        } else if (mik.extra_base_type !== "None") {
          if (no_extras) {
            const new_pseudo_item = pseudo_item.clone();
            new_pseudo_item.add_keyword(mik, "(Choose Later)");
            pseudo_items.push(new_pseudo_item);
          } else {
            if (mik.extra_base_type === "Spell") {
              const limits = mik.extra_base_limit;
              const all_spells: Spell[] = [];
              if (limits.limits.length > 0) {
                for (const limit of limits.limits) {
                  if (limit instanceof SpellLimitation) {
                    const spells = this.getSpellsForLimit({ limit });
                    const all_spell_ids = all_spells.map(o => o._id);
                    all_spells.push(...spells.filter(o => !all_spell_ids.includes(o._id)));
                    // const extra_base_limits = mik.extra_base_limit; // mik.extra_base_limits as { levels: string[], schools: string[], onSpellList: string[] };
                    // let spell_levels: number[] = [];
                    // if (extra_base_limits.levels.includes("Any")) {
                    //   spell_levels = [0,1,2,3,4,5,6,7,8,9];
                    // } else { 
                    //   spell_levels = extra_base_limits.levels.map(o => {
                    //     if (o === "Cantrip") {
                    //       return 0;
                    //     } else {
                    //       return +o;
                    //     }
                    //   });
                    // }
                    // const spells = data_util.spells.filter(o => 
                    //   spell_levels.includes(o.level) && 
                    //   (extra_base_limits.schools.includes("Any") || 
                    //     extra_base_limits.schools.includes(o.school)));
                    // for (const spell of spells) {
                    //   const new_pseudo_item = pseudo_item.clone();
                    //   new_pseudo_item.add_keyword(mik, spell._id, spell);
                    //   pseudo_items.push(new_pseudo_item);
                    // }
                  }
                }
              } else {
                all_spells.push(...data_util.spells);
              }
              
              for (const spell of all_spells) {
                const new_pseudo_item = pseudo_item.clone();
                new_pseudo_item.add_keyword(mik, spell._id, spell);
                pseudo_items.push(new_pseudo_item);
              }
            } else if (mik.extra_base_type === "Dragon Breed") {
              const extra_base_limits = mik.extra_base_limits;
              const dragon_breeds = extra_base_limits.length > 0 ? extra_base_limits : ALL_DRAGONS;
              for (const breed of dragon_breeds) {
                const new_pseudo_item = pseudo_item.clone();
                new_pseudo_item.add_keyword(mik, breed);
                pseudo_items.push(new_pseudo_item);
              }
            } else if (mik.extra_base_type === "Creature Type") {
              const extra_base_limits = mik.extra_base_limits;
              const creature_types = extra_base_limits.length > 0 ? extra_base_limits : CREATURE_TYPES;
              for (const c_type of creature_types) {
                const new_pseudo_item = pseudo_item.clone();
                new_pseudo_item.add_keyword(mik, c_type);
                pseudo_items.push(new_pseudo_item);
              }
            } else if (mik.extra_base_type === "Damage Type") {
              const extra_base_limits = mik.extra_base_limits;
              const dts = extra_base_limits.length > 0 ? extra_base_limits : DAMAGE_TYPES;
              for (const dt of dts) {
                const new_pseudo_item = pseudo_item.clone();
                new_pseudo_item.add_keyword(mik, dt);
                pseudo_items.push(new_pseudo_item);
              }
            } else {
              console.error("Not Yet Implemented");
              console.log(mik);
              debugger;
            }
          }
        } else {
          const new_pseudo_item = pseudo_item.clone();
          new_pseudo_item.add_keyword(mik);
          pseudo_items.push(new_pseudo_item);
        }
        // }
      }
    }
    return limitation ? pseudo_items.filter(o => api.fitItemLimit(o, limitation)) : pseudo_items; 
  }

  getPseudoItem(id: string, log_it = false): PseudoItem | undefined {
    const pseudo_item = new PseudoItem();
    const pieces = id.split(",");
    for (const piece of pieces) {
      const sub_pieces = piece.split(":");
      if (log_it) {
        debugger;
      }
      if (sub_pieces.length === 2) {
        switch (sub_pieces[0]) {
          case "B": 
            // Needs to separate out the selected_rarity if it's here.
            const id = sub_pieces[1];
            const item = data_util.items.find(o => o._id === id);
            if (item) { 
              pseudo_item.base_item = item;
            }
          break;
          case "K": 
            const mik_ids = sub_pieces[1].split(";");
            const miks = data_util.magic_item_keywords.filter(o => mik_ids.includes(o._id));
            for (const mik of miks) {
              pseudo_item.magic_item_keywords.push(mik);
            }
          break;
          case "L":
            pseudo_item.potion_level = +sub_pieces[1];
          break;
          case "E":
          case "BIE":
            pseudo_item.extra = sub_pieces[1];
            const spell = data_util.spells.find(o => o._id === pseudo_item.extra);
            if (spell) {
              pseudo_item.extra_spell = spell;
            }
          break;
          case "R":
            pseudo_item.selected_rarity = +sub_pieces[1];
          break;
        }
      }
    }
    return pseudo_item; 
  }

  getWeaponAttack(char_weapon: CharacterWeapon, 
    char: Character, 
    proficient: boolean, 
    ba: boolean, 
    ba_include_attack_mod: boolean, 
    type: string, 
    the_attacks: { [x: string]: RollPlus[] },
    two_handed_id: string, 
    upgraded: CharacterFeature | null = null, 
    source_id = ""): Attack {
    let max_asm = 0;
    let asm = char.mind.current_ability_scores.getModifier(char_weapon.use_ability_score);
    if (asm) {
      max_asm = asm;
    }
    // if (char_weapon.name.includes("Dagger")) {
    //   debugger;
    // }
    let use_ability_score = char_weapon.use_ability_score;
    const my_attack_bonuses = char.mind.attack_bonuses.filter(o => 
      (o.weapon_id === char_weapon.true_id || 
        (o.weapon_id === "" && this.fitCharWeaponLimit(char, char_weapon, o.weapon_limit))
      ));
    const replace_asm_bonuses = my_attack_bonuses.filter(o => o.replace_asm !== "None");
    for (const ab of replace_asm_bonuses) { // This is for Hexblade and Artificer
      asm = char.mind.current_ability_scores.getModifier(ab.replace_asm);
      if (asm && asm > max_asm && ab.replace_asm !== "None") {
        max_asm = asm;
        use_ability_score = ab.replace_asm;
      }
    }
    const attack = new Attack();
    attack.attack_rolls = [];
    if (!["","None","undefined"].includes(use_ability_score)) {
      const rolls = new RollPlus();
      rolls.ability_score = use_ability_score;
      attack.attack_rolls.push(rolls);
    }
    if (proficient) {
      const bonus = new RollPlus();
      bonus.flat = char.mind.proficiency_modifier;
      attack.attack_rolls.push(bonus);
    } 
    attack.bonus_action = ba;
    const damage_rolls: RollPlus[] = [];
    const damage_roll_hash: any = {};
    const true_type = type.includes("Light ") ? type.substring(6) : type;
    attack.attack_type = true_type as AttackType;
    if (type === "Melee" && !upgraded && the_attacks["Versatile"]) {
      const versatile = WEAPON_KEYWORDS.find(o => o.name === "Versatile");
      if (versatile) {
        // debugger;
        const versatile_id = versatile._id;

        const weapon_keyword_ids = this.getWeaponKeywordIds(char, char_weapon);
        if (char.mind.weapon_keyword_upgrades.find(o => 
          o.base_wk_ids.length === 1 && 
          o.base_wk_ids.includes(versatile_id) && 
          !common_util.anyOverlaps(weapon_keyword_ids, o.excluded_wk_ids) &&
          o.added_wk_ids.length === 0)) {
          the_attacks = {...the_attacks};
          the_attacks["Melee"] = the_attacks["Versatile"];
        }
      }
    }
    if (char_weapon.base_item && 
      char_weapon.base_item instanceof Weapon && 
      the_attacks[true_type]) {
      const weapon_damage_override = char_weapon.override_weapon_damage_type;
      let damages = the_attacks[true_type] as RollPlus[];
      // Realistically, damages will always just be 1 long, but I coded things to allow for more, so I guess I'll go with that.
      let avg = damages.map(o => {
        return Math.ceil(((o.size + 1) / 2) * o.count)
      }).reduce((a, b) => a + b, 0); // Math.ceil(((size + 1) / 2) * count);
      
      const damage_upgrades = this.getDamageUpgrades(char, char_weapon, true_type);
      for (const cf of damage_upgrades) {
        const ff = cf.floating_feature as WeaponDamageUpgradeFeature;
        // console.log(cf);
        // console.log(ff)
        // debugger;
        const roll_plus = this.toRollPlus(ff.damage_rolls, { obj: char, source_id: cf.source_true_id, item_id: cf.item_id });
        if (the_attacks[true_type] && the_attacks[true_type].length > 0) {
          roll_plus.type = the_attacks[true_type][0].type;
        }
        const size = roll_plus.size;
        const count = roll_plus.count;
        const newAvg = Math.ceil(((size + 1) / 2) * count);
        if (newAvg > avg) {
          avg = newAvg;
          the_attacks[true_type] = [roll_plus];
          damages = the_attacks[true_type] as RollPlus[];
        }
      }
      for (const d of damages) {
        const damage_type = weapon_damage_override === "" ? d.type : weapon_damage_override;
        if (damage_roll_hash[damage_type]) {
          if (damage_roll_hash[damage_type][d.size]) {
            const damage = damage_roll_hash[damage_type][d.size];
            // damage.size = d.size;
            damage.count += d.count;
            damage.flat += d.flat;
            // damage.type = damage_type;
            // damage_rolls.push(damage);
          } else {
            const damage = new RollPlus();
            damage.size = d.size;
            damage.count += d.count;
            damage.flat += d.flat;
            damage.type = damage_type;
            damage_roll_hash[damage_type][d.size] = damage;
          }
        } else {
          damage_roll_hash[damage_type] = {};
          const damage = new RollPlus();
          damage.size = d.size;
          damage.count += d.count;
          damage.flat += d.flat;
          damage.type = damage_type;
          damage_roll_hash[damage_type][d.size] = damage;
        }
      }
    }
    const damage_bonuses = char.mind.damage_bonuses.filter(o => 
      this.checkBonusRequirements(char, o, char_weapon 
      ));
    for (const db of damage_bonuses) {
      let damage_type = db.rolls.type;
      if (damage_type === "None") {
        const types = Object.keys(damage_roll_hash) as DamageType[];
        if (types.length > 0) {
          damage_type = types[0];
        }
      }
      const size = this.value(db.rolls.size, { obj: char, source_id, item_id: char_weapon.true_id });
      const count = this.value(db.rolls.count, { obj: char, source_id, item_id: char_weapon.true_id });
      const flat = this.value(db.rolls.flat, { obj: char, source_id, item_id: char_weapon.true_id });
      if (damage_roll_hash[damage_type]) {
        if (damage_roll_hash[damage_type][size]) {
          const damage = damage_roll_hash[damage_type][size] as RollPlus;
          damage.count += count;
          damage.flat += flat;
        } else {
          const damage = new RollPlus();
          damage.size = size;
          damage.count += count;
          damage.flat += flat;
          damage.type = damage_type;
          damage_roll_hash[damage_type][size] = damage;
        }
      } else {
        damage_roll_hash[damage_type] = {};
        const damage = new RollPlus();
        damage.size = size;
        damage.count += count;
        damage.flat += flat;
        damage.type = damage_type;
        damage_roll_hash[damage_type][size] = damage;
      }
    }
    const attack_bonuses = char.mind.attack_bonuses.filter(o => 
      this.checkBonusRequirements(char, o, char_weapon)
    );
    for (const ab of attack_bonuses) {
      attack.attack_rolls.push(this.toRollPlus(ab.rolls, { obj: char, source_id, item_id: char_weapon.true_id }));
    }
    if (upgraded && upgraded.floating_feature instanceof AttackUpgradeFeature) {
      // debugger;
      const rolls = new RollPlus();
      rolls.flat = this.value(upgraded.floating_feature.attack_modifier, { obj: char, source_id, item_id: char_weapon.true_id });
      attack.attack_rolls.push(rolls);
    }
    const damage_roll_keys = Object.keys(damage_roll_hash);
    for (const key1 of damage_roll_keys) {
      const type_hash = damage_roll_hash[key1];
      let flat = 0;
      let first_damage: RollPlus | null = null;
      const size_keys = Object.keys(type_hash);
      for (let i = 0; i < size_keys.length; ++i) {
        const damage = type_hash[size_keys[i]] as RollPlus;
        if (damage.count > 0) {
          if (!first_damage) {
            first_damage = damage;
          }
          damage_rolls.push(damage);
        } else {
          flat += damage.flat;
        }
      }
      if (!first_damage && Object.keys(type_hash).length > 0) {
        const damage = type_hash[Object.keys(type_hash)[0]] as RollPlus;
        damage.flat = flat;
        damage_rolls.push(damage);
      } else if (first_damage) {
        first_damage.flat += flat;
      }
    }
    // TODO: If the modifier is less than 0 then it should 
    // still be applied to BAs
    if ((!upgraded || 
        !(upgraded.floating_feature instanceof AttackUpgradeFeature) || 
        upgraded.floating_feature.include_ability_mod) && 
      (!ba || ba_include_attack_mod || max_asm < 0)) {
      if (damage_rolls.length > 0) {
        const damage = damage_rolls[0];
        damage.ability_score = use_ability_score;
      }
    }
    if (upgraded && upgraded.floating_feature instanceof AttackUpgradeFeature) {
      if (damage_rolls.length > 0) {
        const damage = damage_rolls[0];
        damage.flat += this.value(upgraded.floating_feature.damage_modifier, { obj: char, source_id, item_id: char_weapon.true_id });
      }
    }
    if (!upgraded || !(upgraded.floating_feature instanceof AttackUpgradeFeature) || upgraded.floating_feature.include_ability_mod) {
      for (const roll_plus of damage_rolls.filter(o => o.ability_score === "Attack Ability")) {
        roll_plus.ability_score = use_ability_score;
      }
    }
    // TODO: Make the damages get pushed together as
    // much as possible.  If the type is the same,
    // and the size is the same then put together.
    // Also if the d.size is 0 then it can put the
    // flats together with another one.
    attack.damage_rolls = damage_rolls;
    if (attack.attack_string !== "No Attack") {
      attack.recalc_attack_string(char.mind.current_ability_scores);
    }
    attack.recalc_damage_string(char.mind.current_ability_scores);
    attack.type = upgraded && upgraded.floating_feature ? upgraded.floating_feature.name : type;
    attack.attack_stat = use_ability_score;
    // if (ba) {
    //   console.log(char_weapon);
    //   console.log(attack);
    //   console.log(char.c_options.light_melee_action);
    //   const weapon_keyword_ids = this.getWeaponKeywordIds(char, char_weapon);
    //   console.log(weapon_keyword_ids);
    //   console.log(char.mind.weapon_keyword_upgrades);
    // }
    return attack;
  }

  checkBonusRequirements(char: CharacterSheetInterface, 
    bonus: Bonus, 
    char_weapon: CharacterWeapon | Attack, 
    log_it = false) {
    // log_it = char_weapon instanceof Attack;
    if (log_it) {
      debugger;
    }
    if (bonus.weapon_id !== "") {
      return char_weapon instanceof CharacterWeapon && bonus.weapon_id === char_weapon.true_id;
    }
    return (bonus.apply_to.length === 0 || bonus.apply_to.includes("Weapons")) && 
      this.fitCharWeaponLimit(char, char_weapon, bonus.weapon_limit);
  }

  getWeaponAttacks(char_weapon: CharacterWeapon, char: Character, two_handed_id: string) {
    const log_it = false; // char_weapon.name.includes("Chill"); // 
    let max_asm = -5;
    let max_ability: AbilityScoreType | "Default" = "Default";
    // This is where I'll need to put checks for features like Hex Weapon
    const weapon_keywords = char_weapon.weapon_keywords;
    for (const wk of weapon_keywords.filter(o => o.use_ability_score !== "Default")) {
      const newbie = char.mind.current_ability_scores.getModifier(wk.use_ability_score);
      if (newbie && newbie > max_asm) {
        max_asm = newbie;
        max_ability = wk.use_ability_score;
      }
    }
    if (max_ability === "Default") {
      max_ability = "STR";
      max_asm = char.mind.current_ability_scores.STR;
    }
    for (const wk of weapon_keywords.filter(o => o.alternate_ability_score !== "None")) {
      if (wk.alternate_ability_score !== "None") {
        const newbie = char.mind.current_ability_scores.getModifier(wk.alternate_ability_score);
        if (newbie && newbie > max_asm) {
          max_asm = newbie;
          max_ability = wk.alternate_ability_score;
        }
      }
    }
    char_weapon.use_ability_score = max_ability;
    const attacks: Attack[] = [];

    // Check for proficiency
    let proficient = false;
    if (char_weapon.base_item) {
      const base_item = char_weapon.base_item;
      if ((char_weapon.proficiency_override || 
        char.mind.weapon_proficiencies.filter(o => 
          weapon_keywords.filter(o2 => o2._id === o.proficiency_id).length > 0 ||
          o.proficiency_id === base_item._id
        ).length > 0)) {
        proficient = true;
      }
    }
    // May have different attacks based on weapon keywords and feats.
    // If it's Light then they can 
    // also have a bonus_action attack with it.

    const attack_upgrades = char.mind.attack_upgrades.filter(o => 
      o.floating_feature instanceof AttackUpgradeFeature && 
      char_weapon.base_item instanceof Weapon && this.fitWeaponLimit2(char, char_weapon, o)
    );
    const bonus_action_attacks = char.mind.attack_upgrades.filter(o => 
      o.floating_feature instanceof BonusActionAttackFeature && char_weapon.base_item instanceof Weapon &&
      this.fitCharWeaponLimit(char, char_weapon, o.floating_feature.weapon_limit)
    );
    // const extra_damage_rolls = this.getExtraDamageRolls(char, char_weapon);
    // Make it so if it's using 1D&D, then ba attacks go under actions but get a bonus attack label.  
    // Shouldn't even need changes here
    
    const the_attacks: { [x: string]: RollPlus[] } = {};
    if (char_weapon.base_item instanceof Weapon) {
      const keys = Object.keys(char_weapon.base_item.attacks);
      for (const key of keys) {
        the_attacks[key] = char_weapon.base_item.attacks[key].rolls.map(o => o.clone()); // .map(o => o.clone());
      }
    }
    let attack_types: string[] = [...char_weapon.using_attack_types]; // Object.keys(the_attacks);
    // Flex Weapon Mastery Property
    const versatile = weapon_keywords.find(o => o.name === "Versatile");
    if (versatile) {
      // debugger;
      const versatile_id = versatile._id;
      const weapon_keyword_ids = this.getWeaponKeywordIds(char, char_weapon);
      if (char.mind.weapon_keyword_upgrades.find(o => 
        o.base_wk_ids.length === 1 &&
        o.base_wk_ids.includes(versatile_id) && 
        !common_util.anyOverlaps(weapon_keyword_ids, o.excluded_wk_ids) &&
        o.added_wk_ids.length === 0)) {
        attack_types = attack_types.filter(o => !o.includes("Versatile"));
        // the_attacks["Melee"] = the_attacks["Versatile"].map(o => o.clone());
      }
    }
    let add_damage_on_light_attack = false;
    const light_weapon = weapon_keywords.find(o => o.name === "Light");
    let light_as_action = char.c_options.light_melee_action === "Action";
    if (light_weapon) {
      // debugger;
      if (["Any","Off"].includes(char_weapon.equipped_hand)) {
        const light_attack_add_damage_mods = char.mind.light_attack_add_damage_mods.filter(o => 
          o.floating_feature instanceof LightAttackAddDamageMod && char_weapon.base_item instanceof Weapon &&
          this.fitCharWeaponLimit(char, char_weapon, o.floating_feature.weapon_limit)
        );
        if (light_attack_add_damage_mods.length > 0) {
          add_damage_on_light_attack = true;
        }
        const old_attack_types = [...attack_types];
        old_attack_types.filter(o => !o.startsWith("Light")).forEach(attack_type => {
          const new_attack_type = `Light ${attack_type}`;
          if (!attack_types.includes(new_attack_type)) {
            attack_types.push(new_attack_type);
          }
          if (!the_attacks[new_attack_type]) {
            if (the_attacks[attack_type]) {
              const old_attack_rolls = the_attacks[attack_type] as RollPlus[];
              const light_attack_rolls: RollPlus[] = [];
              old_attack_rolls.forEach(roll => {
                const clone = roll.clone(false);
                light_attack_rolls.push(clone);
              });
              the_attacks[new_attack_type] = light_attack_rolls;
            }
          }
        });
      }
      if (!["Any","Main"].includes(char_weapon.equipped_hand)) {
        attack_types = attack_types.filter(o => o.includes("Light"));
      }
      if (!light_as_action) {
        const light_id = light_weapon._id;
        const weapon_keyword_ids = this.getWeaponKeywordIds(char, char_weapon);
        if (char.mind.weapon_keyword_upgrades.find(o => 
          o.base_wk_ids.length === 1 &&
          o.base_wk_ids.includes(light_id) && 
          !common_util.anyOverlaps(weapon_keyword_ids, o.excluded_wk_ids) &&
          o.added_wk_ids.length === 0)) {
          light_as_action = true;
        }
      }
    }

    // TODO: Make this loop through the attacks on the weapon
    for (const attack_type of attack_types) {
      if (!attack_type.startsWith("Light")) {
        attacks.push(this.getWeaponAttack(char_weapon, char, proficient, false, false, attack_type, the_attacks, two_handed_id));
      } else {
        let ba = attack_type.startsWith("Light") || (attack_type !== "Versatile" && bonus_action_attacks.length > 0);
        let ba_include_attack_mod = ba && ((!attack_type.startsWith("Light") || add_damage_on_light_attack) || char.mind.fighting_styles.filter(o => o.source_id === "60807cfc93d1ed2398cb1128").length === 1);
        if (!ba && attack_type === "Melee") {
          // Possibly they can do two weapon fighting with it
          if (weapon_keywords.filter(o => o.name !== "Light").length > 0) { // && o.can_two_weapon_fight
            ba = true;
            if (char.mind.fighting_styles.filter(o => o.source_id === "60807cfc93d1ed2398cb1128").length === 1) {
              // TODO: same as above
              ba_include_attack_mod = true;
            }
          // } else if (weapon_keywords.filter(o => o.name === "Melee").length > 0 &&
          //   weapon_keywords.filter(o => o.name === "Two-Handed").length === 0) {
          //   if (char.spirit.feats.filter(o => o.source && o.source.name === "Dual Wielder").length > 0) {
          //     // Melee non-two-handed weapons can be used for bonus action attacks with this feat
          //     // TODO: same as above
          //     ba = true;
          //     if (char.mind.fighting_styles.filter(o => o.source_id === "60807cfc93d1ed2398cb1128").length === 1) {
          //       // TODO: same as above
          //       ba_include_attack_mod = true;
          //     }
          //   }
          } 
        } 
        if (ba) {
          const ba_attack = this.getWeaponAttack(char_weapon, char, proficient, true, ba_include_attack_mod, attack_type, the_attacks, two_handed_id);
          if (ba_attack.type.startsWith("Light") && light_as_action) {
            ba_attack.bonus_action = false;
          }
          attacks.push(ba_attack);
        }
      }
    }
    const damage_types: string[] = [];
    let damages: RollPlus[] = [];
    if (log_it) {
      console.log(the_attacks);
    }
    for (const attack_type of attack_types) {
      if (the_attacks[attack_type]) {
        damages = [...the_attacks[attack_type] as RollPlus[]];
      }
    }
    for (const damage of damages) {
      damage_types.push(damage.type);
    }
    const weapon_keyword_ids = this.getWeaponKeywordIds(char, char_weapon);
    // If attack_upgrades includes one that applies to this item then add it in
    for (const cf of attack_upgrades) {
      const upgraded = cf.floating_feature as AttackUpgradeFeature;
      if (log_it) {
        console.log(upgraded);
      }
      if (upgraded.weapon_limit.attack_types.length === 0) {
        attack_types.forEach(attack_type => {
          attacks.push(this.getWeaponAttack(char_weapon, char, proficient, false, true, attack_type, the_attacks, two_handed_id, cf, cf.use_source_id ));
        });
      } else {
        common_util.findOverlaps(upgraded.weapon_limit.attack_types, attack_types).forEach(attack_type => {
          attacks.push(this.getWeaponAttack(char_weapon, char, proficient, false, true, attack_type, the_attacks, two_handed_id, cf, cf.use_source_id ));
        });
      }
    }
    if (log_it) {
      console.log(char.mind.attack_upgrades);
      console.log(weapon_keyword_ids);
      console.log(attack_types);
      console.log(damage_types);
      console.log(char_weapon);
      console.log(bonus_action_attacks);
      console.log(attacks);
      debugger;
    }
    return attacks;
  }

  getWeaponKeywordIds = (
    char: CharacterSheetInterface | undefined, 
    weapon: CharacterWeapon | Weapon
  ) => {
    const weapon_keyword_ids = weapon instanceof CharacterWeapon ? weapon.base_weapon_keyword_ids : weapon.weapon_keyword_ids;
    let new_weapon_keyword_ids = [...weapon_keyword_ids];
    
    if (weapon instanceof CharacterWeapon && weapon.proficiency_as_weapons.length > 0) {
      for (const weapon_id of weapon.proficiency_as_weapons) {
        const weapon2 = data_util.items.find(o => o._id === weapon_id);
        if (weapon2 instanceof Weapon) {
          new_weapon_keyword_ids.push(...weapon2.weapon_keyword_ids);
        }
      }
    }
    if (char instanceof Character) {
      for (const upgrade of char.mind.weapon_keyword_upgrades.filter(o => 
        (o.base_wk_ids.length === 0 || common_util.anyOverlaps(weapon_keyword_ids, o.base_wk_ids)) &&
        !common_util.anyOverlaps(weapon_keyword_ids, o.excluded_wk_ids))) {
        new_weapon_keyword_ids = [...new_weapon_keyword_ids, ...upgrade.added_wk_ids];
      }
      if (char.mind.weapon_keyword_upgrade2s.length > 0) {
        let char_weapon: CharacterWeapon | null = weapon instanceof CharacterWeapon ? weapon : null;
        if (weapon instanceof Weapon) {
          char_weapon = new CharacterWeapon();
          char_weapon.source = weapon;
        }
        if (char_weapon) {
          const cw = char_weapon;
          for (const upgrade of char.mind.weapon_keyword_upgrade2s.filter(o => 
            this.weaponTypeMatch(char, cw, o))) {
            new_weapon_keyword_ids = [...new_weapon_keyword_ids, ...upgrade.added_wk_ids];
          }
        }
      }
    }
    return common_util.unique_array(new_weapon_keyword_ids);
  }

  getWeaponKeywordsForWeapon(char: Character, char_weapon: CharacterWeapon) {
    const response: { weapon_keywords: WeaponKeyword[], wkus: WeaponKeywordUpgradeFeature[], wku2s: WeaponKeywordUpgradeFeature2[] } = { weapon_keywords: [], wkus: [], wku2s: [] };
    
    const weapon_keyword_ids = char_weapon.base_weapon_keyword_ids;
    let new_weapon_keyword_ids = [...weapon_keyword_ids];
    if (char_weapon.proficiency_as_weapons.length > 0) {
      for (const weapon_id of char_weapon.proficiency_as_weapons) {
        const weapon2 = data_util.items.find(o => o._id === weapon_id);
        if (weapon2 instanceof Weapon) {
          new_weapon_keyword_ids.push(...weapon2.weapon_keyword_ids);
        }
      }
    }
    for (const upgrade of char.mind.weapon_keyword_upgrades.filter(o => 
      (o.base_wk_ids.length === 0 || common_util.anyOverlaps(weapon_keyword_ids, o.base_wk_ids)) &&
      !common_util.anyOverlaps(weapon_keyword_ids, o.excluded_wk_ids))) {
      new_weapon_keyword_ids = [...new_weapon_keyword_ids, ...upgrade.added_wk_ids];
      response.wkus.push(upgrade);
    }
    for (const upgrade of char.mind.weapon_keyword_upgrade2s.filter(o => 
      this.weaponTypeMatch(char, char_weapon, o))) {
      new_weapon_keyword_ids = [...new_weapon_keyword_ids, ...upgrade.added_wk_ids];
      response.wku2s.push(upgrade);
    }
    response.weapon_keywords = WEAPON_KEYWORDS.filter(o => new_weapon_keyword_ids.includes(o._id));
    return response;
  }

  weaponTypeMatch(char: Character, char_weapon: CharacterWeapon, wkuf: WeaponKeywordUpgradeFeature2) {
    if (wkuf.weapon_type === "Selectable") {
      const cfs = char.char_feature_sources.find(o => o.selectable_hash[wkuf.selectable_key] !== undefined);
      if (cfs) {
        const selected = cfs.selectable_hash[wkuf.selectable_key];
        return selected.includes(char_weapon.weapon_type);
      } 
      return false;
    } else {
      return char_weapon.weapon_type === wkuf.weapon_type;
    }
  }
  
  getUnarmedStrike(char: CharacterSheetInterface, score: string, ba: boolean): Attack { // , damage_type: DamageType
    const attack = new Attack();
    attack.attack_type = "Melee";
    attack.attack_rolls = [];
    attack.damage_rolls = [];
    const rolls = new RollPlus();
    rolls.ability_score = score;
    rolls.flat = char.mind.proficiency_modifier;
    attack.attack_rolls.push(rolls);
    const damage = new RollPlus();
    damage.ability_score = score;
    damage.size = char.mind.unarmed_strike_size;
    damage.count = char.mind.unarmed_strike_count;
    damage.type = char.mind.unarmed_strike_damage_types[0];
    const damage_roll_hash: any = {};
    damage_roll_hash[damage.type] = {};
    damage_roll_hash[damage.type][damage.size] = damage;
    const attack_bonuses = char.mind.attack_bonuses.filter(o =>
      this.checkBonusRequirements(char, o, attack));
    for (const ab of attack_bonuses) {
      attack.attack_rolls.push(this.toRollPlus(ab.rolls, { obj: char, item_id: "" }));
    }
    attack.bonus_action = ba;
    // if (char.unarmed_strike_add_attack_to_dmg || char.unarmed_strike_count === 0) {
    //   damage.ability_score = score;
    // }
    attack.damage_rolls.push(damage);
    for (const db of char.mind.damage_bonuses.filter(o =>
      this.checkBonusRequirements(char, o, attack //, "Melee", score, damage_roll_hash
      ))) {
      attack.damage_rolls.push(this.toRollPlus(db.rolls, { obj: char, item_id: "" }));
    }
    attack.recalc_attack_string(char.mind.current_ability_scores);
    attack.recalc_damage_string(char.mind.current_ability_scores);
    attack.type = "Normal";
    return attack;
  }

  getUnarmedStrikes(char: CharacterSheetInterface): Attack[] {
    let max_asm = -5;
    let max_score = "";
    for (const score of char.mind.unarmed_strike_scores) {
      const new_score = char.mind.current_ability_scores.getModifier(score);
      if (new_score !== null && new_score > max_asm) {
        max_asm = new_score;
        max_score = score;
      }
    }
    const attacks: Attack[] = [];
    // for (const damage_type of char.unarmed_strike_damage_types) {
    attacks.push(this.getUnarmedStrike(char, max_score, false)); //, damage_type));
    // }
    if (char.mind.unarmed_strike_bonus_action) {
      // for (const damage_type of char.unarmed_strike_damage_types) {
      attacks.push(this.getUnarmedStrike(char, max_score, true)); //, damage_type));
      // }
    }
    return attacks;
  }

  calcAttack(char: CharacterSheetInterface, action: CharacterAction) {

  }

  changeSourceLevel(char: Character, source_id: string, level: number) {
    const cfs = char.char_feature_sources.find(o => o.source_id === source_id);
    if (cfs) {
      if (cfs.level < level) {
        cfs.do_suggestions = true;
      }
      cfs.level = level;
      // this.repopulate_char_feature_bases_for(char, cfs, null);
    }
    char.changed();
  }

  copySubCharFeatureSource = async (char: Character | ComplexCreatureInstance,
    parent: CharacterFeatureSource, 
    char_feature: CharacterFeature,
    cfb: CharacterFeatureBase,
    feature_source: FeatureSource) => {
    await data_util.loadObject(feature_source);
    const scfs_finder = parent.sub_char_feature_sources.filter(o => o.source_id === feature_source._id);
    if (scfs_finder.length === 1) {
      return scfs_finder[0];
    } else {
      let newCFS: CharacterFeatureSource | null = null;
      if (feature_source instanceof Subclass) {
        newCFS = new CharacterSubclass();
      } else if (feature_source instanceof Subrace) {
        newCFS = new CharacterSubrace();
      } else if (feature_source instanceof FightingStyle) {
        newCFS = new CharacterFightingStyle();
      } else if (feature_source instanceof PactBoon) {
        newCFS = new CharacterPactBoon();
      } else if (feature_source instanceof EldritchInvocation) {
        newCFS = new CharacterEldritchInvocation();
      } else if (feature_source instanceof SpecialFeature) {
        newCFS = new CharacterSpecialFeature();
      } else if (feature_source instanceof Feat) {
        newCFS = new CharacterFeat();
      }
      if (newCFS) {
        if (feature_source instanceof Subclass) {
          if (feature_source.use_subclass_levels && parent instanceof CharacterClass) {
            newCFS.level = parent.subclass_level;
          } else {
            newCFS.level = parent.level;
          }
        } else if (feature_source instanceof SpecialFeature) {
          newCFS.level = parent.level;
        }
        newCFS.source_id = feature_source._id;
        newCFS.source = feature_source;
        if (feature_source.name.includes("Magic")) {
          console.log(newCFS);
        }
        await newCFS.copy_source({ char, feature_source, parent_cf: char_feature, parent_cfb: cfb });
        parent.sub_char_feature_sources.push(newCFS);
        // this.repopulate_char_feature_bases_for(char, newCFS);
      }
      // this.repopulate_char_features(char);
      return newCFS;
    }
  }

  enforceOptions = async (char: Character, campaign: Campaign | null = null) => {
    if (campaign && campaign.char_options && campaign.char_options.char_options) {
      char.c_options.copy(campaign.char_options.char_options);
    }
    await this.repopulateCharFeatureBases(char);
    let i = 0;
    if (campaign) {
      const display_unfit_items = [...char.c_options.display_unfit_items];
      const use_suggestions = char.c_options.use_suggestions;
      char.c_options.copy(campaign.c_options);
      char.c_options.display_unfit_items = [...display_unfit_items];
      char.c_options.use_suggestions = use_suggestions;
    }
    if (!char.c_options.bonus_skill_profs_for_int) {
      char.spirit.bonus_skill_profs_ids = [];
    }

    const doesntWork = (obj: CharacterFeatureSource | CharacterSpell) => {
      if (obj instanceof CharacterFeatureSource) {
        const dt_info = DATA_TYPE_INFO.find(o => o.data_type === obj.data_type);
        if (dt_info && obj.source && 
          (!common_util.anyOverlaps(char.c_options.source_books, obj.source.source_book_ids) ||
            char.c_options.blocked.includes(obj.source_id) ||
            (char.c_options.dominant_variants_only.includes(dt_info.dominance_group) && !data_util.isDominant(obj.source))
          )
        ) {
          return true;
        }
        if (obj.source && !char.c_options.world_settings.includes("Any") && obj.source.world_settings.length > 0) {
          if (!common_util.anyOverlaps(obj.source.world_settings, char.c_options.world_settings)) {
            return true;
          }
        }
      } else if (obj instanceof CharacterSpell) {
        const dt_info = DATA_TYPE_INFO.find(o => o.data_type === "spell");
        if (dt_info && obj.spell && 
          (!common_util.anyOverlaps(char.c_options.source_books, obj.spell.source_book_ids) ||
            char.c_options.blocked.includes(obj.spell_id) ||
            (char.c_options.dominant_variants_only.includes(dt_info.dominance_group) && !data_util.isDominant(obj.spell))
          )
        ) {
          return true;
        }
        if (obj.spell && !char.c_options.world_settings.includes("Any") && obj.spell.world_settings.length > 0) {
          if (!common_util.anyOverlaps(obj.spell.world_settings, char.c_options.world_settings)) {
            return true;
          }
        }
      } 
      return false;
    }

    if (doesntWork(char.spirit.race) || (char.spirit.race.char_subrace && doesntWork(char.spirit.race.char_subrace))) {
      char.mind.spells = char.mind.spells.filter(o => !(o.source_type === "Race" || o.source_id === char.spirit.race.source_id || o.source_id === char.spirit.race.subrace_id));
      char.spirit.race = new CharacterRace();
    }
    if (doesntWork(char.spirit.background)) {
      char.mind.spells = char.mind.spells.filter(o => !(o.source_type === "Background" || o.source_id === char.spirit.background.source_id));
      char.spirit.background = new CharacterBackground();
    }
    while (i < char.spirit.classes.length) {
      const char_class = char.spirit.classes[i];
      if (doesntWork(char_class)) {
        // Remove it
        char.spirit.classes = char.spirit.classes.filter(o => o.source_id !== char_class.source_id);
        char.spirit.classes.filter(o => o.position > char_class.position).forEach(cc => {
          cc.position--;
          if (cc.position === 0) {
            cc.fixWithGameClass(char);
          }
        });
        char.mind.spells = char.mind.spells.filter(o => o.source_type !== "Class" || o.source_id !== char_class.source_id);
      } else {
        if (char_class.char_subclass && doesntWork(char_class.char_subclass)) {
          // Remove the subclass
          char_class.sub_char_feature_sources = char_class.sub_char_feature_sources.filter(o => o.source_type !== "Subclass");
          char.mind.spells = char.mind.spells.filter(o => o.source_id !== char_class.subclass_id);
        }
        i++;
      }
    }
    i = 0;
    while (i < char.spirit.feats.length) {
      const char_feat = char.spirit.feats[i];
      if (doesntWork(char_feat)) {
        // Remove it
        const extra = char.spirit.extra_feats.find(o => o.true_id === char_feat.true_id);
        if (extra) {
          char.spirit.extra_feats = char.spirit.extra_feats.filter(o => o.source_id !== char_feat.source_id);
          char.mind.spells = char.mind.spells.filter(o => o.source_type !== "Feat" || o.source_id !== char_feat.source_id);
        } else {
          char_feat.source_id = "";
          char_feat.source = null;
          // // It's not an extra, so we need to remove it from the cf it's from.
          // const cfb = char.mind.char_feature_bases.find(o => o.features.filter(o2 => o2.feature_options.filter(o3 => o3 instanceof CharacterFeat && o3.true_id === char_feat.true_id)));
          // if (cfb) {
          //   const cf = cfb.features.find(o => o.feature_options.filter(o2 => o2 instanceof CharacterFeat && o2.true_id === char_feat.true_id));
          //   if (cf) {
          //     cf.feature_options = [];
          //   }
          // }
        }
      } else {
        i++;
      }
    }
    i = 0;
    while (i < char.spirit.gifts.length) {
      const char_gift = char.spirit.gifts[i];
      if (doesntWork(char_gift)) {
        // Remove it
        char.spirit.gifts = char.spirit.gifts.filter(o => o.source_id !== char_gift.source_id);
        char.mind.spells = char.mind.spells.filter(o => o.source_type !== "Gift" || o.source_id !== char_gift.source_id);
      } else {
        i++;
      }
    }
    i = 0;
    while (i < char.inventory.items.length) {
      const char_item = char.inventory.items[i];
      if (doesntWork(char_item)) {
        // Remove it
        char.inventory.items = char.inventory.items.filter(o => o.source_id !== char_item.source_id);
        char.mind.spells = char.mind.spells.filter(o => o.source_type !== "Item" || o.source_id !== char_item.source_id);
      } else {
        i++;
      }
    }
    i = 0;
    while (i < char.mind.spells.length) {
      const char_spell = char.mind.spells[i];
      if (doesntWork(char_spell)) {
        // Remove it
        char.mind.spells = char.mind.spells.filter(o => o.spell_id !== char_spell.spell_id);
      } else {
        i++;
      }
    }
    i = 0;
    if (char.c_options.ability_score_gen_method === "Not Manual/Rolled" && 
      char.spirit.ability_score_gen_method === "Manual/Rolled") {
      char.spirit.ability_score_gen_method = "Point Buy";
      char.spirit.base_ability_scores = new AbilityScores();
    } else if (char.c_options.ability_score_gen_method !== "Any" && char.spirit.ability_score_gen_method !== char.c_options.ability_score_gen_method) {
      switch(char.c_options.ability_score_gen_method) {
        case "Manual/Rolled": char.spirit.ability_score_gen_method = "Manual/Rolled"; break;
        case "Standard Array": char.spirit.ability_score_gen_method = "Standard Array"; break;
        case "Point Buy": char.spirit.ability_score_gen_method = "Point Buy"; break;
      }
      if (char.spirit.ability_score_gen_method === "Point Buy") {
        char.spirit.base_ability_scores = new AbilityScores();
      } else {
        char.spirit.base_ability_scores = new AbilityScores(0);
      }
    }
    while (i < char.spirit.classes.length) {
      const char_class = char.spirit.classes[i];
      if (char_class.source && 
        (
          // (!["Any",char.c_options.edition_id].includes(char_class.source.edition_id) && 
          // char.c_options.edition_id !== "Any") ||
          (!common_util.anyOverlaps(["",...char.c_options.source_books], char_class.source.source_book_ids)))) {
        // Remove the class
        char.spirit.classes = char.spirit.classes.filter(o => o.source_id !== char_class.source_id);
        char.spirit.classes.filter(o => o.position > char_class.position).forEach(cc => {
          cc.position--;
          if (cc.position === 0) {
            cc.fixWithGameClass(char);
          }
        });
        char.mind.spells = char.mind.spells.filter(o => o.source_type !== "Class" || o.source_id !== char_class.source_id);
      } else {
        if (char_class.subclass &&
          (
            // (!["Any",char.c_options.edition_id].includes(char_class.subclass.edition_id) && 
            // char.c_options.edition_id !== "Any") ||
            (!common_util.anyOverlaps(["",...char.c_options.source_books], char_class.subclass.source_book_ids)))) {
          // Remove the subclass
          this.removeSubclass(char, char_class);
        }
        i++;
      }
    }
    if (char.spirit.background && char.spirit.background.source) {
      if (
        // (!["Any",char.c_options.edition_id].includes(char.spirit.background.source.edition_id) && 
        // char.c_options.edition_id !== "Any") ||
        !common_util.anyOverlaps(["",...char.c_options.source_books], char.spirit.background.source.source_book_ids)) {
        char.spirit.background = new CharacterBackground();
      }
    }
    const char_race = char.spirit.race;
    const char_subrace = char.spirit.race.char_subrace;
    if (char_race && char_race.source && 
      (((
        // (!["Any",char.c_options.edition_id].includes(char_race.source.edition_id) && 
        // char.c_options.edition_id !== "Any") ||
        (!common_util.anyOverlaps(["",...char.c_options.source_books], char_race.source.source_book_ids)))) || 
        (char_subrace !== null && char_subrace.source !== null && 
          ((
            // (!["Any",char.c_options.edition_id].includes(char_subrace.source.edition_id) && 
            // char.c_options.edition_id !== "Any") ||
            (!common_util.anyOverlaps(["",...char.c_options.source_books], char_subrace.source.source_book_ids))))))) {
      char.mind.spells = char.mind.spells.filter(o => o.source_type !== "Race" || o.source_id !== char_race.source_id);
      char.spirit.race = new CharacterRace();
    }
    i = 0;
    while (i < char.mind.spells.length) {
      const char_spell = char.mind.spells[i];
      if (char_spell.spell && 
        (
          // (!["Any",char.c_options.edition_id].includes(char_spell.spell.edition_id) && 
          // char.c_options.edition_id !== "Any") ||
          (!common_util.anyOverlaps(["",...char.c_options.source_books], char_spell.spell.source_book_ids)))) {
          await connect_util.removeSpell(char, char_spell, char_spell.source_type, char_spell.source_id);
      } else {
        i++;
      }
    }
  }

  emptyHash = () => {
    data_util.my_smart_hash = {};
    data_util.archived_data_holder = {};
  }

  removeSubclass(char: Character, char_class: CharacterClass) {
    if (char_class.spellcasting_ability !== "None" && char_class.char_subclass) {
      // Check to see if spellcasting came through the subclass
      for (let j = 0; j < char_class.char_subclass.char_feature_bases.length; ++j) {
        const feature = char_class.char_subclass.char_feature_bases[j];
        if (feature.name === "Spellcasting") {
          char.mind.spells = char.mind.spells.filter(o => o.source_type !== "Class" || (o.source_id !== char_class.source_id && o.source_id !== char_class.subclass_id));
          char_class.spellcasting.spellcasting_ability = "None";
          char_class.spellcasting.spell_attack = 0;
          char_class.spellcasting.spellbook = null;
          // char_class.spell_count_per_level = 0;
          char_class.spellcasting.spell_dc = 0;
          char_class.spellcasting.spellcasting_modifier = 0;
          // char_class.spellcasting.spell_ids = [];
          char_class.spellcasting.spell_level_max = -1;
          char_class.spellcasting.spell_list_ids = [];
          char_class.spellcasting.spell_table = "";
          char_class.spellcasting.spellcasting_focus = "";
          char_class.spellcasting.spellcasting_level = 0;
          char_class.spellcasting.spells_prepared_max = 0;
          // char_class.base_spell_count = 0;
          char_class.spellcasting.bonus_spells = [];
          // char_class.spellcasting.cantrip_ids = [];
          char_class.spellcasting.cantrips_max = 0;
          break;
        } 
      }
    }
    char_class.sub_char_feature_sources = char_class.sub_char_feature_sources.filter(o => o.source_id !== char_class.subclass_id);
    const subclass_fb_finder = char_class.char_feature_bases.filter(o => o.features.filter(o2 => o2.feature_type === "Subclass").length === 1);
    if (subclass_fb_finder.length === 1) {
      const subclass_feature_finder = subclass_fb_finder[0].features.filter(o2 => o2.feature_type === "Subclass");
      if (subclass_feature_finder.length === 1) {
        subclass_feature_finder[0].feature_options[0] = null;
      }
    }
  }

  /**
   * Two-Weapon Fighting:
   * When you take the Attack action and 
   * attack with a light melee weapon that 
   * you're holding in one hand, 
   * you can use a bonus action to attack 
   * with a different light melee weapon 
   * that you're holding in the other hand. 
   * You don't add your ability modifier to 
   * the damage of the bonus attack, 
   * unless that modifier is negative.
   * 
   * If either weapon has the thrown property, 
   * you can throw the weapon, 
   * instead of making a melee attack with it.
   */
  canBonusActionAttack(weapon: CharacterWeapon, char: Character): boolean {
    if (weapon.attacks.filter(o => o.bonus_action).length > 0 || 
      (char.c_options.light_melee_action === "Bonus Action" && 
        weapon.weapon_keywords.filter(o => o.name === "Light").length > 0 &&
        weapon.weapon_keywords.filter(o => o.name === "Melee").length > 0)
        ) {
      return true;
    } else {
      // TODO:
      // Crossbow Expert Attack
      // When you use the Attack action 
      // and attack with a one-handed weapon, 
      // you can use a bonus action to attack 
      // with a hand crossbow you are holding.

      // Dual Wielder
      // You master fighting with two weapons, 
      // gaining the following benefits:

      // You gain a +1 bonus to AC while 
      // you are wielding a separate melee 
      // weapon in each hand.
      // You can use two-weapon fighting even 
      // when the one-handed melee weapons 
      // you are wielding aren't light.
      // You can draw or stow two one-handed 
      // weapons when you would normally be 
      // able to draw or stow only one.
    }

    return false;
  }

  /**
   * Opportunity Attack:
   * You can make an opportunity attack when a 
   * hostile creature that you can see moves 
   * out of your reach. To make the opportunity attack, 
   * you use your reaction to make one melee attack 
   * against the provoking creature. 
   * The attack occurs right before the creature leaves 
   * your reach.
   */
  canReactionAttack(weapon: CharacterWeapon, char: Character): boolean {
    if (weapon.weapon_keywords.filter(o => o.name === "Melee").length > 0 &&
      weapon.equipped_hand !== "Off") {
      return true;
    }

    return false;
  }

  getBFAItemOptions = async (char: Character, char_bf: CharacterBastionFacility, bfa: BastionAbility) => {
    const options: DisablableOption[] = [];
    const subtype = char_bf.subtype;
    for (const bfi of bfa.items.filter(o => 
      (o.for_subtypes.length === 0 || 
        o.for_subtypes.includes(subtype)) &&
      this.fitLimits(char, [o.char_limit], "", "")
    )) {
      if (bfi.type === "Creature") {
        const creatures = await this.getCreatures({ limitation: bfi.creature_limit, char });
        options.push(...creatures.map(o => { 
          const opt: DisablableOption = {
            id: o.id, 
            text: o.name + (bfi.count > 1 ? ` x ${bfi.count}` : "") + (bfi.cost_gold > 0 ? ` for ${bfi.cost_gold}gp` : ""), 
            hidden1: bfi.type, 
            hidden_num1: bfi.count,
            hidden_num2: bfi.cost_gold
          };
          return opt;
        }));
      } else if (bfi.type === "Item") {
        const items = this.getPseudoItems({ limitation: bfi.item_limit, no_extras: true });
        options.push(...items.map(o => { 
          const opt: DisablableOption = {
            id: o.id, 
            text: o.name + (bfi.count > 1 ? ` x ${bfi.count}` : "") + (bfi.cost_gold > 0 ? ` for ${bfi.cost_gold}gp` : ""), 
            hidden1: bfi.type, 
            hidden_num1: bfi.count,
            hidden_num2: bfi.cost_gold
          };
          return opt;
        }));
      } else if (bfi.type === "Custom") {
        options.push(...bfi.custom_options.map(o => { 
          const opt: DisablableOption = {
            id: o.true_id, 
            text: o.name + (bfi.count > 1 ? ` x ${bfi.count}` : "") + (bfi.cost_gold > 0 ? ` for ${bfi.cost_gold}gp` : ""), 
            hidden1: bfi.type, 
            hidden_num1: o.count,
            hidden_num2: bfi.cost_gold
          };
          return opt;
        }));
      }
    }
    return options;
  }

  /**
   * Repopulate, Recalc, etc
   */
  buildMind = async (char: Character | ComplexCreatureInstance, log_it = false) => {
    console.log("buildMind()");
    console.log(char);
    if (char instanceof Character) {
      // Set some vars that get used in a few places.
      char.mind.character_level = char.spirit.character_level;
      char.mind.proficiency_modifier = common_util.proficiencyBonus(char.mind.character_level);

      let dragonmarked_source_id = "";
      if (char.spirit.race.source && char.spirit.race.source.tags.includes("Dragonmark")) {
        dragonmarked_source_id = char.spirit.race.source_id;
      } else if (char.spirit.race.char_subrace && char.spirit.race.char_subrace.source && char.spirit.race.char_subrace.source.tags.includes("Dragonmark")) {
        dragonmarked_source_id = char.spirit.race.subrace_id;
      } else {
        const dragonmark_feat = char.spirit.feats.find(o => o.source && o.source.tags.includes("Dragonmark"));
        if (dragonmark_feat) {
          dragonmarked_source_id = dragonmark_feat.source_id;
        }
      }
      char.mind.dragonmarked_source_id = dragonmarked_source_id;
      let wild_talent_source_id = "";
      const wild_talent_feat = char.spirit.feats.find(o => o.source && o.source.tags.includes("Wild Talent"));
      if (wild_talent_feat) {
        wild_talent_source_id = wild_talent_feat.source_id;
      }
      char.mind.wild_talent_source_id = wild_talent_source_id;

      // Set up all the CFSs in Mind
      char.mind.char_feature_sources = [];
      char.mind.special_features = [];
      char.mind.eldritch_invocations = [];
      char.mind.fighting_styles = [];
      char.mind.feats = [];

      char.mind.char_feature_sources.push(char.spirit.standard_features);
      char.mind.char_feature_sources.push(char.spirit.race);
      char.mind.char_feature_sources.push(char.spirit.background);
      char.mind.char_feature_sources.push(...char.spirit.classes);
      char.mind.char_feature_sources.push(...char.spirit.gifts);
      char.mind.char_feature_sources.push(...char.spirit.extra_feats);
      char.mind.char_feature_sources.push(...char.inventory.char_feature_sources);

      // Now the sub_cfss
      let i = 0; 
      while (i < char.mind.char_feature_sources.length) {
        const cfs = char.mind.char_feature_sources[i];
        if (cfs instanceof CharacterFeat) {
          char.mind.feats.push(cfs);
        } else if (cfs instanceof CharacterSpecialFeature) {
          char.mind.special_features.push(cfs);
        } else if (cfs instanceof CharacterEldritchInvocation) {
          char.mind.eldritch_invocations.push(cfs);
        } else if (cfs instanceof CharacterFightingStyle) {
          char.mind.fighting_styles.push(cfs);
        } else if (cfs instanceof CharacterPactBoon) {
          char.mind.pact_boon = cfs;
        }
        await this.repopulateCharFeatureBasesFor(char, cfs);
        ++i;
      }

      // It's possible that your pb has changed. 
      // If so we may need to update the copy of it in some of your minions
      for (const minion of char.spirit.minions) {
        if (minion instanceof SummonInstance || minion instanceof ComplexCreatureInstance) {
          if (minion.use_your_pb) {
            minion.your_pb = char.mind.proficiency_modifier;
          }
        }
      }
      // This one has to be last because it looks at the char_feature_bases populated above
      await this.repopulateWeaponMasteries(char);
      await this.repopulateCharFeatures(char, char);
    } else {
      // debugger;
      // this.removeCharFeatureBasesForCCI(char, log_it);
      // if (char.spirit.creature_cfs) {
      //   await this.repopulateCharFeatureBasesFor(char, char.creature_cfs, undefined);
      // }
      // if (char.spirit.transform) {
      //   await this.repopulateCharFeatureBasesFor(char, char.spirit.transform, undefined);
      // }
      // if (char.spirit.summon) {
      //   this.removeCharFeatureBasesFor(char, char.summon);
      //   // summon doesn't work as a CCIFeatureSource, so we have to do it differently.
      //   const summon = char.summon;
        
      //   const summon_cfbs = summon.fbs.map((fb) => {
      //     // const f = fb.single_feature;
      //     const cfb = new CharacterFeatureBase();
      //     cfb.true_id = fb.true_id;
      //     cfb.copyFeatureBase(fb, summon, char);
      //     // if (f) {
      //     //   const cf = new SummonFeature();
      //     //   cf.true_id = f.true_id;
      //     //   cf.copyFeature(f, null, char);
      //     //   // actions.push(char_feat);
      //     //   cfb.features.push(cf);
      //     // }
      //     return cfb;
      //   });
      //   char.mind.char_feature_bases = [...char.mind.char_feature_bases, ...summon_cfbs];
      // }
      // for (const cfs of char.creature_gift_cfss) {
      //   await this.repopulateCharFeatureBasesFor(char, cfs, undefined);
      // }
      // for (const cfs of char.extra_cfss) {
      //   await this.repopulateCharFeatureBasesFor(char, cfs, undefined);
      // }
      // if (char instanceof ComplexCreatureInstance) {
      //   for (const cf of char.upgrade_char_features) {
      //     const suf = cf.floating_feature;
      //     if (suf instanceof SummonUpgradeFeature) {
      //       for (const f of suf.features) {
      //         const cfb = new CharacterFeatureBase();
      //         cfb.true_id = uuidv4().toString();
      //         const new_cf = new CharacterFeature();
      //         new_cf.copyFeature(f, char, cfb);
      //         cfb.features.push(new_cf);
      //         char.mind.char_feature_bases.push(cfb);
      //       }
      //     }
      //   }
      // }

      // if (char.owner_char) {
      //   await this.repopulateCharFeatures(char, char.owner_char);
      // }
    }
    // if (char instanceof Character) {
    //   for (const minion of char.minions) {
    //     if (minion instanceof ComplexCreatureInstance) {
    //       await this.repopulateCharFeatureBases(minion, log_it);
    //     }
    //   }
    // }
    char.subscription_holder.recalculated();
  }

  repopulateCharFeatureBases = async (char: Character | ComplexCreatureInstance, log_it = false) => {
    await this.buildMind(char, log_it);
  }

  applyCreatureToSidekick = async (char: Character) => {
    const creature = char.spirit.sidekick_creature;
    if (creature) {
      // Some actions are actually supposed to be weapons that they have.
      // Those ones shouldn't be added here.  Do our best to filter them out.
      const filter_weapons = [
        "Humanoid",
        // "Beast",
        // "Construct",
        "Aberration",
        "Undead",
        // "Dragon",
        // "Monstrosity",
        "Elemental",
        "Fey",
        "Giant",
        // "Ooze",
        // "Plant",
        "Shapechanger",
        "Celestial",
        "Fiend"].includes(creature.creature_type);
      const weapons = filter_weapons ? data_util.items.filter(o => o.item_type === "Weapon") as Weapon[] : [];
      char.mind.extra_attacks = 0;
      for (const fb of creature.fbs) {
        for (const feature of fb.features) {
          if (feature.feature_type === "Extra Attacks") {
            if (feature.floating_feature instanceof NumberFeature) {
              char.mind.extra_attacks = feature.floating_feature.num;
            }
          } else if (feature.feature_type === "Minion Extra Attacks") {
            if (feature.floating_feature instanceof UpgradableNumberFeature) {
              char.mind.extra_attacks = feature.floating_feature.num.base;
            }
          } else {
            const weapon = weapons.find(o => feature.name.includes(o.name));
            if (!weapon && !feature.name.includes("Crossbow")) { // Crossbows can slip through because they flopped the names
              const cf = new CharacterFeature();
              cf.copyFeature(feature, char);
              char.mind.features.push(cf);
            }
          }
        }
      }
    }
  }

  repopulateWeaponMasteries = async (char: Character) => {
    // Attach Weapon Masteries to items
    let weapon_mastery_features: CharacterFeature[] = [];
    let weapon_mastery_master_features: CharacterFeature[] = [];
    let wm_cfbs = char.mind.char_feature_bases.filter(o => o.features.find(o => o.feature_type === "Weapon Mastery"));
    for (const cfb of wm_cfbs) {
      const wm_cfs = cfb.features.filter(o => o.feature_type === "Weapon Mastery");
      weapon_mastery_features = [...weapon_mastery_features,...wm_cfs];
    }
    // We also need to make cwms for abilities that specify they use a weapon mastery
    const ability_cfbs = char.mind.char_feature_bases.filter(o => 
      o.features.some(o => o.floating_feature instanceof Ability && 
        o.floating_feature.counts_as_weapon === "Use Properties" && 
        o.floating_feature.weapon_properties.wmp_id !== "")
    );
    for (const cfb of ability_cfbs) {
      const wm_cfs = cfb.features.filter(o => o.floating_feature instanceof Ability && 
        o.floating_feature.counts_as_weapon === "Use Properties" && 
        o.floating_feature.weapon_properties.wmp_id !== "");
      weapon_mastery_features = [...weapon_mastery_features,...wm_cfs];
    }
    // debugger;
    wm_cfbs = char.mind.char_feature_bases.filter(o => o.features.find(o => o.feature_type === "Weapon Mastery Master"));
    for (const cfb of wm_cfbs) {
      const wm_cfs = cfb.features.filter(o => o.feature_type === "Weapon Mastery Master");
      weapon_mastery_master_features = [...weapon_mastery_master_features,...wm_cfs];
    }
    const cwms: CharacterWeaponMastery[] = [];
    for (const cf of weapon_mastery_features) {
      if (cf.floating_feature instanceof WeaponMasteryFeature) {
        // debugger;
        const new_feature_options: string[] = [];
        const wm_ff = cf.floating_feature;
        const count = this.value(wm_ff.count, { obj: char, source_id: cf.source_true_id, item_id: "" });
        for (let i = 0; i < count; ++i) {
          if (cf.feature_options.length > i && typeof cf.feature_options[i] === "string") {
            const weapon_id = cf.feature_options[i];
            const weapon = data_util.items.find(o => o._id === weapon_id);
            if (weapon instanceof Weapon) {
              new_feature_options.push(weapon_id);
              await data_util.loadObject(weapon);
              let cwm = cwms.find(o => o.source_id === weapon.weapon_mastery_property_id);
              if (!cwm) {
                cwm = new CharacterWeaponMastery();
                const wmp = data_util.weapon_mastery_properties.find(o => o._id === weapon.weapon_mastery_property_id);
                if (wmp) {
                  await data_util.loadObject(wmp);
                  await cwm.copy_source({ char, feature_source: wmp, parent_cf: cf, item_id: cf.use_item_id });
                  cwm.weapon_limits.push(new WeaponLimitation());
                  cwms.push(cwm);
                } else {
                  debugger;
                }
              }
              cwm.cf_ids.push(cf.true_id);
              const limit = cwm.weapon_limits.find(o => o.isEmpty(["item_ids"]));
              if (limit) {
                limit.item_ids = [...limit.item_ids, weapon_id];
              } else {
                debugger;
              }
            } else {
              new_feature_options.push("");
            }
          } else {
            new_feature_options.push("");
          }
        }
        
        cf.feature_options = new_feature_options;
      } else if (cf.floating_feature instanceof Ability) {
        const wmp_id = cf.floating_feature.weapon_properties.wmp_id;
        let cwm = cwms.find(o => o.source_id === wmp_id);
        if (!cwm) {
          cwm = new CharacterWeaponMastery();
          const wmp = data_util.weapon_mastery_properties.find(o => o._id === wmp_id);
          if (wmp) {
            await data_util.loadObject(wmp);
            await cwm.copy_source({ char, feature_source: wmp, parent_cf: cf, item_id: cf.use_item_id });
            cwms.push(cwm);
          } else {
            debugger;
          }
        }
      }
    }
    const cwmms: CharacterWeaponMasteryMaster[] = [];
    for (const cf of weapon_mastery_master_features) {
      if (cf.floating_feature instanceof WeaponMasteryMasterFeature) {
        const new_cwmm = new CharacterWeaponMasteryMaster();
        const wm_ff = cf.floating_feature;
        new_cwmm.wm_ff = wm_ff;
        cwmms.push(new_cwmm);
        for (const wmp_id of cf.floating_feature.wmp_ids){
          let cwm = cwms.find(o => o.source_id === wmp_id)
          if (!cwm) {
            cwm = new CharacterWeaponMastery();
            const wmp = data_util.weapon_mastery_properties.find(o => o._id === wmp_id);
            if (wmp) {
              await data_util.loadObject(wmp);
              await cwm.copy_source({ char, feature_source: wmp, parent_cf: cf, item_id: cf.use_item_id });
              cwms.push(cwm);
            } else {
              debugger;
            }
          }
          cwm.weapon_limits.push(cf.floating_feature.weapon_limit);
        }
      } 
    }
    
    char.mind.char_feature_bases = char.mind.char_feature_bases.filter(o => o.source_type !== "WeaponMasteryProperty");
    char.mind.weapon_mastery_features = weapon_mastery_features;
    char.mind.cwmms = cwmms;
    char.mind.cwms = cwms;
    for (const cwm of char.mind.weapon_masteries) {
      // console.log(cwm);
      await this.repopulateCharFeatureBasesFor(char, cwm, undefined); // , cwm.name.includes("Vex")
    }
  }

  isLevelForFeatureBase(char: Character | ComplexCreatureInstance, cfb: CharacterFeatureBase, source: CharacterFeatureSource, log_it = false) {
    // log_it = cfb.name.includes("Perfected");
    if (log_it) {
      console.log(cfb);
      console.log(source);
    }
    // if (cfb.name.includes("Perfected")) {
    //   debugger;
    // }
    switch (cfb.for_class) {
      case "Default": 
        if (cfb.ancestries.filter(o => o.type === "Subclass").length > 0 && source instanceof CharacterClass) {
          if (source.subclass) {
            if (source.subclass.use_subclass_levels) {
              return cfb.level <= source.subclass_level;
            }
          } else {
            return false;
          }
        }
        if (cfb.parent_feature_base_level > -1) {
          return cfb.parent_feature_base_level <= source.level;
        } else {
          return cfb.level <= source.level;
        }
      case "Character": return cfb.level <= char.mind.character_level;
      default: 
        if (char instanceof Character) {
          const char_class = char.spirit.classes.find(o => o.source_id === cfb.for_class);
          if (char_class) {
            if (cfb.ancestries.filter(o => o.type === "Subclass").length > 0) {
              if (char_class.subclass) {
                if (char_class.subclass.use_subclass_levels) {
                  return cfb.level <= char_class.subclass_level;
                }
              } else {
                return false;
              }
            }
            return cfb.level <= char_class.level;
          } else {
            return cfb.level <= source.level;
          }
        }
        return false;
    } 
  }

  useFeatures(char: Character | ComplexCreatureInstance, 
    source: CharacterFeatureSource, 
    use_all = true,
    log_it = false) {
    // log_it = source.name.includes("Urchin"); // source instanceof CharacterClass; // 
    // if (source instanceof CharacterMagicItemKeyword) {
    //   debugger;
    // }
    if (log_it) {
      console.log(source);
      // console.log(source.all_char_feature_bases.length);
      console.log(source.all_char_feature_bases);
      console.log(source.all_char_feature_bases.filter(o => o.name.includes(log_find_string)));
    }
    let use_features = use_all ? source.all_char_feature_bases : source.char_feature_bases;
    if (log_it) {
      // debugger;
      // use_features = use_features.filter(o => o.name.includes("Subclass"));
      console.log(use_features);
      console.log(use_features.filter(o => o.name.includes(log_find_string)));
    }
    
    if (char instanceof Character) {
      use_features = use_features.filter(o => 
        o.source_book_ids.length === 0 ||
        common_util.anyOverlaps(["",...char.c_options.source_books], o.source_book_ids));
    }
    if (log_it) {
      console.log(use_features);
      console.log(use_features.filter(o => o.optional));
      console.log(use_features.filter(o => o.name.includes(log_find_string)));
    }
    if (char instanceof Character) {
      use_features = use_features.filter(o => 
        o.feature_base &&
        (o.feature_base instanceof FeatureBase || 
          char.spirit.optional_feature_base_ids.includes(o.feature_base._id)));
    }
    if (log_it) {
      console.log(use_features);
      console.log(use_features.filter(o => o.optional));
      console.log(use_features.filter(o => o.name.includes(log_find_string)));
    }
    if (source instanceof CharacterOrg) {
      // This gets its level from the org_instance
      if (source.org_instance) {
        source.level = source.org_instance.level;
      }
    } else if ((source.source instanceof Condition && source.source.max_level > 1) ||
      (source.source instanceof Gift && source.source.use_gift_levels)) {
      // These have their own levels
    } else if (source instanceof CharacterClass || 
      source instanceof CharacterSubclass) {
      // These have their own levels
      // And also have to worry about multiclassing rules
      use_features = use_features.filter(o => 
        o.multiclassing === 0 || 
          (source.position === 0 && o.multiclassing === 1) || 
          (source.position > 0 && o.multiclassing === 2));
      // debugger;
    } else if (source instanceof CharacterSpecialFeature) {
      // This uses the same level as the parent.
      const parent_ancestry = source.parent;
      if (parent_ancestry) {
        const parent = char.char_feature_sources.filter(o => 
          parent_ancestry.true_id === o.true_id)[0];
        if (parent) {
          source.level = parent.level;
        }
        const root_ancestry = source.root;
        if (root_ancestry) {
          const root = char.char_feature_sources.filter(o => 
            root_ancestry.true_id === o.true_id)[0];
          if (root instanceof CharacterClass || 
            root instanceof CharacterSubclass) {
            use_features = use_features.filter(o => 
              o.multiclassing === 0 || 
                (root.position === 0 && o.multiclassing === 1) || 
                (root.position > 0 && o.multiclassing === 2));
          }
        }
      }
    } else if (source instanceof CharacterBackground) {
      // Check Standard Features
      if (char instanceof Character) {
        if (char.spirit.background.source && char.spirit.race.source) {
          const standard = char.spirit.standard_features;
          // Standard Features are only added if the character has both a race and a background
          const race = char.spirit.race.source;
          for (const cfb of standard.char_feature_bases) {
            if (cfb.feature_base instanceof FeatureBaseWithRules) {
              const fb = cfb.feature_base;
              let add_it = false;
              if (fb.look_in.includes("background")) {
                // Look for cfbs on char.spirit.race of fb.feature_type.  
                const cfbs_with_type = use_features.filter(o => 
                  o.attached_source_true_id === "" &&
                  o.features.filter(o2 => o2.feature_type === fb.feature_type).length > 0
                );
                if (cfbs_with_type.length > 0) {
                  // Found it, check the rules we're doing for it.
                  if (fb.dominant_feature_source === "background" || fb.look_in.length === 1) {
                    // We're looking for it here, so we just use this one, and move on.
                  } else {
                    // We're looking for it in both, and race is dominant, so check if it's there.
                    const other_fbs_with_type = race.feature_bases.filter(o => 
                      o.features.filter(o2 => o2.feature_type === fb.feature_type).length > 0
                    );
                    if (other_fbs_with_type.length > 0) {
                      // It's also in race, so we want to remove them from here.
                      use_features = use_features.filter(o => 
                        o.feature_base && 
                        (o.feature_base instanceof OptionalFeatureBase || 
                          !o.feature_base.feature_types.includes(fb.feature_type)));
                    } else {
                      // It's not in race, so keep it
                    }
                  }
                } else {
                  // It's not on the background, so check if we also look in race
                  if (fb.look_in.includes("race")) {
                    const other_fbs_with_type = race.feature_bases.filter(o => 
                      o.features.filter(o2 => o2.feature_type === fb.feature_type).length > 0
                    );
                    if (other_fbs_with_type.length > 0) {
                      // It is in race, so we don't need to do anything.
                    } else {
                      // It's not in either, so we need to add it to one of them.
                      add_it = fb.dominant_feature_source === "race"; // We add it to the non-dominant one if it's not in either
                    }
                  } else {
                    add_it = true; // We only look in background, and it's not there, so add it.
                  }
                }
                if (add_it) {
                  cfb.attached_source_true_id = char.spirit.background.true_id;
                  char.spirit.background.char_feature_bases.push(cfb);
                  use_features.push(cfb);
                  for (const cf of cfb.features) {
                    for (const fo of cf.feature_options) {
                      if (fo instanceof CharacterFeatureSource) {
                        for (const sub_cfb of fo.all_char_feature_bases) {
                          sub_cfb.attached_source_true_id = char.spirit.background.true_id;
                          char.spirit.background.char_feature_bases.push(sub_cfb);
                          use_features.push(sub_cfb);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      source.level = Math.max(char.mind.character_level, 1);
    } else if (source instanceof CharacterRace) {
      // debugger;
      // console.log(char.spirit.standard_features);
      if (char instanceof Character) {
        if (char.spirit.background.source && char.spirit.race.source) {
          const standard = char.spirit.standard_features;
          // Standard Features are only added if the character has both a race and a background
          const background = char.spirit.background.source;
          for (const cfb of standard.char_feature_bases) {
            if (cfb.feature_base instanceof FeatureBaseWithRules) {
              const fb = cfb.feature_base;
              let add_it = false;
              if (fb.look_in.includes("race")) {
                // Look for cfbs on char.spirit.race of fb.feature_type.  
                const cfbs_with_type = use_features.filter(o => 
                  o.attached_source_true_id === "" &&
                  o.features.filter(o2 => o2.feature_type === fb.feature_type).length > 0
                );
                if (cfbs_with_type.length > 0) {
                  // Found it, check the rules we're doing for it.
                  if (fb.dominant_feature_source === "race" || fb.look_in.length === 1) {
                    // We're looking for it here, so we just use this one, and move on.
                  } else {
                    // We're looking for it in both, and background is dominant, so check if it's there.
                    const other_fbs_with_type = background.feature_bases.filter(o => 
                      o.features.filter(o2 => o2.feature_type === fb.feature_type).length > 0
                    );
                    if (other_fbs_with_type.length > 0) {
                      // It's also in background, so we want to remove them from here.
                      use_features = use_features.filter(o => 
                        o.feature_base && 
                        (o.feature_base instanceof OptionalFeatureBase || 
                          !o.feature_base.feature_types.includes(fb.feature_type)));
                    } else {
                      // It's not in background, so keep it
                    }
                  }
                } else {
                  // It's not on the race, so check if we also look in background
                  if (fb.look_in.includes("background")) {
                    const other_fbs_with_type = background.feature_bases.filter(o => 
                      o.features.filter(o2 => o2.feature_type === fb.feature_type).length > 0
                    );
                    if (other_fbs_with_type.length > 0) {
                      // It is in background, so we don't need to do anything.
                    } else {
                      // It's not in either, so we need to add it to one of them.
                      add_it = fb.dominant_feature_source === "background"; // We add it to the non-dominant one if it's not in either
                    }
                  } else {
                    add_it = true; // We only look in race, and it's not there, so add it.
                  }
                }
                if (add_it) { 
                  cfb.attached_source_true_id = char.spirit.race.true_id;
                  char.spirit.race.char_feature_bases.push(cfb);
                  use_features.push(cfb);
                  for (const cf of cfb.features) {
                    for (const fo of cf.feature_options) {
                      if (fo instanceof CharacterFeatureSource) {
                        for (const sub_cfb of fo.all_char_feature_bases) {
                          sub_cfb.attached_source_true_id = char.spirit.race.true_id;
                          char.spirit.race.char_feature_bases.push(sub_cfb);
                          use_features.push(sub_cfb);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      source.level = Math.max(char.mind.character_level, 1);
    } else if (source instanceof CharacterItem) {
      // if (source.name.includes("Sceptre")) {
      //   debugger;
      // }
      if (source.base_item) {
        if (source.base_item.min_rarity !== source.base_item.max_rarity) {
          source.level = source.use_selected_rarity;
        } else {
          source.level = source.rarity;
        }
      }
    } else if (source instanceof CharacterMagicItemKeyword && char instanceof Character) {
      // if (source.name.includes("Dragon")) {
      //   debugger;
      // }
      if (source.min_rarity !== source.max_rarity) {
        const char_item = char.inventory.items.find(o => o.true_id === source.item_id);
        if (char_item) {
          source.level = char_item.use_selected_rarity;
        }
      } else {
        source.level = Math.max(source.min_rarity, 1);
      }
    } else if (source instanceof CharacterSubrace) {
      // There's the possibility that an old subrace that has an ASI is being used with a newer race that doesn't have an ASI.
      // In that situation, the subrace ASI will get included, along with ASIs from the background or standard features, which is bad.
      // So this part checks for that and pulls the subrace ASI out.
      if (use_features.filter(o => o.features.filter(o2 => o2.floating_feature instanceof ASIBaseFeature && 
        (o2.floating_feature.asi_features.length > 1 || 
          o2.floating_feature.asi_features.filter(o3 => 
            o3.amount > 0).length > 0)).length > 0).length > 0) {
        // Subrace has ASI 
        if (char instanceof Character) {
          const char_race = char.spirit.race;
          if (char_race.char_feature_bases.filter(o => 
            o.features.filter(o2 => 
              o2.floating_feature instanceof ASIBaseFeature).length > 0).length === 0) {
            // Race does not, so we need to not include the ones from the subrace.
            use_features = use_features.filter(o => 
              o.features.filter(o2 => 
                o2.floating_feature instanceof ASIBaseFeature && 
                (o2.floating_feature.asi_features.length > 1 || 
                  o2.floating_feature.asi_features.filter(o3 => 
                    o3.amount > 0).length > 0)).length === 0);
          }
        }
      }
      source.level = Math.max(char.mind.character_level, 1);
    } else if (source instanceof CharacterCondition) {
      // It keeps its own level
    } else {
      source.level = Math.max(char.mind.character_level, 1);
    }
    if (log_it) {
      console.log(use_features);
      console.log(use_features.filter(o => o.name.includes(log_find_string)));
      // debugger;
    }
    use_features = use_features.filter(o => 
      this.isLevelForFeatureBase(char, o, source, log_it));
    if (log_it) {
      console.log(use_features);
      console.log(use_features.filter(o => o.multiclassing !== 0));
      console.log(source);
      console.log(use_features.filter(o => o.name.includes(log_find_string)));
    }
    // Any time changes are made to a feature, make it in both locations.
    // It only gets saved on the source.
    // Go through and filter out features that are replaced or upgraded
    let replaced_ids = use_features.filter(o => o.optional && o.replaces_feature_base_id !== "").map(o => o.replaces_feature_base_id);
    // console.log(replaced_ids);
    use_features = use_features.filter(o => !replaced_ids.includes(o.true_id));
    if (log_it) {
      console.log(replaced_ids);
      console.log(use_features);
      console.log(use_features.filter(o => o.name.includes(log_find_string)));
    }
    replaced_ids = use_features.filter(o => o.upgrades_feature_base_id !== "").map(o => o.upgrades_feature_base_id);
    use_features = use_features.filter(o => !replaced_ids.includes(o.true_id));
    if (log_it) {
      console.log(use_features.filter(o => o.upgrades_feature_base_id !== ""));
      console.log(replaced_ids);
      console.log(use_features.filter(o => replaced_ids.includes(o.true_id)));
      console.log(use_features);
      console.log(use_features.filter(o => o.name.includes(log_find_string)));
    }
    
    // Remove duplicates
    const use_these: CharacterFeatureBase[] = [];
    use_features.forEach(cfb => {
      if (use_these.filter(o => o.cfb_true_id === cfb.cfb_true_id).length === 0) {
        use_these.push(cfb);
      }
    });
    if (log_it) {
      console.log(use_these);
      console.log(use_these.filter(o => o.name.includes(log_find_string)));
    }
    return use_these;
  }

  useFeatures2(char: Character, 
    source: CharacterFeatureSource, 
    use_all = true,
    log_it = false) {
    // log_it = source.source instanceof Race;
    if (log_it) {
      console.log(source);
      // console.log(source.all_char_feature_bases.length);
      console.log(source.all_char_feature_bases);
      console.log(char.char_feature_sources.filter(o => 
        o.name.includes(log_find_string)));
      debugger;
    }
    let use_these = char.mind.char_feature_bases.filter(o => 
      o.source_true_id === source.true_id || 
      o.attached_source_true_id === source.true_id
    );
    if (use_all) {
      for (const subcfs of source.sub_char_feature_sources) {
        // debugger;
        const and_these = char.mind.char_feature_bases.filter(o => o.source_true_id === subcfs.true_id);
        if (log_it) {
          const name = subcfs.name;
          console.log(name);
        }
        use_these = [...use_these,...and_these];
      }
    }
    if (log_it) {
      console.log(use_these);
    }
    const use_these2: CharacterFeatureBase[] = [];
    use_these.forEach(cfb => {
      const finder = use_these2.filter(o => o.cfb_true_id === cfb.cfb_true_id);
      if (log_it) {
        console.log(cfb.name);
        console.log(cfb.source_name);
        console.log(use_these2);
        console.log(finder);
      }
      if (finder.length === 0) {
        use_these2.push(cfb);
      }
    });
    if (log_it) {
      console.log(use_these);
      console.log(use_these2);
    }
    return use_these2;
  }

  repopulateCharFeatureBasesFor = async (
    char: Character | ComplexCreatureInstance, 
    cfs: CharacterFeatureSource,
    log_it = false) => {
    // log_it = source instanceof CharacterSubclass; // source.name.includes("Medani");
    if (log_it) {
      console.log(char.mind.char_feature_bases);
      // debugger;
    }
    this.removeCharFeatureBasesFor(char, cfs, log_it);
    cfs.replace_name = "";
    if (!cfs.source) {
      const feature_source = data_util.all_feature_sources.find(o => o._id === cfs.source_id);
      if (feature_source) {
        await data_util.loadObject(feature_source);
        await cfs.copy_source({ char, feature_source });
      }
    }
    if (char instanceof Character) {
      if (cfs instanceof CharacterPactBoon) {
        char.mind.pact_boon = cfs;
      } else if (cfs instanceof CharacterFeat) {
        if (char.spirit.feats.filter(o => o.true_id === cfs.true_id).length === 0) {
          char.spirit.feats.push(cfs);
        }
      } else if (cfs instanceof CharacterFightingStyle) {
        if (char.mind.fighting_styles.filter(o => o.true_id === cfs.true_id).length === 0) {
          char.mind.fighting_styles.push(cfs);
        }
      } else if (cfs instanceof CharacterEldritchInvocation) {
        if (char.mind.eldritch_invocations.filter(o => o.true_id === cfs.true_id).length === 0) {
          char.mind.eldritch_invocations.push(cfs);
        }
      } else if (cfs instanceof CharacterSpecialFeature) {
        if (char.mind.special_features.filter(o => o.true_id === cfs.true_id).length === 0) {
          char.mind.special_features.push(cfs);
        }
      } else if (cfs instanceof CharacterStandardFeatures) {
        // debugger;
        cfs.level = 1;
      }
    }
    if (cfs.table === null && cfs.source instanceof FeatureSource) {
      cfs.table = await data_util.getTableAsync(cfs.source);
    }
    if (log_it) {
      console.log(cfs);
    }
    if (cfs instanceof CharacterItem) {
    } else if (cfs.char_feature_bases.filter(o => o.optional).length === 0) {
      if (cfs instanceof CharacterStandardFeatures && char instanceof Character) {
        const standard_features = data_util.standard_features.find(o => o._id === char.c_options.standard_features_id);
        if (standard_features) {
          await data_util.loadObject(standard_features);
          await cfs.copy_source({ char, feature_source: standard_features });
        }
      } else if (cfs instanceof CCIFeatureSource) {
        // log_it = true;
        if (cfs.source_type === "creature" && char instanceof ComplexCreatureInstance) {
          const creatures = await this.getCreatures({ char });
          const source_finder = creatures.filter(o => o._id === cfs.source_id);
          if (source_finder.length === 1) {
            const the_source = source_finder[0];
            await data_util.loadObject(the_source);
            cfs.copyCCISource({ char, feature_source: the_source });
          }
        } else if (cfs.source_type === "creature_gift" && char instanceof ComplexCreatureInstance) {
          const cgifts = await data_util.getCreatureGifts();
          const source_finder = cgifts.filter(o => o._id === cfs.source_id);
          if (source_finder.length === 1) {
            const the_source = source_finder[0];
            await data_util.loadObject(the_source);
            cfs.copyCCISource({ char, feature_source: the_source });
          }
        } else {
          debugger; // Not implemented yet
        }
      } else if (cfs.data_type !== "") {
        let source_finder = await data_util.getGoodDataOfTypeAsync(cfs.data_type);
        source_finder = source_finder.filter(o => o._id === cfs.source_id);
        if (source_finder.length === 1 && source_finder[0] instanceof FeatureSource) {
          const the_source = source_finder[0];
          // if (the_source.name === "Reaper") {
          //   debugger;
          // }
          await data_util.loadObject(the_source);
          await cfs.copy_source({ char, feature_source: the_source, parent_cf: cfs.parent_cf, item_id: cfs.item_id });
        }
      } else {
        debugger;
      }
    }

    // log_it = source.name.includes("Dagger"); // source.source instanceof Background;
    let use_features = this.useFeatures(char, cfs, true, log_it);
    // log_it = source instanceof CharacterRace;
    if (log_it) {
      console.log(char);
      console.log(cfs);
      console.log(use_features);
      debugger;
      // console.log(char.mind.char_feature_bases);
    }

    use_features = use_features.filter(o => 
      o.source_true_id === cfs.true_id || 
      o.item_id === cfs.item_id ||
      o.item_id === cfs.true_id ||
      o.attached_source_true_id === cfs.true_id
    );
    if (cfs instanceof CharacterClass) {
      if (cfs.char_subclass && cfs.subclass_id !== "") {
        if (cfs.subclass === null) {
          const subclass_id = cfs.subclass_id;
          const subclass = data_util.subclasses.find(o => o._id === subclass_id);
          if (subclass) {
            cfs.char_subclass.source = subclass;
          }
        }
        // Search for SubclassFeatures that are higher than level 1
        if (cfs.subclass) {
          if (cfs.subclass.use_subclass_levels) {
            let max_level = 1;
            const sub_source_cfbs = use_features.filter(o => o.features.filter(o2 => o2.floating_feature instanceof SubclassFeature && o2.floating_feature.level > 1).length > 0);
            for (const sub_source_cfb of sub_source_cfbs) {
              const level = sub_source_cfb.features.filter(o => o.floating_feature instanceof SubclassFeature).map(o => { return (o.floating_feature as SubclassFeature).level; })[0];
              if (level) {
                max_level = Math.max(max_level, level);
              }
            }
            cfs.subclass_level = max_level;
          } else {
            cfs.subclass_level = cfs.level;
          }
        } else {
          cfs.subclass_level = 0;
        }
      } else {
        cfs.subclass_level = 0;
      }
      // we need to repopulate use_features with what it would have at this point if subclass_level had been set properly
      use_features = this.useFeatures(char, cfs, true, log_it);
      if (log_it) {
        console.log(use_features);
      }
      use_features = use_features.filter(o => 
        o.source_true_id === cfs.true_id || 
        o.attached_source_true_id === cfs.true_id ||
        o.item_id === cfs.item_id
      );
    }
    cfs.use_char_feature_bases = use_features;
    const selectable_hash: { [key: string]: string[] } = {};
    const selectable_types: { [key: string]: SelectableType } = {};
    cfs.name_bonuses = [];
    const selectable_cfbs = use_features.filter(o => o.features.filter(o2 => o2.feature_type === "Selectable").length > 0);
    
    // log_it = true;
    // console.log(source);
    // console.log(selectable_cfbs.map(o => o.name));
    for (const cfb of selectable_cfbs) {
      if (log_it) {
        console.log(cfb);
      }
      const selectable_cfs = cfb.features.filter(o => o.feature_type === "Selectable");
      for (const cf of selectable_cfs) {
        // Get it and attach it
        if (log_it) {
          console.log(cf);
        }
        if (cf.floating_feature instanceof Selectable) {
          const selectable = cf.floating_feature;
          if (log_it) {
            console.log(selectable_hash[selectable.the_key] === undefined);
          }
          selectable_types[selectable.the_key] = selectable.type;
          const count = this.value(selectable.count, { obj: char, source_id: cf.source_true_id });
          if ((selectable.type === "Spell" || selectable.type === "Item") && count > 1) {
            if (!selectable_hash[selectable.the_key]) {
              selectable_hash[selectable.the_key] = [];
            }
            if (log_it) {
              console.log(...selectable_hash[selectable.the_key]);
            }
            selectable_hash[selectable.the_key].push(...(cf.feature_options));
          } else {
            if (cf.feature_options[0] === "" && selectable.options.length === 1) {
              cf.feature_options[0] = selectable.options[0];
            }
            if (cf.feature_options[0] !== "") {
              if (!selectable_hash[selectable.the_key]) {
                selectable_hash[selectable.the_key] = [];
              }
              if (log_it) {
                console.log(...selectable_hash[selectable.the_key]);
              }
              selectable_hash[selectable.the_key].push(...(cf.feature_options));
              if (selectable.show_in_source_name && !cfs.name_bonuses.includes(cf.feature_options[0])) {
                switch (selectable.type) {
                  // case "Ability Score": break;
                  // case "Damage Type": break;
                  // case "School of Magic": break;
                  // case "Dragon Type": break;
                  // case "Dragon Breed": break;
                  // case "Strings": break;
                  case "Spell List": 
                    const sl = data_util.spell_lists.find(o => o._id === cf.feature_options[0]);
                    if (sl) {
                      cfs.name_bonuses.push(sl.use_name);
                    } else {
                      cfs.name_bonuses.push(cf.feature_options[0]);
                    }
                  break;
                  case "Race": 
                    const r = data_util.races.find(o => o._id === cf.feature_options[0]);
                    if (r) {
                      cfs.name_bonuses.push(r.use_name);
                    } else {
                      cfs.name_bonuses.push(cf.feature_options[0]);
                    }
                  break;
                  default: cfs.name_bonuses.push(cf.feature_options[0]); break;
                }
              }
            }
          }
        }
      }
    }
    // log_it = false;
    const sf_cfbs = use_features.filter(o => o.features.filter(o2 => o2.floating_feature instanceof SFFeature && o2.floating_feature.show_in_source_name).length > 0);
    
    for (const cfb of sf_cfbs) {
      if (log_it) {
        console.log(cfb);
      }
      const sf_cfs = cfb.features.filter(o => o.floating_feature instanceof SFFeature && o.floating_feature.show_in_source_name);
      for (const cf of sf_cfs) {
        // Get it and attach it
        if (log_it) {
          console.log(cf);
        }
        if (cf.floating_feature instanceof SFFeature) {
          for (const fo of cf.feature_options) {
            if (fo instanceof CharacterSpecialFeature && fo.source) {
              cfs.name_bonuses.push(fo.name);
            }
          }
        }
      }
    }
    const pb_cfbs = use_features.filter(o => o.features.find(o2 => o2.floating_feature instanceof PactBoonFeature));
    
    for (const cfb of pb_cfbs) {
      if (log_it) {
        console.log(cfb);
      }
      const pb_cfs = cfb.features.filter(o => o.floating_feature instanceof PactBoonFeature);
      for (const cf of pb_cfs) {
        // Get it and attach it
        if (log_it) {
          console.log(cf);
        }
        if (cf.floating_feature instanceof PactBoonFeature) {
          const fo = cf.feature_options[0];
          if (fo instanceof CharacterPactBoon && fo.source) {
            cfs.replace_name = fo.source.class_name_replacement;
          }
        }
      }
    }
    // log_it = source instanceof CharacterClass && source.name.includes("lock");
    if (log_it) {
      console.log(use_features);
      // debugger;
    }
    // if (selectable_cfbs.length > 0) {
    //   debugger;
    // }
    cfs.selectable_hash = selectable_hash;
    cfs.selectable_types = selectable_types;
    // Go through use_features to add in subs
    const sub_source_ids: string[] = [];
    const sub_source_cfbs = use_features.filter(o => o.features.filter(o2 => this.isSourceFeature(o2)).length > 0);
    
    for (const cfb of sub_source_cfbs) {
      // log_it = cfb.level === 8; // cfb.name.includes("Bard");
      if (log_it) {
        console.log(cfb);
        // debugger;
      }
      const sub_source_cfs = cfb.features.filter(o => this.isSourceFeature(o));
      for (const cf of sub_source_cfs) {
        // log_it = cf.name.includes("Invocation");
        // Get it and attach it
        if (log_it) {
          console.log(cf);
          const name = cf.name;
          console.log(name);
          // debugger;
          // "b24f9ae1-e94b-4696-b0a5-25bd9fbc6d4e"
          // "29e77aea-67d5-4f37-a5e2-12d95d3d496f"
        }
        if (cf.floating_feature instanceof FeatFeature) {
          const ff = cf.floating_feature;
          // debugger;
          if (log_it) {
            debugger;
          }
          let rebuild = false;
          try {
            if (cf.feature_options.length === 0 || 
              cf.feature_options.filter(o => 
                o instanceof CharacterFeat &&
                (o.source_id === "" || 
                  data_util.feats.filter(o2 => o2._id === o.source_id).length === 0
                )
              ).length > 0) {
              rebuild = true;
            }
          } catch (ex) { }
          if (rebuild) {
            cf.feature_options = [];
            const copyMe = cf.feature;
            const char_feat_ids = char.spirit.feats.filter(o => o.source_id !== "").map(o => { return o.source_id; });
            const char_feat_group_ids = data_util.feats.filter(o => char_feat_ids.includes(o._id)).map(o => o.variant_group_id);
            // Get the feats from this list that they already have.
            // If they already have all but 1
            // then auto-choose it.  Otherwise leave it blank.
            // ff.feat_ids might be outdated.
            const feat_group_ids = common_util.unique_array(data_util.feats.filter(o => common_util.anyOverlaps(o.variant_ids,ff.feat_ids)).map(o => o.variant_group_id));
            const feats_finder = 
              feat_group_ids.filter(id => 
                char_feat_group_ids.filter(o => o === id).length === 0);
            // if ((feats_finder.length !== 1 || feats_finder.includes("Any")) && 
            //   char.c_options.use_suggestions && ff.suggested !== "") {
            //   feats_finder = [ff.suggested];
            // }
            if (log_it) {
              console.log(feats_finder);
            }
            const auto_choose = feats_finder.length === 1 && feats_finder[0] !== "Any";
            if (log_it) {
              console.log(copyMe);
              console.log(ff);
              console.log(cf.feature_options.length);
              console.log(cf.feature_options);
              console.log(feats_finder);
              console.log(auto_choose);
            }
            const char_feat = new CharacterFeat();
            if (auto_choose) {
              const id = feats_finder[0];
              let objFinder = data_util.feats.filter(o => o.variant_group_id === id);
              if (objFinder.length > 1) {
                const dom = data_util.getDominant(objFinder);
                if (dom) {
                  objFinder = [dom];
                }
              }
              let feat: FeatureSource | null = null;
              if (objFinder.length === 1) {
                feat = objFinder[0];
                await data_util.loadObject(feat);
                await char_feat.copy_source({ char, feature_source: feat, parent_cf: cf, parent_cfb: cfb });
                // char.feat_ids.push(id);
              }
              char_feat.feat_source_id = cfs.source_id;
              char_feat.feat_source_name = cfs.name;
              char_feat.feat_source_type = cfs.source_type;
            }
            cf.feature_options.push(char_feat);
            if (log_it) {
              console.log(cf.feature_options.length);
              console.log(cf.feature_options);
            }
          }
        } else if (cf.floating_feature instanceof SubclassFeature && cf.floating_feature.level === 1 &&
          cfs instanceof CharacterClass && cfs.subclass_id === "" && cf.floating_feature.suggested !== "") {
          const suggested = cf.floating_feature.suggested;
          const subclass = data_util.subclasses.filter(o => o._id === suggested)[0];
          if (subclass) {
            if (cf.feature_options.length > 1) {
              cf.feature_options = [];
            }
            cf.feature_options[0] = await this.copySubCharFeatureSource(char, cfs, cf, cfb, subclass);
            if (log_it) {
              console.log(cf.feature_options.length);
              console.log(cf.feature_options);
            }
          }
        } else if (cf.floating_feature instanceof EldritchInvocationsFeature) {
          const new_feature_options: CharacterEldritchInvocation[] = [];
          const ei_ff = cf.floating_feature;
          const count = this.value(ei_ff.count, { obj: char, source_id: cf.source_true_id, item_id: cf.item_id });
          const eis = await data_util.getEldritchInvocations();
          for (let i = 0; i < count; ++i) {
            if (cf.feature_options[i]) {
              if (!(cf.feature_options[i] instanceof CharacterEldritchInvocation)) {
                cf.feature_options[i] = new CharacterEldritchInvocation(cf.feature_options[i]);
              }
              const opt = cf.feature_options[i] as CharacterEldritchInvocation;
              if (opt.source_id !== "") {
                const obj_finder2 = eis.find(o => o._id === opt.source_id);
                if (obj_finder2) {
                  const ei = obj_finder2;
                  await data_util.loadObject(ei);
                  await opt.copy_source({ char, feature_source: ei, parent_cf: cf, item_id: cf.use_item_id });
                }
              }
              new_feature_options.push(opt);
            } else {
              new_feature_options.push(new CharacterEldritchInvocation());
            }
          }
          cf.feature_options = new_feature_options;
        } else if (cf.feature_type === "Fighting Style") {
        } else if (cf.floating_feature instanceof SFFeature) {
          const sff = cf.floating_feature;
          // if (sff.name.includes("Draconic Affi")) {
          //   console.log(sff);
          //   console.log(cf);
          // }
          const count = this.value(sff.count, { obj: char, source_id: cf.source_true_id, root_id: cf.root_id, item_id: cf.item_id });
          if (cf.feature_options.length === 0) {
            if (count === sff.special_feature_ids.length) {
              for (let i = 0; i < count; i++) {
                const csf = new CharacterSpecialFeature();
                csf.source_source_id = cf.root_id === "" ? cf.source_id : cf.root_id;
                const sf = data_util.all_feature_sources.find(o => o._id === sff.special_feature_ids[i]);
                if (sf) {
                  await data_util.loadObject(sf);
                  await csf.copy_source({ char, feature_source: sf, parent_cf: cf, item_id: cf.item_id });
                }
                cf.feature_options.push(csf);
              }
            } else {
              for (let i = 0; i < count; i++) {
                const csf = new CharacterSpecialFeature();
                csf.source_source_id = cf.root_id === "" ? cf.source_id : cf.root_id;
                // Should be sourceless at this point
                // csf.connect_source(char, copyMe, all_feature_sources);
                cf.feature_options.push(csf);
              }
            }
          } else {
            while (cf.feature_options.length > count) {
              cf.feature_options.splice(-1, 1);
            }
            for (let i = 0; i < count; i++) {
              if (!(cf.feature_options[i] instanceof CharacterSpecialFeature)) {
                cf.feature_options[i] = new CharacterSpecialFeature(cf.feature_options[i]);
              }
              const csf = cf.feature_options[i];
              if (csf instanceof CharacterSpecialFeature) {
                csf.source_source_id = cf.root_id === "" ? cf.source_id : cf.root_id;
                if (csf.source_id !== "" && csf.source === null) {
                  const sf = data_util.all_feature_sources.find(o => o._id === csf.source_id);
                  if (sf) {
                    await data_util.loadObject(sf);
                    await csf.copy_source({ char, feature_source: sf, parent_cf: cf, item_id: cf.item_id });
                  }
                }
              } else {
                console.error(csf);
                console.error(cf.feature_options);
                debugger;
              }
            }
          }
        }
        for (const fo of cf.feature_options) {
          let sub = fo;
          if (sub instanceof CharacterASIBaseFeature) {
            if (sub.feat instanceof CharacterFeatureSource) {
              sub = sub.feat;
            }
          }
          if (sub instanceof CharacterFeatureSource) { 
            if (!sub.source) {
              const feature_source = data_util.all_feature_sources.find(o => o._id === sub.source_id);
              if (feature_source) {
                await data_util.loadObject(feature_source);
                await sub.copy_source({ char, feature_source, parent_cf: cf, parent_cfb: cfb });
                sub.parent_feature_base_level = cfb.sort_level;
              }
            }
            sub.parent_feature_id = cf.true_id;
            sub.parent_feature_base_id = cfb.true_id;
            sub.parent_feature_base_level = cfb.level > cfs.parent_feature_base_level ? cfb.level : cfs.parent_feature_base_level;
            sub_source_ids.push(sub.true_id);
            if (log_it) {
              console.log(sub);
              console.log(cfs.sub_char_feature_sources.length);
              console.log(cfs.sub_char_feature_sources);
              console.log(cfs.sub_char_feature_sources.filter(o => o.true_id === sub.true_id));
            }
            if (cfs.sub_char_feature_sources.filter(o => o.true_id === sub.true_id).length === 0) {
              cfs.sub_char_feature_sources.push(sub);
            }
            for (const cfb of sub.char_feature_bases.filter(o => o.level < sub.parent_feature_base_level)) {
              // if (cfb.name === "Reaper") {
              //   console.log(cfb);
              //   debugger;
              // }
              cfb.parent_feature_base_level = sub.parent_feature_base_level;
              // if (cfb.name === "Reaper") {
              //   console.log(cfb.parent_feature_base_level);
              // }
            }
            // if (sub.name.includes("Death")) {
            //   console.log(sub.char_feature_bases.filter(o => o.name === "Reaper").map(o => o.parent_feature_base_level));
            //   if (source instanceof CharacterClass && source.char_subclass) {
            //     const sub2 = source.char_subclass;
            //     if (sub2.name.includes("Death")) {
            //       console.log(sub2.char_feature_bases.filter(o => o.name === "Reaper").map(o => o.parent_feature_base_level));
            //     }
            //   }
            // }
          }
        }
        // if (source instanceof CharacterClass && source.char_subclass) {
        //   const sub = source.char_subclass;
        //   if (sub.name.includes("Death")) {
        //     console.log(sub.char_feature_bases.filter(o => o.name === "Reaper").map(o => o.parent_feature_base_level));
        //   }
        // }
      }
      // if (source instanceof CharacterClass && source.char_subclass) {
      //   const sub = source.char_subclass;
      //   if (sub.name.includes("Death")) {
      //     console.log(sub.char_feature_bases.filter(o => o.name === "Reaper").map(o => o.parent_feature_base_level));
      //   }
      // }
    }
    // if (source instanceof CharacterClass && source.char_subclass) {
    //   const sub = source.char_subclass;
    //   if (sub.name.includes("Death")) {
    //     console.log(sub.char_feature_bases.filter(o => o.name === "Reaper").map(o => o.parent_feature_base_level));
    //   }
    // }
    if (log_it) {
      console.log(cfs.sub_char_feature_sources);
    }
    let removing_subs = cfs.sub_char_feature_sources.filter(o => 
      !sub_source_ids.includes(o.true_id) && 
      !(o instanceof CharacterMagicItemKeyword) && 
      // !(o instanceof CharacterWeaponMastery) && 
      // !(o instanceof CharacterMagicItem) && 
      !(o instanceof CharacterBaseItem)
    ).map(o => o.source_id);
    if (cfs instanceof CharacterRace) {
      removing_subs = removing_subs.filter(o => o !== cfs.subrace_id);
    }
    if (log_it) {
      console.log(removing_subs);
    }
    cfs.sub_char_feature_sources = cfs.sub_char_feature_sources.filter(o => !removing_subs.includes(o.source_id));
    // while (removing_subs.length > 0) {
    //   const removing_sub = removing_subs[0];
    //   source.sub_char_feature_sources = source.sub_char_feature_sources.filter(o => o.source_id !== removing_sub);
    //   removing_subs.splice(0, 1);
    // }
    if (log_it) {
      // debugger;
    }
    if (cfs instanceof CharacterStandardFeatures) {
      // source.char_feature_bases = use_features;
    } else {
      // Then add in the features for the source up to the appropriate level
      char.mind.char_feature_bases = [...char.mind.char_feature_bases, ...use_features];
      if (log_it) {
        console.log(cfs.name);
        console.log(use_features);
        console.log(cfs.sub_char_feature_sources);
        // console.log(char.mind.char_feature_bases.filter(o => 
        //   o.true_id === source.source_id || 
        //   o.source_id === source.source_id));
        console.log(char.mind.char_feature_bases.filter(o => 
          o.source_true_id === cfs.true_id || 
          o.attached_source_true_id === cfs.true_id
        ));
      }
      for (const sub_cfs of cfs.sub_char_feature_sources) {
        // I need to get the optional features
        if (cfs instanceof CharacterClass && 
          sub_cfs instanceof CharacterSubclass) {
          if (sub_cfs.source) {
            if (sub_cfs.source.use_subclass_levels) {
              sub_cfs.level = cfs.subclass_level;
            } else {
              sub_cfs.level = cfs.level;
            }
          }
          if (sub_cfs.source && sub_cfs.source.use_subclass_levels) {
            const need_true_levels = sub_cfs.all_char_feature_bases.filter(o => o.true_level === -1);
            if (need_true_levels.length > 0) {
              const sub_source_cfbs = cfs.char_feature_bases.filter(o => o.features.filter(o2 => o2.floating_feature instanceof SubclassFeature).length > 0);
              for (const sub_source_cfb of sub_source_cfbs) {
                const subclass_level = sub_source_cfb.features.filter(o => o.floating_feature instanceof SubclassFeature).map(o => {
                  return (o.floating_feature as SubclassFeature).level;
                })[0];
                if (subclass_level !== undefined) {
                  const level = sub_source_cfb.sort_level;
                  const need_this_level = need_true_levels.filter(o => o.level === subclass_level);
                  for (const need_it of need_this_level) {
                    need_it.true_level = level;
                  }
                }
              }
            }
          }
        }
        if (log_it) {
          console.log(sub_cfs);
          // debugger;
        }
        // It should NOT be using char_feature here.  
        // It should be getting the cf that is the parent for the scfs and passing it
        if (sub_cfs.parent_feature_base_id !== "" && sub_cfs.parent_feature_id !== "") {
          const cfb = cfs.all_char_feature_bases.find(o => o.true_id === sub_cfs.parent_feature_base_id);
          if (cfb) {
            const cf = cfb.features.find(o => o.true_id === sub_cfs.parent_feature_id);
            sub_cfs.parent_cfb = cfb;
            sub_cfs.parent_cf = cf;
          }
        }
        if (!char.mind.char_feature_sources.some(o => o.true_id === sub_cfs.true_id)) {
          char.mind.char_feature_sources.push(sub_cfs);
        }
        // await this.repopulateCharFeatureBasesFor(char, sub_cfs, cf, log_it);
      }
      // if (log_it) {
      //   console.log(char.char_feature_sources.filter(o => 
      //     o.name.includes("Improvement")));
      // }
    }
  }

  repopulateCharFeatureBasesForItems = async (char: Character) => {
    char.mind.char_feature_bases = char.mind.char_feature_bases.filter(o => 
      !o.source_type.includes("Item"));
    // Make sure attuned and equipped items still exist.
    // Hopefully will be unnecessary someday.
    let i = 0; 
    while (i < char.inventory.attuned_items.length) {
      const attuned_item = char.inventory.attuned_items[i];
      const item_finder = char.inventory.items.filter(o => o.true_id === attuned_item.true_id);
      if (item_finder.length === 0) {
        item_finder[0].attuned = false;
      } else {
        ++i;
      }
    }
    i = 0; 
    while (i < char.inventory.equipped_items.length) {
      const equipped_item = char.inventory.equipped_items[i];
      const item_finder = char.inventory.items.filter(o => o.true_id === equipped_item.true_id);
      if (item_finder.length === 0) {
        item_finder[0].equipped = false;
      } else {
        ++i;
      }
    }
    // Remove cmiks that are from iaas that they don't have anymore
    for (const char_item of char.inventory.items) {
      const remove_us: string[] = [];
      for (const cmik of char_item.char_magic_item_keywords.filter(o => o.char_feature_id !== "")) {
      
        // It needs to search through all current cfb's to find the cf_id
        const cfb_with_cf_id = char.mind.char_feature_bases.find(o => o.features.find(o2 => o2.true_id === cmik.char_feature_id));
        if (!cfb_with_cf_id) {
          // The source has been removed, so remove the cmik
          remove_us.push(cmik.true_id);
        }
      }
      
      char_item.sub_char_feature_sources = char_item.sub_char_feature_sources.filter(o => 
        !remove_us.includes(o.true_id)
      );
      char_item.char_feature_bases = char_item.char_feature_bases.filter(o => 
        !remove_us.includes(o.source_true_id) // && !remove_us.includes(o.attached_source_true_id)
      );
    }
    // debugger;
    for (const char_item of char.inventory.equipped_items) {
      // if (char_item.name.includes("Plate")) {
      //   debugger;
      // }
      for (const cfb of char_item.all_char_feature_bases) {
        cfb.item_id = char_item.true_id;
        cfb.item_name = char_item.get_use_name();
        for (const cf of cfb.features) {
          cf.item_id = char_item.true_id;
          cf.item_name = char_item.get_use_name();
        }
      }
      if (!char_item.attunement || char_item.attuned) {
        await this.repopulateCharFeatureBasesFor(char, char_item, undefined); // , char_item.name.includes("Shortb"));
      }
    }
  }

  // I should make it remove based on source_true_id
  removeCharFeatureBasesFor(char: Character | ComplexCreatureInstance, cfs: CharacterFeatureSource | Summon, log_it = false) {
    // log_it = cfs.name.includes("Bard");
    if (log_it) {
      console.log("Removing");
      console.log(char.mind.char_feature_bases.filter(o => 
        o.ancestries.filter(o2 => o2.true_id === cfs.true_id).length > 0));
      // debugger;
    }
    if (cfs instanceof CharacterFeatureSource) {
      char.mind.char_feature_bases = char.mind.char_feature_bases.filter(o => 
        o.ancestries.filter(o2 => o2.true_id === cfs.true_id).length === 0);
      for (let i = 0; i < cfs.sub_char_feature_sources.length; ++i) {
        const child = cfs.sub_char_feature_sources[i];
        this.removeCharFeatureBasesFor(char, child);
      }
    } else if (cfs instanceof Summon) {
      char.mind.char_feature_bases = char.mind.char_feature_bases.filter(o => o.source_type !== "Summon");
    }
  }

  // removeCharFeatureBasesForCCI(char: ComplexCreatureInstance, log_it = false) {
  //   // log_it = cfs.name.includes("Bard");
  //   if (log_it) {
  //     console.log("Removing");
  //     console.log(char.mind.char_feature_bases);
  //     // debugger;
  //   }
  //   char.mind.char_feature_bases = char.mind.char_feature_bases.filter(o => 
  //     !o.ancestries.some(o2 => 
  //       o2.type === "creature" || 
  //       // o2.type === "creature_gift" || 
  //       o2.type === "transform"
  //   ));
  // }

  removeCharFeatureBasesForConditions(char: Character) {
    char.mind.char_feature_bases = char.mind.char_feature_bases.filter(o => 
      o.source_type !== "Condition");
    if (char.spirit.transform) {
      char.spirit.transform.char_feature_bases = []; // TransformInstance only gets these from conditions
    }
  }

  newCharacterFeatureSource(obj: any) {
    let cfs = new CharacterFeatureSource(obj);
    switch(cfs.source_type) {
      case "Feat": 
        cfs = new CharacterFeat(obj); 
        console.log(obj);
        console.log(cfs);
      break;
      case "Subclass": cfs = new CharacterSubclass(obj); break;
      case "Subrace": cfs = new CharacterSubrace(obj); break;
      case "Fighting Style": cfs = new CharacterFightingStyle(obj); break;
      case "Pact Boon": cfs = new CharacterPactBoon(obj); break;
      case "Eldritch Invocation": cfs = new CharacterEldritchInvocation(obj); break;
      case "Special Feature": cfs = new CharacterSpecialFeature(obj); break;
      default: console.log(obj); break;
    }
    return cfs;
  }

  isSourceFeature(cf: CharacterFeature) {
    if (cf.feature_type === "Ability Score Improvement") {
      const asi_feature = cf.feature_options[0] as CharacterASIBaseFeature;
      // console.log(asi_feature);
      // console.log(asi_feature.feat);
      // console.log(asi_feature.feat.source_id);
      if (asi_feature.feat && asi_feature.feat.source_id !== "") {
        return true;
      }
    } else if (cf.feature_type === "Feat" || 
      cf.feature_type === "Eldritch Invocations" ||
      cf.feature_type === "Fighting Style" || 
      cf.feature_type === "Pact Boon" || 
      // cf.feature_type === "Subclass" || 
      cf.feature_type === "Subrace" || 
      (cf.feature_type !== "Special Feature List Merge" && cf.feature_type.includes("Special Feature"))) {
      return true;
    } else if (cf.floating_feature instanceof SubclassFeature && cf.floating_feature.level === 1) {
      return true;
    }
    return false;
  }

  enforceReplacementKeys(char: Character) {
    // Go through all the cfbs with replacement_key !== ""
    // There should either be a single cfb with each key, or two, 
    // with one that has replace_key === true (aka replacers).  
    // We also add the replacer cfbs to the cfs of the replaced
    // We should start with the replacers.
    // Then for each of them remove their corresponding replaced.
    // and set the replacers to pseudo use the source of their replaced.
    // This is done by adding them to the cfs of the replaced (if not already there), 
    // and setting their replaces_cfb_on_source_id (etc) with the ones from the replaced
    const replacer_cfbs = char.mind.char_feature_bases.filter(o => o.replace_key);
    // console.log(replacer_cfbs);
    // debugger;
    for (const replacer of replacer_cfbs) {
      // Find their replaced
      const replaced = char.mind.char_feature_bases.find(o => o.replacement_key === replacer.replacement_key && !o.replace_key);
      if (replaced) {
        replacer.replaces_cfb_on_source_id = replaced.source_id;
        replacer.replaces_cfb_on_source_name = replaced.source_name;
        replacer.replaces_cfb_on_source_type = replaced.source_type;
        replacer.replaces_cfb_on_item_id = replaced.item_id;
        replacer.replaces_cfb_on_item_name = replaced.item_name;
        replacer.item_id = replaced.item_id;
        replacer.item_name = replaced.item_name;
        replacer._source_true_id = replaced.source_true_id;
        replacer.features.forEach(cf => {
          cf.source_true_id = replaced.source_true_id;
          cf.replaces_cfb_on_source_id = replaced.source_id;
          cf.replaces_cfb_on_source_name = replaced.source_name;
          cf.replaces_cfb_on_source_type = replaced.source_type;
          cf.replaces_cfb_on_item_id = replaced.item_id;
          cf.replaces_cfb_on_item_name = replaced.item_name;
        });
        char.mind.char_feature_bases = char.mind.char_feature_bases.filter(o => o.true_id !== replaced.true_id);

        const cfs_finder = char.char_feature_sources.filter(o => o.source_id === replacer.replaces_cfb_on_source_id);
        if (cfs_finder.length === 1) {
          const cfs = cfs_finder[0];
          if (cfs.char_feature_bases.filter(o => o.true_id === replacer.true_id).length === 0) {
            cfs.char_feature_bases.push(replacer);
          }
        }
      }
    }
  }

  hasCondition(char_int: Character, required_condition_ids: string[], condition_level: number) {
    const char_conds = char_int.spirit.conditions.filter(o => required_condition_ids.includes(o.source_id));
    const char_cond_levels = char_conds.map(o => o.level);
    const max_level = Math.max(...char_cond_levels,0);
    if (max_level >= condition_level) {
      return true;
    } else {
      const required_alternates = required_condition_ids.map(o => {
        const alternate_condition_feature = char_int.mind.alternate_condition_features.find(o2 => o2.original_condition_id === o);
        if (alternate_condition_feature) {
          return { id: alternate_condition_feature.alternate_condition_id, multiplier: alternate_condition_feature.equivalent_level_multiplier }; 
        } else {
          return { id: o, multiplier: 1 };
        }
      });
      for (const req_alt of required_alternates) {
        const char_cond = char_int.spirit.conditions.find(o => req_alt.id === o.source_id);
        if (char_cond && char_cond.level * req_alt.multiplier >= condition_level) {
          return true;
        }
      }
    }
    return false;
  }

  getConditionLevel(char_int: Character, condition_id: string) {
    let char_cond = char_int.spirit.conditions.find(o => o.source_id === condition_id);
    if (char_cond) {
      return char_cond.level;
    } else {
      const alternate_condition_feature = char_int.mind.alternate_condition_features.find(o2 => 
        o2.original_condition_id === condition_id);
      if (alternate_condition_feature) {
        const use_cond_id = alternate_condition_feature.alternate_condition_id;
        char_cond = char_int.spirit.conditions.find(o => o.source_id === use_cond_id);
        // const alternate_condition = char_int.condition_hash[alternate_condition_feature.alternate_condition_id];
        if (char_cond) {
          return Math.floor(char_cond.level * alternate_condition_feature.equivalent_level_multiplier);
        }
      }
    }
    return 0;
  }

  // I need to make it put all the cfs from cfbs into char.mind.features
  // And then go from char.mind.features into the others.
  repopulateCharFeatures = async (char_int: CharacterSheetInterface, char: Character) => {
    char_int.mind.features = [];
    const cf_true_ids: string[] = [];
    if (char_int instanceof Character) {
      this.enforceReplacementKeys(char_int);
    }
    char_int.mind.alternate_condition_features = [];
    const alternate_condition_cfbs = char_int instanceof Character ? char_int.mind.char_feature_bases.filter(o => 
      o.feature_base && (!o.replace_key || o.replaces_cfb_on_source_id !== "") &&
      o.features.filter(o2 => o2.feature_type === "Alternate Condition").length > 0
    ) : char_int.mind.char_feature_bases.filter(o => o.features.filter(o2 => o2.feature_type === "Alternate Condition").length > 0);
    for (const cfb of alternate_condition_cfbs) {
      for (const cf of cfb.features) {
        if (cf.feature_type === "Alternate Condition") {
          if (cf.floating_feature instanceof AlternateConditionFeature) {
            char_int.mind.alternate_condition_features.push(cf.floating_feature);
          }
        }
      }
    }
    // console.log(char_int.char_feature_bases.find(o => o.name.includes("Natural Weapons")));
    const cfbs = char_int instanceof Character ? char_int.mind.char_feature_bases.filter(o => o.feature_base &&
      (o.required_condition_ids.length === 0 || 
        (this.hasCondition(char_int, o.required_condition_ids, o.condition_level) !== o.exclude_conditions)
      ) && 
      (o.min_spell_slot_level <= char_int.body.max_slot_level) &&
      (!o.replace_key || o.replaces_cfb_on_source_id !== "")
    ) : char_int.mind.char_feature_bases;
    // console.log(cfbs.filter(o => o.name.includes(log_find_string)));
    for (const cfb of cfbs) {
      for (const cf of cfb.features) {
        if (!cf_true_ids.includes(cf.true_id)) {
          // if (cf.name.includes("Cunning")) {
          //   debugger;
          // }
          cf_true_ids.push(cf.true_id);
          char_int.mind.features.push(cf);
        }
      }
    }
    if (char_int instanceof ComplexCreatureInstance && char_int.summon_instance) {
      char_int.mind.features.push(...char_int.summon_instance.traits);
      char_int.mind.features.push(...char_int.summon_instance.action_cfs);
      char_int.mind.features.push(...char_int.summon_instance.legendary_actions);
      char_int.mind.features.push(...char_int.summon_instance.lair_actions);
    } 
    // console.log(char_int.features.filter(o => o.name.includes(log_find_string)));
    if (char_int instanceof Character && char_int.spirit.sidekick && char_int.spirit.sidekick_creature) {
      await this.applyCreatureToSidekick(char_int);
    }
    await this.repopulateTypedCharFeatures(char_int, char);
  }
  repopulateTypedCharFeatures = async (char_int: CharacterSheetInterface, char: Character) => {
    console.log("repopulateTypedCharFeatures()");
    if (char_int instanceof Character) {
      char_int.mind.summon_upgrade_features = [];
      char_int.mind.characteristic_feature_source_names = [];
      char_int.mind.show_extra_conditions = [...char_int.c_options.show_extra_conditions];
      // this.recalc_source_features(char);
      // this.recalc_sources(char);
      char_int.mind.special_feat_accesses = [];
      char_int.mind.action_type_upgrades = [];
      char_int.mind.knowledge_features = [];
      char_int.char_feature_sources.forEach(cfs => {
        cfs.suggested_spells = [];
      });
      char_int.mind.spell_damage_options = [];
    } else {
      // debugger;
    }
    if (!(char_int instanceof Character) || !char_int.spirit.sidekick) {
      char_int.mind.extra_attacks = 0;
    }
    char_int.mind.resource_features = [];
    char_int.mind.ability_features = [];
    char_int.mind.characteristic_features = [];
    char_int.mind.transform_upgrades = [];
    char_int.mind.asi_features = [];
    char_int.mind.proficiency_features = [];
    char_int.mind.spell_modifier_features = [];
    char_int.mind.disable_action_features = [];
    char_int.mind.modifier_features = [];
    char_int.mind.language_features = [];
    char_int.mind.sense_features = [];
    char_int.mind.rerolls = [];
    char_int.mind.minimum_rolls = [];
    char_int.mind.advantages = [];
    // char.source_features = [];
    char_int.mind.misc_features = [];
    char_int.mind.spellcasting_features = [];
    char_int.mind.start_equipment_features = [];
    char_int.mind.attack_upgrades = [];
    char_int.mind.weapon_damage_upgrades = [];
    // char_int.mind.extra_effects = [];
    char_int.mind.extra_effects_features = [];
    // char_int.mind.bonus_action_attacks = [];
    char_int.mind.light_attack_add_damage_mods = [];
    char_int.mind.skill_ability_overrides = [];
    char_int.mind.ignore_stealth_disadvantage_for_armor_type_ids = [];
    char_int.mind.greater_advantages = [];
    char_int.mind.size_option_features = [];
    char_int.mind.size_options = [];
    if (char_int instanceof Character) {
      char_int.mind.limit_spoof_features = [];
      char_int.mind.rest_alteration_features = [];
    } else if (char_int instanceof TransformInstance && char_int.spirit.transform) {
      // const transform = char_int.spirit.transform;
      // if (transform.size.use_options && transform.size.options) {
      //   // Transform presents options
      //   if (transform.size.options.length > 0) {
      //     char_int.size_options.push(...transform.size.options as SizeType[]);
      //   } 
      // } else if (transform.size.overridable) {
      //   const creature = char_int.creature;
      //   const new_size = this.applyOverridableNumber(char, transform.size.overridable, char.base_size, creature ? creature.size_num : 0);
      //   if (new_size > 0 && new_size < 7) {
      //     char_int.size_options.push(new_size as SizeType);
      //   }
      // }
    }
    for (const cf of char_int.mind.features) {
      const feature_type = cf.feature_type;
      // if (cf.name.includes(log_find_string)) {
      //   console.log(cf);
      // }
      if (feature_type.includes("Proficienc") || 
        ["Expertise","Jack of All Trades"].includes(feature_type)) {
        char_int.mind.proficiency_features.push(cf);
      } else if (feature_type.includes("Modifier")) {
        if (feature_type === "Spell Modifier") {
          char_int.mind.spell_modifier_features.push(cf);
        } else if (cf.floating_feature instanceof Modifier && 
          ["Ability Score Max","Ability Score"].includes(cf.floating_feature.modifies)) {
          char_int.mind.asi_features.push(cf);
        } else if (feature_type === "Spellbook Modifier") {
          char_int.mind.spellcasting_features.push(cf);
        } else {
          char_int.mind.modifier_features.push(cf);
        }
      } else if (feature_type.includes("Language")) {
        char_int.mind.language_features.push(cf);
      } else if (feature_type === "Ability Score Improvement") {
        const asi_feature = cf.feature_options[0] as CharacterASIBaseFeature;
        if (asi_feature.feat.source_id === "") {
          char_int.mind.asi_features.push(cf);
        }
      } else if (feature_type === "Creature Type") {
        char_int.mind.misc_features.push(cf);
      } else if (feature_type === "Sense") {
        char_int.mind.sense_features.push(cf);
      } else if (feature_type === "Reroll") {
        if (cf.floating_feature instanceof Reroll) {
          char_int.mind.rerolls.push(cf.floating_feature);
        }
      } else if (feature_type === "Minimum Roll") {
        if (cf.floating_feature instanceof MinimumRoll) {
          char_int.mind.minimum_rolls.push(cf.floating_feature);
        }
      } else if (feature_type === "Advantage") {
        if (cf.floating_feature instanceof Advantage) {
          char_int.mind.advantages.push({
            true_id: uuidv4().toString(),
            advantage: cf.floating_feature as Advantage,
            source_id: cf.root_id,
            source_type: cf.root_type,
            source_name: cf.root_name,
            cfb_id: cf.cfb_id,
            cfb_name: cf.cfb_name,
          });
        }
      } else if (["Damage Multiplier",
        "Extra Attacks",
        "Special Feature List Merge",
        "Extra IAA Slots"].includes(feature_type)) {
        // console.log(cf);
        char_int.mind.misc_features.push(cf);
      } else if (["Feat",
        "Eldritch Invocation",
        "Eldritch Invocations",
        "Fighting Style",
        "Pact Boon","Selectable"].includes(feature_type) || 
        feature_type.includes("Special Feature")) {
        // Handled previously
      } else if (["Spellcasting","Bonus Spells","Bonus Spells Upgrade",
        "Extra Spell Lists","Spells","Spellbook",
        "Ritual Casting","Cantrips","Mystic Arcanum",
        "Spell Mastery"].includes(feature_type)) {
        char_int.mind.spellcasting_features.push(cf);
      } else if (feature_type === "Subclass") {
        // Doesn't need to be handled
      } else if (feature_type === "Subrace") {
        // Doesn't need to be handled
      } else if (feature_type === "Start Equipment") {
        char_int.mind.start_equipment_features.push(cf); 
      } else if (["Unarmed Strikes","Resource Refresh Rule Change",
        "Replace Ability Score for Attacks","Proficiency Override","Ignore Heavy Rule"].includes(feature_type)) {
        char_int.mind.misc_features.push(cf); 
        // Don't need to be further processed.  
        // This is just to make it easy to find them for start equipment in equipment page
      } else if (feature_type === "Spellcasting Focus") {
        // Doesn't need to be handled
      } else if (feature_type === "Condition") {
        // Handled Previously
      } else if (feature_type === "Alternate Condition") {
        // Handled Previously in repopulateCharFeatures
      } else if (feature_type === "Limit Spoof") {
        if (char_int instanceof Character) {
          char_int.mind.limit_spoof_features.push(cf);
        }
      } else if (feature_type === "Rest Alteration") {
        if (char_int instanceof Character) {
          char_int.mind.rest_alteration_features.push(cf);
        }
      } else if (feature_type === "Allowed Conditions") {
        if (cf.floating_feature instanceof StringsFeature) {
          char_int.mind.show_extra_conditions = [...char_int.mind.show_extra_conditions, ...cf.floating_feature.strings];
        }
      } else if (["Attack Upgrade",
        "Bonus Action Attack",
        "Weapon Keyword Upgrade",
        "Weapon Keyword Upgrade 2"].includes(feature_type)) {
        char_int.mind.attack_upgrades.push(cf); // .floating_feature as AttackUpgradeFeature);
      } else if (["Weapon Damage Upgrade"].includes(feature_type)) {
        // debugger;
        char_int.mind.weapon_damage_upgrades.push(cf); // .floating_feature as AttackUpgradeFeature);
      } else if (["Extra Effects","Extra Effect Type",
        "Extra Effects of Type"].includes(feature_type)) {
        // console.log(cf);
        char_int.mind.extra_effects_features.push(cf); // .floating_feature as AttackUpgradeFeature);
        // console.log(char_int.mind.extra_effects_features.map(o => o.clone()));
      } else if (feature_type === "Light Attack Add Damage Mod") {
        char_int.mind.light_attack_add_damage_mods.push(cf);
      } else if (["Ability",
        "Skill as Ability",
        "Spell as Ability",
        "Spell As Ability",
        "Extra Spell as Ability",
        "Item Affecting Ability",
        "Item Affecting Ability Type 2",
        "Creature Ability",
      ].includes(feature_type)) {
        char_int.mind.ability_features.push(cf);
      } else if (["Cantrips from List",
        "Spells from List",
        "Cantrips From List",
        "Spells From List"].includes(feature_type)) {
        char_int.mind.ability_features.push(cf);
      } else if (feature_type === "Suggested Spells") { 
        if (char_int instanceof Character && cf.floating_feature instanceof SuggestedSpells) {
          const source_finder = char_int.char_feature_sources.filter(o => o.true_id === cf.source_true_id);
          if (source_finder.length === 1) {
            const source = source_finder[0];
            source.suggested_spells.push(cf.floating_feature);
          }
        }
      } else if (feature_type === "Special Feat Access") { 
        if (char_int instanceof Character && cf.floating_feature instanceof StringFeature) {
          if (!char_int.mind.special_feat_accesses.includes(cf.floating_feature.str)) {
            char_int.mind.special_feat_accesses.push(cf.floating_feature.str);
          }
        }
      } else if (feature_type === "Action Type Upgrade") {
        if (char_int instanceof Character && cf.floating_feature instanceof ActionTypeUpgrade) {
          char_int.mind.action_type_upgrades.push(cf.floating_feature);
        }
      } else if (feature_type === "Ignore Stealth Disadvantage") {
        if (char_int instanceof Character && cf.floating_feature instanceof IgnoreStealthDisadvantage) {
          char_int.mind.ignore_stealth_disadvantage_for_armor_type_ids.push(...cf.floating_feature.armor_type_ids);
        }
      } else if (feature_type.includes("Characteristic")) {
        char_int.mind.characteristic_features.push(cf);
        if (char_int instanceof Character && cf.floating_feature instanceof CharacteristicFeature 
          && cf.floating_feature.show_in_source_name) {
          if (cf.floating_feature.replace_source_name) {
            const source = this.getCharFeatureSource(char_int, cf.use_source_id);
            if (source) {
              source.replace_name = cf.feature_options[0];
            }
          } else {
            const source = this.getCharFeatureSource(char_int, cf.use_source_id);
            if (source && !source.name_bonuses.includes(cf.feature_options[0])) {
              source.name_bonuses.push(cf.feature_options[0]);
            }
          }
        }
        if (char_int instanceof Character && !char_int.mind.characteristic_feature_source_names.includes(cf.source_name) && cf.item_id === "") {
          char_int.mind.characteristic_feature_source_names.push(cf.source_name);
        }
      } else if (feature_type === "Resource") {
        char_int.mind.resource_features.push(cf);
      } else if (feature_type === "Transform Upgrade") {
        char_int.mind.transform_upgrades.push(cf);
      } else if (feature_type === "Knowledge") {
        if (char_int instanceof Character) {
          char_int.mind.knowledge_features.push(cf);
        }
      } else if (feature_type === "Learnable") {
        if (char_int instanceof Character) {
          char_int.mind.learnable_features.push(cf);
        }
      } else if (feature_type === "Summon Upgrade") {
        if (char_int instanceof Character && cf.floating_feature instanceof SummonUpgradeFeature) {
          char_int.mind.summon_upgrade_features.push(cf);
        }
      } else if (feature_type === "Skill Ability Override") {
        if (cf.floating_feature instanceof SkillAbilityOverrideFeature) {
          char_int.mind.skill_ability_overrides.push(cf.floating_feature);
        }
      } else if (feature_type === "Spell Damage Options") {
        if (char_int instanceof Character) {
          char_int.mind.spell_damage_options.push(cf);
        }
      } else if (feature_type === "Size Options") {
        if (cf.floating_feature instanceof SizeOptions) {
          char_int.mind.size_option_features.push(cf.floating_feature);
        }
      } else if (feature_type === "Disable Actions") {
        char_int.mind.disable_action_features.push(cf);
      } else if (feature_type === "Weapon Mastery") {
        // Handled Previously
      } else if (feature_type === "Greater Advantage") {
        if (cf.floating_feature instanceof GreaterAdvantage) {
          char_int.mind.greater_advantages.push(cf.floating_feature);
        }
      } else if (feature_type === "Minion Extra Attacks") {
        if (char_int instanceof TransformInstance) {
          if (cf.floating_feature instanceof UpgradableNumberFeature) {
            char_int.mind.extra_attacks = cf.floating_feature.num.base;
          }
        }
      } else if (feature_type !== "") {
        console.log(cf);
      }
    }
      
    // Minions and Transforms need to be connected again after char.mind.features is populated and before we are processing them in doRecals4
    await connect_util.connectMinions(char); 
    await connect_util.connectTransform(char);

    // console.log(char.minions);

    await this.doRecalcs1(char_int, char);
  }

  doRecalcs1 = async (char_int: CharacterSheetInterface, char: Character, do_all = true) => {
    // console.log(char_int.mind.extra_effects_features.map(o => o.clone()));
    if (!(char_int instanceof TransformInstance)) {
      this.recalcAsis(char_int);
    }
    this.recalcProficiencies(char_int);
    await this.applyModifiers(char_int, char);
    this.recalcLanguages(char_int);
    if (do_all) {
      await this.doRecalcs2(char_int, char, do_all);
    }
  }

  doRecalcs2 = async (char_int: CharacterSheetInterface, char: Character, do_all = true) => {
    // console.log(char_int.mind.extra_effects_features.map(o => o.clone()));
    if (char_int instanceof Character) {
      await this.recalcKnowledge(char_int);
      await this.recalcSpellSlots(char_int);
      this.recalcSenses(char_int);
    }
    this.recalcExtraEffects(char_int);
    if (char_int instanceof Character) {
      await this.recalcResources(char_int);
    }
    this.recalcMisc(char_int, char);
    // if (char instanceof Character) {
    await this.recalcActions(char_int, char);
    // }
    if (do_all) {
      await this.doRecalcs3(char_int, char, do_all);
    }
  }

  doRecalcs3 = async (char_int: CharacterSheetInterface, char: Character, do_all = true) => {
    // console.log(char_int.mind.extra_effects_features.map(o => o.clone()));
    this.recalcChecksAndThrows(char_int);
    if (char_int instanceof Character) {
      this.recalcAttention(char_int);
      this.recalcWeights(char_int);
    }
    if (do_all) {
      await this.doRecalcs4(char_int, char, do_all);
    }
  }

  doRecalcs4 = async (char_int: CharacterSheetInterface, char: Character, do_all = true) => {
    // console.log(char_int.mind.extra_effects_features.map(o => o.clone()));
    if (char_int instanceof Character) {
      if (char_int.transform) {
        await this.applyTransformToInstance(char_int, char_int.transform);
        // console.log(char_int.transform.current_ability_scores.clone());
        await this.repopulateTypedCharFeatures(char_int.transform, char_int);
        // debugger;
        // console.log(char_int.transform.transform_upgrades);
        if (char_int.transform.transform_upgrades.length > 0) {
          const transform = char_int.transform;
          const transform_upgrades = transform.transform_upgrades.filter(o => 
            o.floating_feature instanceof TransformUpgradeFeature
          );
          for (const cf of transform_upgrades) {
            await this.applyTransformUpgradeToInstance(char, cf);
          }
          await this.repopulateTypedCharFeatures(char_int.transform, char_int);
        }
        // console.log(char_int.transform.current_ability_scores.clone());
      }
      const creatures = char_int.spirit.minions.some(o => o instanceof ComplexCreatureInstance) ? await this.getCreatures({ char }) : [];
      const repopulate_us: string[] = [];
      for (const minion of char_int.spirit.minions) {
        let upgrades = char_int.mind.summon_upgrade_features.filter(o => {
          if (o.floating_feature instanceof SummonUpgradeFeature) {
            return api.fitCreatureLimit(minion, o.floating_feature.limits);
          }
          return false;
        });
        if (!(minion instanceof ComplexCreatureInstance)) {
          // if (minion instanceof TransformInstance) {
          //   await this.applyTransformToInstance(char_int, minion);
          //   await this.repopulateTypedCharFeatures(minion, char_int);
          //   if (minion.transform_upgrades.length > 0) {
          //     const transform = minion;
          //     const transform_upgrades = transform.transform_upgrades.filter(o => 
          //       o.floating_feature instanceof TransformUpgradeFeature
          //     );
          //     for (const cf of transform_upgrades) {
          //       await this.applyTransformUpgradeToInstance(char, cf);
          //     }
          //     await this.repopulateTypedCharFeatures(minion, char_int);
          //   }
          // }
          if (upgrades.length > 0) {
            const cci = new ComplexCreatureInstance();
            cci.owner_char = char;
            if (minion instanceof SummonInstance) {
              cci.copySI(minion);
              if (minion.summon && minion.summon.built_in_gift_ids.length > 0) {
                const gifts = await data_util.getCreatureGifts();
                for (const id of minion.summon.built_in_gift_ids) {
                  const cg = gifts.find(o => o._id === id);
                  if (cg) {
                    await api.loadObject(cg);
                    const cci_source = new CCIFeatureSource();
                    cci_source.copyCCISource({ feature_source: cg, char: cci });
                    cci.creature_gift_cfss.push(cci_source);
                  }
                }
              }
            } else if (minion instanceof BasicCreatureInstance) {
              cci.copyCI(minion);
            } else {
              debugger; // I'm changing it so TransformInstance isn't really a thing, so it shouldn't ever come here.
            }
            cci.subscription_holder.feedTo = char_int.subscription_holder;
            await api.upsertObject("complex_creature", cci);
            char_int.spirit.minions = char_int.spirit.minions.filter(o => o.true_id !== minion.true_id);
            char_int.spirit.minions.push(cci);
            repopulate_us.push(cci._id);
          } else if (minion instanceof SummonInstance && 
            minion.summon && 
            minion.summon.fbs.some(o => 
              o.feature_types.length > 1 || o.feature_types[0] !== "Minion Ability")) {
            
            const cci = new ComplexCreatureInstance();
            cci.owner_char = char;
            cci.copySI(minion);
            if (minion.summon && minion.summon.built_in_gift_ids.length > 0) {
              const gifts = await data_util.getCreatureGifts();
              for (const id of minion.summon.built_in_gift_ids) {
                const cg = gifts.find(o => o._id === id);
                if (cg) {
                  await api.loadObject(cg);
                  const cci_source = new CCIFeatureSource();
                  cci_source.copyCCISource({ feature_source: cg, char: cci });
                  cci.creature_gift_cfss.push(cci_source);
                }
              }
            }
            cci.subscription_holder.feedTo = char_int.subscription_holder;
            await api.upsertObject("complex_creature", cci);
            char_int.spirit.minions = char_int.spirit.minions.filter(o => o.true_id !== minion.true_id);
            char_int.spirit.minions.push(cci);
            repopulate_us.push(cci._id);
          }
        }
        minion.subscription_holder.feedTo = char.subscription_holder;
      }
      for (const minion of char_int.spirit.minions) {
        if (minion instanceof ComplexCreatureInstance) {
          minion.owner_char = char;
          if (minion.use_your_pb) {
            minion.your_pb = char.mind.proficiency_modifier;
          }
          // debugger;
          if (minion.creature_id !== "" && !minion.creature) {
            const creature = creatures.find(o => o._id === minion.creature_id);
            if (creature) {
              await api.loadObject(creature);
              // minion.name = creature.name;
            }
          }
          if (minion.transform_id !== "" && !minion.transform) {
            // const transform = selected_option.transform;
            // if (transform) {
            //   minion.transform = new CCIFeatureSource();
            //   minion.transform.copyCCISource({ feature_source: transform, char: minion });
            //   minion.transform_id = transform._id;
            // } 
          }
          if (minion.summon_cf_true_id !== "" && !minion.summon) {
            // debugger;
            // const cf = char.mind.features.find(o => o.true_id === minion.summon_cf_true_id);
            // if (cf) {
            //   if (cf.floating_feature instanceof Ability) {
            //     const summon_effects = cf.floating_feature.effects.filter(o => o.type === "Summon");
            //     if (summon_effects.length === 1) {
            //       const summon_effect = summon_effects[0];
            //       let potence: Potence | undefined = summon_effect.potences[0];
            //       if (summon_effect.potences.length > 1) {
            //         switch (summon_effect.potence_type) {
            //           case "Character": potence = summon_effect.getPotence(char.mind.character_level); break;
            //           case "None": potence = summon_effect.getPotence(char.mind.character_level); break;
            //           case "Slot": potence = summon_effect.getPotence(minion.summon_slot_level); break;
            //           case "Source": 
            //             const cfs = char.char_feature_sources.find(o => o.true_id === minion.summon_source_true_id);
            //             if (cfs) {
            //               potence = summon_effect.getPotence(cfs.level); 
            //             } else {
            //               debugger;
            //             }
            //           break;
            //         }
            //       }
            //       if (potence) {
            //         // Now we have to find it in the summon_options
            //         const summon_option = potence.summon_options.find(o => o.custom_stat_block && o.custom_stat_block.true_id === minion.summon_option_true_id);
            //         if (summon_option && summon_option.custom_stat_block) {
            //           // debugger;
            //           const summon = summon_option.custom_stat_block;
            //           minion.summon = summon;
            //         }
            //       }
            //     } else {
            //       debugger;
            //     }
            //   } else {
            //     debugger;
            //   }
            // } else {
            //   debugger;
            // }
          } else if (minion.summon_source_true_id !== "" && !minion.summon) {
            debugger;
          }
          if (minion.cgift_ids.length > 0) {
            const cgifts = await data_util.getCreatureGifts();
            for (const cgift_id of minion.cgift_ids) {
              const cgift = cgifts.find(o => o._id === cgift_id);
              if (cgift) {
                await data_util.loadObject(cgift);
                let cgift_cfs = minion.creature_gift_cfss.find(o => o.source_id === cgift_id);
                if (!cgift_cfs) {
                  cgift_cfs = new CCIFeatureSource();
                  cgift_cfs.copyCCISource({ feature_source: cgift, char: minion });
                  minion.creature_gift_cfss.push(cgift_cfs);
                }
              } else {
                debugger;
              }
            }
          }
          // minion.upgrade_char_features = upgrades;
          // Get the properties from the things that aren't regular features and set them on it before processing.
          const use_max_hp = minion.hp.current === minion.hp.max;
          if (minion.creature) {
            const creature = minion.creature;
            minion.current_ability_scores = creature.current_ability_scores.clone();
            minion.creature_id = creature._id;
            minion.hit_dice = [];
            // let max_hit_points = 0;
            // let max_hp_bonuses = 0;
            // let extra_from_first_die = 0;
            for (const hd_upg of creature.hit_dice) {
              const hd = this.toHitDice(hd_upg, { obj: minion });
              // max_hit_points += (hd.size / 2 + 1) * hd.count;
              // max_hp_bonuses += hd.count * minion.current_ability_scores.CON;
              // if (extra_from_first_die === 0) {
              //   extra_from_first_die = hd.size * 0.5;
              // }
              minion.hit_dice.push(hd);
            }
            minion.hp.max = this.calcMaxHP(minion.hit_dice, minion.current_ability_scores.CON); // extra_from_first_die + max_hit_points + max_hp_bonuses;
            minion.hp.current = use_max_hp ? minion.hp.max : Math.min(minion.hp.current, minion.hp.max);
            minion.creature_cfs = new CCIFeatureSource();
            minion.creature_cfs.copyCCISource({ feature_source: creature, char: minion });
            minion.senses = [];
            const attributes = creature.attributes_table.getEntry(minion.challenge_rating);
            if (attributes) {
              let keys = Object.keys(attributes.senses);
              // debugger;
              for (const key of keys) {
                console.log(key);
                const key2 = key.replace(" ", "").toLocaleLowerCase();
                const sense = SENSES.find(o => o._id === key || o.name.replace(" ", "").toLocaleLowerCase() === key2);
                if (sense) {
                  const char_sense = new CharacterSense();
                  char_sense.name = sense.name;
                  char_sense.sense_id = sense._id;
                  char_sense.range = attributes.senses[key];
                  minion.senses.push(char_sense);
                }
              }
            }
            minion.armor_class = creature.ac_for_cr(minion.challenge_rating);
            if (minion.transform) {
              debugger;
            }
          } else if (minion.summon) {
            // debugger;
            const summon = minion.summon;
            minion.current_ability_scores = this.toAbilityScores(summon.ability_scores, 
              { 
                obj: char, 
                source_id: minion.summon_source_true_id, 
                base_slot_level: minion.summon_base_slot_level,
                slot_level: minion.summon_slot_level
              });
            minion.hit_dice = [];
            // let max_hit_points = 0;
            // let max_hp_bonuses = 0;
            // let extra_from_first_die = 0;
            const hd_size = summon.hd_size_from_size ? HIT_DICE_SIZE_MAP[minion.size_num] : 
              this.value(summon.hit_dice_size, 
                { 
                  obj: char, 
                  source_id: minion.summon_source_true_id, 
                  base_slot_level: minion.summon_base_slot_level,
                  slot_level: minion.summon_slot_level
                }
              );
            const hd_count = this.value(summon.hit_dice_count, 
              { 
                obj: char, 
                source_id: minion.summon_source_true_id, 
                base_slot_level: minion.summon_base_slot_level,
                slot_level: minion.summon_slot_level
              }
            );
            const hd = new HitDiceWithUsed();
            hd.size = hd_size;
            hd.count = hd_count;
            // max_hit_points += (hd.size + 1) * 0.5 * hd.count;
            // max_hp_bonuses += hd.count * minion.current_ability_scores.CON;
            // if (extra_from_first_die === 0) {
            //   extra_from_first_die = hd.size * 0.5;
            // }
            minion.hit_dice.push(hd);
            if (!char.c_options.use_minion_hp_calcs && minion.summon_instance) {
              // For some reason, summons the math doesn't always work out. 
              // It tends to be lower, but not always. 
              // For example, 
              // the Reanimated Companion has Max HP = 5 + 5 * Artificer Level, 
              // and has d8 Hit Dice with count equal to Artificer Level. 
              // That means that at Artificer Level 9, it will have Max HP = 50 = (5 + 5 * 9) and 9d8 Hit Dice.
              // it's CON is +3, so using typical Max HP calcs it would have 
              // 8 from the 1st Hit Die + 36 (4.5 * 8) from the other 8 Hit Dice + 27 (3 * 9) from its CON.
              // So really at level 9, your Reanimated Companion should have 71 Max HP, but it only has 50.
              // I suspect this is just to make the math easier, 
              // but making the math easier shouldn't give it that big of a nerf. 
              // It's basically taking away most of the CON mod for each level from its HP.
              // Use Minion HP Calculations in Character Options can change it 
              // to make it use the calculations instead of what is specified in the Summon.
            } else {
              minion.hp.max = this.calcMaxHP(minion.hit_dice, minion.current_ability_scores.CON); // extra_from_first_die + max_hit_points + max_hp_bonuses;
              minion.hp.current = use_max_hp ? minion.hp.max : Math.min(minion.hp.current, minion.hp.max);
            }
            const attributes = summon.attributes;
            minion.senses = [];
            if (attributes) {
              let keys = Object.keys(attributes.senses);
              // debugger;
              for (const key of keys) {
                console.log(key);
                const key2 = key.replace(" ", "").toLocaleLowerCase();
                const sense = SENSES.find(o => o._id === key || o.name.replace(" ", "").toLocaleLowerCase() === key2);
                if (sense) {
                  const char_sense = new CharacterSense();
                  char_sense.name = sense.name;
                  char_sense.sense_id = sense._id;
                  char_sense.range = attributes.senses[key];
                  minion.senses.push(char_sense);
                }
              }
            }
            minion.armor_class = this.value(summon.armor_class, { obj: char, base_slot_level: minion.summon_base_slot_level, slot_level: minion.summon_slot_level });
          }
          const upgrades = char_int.mind.summon_upgrade_features.filter(o => {
            if (o.floating_feature instanceof SummonUpgradeFeature) {
              return api.fitCreatureLimit(minion, o.floating_feature.limits);
            }
            return false;
          });
          minion.upgrade_char_features = upgrades;
          await this.repopulateCharFeatureBases(minion);
        }
      }
    }
    // if (char_int instanceof Character && char_int.transform) {
    //   console.log(char_int.transform.current_ability_scores.clone());
    // }
  }
  
  getModifierAmount(char: CharacterSheetInterface, 
    current: AbilityScores, 
    mod: Modifier, 
    source_id: string,
    item_id: string) {
    return this.value(mod.amount_unb, { obj: char, source_id, item_id });
  }

  recalcAsis(char: CharacterSheetInterface) {
    const maxes = new AbilityScores(20);
    const overrides = new AbilityScores(null);
    const bonuses = new AbilityScores(0);
    const current = char instanceof Character ? new AbilityScores(char.spirit.base_ability_scores) : new AbilityScores(char.mind.current_ability_scores);

    const increaseAbilityScores = (cf: CharacterFeature, char_asi_base_feature: CharacterASIBaseFeature) => {
      const override_score = char_asi_base_feature.asi_base_feature && char_asi_base_feature.asi_base_feature.override_score;
      for (let i = 0; i < char_asi_base_feature.asi_features.length; i++) {
        const asi = char_asi_base_feature.asi_features[i];
        const amount = asi.amount;
        let ability = asi.selected_option;
        if (ability === "Selectable") {
          if (char instanceof Character) {
            let cfs = char.char_feature_sources.find(o => o.true_id === cf.source_true_id);
            const asi_base_feature = char_asi_base_feature.asi_base_feature;
            const key = asi_base_feature && asi_base_feature.asi_features[i] ? asi_base_feature.asi_features[i].selectable_key : "";
            if (cfs && key !== "" && 
              cfs.selectable_hash[key] && 
              ABILITY_SCORES.includes(cfs.selectable_hash[key][0])
            ) {
              ability = cfs.selectable_hash[key][0] as AbilityScoreType;
            } else {
              cfs = char.char_feature_sources.find(o => 
                o.selectable_hash[key] && 
                o.selectable_hash[key].length > 0 && 
                ABILITY_SCORES.includes(o.selectable_hash[key][0])
              );
              if (cfs) {
                ability = cfs.selectable_hash[key][0] as AbilityScoreType;
              } else {
                console.error("Selectable Error");
                debugger;
              }
            }
          } else {
            console.error("Selectable Error");
            debugger;
          }
        }
        switch (ability) {
          case "STR":
            if (override_score) {
              overrides._strength = amount;
            } else {
              bonuses.addAbilityScore("strength", amount);
            }
          break;
          case "DEX":
            if (override_score) {
              overrides._dexterity = amount;
            } else {
              bonuses.addAbilityScore("dexterity", amount);
            }
          break;
          case "CON":
            if (override_score) {
              overrides._constitution = amount;
            } else {
              bonuses.addAbilityScore("constitution", amount);
            }
          break;
          case "INT":
            if (override_score) {
              overrides._intelligence = amount;
            } else {
              bonuses.addAbilityScore("intelligence", amount);
            }
          break;
          case "WIS":
            if (override_score) {
              overrides._wisdom = amount;
            } else {
              bonuses.addAbilityScore("wisdom", amount);
            }
          break;
          case "CHA":
            if (override_score) {
              overrides._charisma = amount;
            } else {
              bonuses.addAbilityScore("charisma", amount);
            }
          break;
        }
      }
    }
    const ability_score_features: { cf: CharacterFeature, casibf: CharacterASIBaseFeature }[] = [];
    for (const cf of char.mind.asi_features) {
      if (cf.floating_feature instanceof Modifier) {
        const mod = cf.floating_feature as Modifier;
        if (mod.amount_unb.isBasic()) {
          const amount = this.getModifierAmount(char, current, mod, cf.root_id, cf.item_id);
          if (amount) {
            for (let i = 0; i < mod.modifies_details.length; i++) {
              let ability_score = mod.modifies_details[i];
              if (ability_score === "Same as Feat") {
                const asi_finder = char.mind.asi_features.filter(o => o.source_true_id === cf.source_true_id);
                if (asi_finder.length === 1) {
                  ability_score = (asi_finder[0].feature_options[0] as CharacterASIBaseFeature).asi_features[0].selected_option;
                }
              } else if (ability_score === "Selectable") {
                if (char instanceof Character) {
                  const source = char.char_feature_sources.find(o => o.true_id === cf.source_true_id);
                  if (source && source.selectable_hash[mod.selectable_key]) {
                    ability_score = source.selectable_hash[mod.selectable_key][0];
                  }
                } else {
                  console.error(cf);
                }
              }
              if (ABILITY_SCORES.includes(ability_score) || ABILITY_SCORES_NAMES.includes(ability_score)) {
                if (mod.modifies === "Ability Score Max") {
                  maxes.addAbilityScore(ability_score, +amount);
                } else if (mod.modifies === "Ability Score") {
                  if (mod.mod_type.includes("Add")) {
                    bonuses.addAbilityScore(ability_score, +amount);
                  } else if (mod.mod_type === "Replace") {
                    overrides.addAbilityScore(ability_score, +amount);
                  }
                }
              }
            }
          } else {
            console.log(cf);
          }
        }
      } else {
        const casibf = cf.feature_options[0] as CharacterASIBaseFeature;
        // asi_base_feature.source_type = cf.s;
        ability_score_features.push({ cf, casibf });
      }
    }
    // console.log(ability_score_features);
    for (const char_asi_base_feature of ability_score_features.filter(o => !o.casibf.asi_base_feature || !o.casibf.asi_base_feature.override_score)) {
      if (!char_asi_base_feature.casibf.feat_option || char_asi_base_feature.casibf.use_feat === false) {
        increaseAbilityScores(char_asi_base_feature.cf, char_asi_base_feature.casibf);
      }
    }
    for (const char_asi_base_feature of ability_score_features.filter(o => o.casibf.asi_base_feature && o.casibf.asi_base_feature.override_score)) {
      if (!char_asi_base_feature.casibf.feat_option || char_asi_base_feature.casibf.use_feat === false) {
        increaseAbilityScores(char_asi_base_feature.cf, char_asi_base_feature.casibf);
      }
    }
    char.mind.ability_score_features = ability_score_features;

    // for (const ability of Object.keys(char.max_ability_score_customizations)) {
    //   const customization = char.max_ability_score_customizations[ability];

    //   const override = customization["Override"];
    //   if (override && override.value !== null) {
    //     maxes.setAbilityScore(ability, maxes.getAbilityScore(ability) + override.value);
    //   } else {
    //     const modifier = customization["Modifier"];
    //     if (modifier && modifier.value !== null) {
    //       maxes.setAbilityScore(ability, maxes.getAbilityScore(ability) + modifier.value);
    //     }
    //   }
    // }
    // for (const ability of Object.keys(char.ability_score_customizations)) {
    //   const customization = char.ability_score_customizations[ability];

    //   const override = customization["Override"];
    //   if (override && override.value !== null) {
    //     overrides.setAbilityScore(ability, override.value);
    //   } else {
    //     const modifier = customization["Modifier"];
    //     if (modifier && modifier.value !== null) {
    //       bonuses.setAbilityScore(ability, bonuses.getAbilityScore(ability) + modifier.value);
    //     }
    //   }
    // }
    
    // char.spirit.override_ability_scores = overrides.clone();
    
    if (maxes.strength !== char.mind.max_ability_scores.strength ||
      maxes.dexterity !== char.mind.max_ability_scores.dexterity ||
      maxes.constitution !== char.mind.max_ability_scores.constitution ||
      maxes.intelligence !== char.mind.max_ability_scores.intelligence ||
      maxes.wisdom !== char.mind.max_ability_scores.wisdom ||
      maxes.charisma !== char.mind.max_ability_scores.charisma) {
      char.mind.max_ability_scores = maxes.clone();
      char.subscription_holder.statsChanged();
    } 
    char.mind.bonus_ability_score_modifiers = bonuses.clone();
    // bonuses.add(char.custom_bonus_ability_score_modifiers);
    // overrides.mix(char.custom_override_ability_scores);
    // maxes.mix(char.custom_max_ability_scores);

    if (overrides._strength) {
      current._strength = overrides.strength;
    } else {
      current.addAbilityScore("Strength", bonuses.strength);
    }
    current._strength = Math.min(maxes.strength, current.strength);
    if (overrides._dexterity) {
      current._dexterity = overrides.dexterity;
    } else {
      current.addAbilityScore("Dexterity", bonuses.dexterity);
    }
    current._dexterity = Math.min(maxes.dexterity, current.dexterity);
    if (overrides._constitution) {
      current._constitution = overrides.constitution;
    } else {
      current.addAbilityScore("Constitution", bonuses.constitution);
    }
    current._constitution = Math.min(maxes.constitution, current.constitution);
    if (overrides._intelligence) {
      current._intelligence = overrides.intelligence;
    } else {
      current.addAbilityScore("Intelligence", bonuses.intelligence);
    }
    current._intelligence = Math.min(maxes.intelligence, current.intelligence);
    if (overrides._wisdom) {
      current._wisdom = overrides.wisdom;
    } else {
      current.addAbilityScore("Wisdom", bonuses.wisdom);
    }
    current._wisdom = Math.min(maxes.wisdom, current.wisdom);
    if (overrides._charisma) {
      current._charisma = overrides.charisma;
    } else {
      current.addAbilityScore("Charisma", bonuses.charisma);
    }
    current._charisma = Math.min(maxes.charisma, current.charisma);
    // This is a bug!!!!!!!!!!!!!!!! - Clara
    //    /___/
    //  >()___|-
    //    \   \
    const applyASIMod = (cf: CharacterFeature) => {
      if (cf.floating_feature instanceof Modifier) {
        const mod = cf.floating_feature as Modifier;
        let amount = 0;
        if (mod.amount_unb.isBasic()) {
          amount = mod.amount_unb.base;
        } else {
          amount = this.getModifierAmount(char, current, mod, cf.root_id, cf.item_id);
        }
        if (amount) {
          for (let i = 0; i < mod.modifies_details.length; i++) {
            let ability_score = mod.modifies_details[i];
            if (ability_score === "Same as Feat") {
              const asi_finder = char.mind.asi_features.filter(o => o.source_true_id === cf.source_true_id);
              if (asi_finder.length === 1) {
                ability_score = (asi_finder[0].feature_options[0] as CharacterASIBaseFeature).asi_features[0].selected_option;
              }
            } else if (ability_score === "Selectable") {
              if (char instanceof Character) {
                const source = char.char_feature_sources.find(o => o.true_id === cf.source_true_id);
                if (source && source.selectable_hash[mod.selectable_key]) {
                  ability_score = source.selectable_hash[mod.selectable_key][0];
                }
              } else {
                console.error(cf);
              }
            }
            if (mod.modifies === "Ability Score Max") {
              maxes.addAbilityScore(ability_score, +amount);
            } else if (mod.modifies === "Ability Score") {
              if (mod.mod_type === "Add" || (mod.mod_type === "Add if > 0" && amount > 0)) {
                bonuses.addAbilityScore(ability_score, +amount);
              } else if (mod.mod_type === "Replace") {
                overrides.setAbilityScore(ability_score, +amount);
              } else if (mod.mod_type === "Replace if Greater") {
                const override_score = overrides.getNullableAbilityScore(ability_score);
                if (override_score !== null) {
                  if (override_score < amount) {
                    overrides.setAbilityScore(ability_score, +amount);
                  }
                } else {
                  const current_score = current.getAbilityScore(ability_score);
                  const bonuses_score = bonuses.getAbilityScore(ability_score);
                  if (current_score + bonuses_score < amount) {
                    overrides.setAbilityScore(ability_score, +amount);
                  }
                }
              }
            }
          }
        } else {
          console.log(cf);
        }
      }
    }
    // Apply ASI Modifiers
    for (const cf of char.mind.asi_features.filter(o => 
      o.floating_feature instanceof Modifier && 
      o.floating_feature.mod_type !== "Replace if Greater")) {
      applyASIMod(cf);
    }
    for (const cf of char.mind.asi_features.filter(o => 
      o.floating_feature instanceof Modifier && 
      o.floating_feature.mod_type === "Replace if Greater")) {
      applyASIMod(cf);
    }
    for (const ability_score of ABILITY_SCORES) {
      if (isStatType(ability_score)) {
        const override_score = overrides.getNullableAbilityScore(ability_score);
        if (override_score !== null) {
          current.setAbilityScore(ability_score, override_score);
        }
      }
    }
    char.mind.saving_throw_profs = {
      STR: current.STR,
      DEX: current.DEX,
      CON: current.CON,
      INT: current.INT,
      WIS: current.WIS,
      CHA: current.CHA
    };
    if (current.strength !== char.mind.current_ability_scores.strength ||
      current.dexterity !== char.mind.current_ability_scores.dexterity ||
      current.constitution !== char.mind.current_ability_scores.constitution ||
      current.intelligence !== char.mind.current_ability_scores.intelligence ||
      current.wisdom !== char.mind.current_ability_scores.wisdom ||
      current.charisma !== char.mind.current_ability_scores.charisma) {
      char.mind.current_ability_scores = current;
      char.subscription_holder.statsChanged();
    } 
  }

  recalcFormulaValues = async (char: CharacterSheetInterface) => {
    char.mind.formula_values = {};
    let transform: TransformInstance | null = char instanceof TransformInstance ? char : null;
    if (char instanceof Character) {
      for (const cfs of char.spirit.classes) {
        if (cfs.source) {
          const source = cfs.source;
          for (const key of Object.keys(source.formulae)) {
            char.mind.formula_values[key] = this.value(source.formulae[key], { obj: char, source_id: source._id, item_id: "" });
          }
        }
        if (cfs.subclass && cfs.subclass) {
          const source = cfs.subclass;
          for (const key of Object.keys(source.formulae)) {
            char.formula_values[key] = this.value(source.formulae[key], { obj: char, source_id: source._id, item_id: "" });
          }
        }
      }
      // for (const cfs of char.adaptations) {
      //   if (cfs.adaptation) {
      //     const source = cfs.adaptation;
      //     for (const key of Object.keys(source.formulae)) {
      //       char.formula_values[key] = this.value(source.formulae[key], { obj: char, source_id: source._id, item_id: "" });
      //     }
      //   }
      // }
      transform = char.spirit.transform;
    }
    // debugger;
    if (transform && char instanceof Character) {
      transform.formula_values = char.formula_values;
      if (transform.transform) {
        const source = transform.transform;
        for (const key of Object.keys(source.formulae)) {
          transform.formula_values[key] = this.value(source.formulae[key], { obj: char, source_id: source._id, item_id: "" });
        }
      }
      // if (transform.adaptations.length > 0) {
      //   const adaptations = await this.getAdaptations();
      //   for (const cfs of transform.adaptations) {
      //     if (!cfs.adaptation) {
      //       const adaptation = adaptations.find(o => o._id === cfs.adaptation_id);
      //       if (adaptation) {
      //         cfs.adaptation = adaptation;
      //       }
      //     }
      //     if (cfs.adaptation) {
      //       const source = cfs.adaptation;
      //       for (const key of Object.keys(source.formulae)) {
      //         transform.formula_values[key] = this.value(source.formulae[key], { obj: char, source_id: source._id, item_id: "" });
      //       }
      //     }
      //   }
      // }
    }
  }

  recalcSpellcasting = async (char: Character) => {
    // for (const char_class of char.spirit.classes) {
    //   console.log(char_class.spell_dc);
    // }
    const spells: CharacterSpell[] = [];
    const spellbook_spells: CharacterSpell[] = [];
    for (const cfs of char.char_feature_sources) {
      let extra_spells = 0;
      const spellcasting = cfs.spellcasting;
      spellcasting.cantrips_max = 0;
      spellcasting.spells_prepared_max = 0;
      spellcasting.spell_dc = 0;
      spellcasting.spell_attack = 0;
      spellcasting.spellcasting_modifier = 0;
      spellcasting.spellcasting_ability = "None";
      const sfs = char.mind.spellcasting_features.filter(o => 
        !(o.ancestries.some(o2 => o2.type === "Feat") || o.ancestries.some(o2 => o2.type === "Gift")) &&
        (o.root_id === cfs.source_id || (cfs instanceof CharacterClass && o.root_id === cfs.subclass_id)) && 
        !["Bonus Spells","Bonus Spells Upgrade","Extra Spell Lists","Spellbook Modifier"].includes(o.feature_type));
      for (const cf of sfs) {
        if (cf.floating_feature) {
          if (cf.feature_type === "Spellcasting") {
            const ff = cf.floating_feature;
            if (ff instanceof SpellcastingFeature) {
              let ability = ff.ability;
              let spell_list_ids = ff.spell_list_ids;
              if (ability === "Selectable") {
                // Search the selectable_hash of char_class and then its sub_char_feature_sources
                const selectable_key = ff.ability_selectable_key;
                let ability_maybe = cfs.selectable_hash[selectable_key];
                if (ability_maybe === undefined) {
                  const sub_cfs = cfs.sub_char_feature_sources.find(o => o.selectable_hash[selectable_key] && o.selectable_hash[selectable_key][0] !== undefined);
                  if (sub_cfs) {
                    ability_maybe = sub_cfs.selectable_hash[selectable_key];
                  }
                }
                if (ability_maybe === undefined) {
                  const cfs = char.char_feature_sources.find(o => o.selectable_hash[selectable_key] && o.selectable_hash[selectable_key][0] !== undefined);
                  if (cfs) {
                    ability_maybe = cfs.selectable_hash[selectable_key];
                  }
                }
                if (ability_maybe !== undefined) {
                  ability = ability_maybe[0] as AbilityScoreExpandedType;
                }
              }
              if (spell_list_ids.includes("Selectable")) {
                const selectable_key = ff.spell_list_selectable_key;
                let spell_list_maybe = cfs.selectable_hash[selectable_key];
                if (spell_list_maybe === undefined) {
                  const sub_cfs = cfs.sub_char_feature_sources.find(o => o.selectable_hash[selectable_key] && o.selectable_hash[selectable_key][0] !== undefined);
                  if (sub_cfs) {
                    spell_list_maybe = sub_cfs.selectable_hash[selectable_key];
                  }
                }
                if (spell_list_maybe === undefined) {
                  const cfs = char.char_feature_sources.find(o => o.selectable_hash[selectable_key] && o.selectable_hash[selectable_key][0] !== undefined);
                  if (cfs) {
                    spell_list_maybe = cfs.selectable_hash[selectable_key];
                  }
                }
                if (spell_list_maybe !== undefined) {
                  spell_list_ids = spell_list_ids.filter(o => o !== "Selectable");
                  spell_list_ids.push(spell_list_maybe[0]);
                }
              }
              if (ability !== "Selectable" && !spell_list_ids.includes("Selectable")) {
                spellcasting.spellcasting_ability = ability as AbilityScoreType;
                const spellcasting_ability_modifier = char.mind.current_ability_scores.getModifier(ability);
                if (spellcasting_ability_modifier !== null) {
                  // They can only have one Spellcasting feature per class
                  spellcasting.spellcasting_modifier = spellcasting_ability_modifier;
                  spellcasting.spell_dc = 8 + char.mind.proficiency_modifier + spellcasting_ability_modifier;
                  spellcasting.spell_attack = char.mind.proficiency_modifier + spellcasting_ability_modifier;
                }
                // debugger;
                spellcasting.cantrips_max += Math.floor(this.value(ff.cantrips_max, { obj: char, source_id: cfs.true_id, item_id: "" }));
                spellcasting.knowledge_type = ff.knowledge_type;
                spellcasting.spells_prepared_max += Math.floor(this.value(ff.spells_prepared, { obj: char, source_id: cfs.true_id, item_id: "" }));
                
                spellcasting.spell_list_ids = spell_list_ids;

                spellcasting.schools = [...ff.schools];
                spellcasting.spell_table = ff.table;
                spellcasting.spellcasting_level = ff.level; // Spellcasting Level goes together with table.  If you have different tables then the levels from those classes don't add to each other
                // char_class.spellcasting.spellcasting_level_bonus = ff.level_bonus;
                if (ff.focus !== "") {
                  spellcasting.spellcasting_focus = ff.focus;
                }
                if (ff.ritual_casting) {
                  spellcasting.ritual_casting = ff.ritual_casting;
                }
                if (ff.spellbook) {
                  if (!spellcasting.spellbook) {
                    spellcasting.spellbook = new CharacterSpellbook();
                  }
                  spellcasting.spellbook.spellbook = ff.spellbook;
                }
              }
            }
          } else if (["Spellbook","Spell Book"].includes(cf.feature_type)) {
            const ff = cf.floating_feature as Spellbook;
            if (spellcasting.spellbook) {
              spellcasting.spellbook.spellbook = ff;
            } else {
              spellcasting.spellbook = new CharacterSpellbook();
              spellcasting.spellbook.spellbook = ff;
            }
          } else if (cf.feature_type === "Ritual Casting") {
            spellcasting.ritual_casting = true;
          } else if (cf.feature_type === "Cantrips") {
            const ff = cf.floating_feature as NumberFeature;
            spellcasting.cantrips_max += +ff.num;
          } else if (cf.feature_type === "Spells") {
            // These are additional spells known/prepared
            // on top of the calculated number.
            // In standard 5e, this is the only way 
            // Warlocks, Bards, Rangers, and 
            // Sorcerers have any spells, as well as the
            // Spellcasting subclasses for Rogue and Fighter.
            const ff = cf.floating_feature as NumberFeature;
            extra_spells += +ff.num;
          } else if (cf.feature_type === "Mystic Arcanum") {
            // const feature = sc.the_feature as number;
            // char_class.mystic_arcanum_levels.push(feature);
          } else if (cf.feature_type === "Spell Mastery") {
            // const feature = sc.the_feature as number;
            // char_class.spell_mastery_levels.push(feature);
          }
        }
      }
      if (spellcasting.spellbook && spellcasting.spellbook.spellbook) {
        // debugger;
        const spellbook_modifiers = char.mind.spellcasting_features.filter(o => 
          (o.root_id === cfs.source_id || (cfs instanceof CharacterClass && o.root_id === cfs.subclass_id)) && 
          o.feature_type === "Spellbook Modifier");
        for (const cf of spellbook_modifiers) {
          if (cf.floating_feature instanceof SpellbookModifier) {
            const mod = cf.floating_feature;
            if (spellcasting.spellbook.modifiers.filter(o => o._id === mod._id).length === 0) {
              const char_mod = new CharacterSpellbookModifier();
              char_mod.modifier = mod;
              char_mod.source_true_id = cf.source_true_id;
              spellcasting.spellbook.modifiers.push(char_mod);
            }
          }
        }
      }
      // This is where the extra spells get added.
      spellcasting.spells_prepared_max += extra_spells;
      spellcasting.spell_level_max = 0;
      const class_level = Math.max(cfs.level, 1);
      // debugger;
      const caster_level = Math.ceil(class_level * spellcasting.spellcasting_level);
      if (caster_level > 0) {
        const types = await data_util.getSpellSlotTypes();
        const type = types.find(o => o._id === spellcasting.spell_table);
        if (type) {
          const highest_level = Math.max(0,...type.entries.filter(o => o.level <= caster_level).map(o => o.level));
          const entry = type.entries.find(o => o.level === highest_level);
          if (entry) {
            const keys = Object.keys(entry.slots_per_level);
            for (const key of keys) {
              spellcasting.spell_level_max = Math.max(+key, spellcasting.spell_level_max);
            }
          }
        }
      }
      // Put spells_prepared_max modifier here
      const spellcasting_mods = char.mind.modifier_features.filter(o => 
        o.floating_feature instanceof Modifier && 
        o.floating_feature.modifies === "Max Prepared Spells" &&
        (o.floating_feature.class_ids.includes(cfs.source_id) || 
          common_util.anyOverlaps(o.floating_feature.class_ids, cfs.variant_ids))
      );
      for (const cf of spellcasting_mods) {
        const mod = cf.floating_feature as Modifier;
        const value = this.value(mod.amount_unb, { obj: char, source_id: cf.source_true_id });
        cfs.spellcasting.spells_prepared_max += value;
      }
      spells.push(...spellcasting.spells);
      if (spellcasting.spellbook) {
        spellbook_spells.push(...spellcasting.spellbook.spells);
      }
    }
    char.mind.spells = spells;
    char.mind.spellbook_spells = spellbook_spells;
    // for (const char_class of char.spirit.classes) {
    //   console.log(char_class.spell_dc);
    // }
    // const char_features = char.mind.spellcasting_features.filter(o => 
    //   o.ancestries.some(o2 => o2.type === "Feat") || 
    //   o.ancestries.some(o2 => o2.type === "Gift")
    // );
    // for (const cf of char_features) {
    //   console.log("Not currently supported");
    //   console.log(cf);
    // }
  }

  recalcSpells = async (char: Character, from_recalc = false) => {
    // I should probably move ritual_only onto CharacterFeatureSource
    // Remove spells granted by features we no longer have
    // console.log(char.mind.spells.map(o => o.name));

    for (const char_spell of char.mind.spells) {
      if (char_spell.spell) {
        await data_util.loadObject(char_spell.spell);
      }
    }
    for (const char_spell of char.mind.spellbook_spells) {
      if (char_spell.spell) {
        await data_util.loadObject(char_spell.spell);
      }
    }
    
    const upgraded_bonus_spells = char.mind.spellcasting_features.filter(o => 
      o.feature_type === "Bonus Spells Upgrade").map(o => {
      if (o.floating_feature instanceof BonusSpellsUpgrade) {
        return o.floating_feature.upgrade_key;
      }
      return "";
    });

    const cf_ids = char.mind.spellcasting_features.map(o => o.true_id);
    const ff_ids = char.mind.spellcasting_features.map(o => o.floating_feature?._id??"");
    const remove_us = char.mind.spells.filter(o => 
      (o.cf_id !== "" || o.always_known) && (!cf_ids.includes(o.cf_id) || !ff_ids.includes(o.ff_id))).map(o => o.true_id);
    char.mind.spells = char.mind.spells.filter(o => !remove_us.includes(o.true_id));
    for (const cf of char.mind.spellcasting_features.filter(o => o.feature_type === "Bonus Spells")) {
      const bonus_spells = cf.floating_feature as BonusSpells;
      // console.log(cf.clone());
      let char_bs = new CharacterBonusSpells();
      if (cf.feature_options[0]) {
        char_bs = cf.feature_options[0] as CharacterBonusSpells;
      }
      if (!char_bs.ff) {
        const ff = api.get_floating_feature(char_bs.ff_id);
        if (ff instanceof BonusSpells) {
          char_bs.ff = ff;
        }
      }
      if (char_bs.ff) {
        const selected_spell_id_for_given_id: { [given_id: string]: string } = {};
        const spell_ids = bonus_spells.spells.map(o => o.spell_id);
        for (const given_id of spell_ids) {
          const selected_spell_id = char_bs.selected_spell_id_for_given_id[given_id];
          const variants = data_util.getSpellVariants(given_id);
          if (selected_spell_id && variants.filter(o => o._id === selected_spell_id).length === 1) {
            selected_spell_id_for_given_id[given_id] = selected_spell_id;
          } else {
            const dominant = data_util.getDominant(variants);
            if (dominant) {
              selected_spell_id_for_given_id[given_id] = dominant._id;
            }
          }
        }
        char_bs.selected_spell_id_for_given_id = selected_spell_id_for_given_id;
      }
      cf.feature_options[0] = char_bs;
    }

    const forget_us: CharacterSpell[] = [];

    const ritual_only: CharacterSpell[] = [];
    for (const char_class of char.spirit.classes) {
      const class_level = Math.max(char_class.level, 1);
      const max_spell_level = char_class.spell_level_max;
      const spellcasting_features = char.mind.spellcasting_features.filter(o => 
        (o.root_id === char_class.source_id || 
          o.root_id === char_class.subclass_id) && 
        ["Extra Spell Lists","Bonus Spells"].includes(o.feature_type));
      const char_bonus_spells: CharacterBonusSpells[] = []; // char_class.bonus_spells.filter(o => o.classless);
      for (const cf of spellcasting_features) {
        if (cf.floating_feature) {
          if (cf.feature_type === "Bonus Spells") {
            const bonus_spells = cf.floating_feature as BonusSpells;
            const char_bs = cf.feature_options[0] as CharacterBonusSpells;
            // console.log(bonus_spells);
            if (bonus_spells.always_known || 
              (bonus_spells.upgrade_key !== "" && upgraded_bonus_spells.includes(bonus_spells.upgrade_key))) {
              // TODO: My Bonus Spells are having 0 DC and 0 Attack after spells changed until refresh.  
              const spell_ids = bonus_spells.spells.filter(o => o.level <= class_level).map(o => o.spell_id);
              const actual_spell_ids: string[] = [];
              for (const id of spell_ids) {
                // If they don't already have the spell (on char class), and they're able to cast it, add it.
                const selected_spell_id = char_bs.selected_spell_id_for_given_id[id];
                const spell = data_util.all_spells.find(o => o._id === selected_spell_id);
                if (spell && spell.level <= max_spell_level) {
                  await data_util.loadObject(spell);
                  actual_spell_ids.push(selected_spell_id);
                  const spell_id = spell._id;
                  const char_spell_finder = char.mind.spells.filter(o => 
                    o.cf_id === char_bs.cf_id &&
                    o.spell_id === spell_id && 
                    o.source_type === "Class" && 
                    (o.source_id === char_class.source_id || 
                      o.source_id === char_class.subclass_id));
                  if (char_spell_finder.length === 0) {
                    const char_spell = new CharacterSpell();
                    char_spell.copySpell(spell);
                    char_spell.always_known = true;
                    char_spell.connectSource(char_class);
                    char_spell.cf_id = cf.true_id;
                    char_spell.ff_id = cf.floating_feature._id;
                    char.mind.spells.push(char_spell);
                  } else {
                    // If they do have it, make sure it's marked as always known.
                    const char_spell = char_spell_finder[0];
                    char_spell.connectSpell(spell);
                    char_spell.always_known = true;
                    char_spell.connectSource(char_class);
                    char_spell.cf_id = cf.true_id;
                    char_spell.ff_id = cf.floating_feature._id;
                  }
                }
              }
              // console.log(char.mind.spells.map(o => o.name));
              const remove_us = char.mind.spells.filter(o => 
                o.cf_id === char_bs.cf_id &&
                !actual_spell_ids.includes(o.spell_id) && 
                o.source_type === "Class" && 
                (o.source_id === char_class.source_id || 
                  o.source_id === char_class.subclass_id)).map(o => o.true_id);
              // console.log(char_bs);
              // console.log(remove_us);
              if (remove_us.length > 0) {
                char.mind.spells = char.mind.spells.filter(o => !remove_us.includes(o.true_id));
              }
              // console.log(char.mind.spells.map(o => o.name));
            } 
            char_bonus_spells.push(char_bs);
          } else if (cf.feature_type === "Extra Spell Lists") {
            const feature = cf.floating_feature as ExtraSpellLists;
            char_class.extra_spell_lists.push(feature);
          }
        }
      }
      // Classless Bonus Spells for Dragonmarks
      const bonus_spells_features = char.mind.spellcasting_features.filter(o => 
        o.feature_type === "Bonus Spells" &&
        o.ancestries.some(o2 => o2.type === "Feat" || o2.type === "Gift"));
      // console.log(bonus_spells_features);
      for (const cf of bonus_spells_features) {
        if (cf.floating_feature instanceof BonusSpells) {
          const bonus_spells = cf.floating_feature;
          const char_bs = cf.feature_options[0] as CharacterBonusSpells;
          if (bonus_spells.always_known || 
            (bonus_spells.upgrade_key !== "" && upgraded_bonus_spells.includes(bonus_spells.upgrade_key))) {
            // TODO: My Bonus Spells are having 0 DC and 0 Attack after spells changed until refresh.  
            const spell_ids = bonus_spells.spells.filter(o => o.level <= class_level).map(o => o.spell_id);
            const actual_spell_ids: string[] = [];
            for (const id of spell_ids) {
              // If they don't already have the spell (on char class), and they're able to cast it, add it.
              const selected_spell_id = char_bs.selected_spell_id_for_given_id[id];
              const spell = data_util.all_spells.find(o => o._id === selected_spell_id);
              if (spell && spell.level <= max_spell_level) {
                await data_util.loadObject(spell);
                actual_spell_ids.push(selected_spell_id);
                const spell_id = spell._id;
                const char_spell_finder = char.mind.spells.filter(o => 
                  o.cf_id === char_bs.cf_id &&
                  o.spell_id === spell_id && 
                  o.source_type === "Class" && 
                  (o.source_id === char_class.source_id || 
                    o.source_id === char_class.subclass_id));
                if (char_spell_finder.length === 0) {
                  const char_spell = new CharacterSpell();
                  char_spell.copySpell(spell);
                  char_spell.always_known = true;
                  char_spell.connectSource(char_class);
                  char_spell.cf_id = cf.true_id;
                  char_spell.ff_id = cf.floating_feature._id;
                  char.mind.spells.push(char_spell);
                } else {
                  // If they do have it, make sure it's marked as always known.
                  const char_spell = char_spell_finder[0];
                  char_spell.connectSpell(spell);
                  char_spell.always_known = true;
                  char_spell.connectSource(char_class);
                  char_spell.cf_id = cf.true_id;
                  char_spell.ff_id = cf.floating_feature._id;
                }
              }
            }
            // console.log(char.mind.spells.map(o => o.name));
            const remove_us = char.mind.spells.filter(o => 
              o.cf_id === char_bs.cf_id &&
              !actual_spell_ids.includes(o.spell_id) && 
              o.source_type === "Class" && 
              (o.source_id === char_class.source_id || 
                o.source_id === char_class.subclass_id)).map(o => o.true_id);
            // console.log(char_bs);
            // console.log(remove_us);
            if (remove_us.length > 0) {
              char.mind.spells = char.mind.spells.filter(o => !remove_us.includes(o.true_id));
            }
            // console.log(char.mind.spells.map(o => o.name));
          } 
          char_bs.classless = true;
          char_bonus_spells.push(char_bs);
        }
      }
      char_class.spellcasting.bonus_spells = char_bonus_spells;
      // console.log(char.mind.spells.map(o => o.name));
      // char_class.spellcasting.spell_ids = [];
      // char_class.spellcasting.cantrip_ids = [];
      if (char_class.spellcasting.spellbook) {
        const book_spells = char_class.spellcasting.spellbook.spells;
        for (const char_spell of book_spells) {
          char_spell.connectSource(char_class);
          if (!char_spell.the_spell) {
            const spell = data_util.spells.find(o => o._id === char_spell.spell_id);
            if (spell) {
              await data_util.loadObject(spell);
              char_spell.connectSpell(spell);
            }
          }
        }
      }
      // console.log(char.mind.spells.map(o => o.name));
      const char_spells = char.mind.spells.filter(o => 
        o.source_type === "Class" && 
        (o.source_id === char_class.source_id || 
          o.source_id === char_class.subclass_id));
      for (const char_spell of char_spells) {
        char_spell.connectSource(char_class);
        if (!char_spell.the_spell) {
          const obj_finder = data_util.getSpell(char_spell.spell_id);
          if (obj_finder) {
            char_spell.connectSpell(obj_finder);
          }
        }
        if (!char_spell.always_known && 
          char_class.spellcasting.spells.filter(o => o.true_id === char_spell.true_id).length === 0 && 
          char_class.spellcasting.extra_spells.filter(o => o.true_id === char_spell.true_id).length === 0) {
          // If the level of this class has lowered, 
          // or the subclass has changed (removing the spellcasting feature)
          // Then some spells may need to be removed.
          // Just remove ones that are higher than the highest they should have for this class.
          if (char_spell.level === 0) {
            if (char_class.cantrips_max > 0) {
              // char_class.cantrip_ids.push(char_spell.spell_id);
              char_class.spellcasting.spells.push(char_spell);
            } else {
              forget_us.push(char_spell);
            }
          } else {
            if (char_class.spells_prepared_max > 0 && char_spell.level <= char_class.spell_level_max) {
              // char_class.spell_ids.push(char_spell.spell_id);
              char_class.spellcasting.spells.push(char_spell);
            } else {
              forget_us.push(char_spell);
            }
          }
        }
        if (char_class.ritual_casting && char_spell.the_spell && char_spell.the_spell.ritual) {
          char_spell.ritual = true;
        }
      }
      // console.log(char.mind.spells.map(o => o.name));
      if (char_class.spellbook && char_class.spellbook.spellbook) {
        const spellbook = char_class.spellbook;
        const the_spellbook = char_class.spellbook.spellbook;
        spellbook.time_num_per_spell_level = this.value(the_spellbook.time_num_per_spell_level, { obj: char, source_id: char_class.true_id, item_id: "" });
        spellbook.cost_per_spell_level = this.value(the_spellbook.cost_per_spell_level, { obj: char, source_id: char_class.true_id, item_id: "" });

        const free_spells = this.value(the_spellbook.spells_known, { obj: char, source_id: char_class.true_id, item_id: "" });
        let used_free_spells = 0;
        for (const mod of spellbook.modifiers) {
          if (!mod.extra_free_spells.isBlank()) {
            mod.unused_free_spells = this.value(mod.extra_free_spells, { obj: char, source_id: mod.source_true_id, item_id: "" });
          }
          if (mod.modifier) {
            if (!mod.modifier.time_num_per_spell_level) {
              mod.time_num_per_spell_level = this.value(mod.modifier.time_num_per_spell_level, { obj: char, source_id: mod.source_true_id, item_id: "" });
            }
            if (!mod.modifier.cost_per_spell_level) {
              mod.cost_per_spell_level = this.value(mod.modifier.cost_per_spell_level, { obj: char, source_id: mod.source_true_id, item_id: "" });
            }
          }
        }
        const free_spell_mods = spellbook.modifiers.filter(o => !o.extra_free_spells.isBlank());
        for (const char_spell of spellbook.spells) {
          if (!char_spell.extra) {
            const free_spell_mod = free_spell_mods.find(o => o.unused_free_spells > 0 && (o.schools.length === 0 || o.schools.includes(char_spell.school)));
            if (free_spell_mod) {
              free_spell_mod.unused_free_spells--;
            } else {
              used_free_spells++;
            }
          }
          char_spell.connectSource(char_class);
          if ((char_class.ritual_casting || the_spellbook.rituals_only) &&
            char.mind.spells.filter(o => o.spell_id === char_spell.spell_id && o.source_id === char_class.true_id).length === 0) {
            if (char_spell.spell === null) {
              const spell = data_util.spells.find(o => o._id === char_spell.spell_id);
              if (spell) {
                await data_util.loadObject(spell);
                char_spell.connectSpell(spell);
              }
            }
            if (char_spell.spell && char_spell.spell.ritual) {
              char_spell.ritual_only = true;
              char_spell.ritual = true;
              ritual_only.push(char_spell);
            }
          }
        }
        spellbook.free_spells = free_spells;
        spellbook.used_free_spells = used_free_spells;
      }
      if (char.c_options.use_suggestions && char_class.do_suggestions) {
        let check_level = char_class.level;
        while (char_class.cantrips_max > char_class.cantrips.length && check_level > 0) {
          let suggested_ids = char_class.suggestions_for_level_and_type(check_level, "cantrip");
          // console.log(suggested_ids);
          while (char_class.cantrips_max > char_class.cantrips.length && suggested_ids.length > 0) {
            const suggested_id = suggested_ids[0];
            const spell = data_util.spells.find(o => o._id === suggested_id);
            if (spell) {
              await data_util.loadObject(spell);
              const { known_from_this_source, known_from_other_source, known_variant, basically_always_known } = this.getSpellStuff({ character: char, char_class, spell: spell });
              if (!known_from_this_source && !known_from_other_source && !known_variant && !basically_always_known) {
                await connect_util.addSpell(char, spell, char_class);
              }
            } else {
              console.error("Spell not found");
              console.log(suggested_ids[0]);
            }
            suggested_ids = suggested_ids.slice(1);
          }
          check_level--;
        }
        check_level = char_class.level;
        while (char_class.spells_prepared_max > char_class.leveled_spells.length && check_level > 0) {
          let suggested_ids = char_class.suggestions_for_level_and_type(check_level, "spell");
          // console.log(suggested_ids);
          while (char_class.spells_prepared_max > char_class.leveled_spells.length && suggested_ids.length > 0) {
            const suggested_id = suggested_ids[0];
            const spell = data_util.spells.find(o => o._id === suggested_id);
            if (spell) {
              await data_util.loadObject(spell);
              const { known_from_this_source, known_from_other_source, known_variant, basically_always_known } = this.getSpellStuff({ character: char, char_class, spell: spell });
              if (!known_from_this_source && !known_from_other_source && !known_variant && !basically_always_known) {
                await connect_util.addSpell(char, spell, char_class);
              }
            } else {
              console.error("Spell not found");
              console.log(suggested_ids[0]);
            }
            suggested_ids = suggested_ids.slice(1);
          }
          check_level--;
        }
        char_class.do_suggestions = false;
      }
      // When lowering Class levels spells may need to be unlearned.
      // This needs to be here so that the spell levels will be accurate because they need to be connected first.
      char.mind.spells = char.mind.spells.filter(o => o.source_id !== char_class.source_id || o.level <= char_class.spell_level_max);
      char_class.spellcasting.spells = char_class.spellcasting.spells.filter(o => o.level <= char_class.spell_level_max);

      // Double check that there are no duplicates. There shouldn't be, but Scott ran into it, and I'm not sure why.
      // Putting in logging of any that it finds, but also remove them so they don't cause problems downstream.
      const spell_ids = char_class.spellcasting.spells.map(o => o.spell_id).sort();
      const unique_spell_ids = common_util.unique_array(spell_ids);
      if (unique_spell_ids.length < spell_ids.length) {
        // debugger;
        const duplicates = unique_spell_ids.filter(o => spell_ids.filter(o2 => o2 === o).length > 1);
        for (const dup of duplicates) {
          const char_spell = char_class.spellcasting.spells.find(o => o.spell_id === dup);
          if (char_spell) {
            char_class.spellcasting.spells = char_class.spellcasting.spells.filter(o => o.true_id !== char_spell.true_id);
          }
        }
      }
    }
    char.mind.ritual_only = ritual_only;
    char.subscription_holder.spellsRecalculated(from_recalc);
  }

  recalcExtraEffects(char_int: CharacterSheetInterface) {
    const old_extra_effects = char_int.mind.extra_effects.map(o => o.cloneEmpty());
    const new_extra_effects: CharacterExtraEffects[] = [];
    // console.log(char_int.mind.extra_effects_features);
    for (const cf of char_int.mind.extra_effects_features.filter(o => 
      o.floating_feature instanceof ExtraEffectTypeFeature &&
      (o.floating_feature.consumed_resource.resource_consumed !== "Slot" || 
        char_int.body.use_slots.filter(o2 => 
          o.floating_feature instanceof ExtraEffectTypeFeature &&
          o2.level === o.floating_feature.consumed_resource.slot_level).length > 0) &&
      (o.floating_feature.consumed_resource.resource_consumed !== "Pact" || 
        char_int.body.use_slots.filter(o2 => 
          o2.slot_name.includes("Pact") &&
          o.floating_feature instanceof ExtraEffectTypeFeature &&
          o2.level === o.floating_feature.consumed_resource.slot_level).length > 0)
    )) {
      const old_ee = old_extra_effects.find(o => o.true_id === cf.true_id);
      if (old_ee) {
        old_ee.char_features.push(cf);
        old_ee.calc_special_resource_amount(char_int);
        new_extra_effects.push(old_ee);
      } else {
        const new_ee = new CharacterExtraEffects();
        new_ee.true_id = cf.true_id;
        new_ee.char_features.push(cf);
        new_ee.calc_special_resource_amount(char_int);
        new_extra_effects.push(new_ee);
      }
    }
    for (const cf of char_int.mind.extra_effects_features.filter(o => 
      !(o.floating_feature instanceof ExtraEffectTypeFeature))) {
      if (cf.floating_feature instanceof ExtraEffectsFeature) {
        const eef = cf.floating_feature;
        if (eef.potence_type === "Slot") {
          // debugger;
          const min_level = eef.consumed_resource.slot_level;
          // let first_action: CharacterAction | null = null;
          let use_slots = char_int.body.use_slots.filter(o => o.level >= min_level);
          if (eef.consumed_resource.resource_consumed === "Pact") {
            use_slots = use_slots.filter(o => o.slot_name.includes("Pact"));
          }
          // if (eef.name.includes("Eldritch Smite")) {
          //   console.log(eef);
          //   console.log(char_int.body.use_slots);
          //   debugger;
          // }
          for (const slot of use_slots) {
            const old_ee = old_extra_effects.find(o => o.true_id === cf.true_id && o._slot_level === slot.level);
            if (old_ee) {
              old_ee.char_features.push(cf);
              old_ee.calc_special_resource_amount(char_int);
              new_extra_effects.push(old_ee);
            } else {
              const new_ee = new CharacterExtraEffects();
              new_ee.true_id = cf.true_id;
              new_ee._slot_level = slot.level;
              new_ee.char_features.push(cf);
              new_ee.calc_special_resource_amount(char_int);
              new_extra_effects.push(new_ee);
            }
          }
          // if (first_action) {
          //   char.mind.actions.push(first_action);
          // }
        } else {
          const old_ee = old_extra_effects.find(o => o.true_id === cf.true_id);
          if (old_ee) {
            old_ee.char_features.push(cf);
            old_ee.calc_special_resource_amount(char_int);
            new_extra_effects.push(old_ee);
          } else {
            const new_ee = new CharacterExtraEffects();
            new_ee.true_id = cf.true_id;
            new_ee.char_features.push(cf);
            new_ee.calc_special_resource_amount(char_int);
            new_extra_effects.push(new_ee);
          }
        }
      } else if (cf.floating_feature instanceof ExtraEffectsOfTypeFeature) {
        const type = cf.floating_feature.ee_type;
        const ee = new_extra_effects.find(o => o.name === type);
        if (ee) {
          ee.char_features.push(cf);
        }
      } 
    }
    for (const cf of char_int.mind.ability_features.filter(o => 
      (o.floating_feature instanceof SpellsFromList || 
        o.floating_feature instanceof SpellsFromListWithCosts) && 
      o.floating_feature.spell_overrides.effects.length > 0)) {
      const new_ee = new CharacterExtraEffects();
      new_ee.true_id = cf.true_id;
      new_ee.char_features.push(cf);
      new_ee.calc_special_resource_amount(char_int);
      new_extra_effects.push(new_ee);
    }
    
    // if (obj.the_ability.spell_overrides.effects.length > 0) {
        
    // }
    char_int.mind.extra_effects = new_extra_effects;
  }

  recalcProficiencies(char: CharacterSheetInterface) {
    // debugger;
    // First do the non-skill ones
    // Then for the skill ones, first do the double ones, then the single ones, then expertise
    // If a single or expertise is taken, then clear the choice out on the one it's processing,
    // and mark it as needs attention, including cfb and cfs.
    let proficiencies: CharacterProficiency[] = [];
    // if (char instanceof Character && char.spirit.sidekick && char.spirit.sidekick_ci && char.spirit.sidekick_creature) {
    //   const ci = char.spirit.sidekick_ci;
    //   const creature = char.spirit.sidekick_creature;
    //   for (const sp of ci.skill_proficiencies2) {
    //     const prof: CharacterProficiency = {
    //       prof_feature_id: "",
    //       expertise_feature_id: "",
    //       proficiency_id: sp.skill_id,
    //       proficiency_level: sp.prof_level,
    //       type: "Skill",
    //       extra_bonus: 0
    //     };
    //     proficiencies.push(prof);
    //   }
    //   for (const tool of data_util.tools) {
    //     if (ci.tool_proficiencies.includes(tool._id)) {
    //       const prof: CharacterProficiency = {
    //         prof_feature_id: "",
    //         expertise_feature_id: "",
    //         proficiency_id: tool._id,
    //         proficiency_level: 1,
    //         type: "Tool",
    //         extra_bonus: 0
    //       };
    //       proficiencies.push(prof);
    //     }
    //   }
    //   // console.log(creature);
    //   for (const ability_score of creature.saving_throws) {
    //     const prof: CharacterProficiency = {
    //       prof_feature_id: "",
    //       expertise_feature_id: "",
    //       proficiency_id: ability_score,
    //       proficiency_level: 1,
    //       type: "Saving Throw",
    //       extra_bonus: 0
    //     };
    //     proficiencies.push(prof);
    //   }
    // }
    if (char instanceof Character && char.spirit.classes.length === 1 && char.mind.character_level < 1) { // Level 0 Simple Weapons
      proficiencies.push({ 
        type: "Weapon", 
        proficiency_id: "5fd12dcf7a9c0d15f0a87840", 
        prof_feature_id: "", 
        expertise_feature_id: "", 
        proficiency_level: 1,
        extra_bonus: 0
      });
    }
    if (char instanceof Character) {
      for (const char_item of char.inventory.items) {
        char_item.proficiency_override = false;
      }
    }
    // debugger;
    const process_feature = (cf: CharacterFeature) => {
      const log_it = false; // cf.name === "Resilient Saving Throw Proficiency"; // cf.feature_type === "Expertise";
      if (log_it) {
        console.log(cf);
        console.log(char);
      }
      if (cf.feature && cf.floating_feature) {
        if (cf.feature_type === "Proficiencies" && cf.floating_feature instanceof Proficiency) {
          let rebuild = true;
          const proficiency = cf.floating_feature as Proficiency;
          // log_it = proficiency.proficiency_types.includes("Saving Throw");
          // log_it = cf.name === "Scimitars";
          // log_it = false; // proficiency.prof_or_exp; // || cf.feature_id === "084de506-8433-483c-b9ee-f6fa1f3868f5";
          if (log_it) {
            // debugger;
            console.log(cf);
            console.log(proficiency);
          }
          const copyMe = cf.feature;
          if (proficiency.prof_or_exp) {
            rebuild = false;
            while (cf.feature_options.length > proficiency.choice_count) {
              cf.feature_options = cf.feature_options.slice(cf.feature_options.length - 1);
            }
            while (cf.feature_options.length < proficiency.choice_count) {
              const char_prof: CharacterProficiency = {
                prof_feature_id: cf.true_id,
                expertise_feature_id: cf.true_id,
                proficiency_id: "",
                proficiency_level: 2,
                type: "",
                extra_bonus: this.value(cf.floating_feature.extra_bonus, { obj: char, source_id: cf.source_true_id, item_id: cf.item_id, root_id: cf.root_id })
              };
              cf.feature_options.push(char_prof);
            }
          } else {
            try {
              if ((cf.feature_options as CharacterProficiency[]).filter(o => 
                o.proficiency_id !== "").length > 0) {
                rebuild = false;
              }
              if (cf.feature_options.length !== proficiency.choice_count || 
                (cf.feature_options as CharacterProficiency[]).filter(o => 
                  o.proficiency_id === undefined).length > 0) {
                rebuild = true;
              }
            } catch (ex) { }
          } 
          if (proficiency.proficiency_types.includes("Special") && 
            cf.feature_options.length === proficiency.choice_count) {
            rebuild = false;
          }
          if (rebuild && cf.feature) {
            let old_feature_options = (cf.feature_options as CharacterProficiency[]).filter(o => o.proficiency_id !== "");
            cf.feature_options = [];
            if (proficiency.double) {
              let suggestions = char instanceof Character && char.c_options.use_suggestions ? proficiency.suggestions.filter(o => 
                char.proficiencies.filter(o2 => 
                  o2.proficiency_level === 2 && 
                  o2.proficiency_id === o.proficiency_id).length === 0) : [];
              // For double it's a little more complicated.
              // We need to check for proficiency, but also if it's doubled (expertise)
              // If they're proficient but not expert, then we want to use this one and set the original to blank.
              // If they're expert then leave this blank so the player can choose one.
              // Currently, all features with double should be auto_choose.  
              // Allowing otherwise greatly increases the complexity, 
              // so I need to make sure to enforce it on the Proficiency Feature UI.
              for (let i = 0; i < proficiency.choice_count; i++) {
                const the_prof = proficiency.the_proficiencies[i];
                const profs_finder = proficiencies.filter(o => o.proficiency_id === the_prof.proficiency_id && o.type === the_prof.type);
                if (profs_finder.length === 1) {
                  const other_char_prof = profs_finder[0];
                  if (other_char_prof.proficiency_level === 2) {
                    // It's already Expertise, so do a blank one
                    let proficiency_id = "";
                    let type = "";
                    if (suggestions.length > 0) {
                      proficiency_id = suggestions[0].proficiency_id;
                      type = suggestions[0].type;
                      suggestions = suggestions.slice(1);
                    }
                    const char_prof: CharacterProficiency = {
                      prof_feature_id: cf.true_id,
                      expertise_feature_id: cf.true_id,
                      proficiency_id,
                      proficiency_level: 2,
                      type,
                      extra_bonus: this.value(cf.floating_feature.extra_bonus, { obj: char, source_id: cf.source_true_id, root_id: cf.root_id, item_id: cf.item_id })
                    };
                    cf.feature_options.push(char_prof);
                  } else {
                    // It's not Expertise, so change it to blank, and then do this one normal
                    other_char_prof.proficiency_id = "";
                    const char_prof: CharacterProficiency = {
                      prof_feature_id: cf.true_id,
                      expertise_feature_id: cf.true_id,
                      proficiency_id: the_prof.proficiency_id,
                      proficiency_level: 2,
                      type: "Skill",
                      extra_bonus: this.value(cf.floating_feature.extra_bonus, { obj: char, source_id: cf.source_true_id, root_id: cf.root_id, item_id: cf.item_id })
                    };
                    cf.feature_options.push(char_prof);
                  }
                } else {
                  const char_prof: CharacterProficiency = {
                    prof_feature_id: cf.true_id,
                    expertise_feature_id: cf.true_id,
                    proficiency_id: the_prof.proficiency_id,
                    proficiency_level: 2,
                    type: the_prof.type,
                    extra_bonus: this.value(cf.floating_feature.extra_bonus, { obj: char, source_id: cf.source_true_id, root_id: cf.root_id, item_id: cf.item_id })
                  };
                  cf.feature_options.push(char_prof);
                }
              }
            } else {
              // Get the proficiencies from this list that they already know.
              // If the number of them that they don't already know is equal to choice_count,
              // then auto-choose them.  Otherwise leave it blank.
              let profs_finder = 
                proficiency.proficiency_types.includes("Armor") || 
                proficiency.proficiency_types.includes("Weapon") || 
                proficiency.proficiency_types.includes("Special") ? 
                proficiency.the_proficiencies :
                proficiency.the_proficiencies.filter(profsimple => 
                  proficiencies.filter(o => 
                    o.proficiency_id === profsimple.proficiency_id).length === 0);
              if (log_it) {
                console.log(profs_finder);
                console.log(proficiencies.filter(o => 
                  o.type === "Saving Throw"));
              }
              if (profs_finder.length === 0) {
                profs_finder = 
                  proficiency.alternates.filter(profsimple => 
                    proficiencies.filter(o => 
                      o.proficiency_id === profsimple.proficiency_id).length === 0);
              }
              const auto_choose = profs_finder.length > 0 && proficiency.choice_count >= profs_finder.length;
              if (log_it) {
                // console.log(proficiencies.filter(o => 
                //   o.type === "Saving Throw"));
                console.log(copyMe);
                console.log(proficiency);
                console.log(cf.feature_options.length);
                console.log(cf.feature_options);
                console.log(profs_finder);
                console.log(auto_choose);
              }
              if (auto_choose) {
                for (let i = 0; i < proficiency.choice_count; i++) {
                  const prof_simple_maybe: ProficiencySimple | null = profs_finder.length > i ? profs_finder[i] : null;
                  let type = prof_simple_maybe ? prof_simple_maybe.type : "";
                  if (type === "Special") {
                    type = "Weapon";
                  }
                  const char_prof: CharacterProficiency = {
                    prof_feature_id: cf.true_id,
                    expertise_feature_id: "",
                    proficiency_id: prof_simple_maybe ? prof_simple_maybe.proficiency_id : "",
                    proficiency_level: 1,
                    type,
                    extra_bonus: this.value(cf.floating_feature.extra_bonus, { obj: char, source_id: cf.source_true_id, root_id: cf.root_id, item_id: cf.item_id })
                  };
                  cf.feature_options.push(char_prof);
                }
              } else {
                let suggestions = char instanceof Character && char.c_options.use_suggestions ? proficiency.suggestions.filter(o => 
                  char.proficiencies.filter(o2 => 
                    o2.proficiency_id === o.proficiency_id).length === 0) : [];
                for (let i = 0; i < proficiency.choice_count; i++) {
                  let proficiency_id = "";
                  let type = "";
                  if (suggestions.length > 0) {
                    proficiency_id = suggestions[0].proficiency_id;
                    type = suggestions[0].type;
                    suggestions = suggestions.slice(1);
                  }
                  const char_prof: CharacterProficiency = {
                    prof_feature_id: cf.true_id,
                    expertise_feature_id: "",
                    proficiency_id,
                    proficiency_level: 1,
                    type,
                    extra_bonus: this.value(cf.floating_feature.extra_bonus, { obj: char, source_id: cf.source_true_id, root_id: cf.root_id, item_id: cf.item_id })
                  };
                  cf.feature_options.push(char_prof);
                }
              }
              if (log_it) {
                console.log(cf.feature_options.length);
                console.log(cf.feature_options);
              }
            }
            const new_feature_options = cf.feature_options as CharacterProficiency[];
            old_feature_options = old_feature_options.filter(o => new_feature_options.filter(o2 => o2.proficiency_id === o.proficiency_id).length === 0);
            if (old_feature_options.length > 0) {
              const empty_feature_options = new_feature_options.filter(o => o.proficiency_id === "");
              let j = 0;
              for (let i = 0; i < empty_feature_options.length; ++i) {
                empty_feature_options[i].proficiency_id = old_feature_options[j].proficiency_id;
                j++;
                if (old_feature_options.length === j) {
                  break;
                }
              }
            }
          }
          for (const opt of cf.feature_options) {
            if (log_it) {
              console.log(opt);
              // debugger;
            }
            if (opt.proficiency_id !== "") {
              let prof_id = opt.proficiency_id;
              if (log_it) {
                console.log(prof_id);
              }
              if (prof_id === "Same as Feat" && char instanceof Character) {
                let asi_finder = char.asi_features.filter(o => 
                  o.source_true_id === cf.source_true_id
                );
                if (asi_finder.length > 1) {
                  if (log_it) {
                    console.log(cf.ancestries);
                    debugger;
                  }
                  // Go through each one and find the one that is closest to cf in its ancestry
                  for (const anc of cf.ancestries) {
                    const new_asi_finder = asi_finder.filter(o => 
                      o.ancestries.find(o2 => o2.true_id === anc.true_id)
                    );
                    if (log_it) {
                      console.log(new_asi_finder);
                      // debugger;
                    }
                    if (new_asi_finder.length > 0) {
                      asi_finder = new_asi_finder;
                    }
                    if (asi_finder.length === 1) {
                      break;
                    }
                  }
                  if (asi_finder.length > 1) {
                    asi_finder = [asi_finder[0]];
                  }
                }
                if (asi_finder.length === 1) {
                  prof_id = (asi_finder[0].feature_options[0] as CharacterASIBaseFeature).asi_features[0].selected_option;
                }
              }
              if (log_it) {
                console.log(prof_id);
              }  
              const opt2 = {...opt};
              opt2.proficiency_id = prof_id;
              if (proficiency.prof_or_exp) {
                // Check for other char_prof with this prof_id
                const other_prof_finder = proficiencies.filter(o => o.proficiency_id === prof_id);
                if (other_prof_finder.length > 0) {
                  const level = Math.max(...other_prof_finder.map(o => o.proficiency_level));
                  if (level === 2) {
                    opt2.proficiency_id = "";
                  } else {
                    opt2.proficiency_level = 2;
                    opt2.type = "Expertise";
                  }
                } else {
                  opt2.proficiency_level = 1;
                  opt2.type = "Skill";
                }
              } else {
                const prof_finder = proficiencies.filter(o => o.type === opt.type && o.proficiency_id === prof_id);
                if (prof_finder.length > 0) {
                  proficiencies = proficiencies.filter(o => o.type !== opt.type || o.proficiency_id !== prof_id);
                }
              }
              if (opt2.type === "") {
                opt2.type = proficiency.proficiency_types[0];
                opt.type = proficiency.proficiency_types[0];
              }
              if (opt2.type === "Special") {
                opt2.type = "Weapon";
              }
              proficiencies.push(opt2);
              if (log_it) {
                console.log(proficiencies);
              }  
            }
          }
        } else if (cf.feature_type === "Expertise") {
          const expertise = cf.floating_feature as Proficiency;
          let suggestions = char instanceof Character && char.c_options.use_suggestions ? expertise.suggestions.filter(o => 
            char.proficiencies.filter(o2 => 
              o2.proficiency_level === 2 && 
              o2.proficiency_id === o.proficiency_id).length === 0) : [];
          while (expertise.choice_count > cf.feature_options.length) {
            let proficiency_id = "";
            if (suggestions.length > 0) {
              proficiency_id = suggestions[0].proficiency_id;
              suggestions = suggestions.slice(1);
            }
            const char_prof: CharacterProficiency = {
              prof_feature_id: cf.true_id,
              expertise_feature_id: cf.true_id,
              proficiency_id,
              proficiency_level: 2,
              type: "Expertise",
              extra_bonus: this.value(expertise.extra_bonus, { obj: char, source_id: cf.source_true_id, root_id: cf.root_id, item_id: cf.item_id })
            };
            cf.feature_options.push(char_prof);
          }
          if (expertise.choice_count < cf.feature_options.length) {
            cf.feature_options.splice(expertise.choice_count, cf.feature_options.length - expertise.choice_count);
          }
          cf.feature_options.forEach((opt: CharacterProficiency) => {
            if (opt.proficiency_id !== "") {
              const prof_finder = proficiencies.filter(o => o.type === "Expertise" && o.proficiency_id === opt.proficiency_id);
              if (prof_finder.length > 0) {
                proficiencies = proficiencies.filter(o => o.type !== "Expertise" || o.proficiency_id !== opt.proficiency_id);
              }
              proficiencies.push(opt);
            }
          });
        } else if (cf.feature_type === "Jack of All Trades") {
          char.mind.jack_of_all_trades = true;
        } else if (cf.feature_type === "Proficiency Override") {
          const item_finder = char instanceof Character ? char.inventory.items.find(o => o.true_id === cf.item_id) : undefined;
          if (item_finder) {
            item_finder.proficiency_override = true;
          }
        } else {
          console.log(cf);
        }
      }
    };
    if (char instanceof Character) {
      for (const cf of char.proficiency_features.filter(o => o.feature_type !== "Expertise" && 
        o.floating_feature instanceof Proficiency && 
        !o.floating_feature.prof_or_exp)) {
        process_feature(cf);
      }
      for (const cf of char.proficiency_features.filter(o => o.feature_type !== "Expertise" && 
        o.floating_feature instanceof Proficiency && 
        o.floating_feature.prof_or_exp)) {
        process_feature(cf);
      }
      for (const cf of char.proficiency_features.filter(o => o.feature_type === "Expertise")) {
        process_feature(cf);
      }
      for (const cf of char.proficiency_features.filter(o => o.feature_type === "Proficiency Override")) {
        process_feature(cf);
      }
      if (char instanceof Character && char.c_options.bonus_skill_profs_for_int) {
        if (char.bonus_skill_profs_ids.length > char.mind.current_ability_scores.INT) {
          const new_ids: string[] = [];
          for (let i = 0; i < char.mind.current_ability_scores.INT; ++i) {
            new_ids.push(char.bonus_skill_profs_ids[i]);
          }
          char.spirit.bonus_skill_profs_ids = new_ids;
        } else {
          while (char.bonus_skill_profs_ids.length < char.mind.current_ability_scores.INT) {
            char.bonus_skill_profs_ids.push("");
          }
        }
        for (let i = 0; i < char.bonus_skill_profs_ids.length; ++i) {
          const id = char.bonus_skill_profs_ids[i];
          if (id !== "") {
            // TODO: Find a way to make it give tools as options instead of only skills
            const prof_finder = proficiencies.filter(o => o.type === "Skill" && o.proficiency_id === id);
            if (prof_finder.length > 0) {
              char.bonus_skill_profs_ids[i] = "";
            } else {
              const opt: CharacterProficiency = {
                prof_feature_id: `bonus_skill_profs_ids_${i}`,
                expertise_feature_id: "",
                proficiency_id: id,
                proficiency_level: 1,
                type: "Skill",
                extra_bonus: 0
              };
              proficiencies.push(opt);
            }
          }
        }
      }
      // debugger;
      // const prof_types = Object.keys(char.non_skill_prof_customizations);
      // for (const prof_type of prof_types) {
      //   for (const cust of char.non_skill_prof_customizations[prof_type]) {
      //     if (prof_type !== "Language") {
      //       if (cust.proficiency === true) {
      //         const prof = proficiencies.find(o => o.proficiency_id === cust.id);
      //         if (prof === undefined) {
      //           proficiencies.push({ 
      //             type: prof_type, 
      //             proficiency_id: cust.id, 
      //             prof_feature_id: "", 
      //             expertise_feature_id: "", 
      //             proficiency_level: 1,
      //             extra_bonus: 0
      //           });
      //         }
      //       } else if (cust.proficiency === false) {
      //         proficiencies = proficiencies.filter(o => o.proficiency_id !== cust.id);
      //       }
      //     }
      //   }
      // }
    }
    char.mind.proficiencies = proficiencies;
    char.mind.skill_proficiencies = proficiencies.filter(o => o.type === "Skill");
    char.mind.weapon_proficiencies = proficiencies.filter(o => o.type === "Weapon");
    char.mind.tool_proficiencies = proficiencies.filter(o => o.type === "Tool");
    char.mind.armor_proficiencies = proficiencies.filter(o => o.type === "Armor");
    char.mind.saving_throw_proficiencies = proficiencies.filter(o => o.type === "Saving Throw");
    // char.mind.special_weapon_proficiencies = special_weapon_proficiencies;
    // console.log(char.mind.saving_throw_proficiencies);
  }
  
  checkArmorRequirements(char: CharacterSheetInterface, mod: Modifier, log_it = false) {
    // Check if it matches the armor_requirement field
    if (mod.allowed_armor_types.includes("ALL") || 
      mod.allowed_armor_types.includes("All") || 
      mod.allowed_armor_types.includes("Any")) {
      // Check for required
      if (mod.required_armor_types.includes("None")) {
        return true;
      } else if (mod.required_armor_types.includes("Any")) {
        return char instanceof Character ? char.inventory.equipped_items.filter(o => 
          o.base_item &&
          o.base_item.item_type === "Armor" &&
          o.base_item.name !== "Shield"
        ).length > 0 : false;
      } else {
        // Make sure they meet at least one of the required armor types
        const valid_items = char instanceof Character ? char.inventory.equipped_items.filter(o => 
          o.base_item && 
          o.base_item instanceof Armor &&
          mod.required_armor_types.includes(o.base_item.armor_type_id)) : [];
        return valid_items.length > 0;
      }
    } else if (mod.allowed_armor_types.includes("None")) {
      return char instanceof Character ? char.inventory.equipped_items.filter(o => 
        o.base_item &&
        o.base_item.item_type === "Armor"
      ).length === 0 : true;
    } else if (mod.allowed_armor_types.includes("Shield Only")) {
      return char instanceof Character ? char.inventory.equipped_items.filter(o => 
        o.base_item &&
        o.base_item.item_type === "Armor" &&
        o.base_item.name !== "Shield"
      ).length === 0 : true;
    } else {
      const bad_armor_items = char instanceof Character ? char.inventory.equipped_items.filter(o =>
        o.base_item &&
        o.base_item.item_type === "Armor" &&
        o.base_item instanceof Armor &&
        !mod.allowed_armor_types.includes(o.base_item.armor_type_id)) : [];

      return bad_armor_items.length === 0;
    }
  }

  calcMaxHP(hit_dice: HitDiceWithUsed[], CON: number, first_id: string = "") {
    let max_hp = 0;
    let first_hd: HitDiceWithUsed | undefined;
    if (first_id !== "") {
      first_hd = hit_dice.find(o => o.true_id === first_id);
    } 
    if (!first_hd) {
      first_hd = hit_dice[0];
    }
    if (first_hd) {
      max_hp += first_hd.size + CON + ((((first_hd.size + 1) / 2) + CON) * (first_hd.count - 1));
      const true_id = first_hd.true_id;
      const other_hds = hit_dice.filter(o => o.true_id !== true_id);
      for (const hd of other_hds) {
        max_hp += (((hd.size + 1) / 2) + CON) * hd.count;
      }
    }
    return Math.floor(max_hp);
  }

  applyModifiers = async (char_int: CharacterSheetInterface, char: Character) => {
    let modifier_features = char_int.mind.modifier_features;
    let spell_modifier_features = char_int.mind.spell_modifier_features;
    console.log(modifier_features);
    if (char_int instanceof TransformInstance) {
      // Only apply modifiers that are part of the Transform, 
      // not those that are part of the regular form's stuff. 
      // Those should have been copied if they should be here.
      let cf_ids = char.mind.modifier_features.map(o => o.true_id);
      modifier_features = modifier_features.filter(o => !cf_ids.includes(o.true_id));
      cf_ids = char.mind.spell_modifier_features.map(o => o.true_id);
      spell_modifier_features = spell_modifier_features.filter(o => !cf_ids.includes(o.true_id));
    }
    char_int.mind.size_modifier = 0;
    const old_current_hp = char_int.body.hp.current;
    const old_max_hp = char_int.body.hp.max;
    const calc_steps: string[] = [];
    let max_hit_points = 0;
    const old_hit_dice = char_int.body.resource_holder.hit_dice;
    const hit_dice: HitDiceWithUsed[] = [];
    // let start_hit_dice: HitDice = new HitDice({ size: 6, count: 1 });
    if (char_int instanceof Character && 
      char_int.spirit.classes.length > 0 && 
      char_int.character_level >= 1) {
      for (const char_class of char_int.spirit.classes.sort((a, b) => {
        if (a.position > b.position) {
          return 1;
        } else {
          if (a.position === b.position) {
            return a.name.localeCompare(b.name);
          } else {
            return -1;
          }
        }
      })) {
        if (char_class.source && char_class.source.hit_die) {
          const hd = char_class.source.hit_die;
          const hit_dice_finder = hit_dice.filter(o => char_class.source && char_class.source.hit_die && o.size === char_class.source.hit_die);
          if (hit_dice_finder.length === 0) {
            hit_dice.push(new HitDiceWithUsed({ size: char_class.source.hit_die, count: char_class.level }));
          } else {
            hit_dice_finder[0].count += char_class.level;
          }
          if (char_class.position === 0) {
            max_hit_points += hd + char_int.mind.current_ability_scores.CON;
            calc_steps.push(`First Level from ${char_class.name} -> Hit Dice Size (${hd}) + CON (${char_int.mind.current_ability_scores.CON}) = ${max_hit_points}`);
            if (char_class.level > 1) {
              const later_level_hp = ((hd / 2) + 1 + char_int.mind.current_ability_scores.CON) * (char_class.level - 1);
              calc_steps.push(`${char_class.level - 1} Later Levels from ${char_class.name} -> (Hit Dice Size (${hd}) / 2 = ${hd / 2}) + 1 + CON (${char_int.mind.current_ability_scores.CON}) = ${later_level_hp}`);
              max_hit_points += later_level_hp;
            }
          } else {
            const later_level_hp = ((hd / 2) + 1 + char_int.mind.current_ability_scores.CON) * (char_class.level);
            calc_steps.push(`${char_class.level} Levels from ${char_class.name} -> (Hit Dice Size (${hd}) / 2 = ${hd / 2}) + 1 + CON (${char_int.mind.current_ability_scores.CON}) = ${later_level_hp}`);
            max_hit_points += later_level_hp;
          }
        } 
      }
      // if (start_hit_dice) {
      //   max_hit_points += start_hit_dice.size + char_int.mind.current_ability_scores.CON;
      //   calc_steps.push(`First Level HP -> Hit Dice Size (${start_hit_dice.size}) + CON (${char_int.mind.current_ability_scores.CON}) = ${max_hit_points}`);
      // }
      for (const hd of hit_dice) {
        // max_hit_points += (((hd.size / 2) + 1) + char_int.mind.current_ability_scores.CON) * hd.count;
        const old_finder = old_hit_dice.filter(o => o.size === hd.size);
        if (old_finder.length === 1) {
          hd.used = Math.min(old_finder[0].used, hd.count);
        }
      }
    } else {
      max_hit_points += 6 + char_int.mind.current_ability_scores.CON;
    }
    char_int.body.resource_holder.hit_dice = hit_dice;
    char_int.mind.max_ac_dex_bonus_for_med_armor = 2;
    let armor_dex_bonus = char_int.mind.current_ability_scores.DEX;
    let shield_bonus = 0;
    let armor_base_armor_class = 0;
    let base_armor_class = 10; // Math.max(10, armor_base_armor_class) + armor_dex_bonus + shield_bonus;
    let armor_class_bonuses = 0;
    let max_hp_bonuses = 0;
    let saving_throw_bonuses: Bonus[] = [];
    let check_bonuses: Bonus[] = []; 
    let attack_bonuses = char_int.mind.attack_bonuses.filter(o => o.source !== "Modifier");
    let damage_bonuses = char_int.mind.damage_bonuses.filter(o => o.source !== "Modifier");
    for (const cf of modifier_features.filter(o => 
      o.floating_feature instanceof Modifier && 
      o.floating_feature.modifies === "Med Armor Max AC from DEX")) {
      const response = this.applyModifier(char_int, char, cf,
        max_hp_bonuses, 
        max_hit_points,
        armor_class_bonuses,
        base_armor_class,
        saving_throw_bonuses,
        check_bonuses,
        attack_bonuses,
        damage_bonuses);
      max_hp_bonuses = response.max_hp_bonuses; 
      max_hit_points = response.max_hit_points;
      armor_class_bonuses = response.armor_class_bonuses;
      base_armor_class = response.base_armor_class;
      saving_throw_bonuses = response.saving_throw_bonuses;
      check_bonuses = response.check_bonuses;
      attack_bonuses = response.attack_bonuses;
      damage_bonuses = response.damage_bonuses;
      calc_steps.push(...response.calc_steps);
    }
    if (char_int instanceof Character) {
      for (const ca of char_int.equipped_items.filter(o => o instanceof CharacterArmor)) {
        const char_armor = ca as CharacterArmor;
        if (char_armor.armor_type) {
          if (char_armor.armor_type.name === "Shield") {
            shield_bonus = char_armor.armor_class;
          } else {
            const dex_bonus_max = char_armor.dex_bonus_max;
            if (dex_bonus_max !== null) {
              armor_dex_bonus = dex_bonus_max ? Math.min(armor_dex_bonus, char_int.max_ac_dex_bonus_for_med_armor) : 0;
            }
            armor_base_armor_class = char_armor.armor_class;
          }
        } 
      }
    }
    base_armor_class = Math.max(10, armor_base_armor_class) + armor_dex_bonus + shield_bonus;
    armor_class_bonuses = 0;
    max_hp_bonuses = 0;
    saving_throw_bonuses = [];
    check_bonuses = []; 
    attack_bonuses = char_int.mind.attack_bonuses.filter(o => o.source !== "Modifier");
    damage_bonuses = char_int.mind.damage_bonuses.filter(o => o.source !== "Modifier")
    if (char_int instanceof Character) {
      if (char_int.spirit.sidekick) {
        // if (char_int.spirit.sidekick_ci) {
        //   const ci = char_int.spirit.sidekick_ci;
        //   char_int.speed = {
        //     walk: ci.speed.walk ? ci.speed.walk : 0,
        //     swim: ci.speed.swim ? ci.speed.swim : 0,
        //     climb: ci.speed.climb ? ci.speed.climb : 0,
        //     fly: ci.speed.fly ? ci.speed.fly : 0,
        //     burrow: ci.speed.burrow ? ci.speed.burrow : 0
        //   };
        // }
      } else {
        char_int.speed.walk = char_int.race.source instanceof Race ? char_int.race.source.speed : 0;
        char_int.speed.swim = 0;
        char_int.speed.climb = 0;
        char_int.speed.fly = 0;
        char_int.speed.burrow = 0;
      }
      char_int.mind.max_attuned_items = this.value(char_int.c_options.attunement_slots, { obj: char_int, item_id: "" });
    }
    char_int.mind.initiative_modifier = char_int.mind.current_ability_scores.DEX;
    char_int.mind.table_modifiers = [];
    
    char_int.mind.unarmed_strike_scores = ["STR"];
    char_int.mind.unarmed_strike_add_attack_to_dmg = false;
    char_int.mind.unarmed_strike_bonus_action = false;
    char_int.mind.unarmed_strike_damage_types = ["Bludgeoning"];
    char_int.mind.unarmed_strike_count = 0;
    char_int.mind.unarmed_strike_size = 0;
    char_int.mind.passive_bonuses = {
      perception: 0,
      insight: 0,
      investigation: 0
    };
    char_int.mind.range_bonuses = [];
    // char_int.size = char_int.base_size;
    char_int.mind.size_bonus_for_carrying = 0;
    char_int.mind.carrying_capacity_mult = 1;

    for (const cf of modifier_features.filter(o => 
      o.floating_feature instanceof Modifier && 
      o.floating_feature.modifies === "Speed" && 
      o.floating_feature.modifies_details.includes("Walking"))) {
      const response = this.applyModifier(char_int, char, cf,
        max_hp_bonuses, 
        max_hit_points,
        armor_class_bonuses,
        base_armor_class,
        saving_throw_bonuses,
        check_bonuses,
        attack_bonuses,
        damage_bonuses);
      max_hp_bonuses = response.max_hp_bonuses; 
      max_hit_points = response.max_hit_points;
      armor_class_bonuses = response.armor_class_bonuses;
      base_armor_class = response.base_armor_class;
      saving_throw_bonuses = response.saving_throw_bonuses;
      check_bonuses = response.check_bonuses;
      attack_bonuses = response.attack_bonuses;
      damage_bonuses = response.damage_bonuses;
      calc_steps.push(...response.calc_steps);
    }
    for (const cf of modifier_features.filter(o => 
      o.floating_feature instanceof Modifier && 
      o.floating_feature.modifies === "Speed" && 
      !o.floating_feature.modifies_details.includes("Walking") && 
      !o.floating_feature.modifies_details.includes("All"))) {
      const response = this.applyModifier(char_int, char, cf,
        max_hp_bonuses, 
        max_hit_points,
        armor_class_bonuses,
        base_armor_class,
        saving_throw_bonuses,
        check_bonuses,
        attack_bonuses,
        damage_bonuses);
      max_hp_bonuses = response.max_hp_bonuses; 
      max_hit_points = response.max_hit_points;
      armor_class_bonuses = response.armor_class_bonuses;
      base_armor_class = response.base_armor_class;
      saving_throw_bonuses = response.saving_throw_bonuses;
      check_bonuses = response.check_bonuses;
      attack_bonuses = response.attack_bonuses;
      damage_bonuses = response.damage_bonuses;
      calc_steps.push(...response.calc_steps);
    }
    for (const cf of modifier_features.filter(o => 
      o.floating_feature instanceof Modifier && 
      o.floating_feature.modifies === "Speed" && 
      o.floating_feature.modifies_details.includes("All"))) {
      const response = this.applyModifier(char_int, char, cf,
        max_hp_bonuses, 
        max_hit_points,
        armor_class_bonuses,
        base_armor_class,
        saving_throw_bonuses,
        check_bonuses,
        attack_bonuses,
        damage_bonuses);
      max_hp_bonuses = response.max_hp_bonuses; 
      max_hit_points = response.max_hit_points;
      armor_class_bonuses = response.armor_class_bonuses;
      base_armor_class = response.base_armor_class;
      saving_throw_bonuses = response.saving_throw_bonuses;
      check_bonuses = response.check_bonuses;
      attack_bonuses = response.attack_bonuses;
      damage_bonuses = response.damage_bonuses;
      calc_steps.push(...response.calc_steps);
    }
    const non_spell_modifiers = modifier_features.filter(o => 
      o.floating_feature instanceof Modifier && 
      !o.floating_feature.amount_unb.add_stats_groups.some(o2 => o2.add_ability_scores.includes("Spellcasting")) &&
      o.floating_feature.modifies !== "Spell DC" && 
      o.floating_feature.modifies !== "Formula Value" &&
      o.floating_feature.modifies !== "Speed" && 
      (o.floating_feature.modifies !== "Attack" || 
        (o.floating_feature.modifies === "Attack" && 
          !o.floating_feature.apply_to.includes("Spells") &&
          o.floating_feature.modifies_details.length > 0 && 
          !o.floating_feature.modifies_details.includes("Spell Attacks") && 
          !o.floating_feature.modifies_details.includes("Cantrip Attacks")
        )
      )
    );
    for (const cf of non_spell_modifiers) {
      const response = this.applyModifier(char_int, char, cf,
        max_hp_bonuses, 
        max_hit_points,
        armor_class_bonuses,
        base_armor_class,
        saving_throw_bonuses,
        check_bonuses,
        attack_bonuses,
        damage_bonuses);
      max_hp_bonuses = response.max_hp_bonuses; 
      max_hit_points = response.max_hit_points;
      armor_class_bonuses = response.armor_class_bonuses;
      base_armor_class = response.base_armor_class;
      saving_throw_bonuses = response.saving_throw_bonuses;
      check_bonuses = response.check_bonuses;
      attack_bonuses = response.attack_bonuses;
      damage_bonuses = response.damage_bonuses;
      calc_steps.push(...response.calc_steps);
    }
    const spell_modifiers: CharacterAbilityModifier[] = [];
    // debugger;
    char_int.mind.actions = char_int.mind.actions.filter(o => o.type !== "Spell");
    // Apply modifiers to spells
    for (const cf of spell_modifier_features) {
      const modifier = cf.floating_feature as SpellModifier;
      spell_modifiers.push(new CharacterAbilityModifier({ 
        source_type: cf.root_type, 
        source_id: cf.root_id, 
        ancestries: cf.ancestries.map(o => { return { ...o}; }),
        source_name: cf.root_name, 
        modifier,
        char_feature: cf
      }));
    }
    char_int.mind.spell_modifiers = spell_modifiers;
    // console.log(char_int.mind.spell_modifiers);
    
    await this.recalcFormulaValues(char_int);
    if (char_int instanceof Character) {
      // for (const char_class of char.spirit.classes) {
      //   console.log(char_class.spell_dc);
      // }
      await this.recalcSpellcasting(char_int);
    }

    const other_spell_modifiers = modifier_features.filter(o => 
      o.floating_feature instanceof Modifier && 
      (o.floating_feature.amount_unb.add_stats_groups.some(o2 => o2.add_ability_scores.includes("Spellcasting")) ||
        o.floating_feature.modifies === "Spell DC" || 
        o.floating_feature.modifies === "Formula Value" ||
        (o.floating_feature.modifies === "Attack" && 
          (o.floating_feature.apply_to.includes("Spells") ||
            o.floating_feature.modifies_details.length === 0 || 
            o.floating_feature.modifies_details.includes("Spell Attacks") || 
            o.floating_feature.modifies_details.includes("Cantrip Attacks")
          )
        )
      )
    );
    // const other_spell_modifiers_old = modifier_features.filter(o => 
    //   o.floating_feature instanceof Modifier && 
    //   (o.floating_feature.amount_unb.add_stats_groups.some(o2 => o2.add_ability_scores.includes("Spellcasting")) ||
    //     o.floating_feature.modifies === "Spell DC" || 
    //     o.floating_feature.modifies === "Formula Value" ||
    //     (o.floating_feature.modifies === "Attack" && 
    //       (o.floating_feature.modifies_details.length === 0 || 
    //         o.floating_feature.modifies_details.includes("Spell Attacks") || 
    //         o.floating_feature.modifies_details.includes("Cantrip Attacks")
    //       )
    //     )
    //   )
    // );
    for (const cf of other_spell_modifiers) {
      const response = this.applyModifier(char_int, char, cf, 
        max_hp_bonuses, 
        max_hit_points,
        armor_class_bonuses,
        base_armor_class,
        saving_throw_bonuses,
        check_bonuses,
        attack_bonuses,
        damage_bonuses);
      max_hp_bonuses = response.max_hp_bonuses; 
      max_hit_points = response.max_hit_points;
      armor_class_bonuses = response.armor_class_bonuses;
      base_armor_class = response.base_armor_class;
      saving_throw_bonuses = response.saving_throw_bonuses;
      check_bonuses = response.check_bonuses;
      attack_bonuses = response.attack_bonuses;
      damage_bonuses = response.damage_bonuses;
      calc_steps.push(...response.calc_steps);
    }
    // for (const char_class of char.spirit.classes) {
    //   console.log(char_class.spell_dc);
    // }
    if (char_int instanceof Character) {
      await this.recalcSpells(char_int, true);
    }
    if (char_int instanceof Character) {
      char_int.hp.max = max_hit_points + max_hp_bonuses;
      char_int.hp.calc_steps = calc_steps;
      const max_hp_diff = char_int.hp.max - old_max_hp;
      // debugger;
      char_int.hp.current = max_hp_diff + old_current_hp;

      char_int.mind.base_armor_class = base_armor_class;
      // if (char_int.AC_customization.AC["Override"] && char_int.AC_customization.AC["Override"].value) {
      //   char_int.mind.armor_class = char_int.AC_customization.AC["Override"].value;
      // } else if (char_int.AC_customization.AC["Modifier"] && char_int.AC_customization.AC["Modifier"].value) {
      //   char_int.mind.armor_class = base_armor_class + armor_class_bonuses + char_int.AC_customization.AC["Modifier"].value;
      // } else {
        char_int.mind.armor_class = base_armor_class + armor_class_bonuses;
      // }
      // if (char_int.mind.attunement_customization) {
      //   char_int.mind.max_attuned_items = this.value(char_int.attunement_customization, { obj: char_int, item_id: "" });
      // }
    }
    char_int.mind.saving_throw_bonuses = saving_throw_bonuses;
    char_int.mind.check_bonuses = check_bonuses;
    char_int.mind.attack_bonuses = attack_bonuses;
    char_int.mind.damage_bonuses = damage_bonuses;
  }

  checkCharacterSize(char_int: CharacterSheetInterface, char: Character) {
    if (char_int instanceof Character) {
      if (char_int.size_option_features.length > 0) {
        // Put all the options together.
        let ignore_char_size = true;
        let size_options = [...char_int.size_options];
        let default_size: SizeType = 0;
        for (const so of char_int.size_option_features) {
          if (!so.ignore_char_size) {
            ignore_char_size = false;
          }
          if (so.default_size > 0) {
            default_size = so.default_size;
          }
          size_options.push(...so.size_options);
        }
        if (!ignore_char_size) {
          size_options.push(char_int.base_size);
        }
        size_options = size_options.filter(o => o !== 0); // Just to be certain
        size_options = common_util.unique_array(size_options);
        if (default_size === 0) {
          if (size_options.includes(char_int.base_size)) {
            default_size = char_int.base_size;
          } else {
            // Get the closest included size to it
            const min = Math.min(...size_options);
            const max = Math.max(...size_options);
            if (char_int.base_size < min) {
              default_size = min as SizeType;
            } else if (char_int.base_size > max) {
              default_size = max as SizeType;
            } else {
              // It's somewhere in the middle.  It's weird that it's not included as an option.  Probably will never actually come here.  Just make it min.
              default_size = min as SizeType;
            }
          }
        }
        if (!size_options.includes(char_int.base_size)) {
          char_int.spirit.base_size = default_size;
        }
      } else if (char_int.size_options.length > 0) {
        let size_options = [...char_int.size_options];
        let default_size: SizeType = 0;
        size_options = size_options.filter(o => o !== 0); // Just to be certain
        size_options = common_util.unique_array(size_options);
        if (default_size === 0) {
          if (size_options.includes(char_int.base_size)) {
            default_size = char_int.base_size;
          } else {
            // Get the closest included size to it
            const min = Math.min(...size_options);
            const max = Math.max(...size_options);
            if (char_int.base_size < min) {
              default_size = min as SizeType;
            } else if (char_int.base_size > max) {
              default_size = max as SizeType;
            } else {
              // It's somewhere in the middle.  It's weird that it's not included as an option.  Probably will never actually come here.  Just make it min.
              default_size = min as SizeType;
            }
          }
        }
        if (!size_options.includes(char_int.spirit.base_size)) {
          char_int.spirit.base_size = default_size;
        }
      } else if (char.spirit.race.source) {
        if (char.spirit.race.source.sizes.length > 1) {
          if (!char.spirit.race.source.sizes.includes(char_int.spirit.base_size)) {
            char_int.spirit.base_size = 0;
          }
        }
      }
    } else if (char.spirit.race.source) {
      if (char.spirit.race.source.sizes.length > 1) {
        if (!char.spirit.race.source.sizes.includes(char_int.spirit.base_size)) {
          char_int.spirit.base_size = 0;
        }
      }
    }
    char.mind.base_size = char.spirit.base_size;
    char_int.mind.base_size = char_int.spirit.base_size;
    if (char.customizations.overrides.size) {
      char.mind.overriding_size = char.customizations.overrides.size;
    } 
  }
  
  applyModifier(char_int: CharacterSheetInterface, 
    char: Character,
    cf: CharacterFeature | Feature, 
    max_hp_bonuses: number, 
    max_hit_points: number,
    armor_class_bonuses: number,
    base_armor_class: number,
    saving_throw_bonuses: Bonus[],
    check_bonuses: Bonus[],
    attack_bonuses: Bonus[],
    damage_bonuses: Bonus[]) {
    this.checkCharacterSize(char_int, char);
    const get_amount = (mod_type: string, current_amount: number, mod_amount: number): number => {
      // mod_types = "Add","Add if > 0","Multiply","Multiply if > 0",
      // "Replace","Replace if Greater"
      let value = current_amount;
      switch(mod_type) {
        case "Add": value = mod_amount + current_amount; break;
        case "Add if > 0": value = mod_amount > 0 ? mod_amount + current_amount : current_amount; break;
        case "Multiply": value = Math.floor(mod_amount * current_amount); break;
        case "Multiply if > 0": value = mod_amount > 0 ? Math.floor(mod_amount * current_amount) : current_amount; break;
        case "Replace": value = mod_amount; break;
        case "Replace if Greater": value = Math.max(mod_amount, current_amount); break;
      }
      return Math.max(0, value);
    };
    const source_id = cf instanceof CharacterFeature ? (cf.use_item_id === "" ? cf.root_id : cf.use_item_id) : "";
    const use_item_id = cf instanceof CharacterFeature ? cf.use_item_id : "";
    const source_true_id = cf instanceof CharacterFeature ? cf.source_true_id : "";
    // const source_type = cf instanceof CharacterFeature ? cf.source_type : "";
    const calc_steps: string[] = [];

    // console.log(cf.name);
    if (cf.floating_feature && char_int instanceof Character) {
      const mod = cf.floating_feature as Modifier;
      if (mod) {
        const mod_type = mod.mod_type;
        if (mod.modifies === "Table Value") {
          char_int.table_modifiers.push(mod);
        } else if (mod.modifies === "Formula Value") {
          const amount = this.getModifierAmount(char_int, char_int.mind.current_ability_scores, mod, source_id, use_item_id);
          if (amount) {
            char_int.formula_values[mod.modifies_details[0]] = get_amount(mod_type, char_int.formula_values[mod.modifies_details[0]], +amount);
          }
        } else if (this.checkArmorRequirements(char_int, mod)) {
          let amount = this.getModifierAmount(char_int, char_int.mind.current_ability_scores, mod, source_id, use_item_id);
          if (typeof(amount) === "number") {
            if (mod.modifies === "Max HP") {
              if (mod_type.includes("Add")) {
                max_hp_bonuses = get_amount(mod_type, max_hp_bonuses, +amount);
                if (cf instanceof CharacterFeature) {
                  const cfb = char.mind.char_feature_bases.find(o => o.true_id === cf.cfb_id);
                  if (cfb) {
                    const cfs = char.char_feature_sources.find(o => cfb.ancestries.find(o => o.true_id === cfb.source_true_id));
                    if (cfs) {
                      calc_steps.push(`Max HP Adjusted by ${cfb.name} on ${cfs.name} (${max_hp_bonuses})`);
                    }
                  }
                }
              } else {
                max_hit_points = get_amount(mod_type, max_hit_points, +amount);
                if (cf instanceof CharacterFeature) {
                  const cfb = char.mind.char_feature_bases.find(o => o.true_id === cf.cfb_id);
                  if (cfb) {
                    const cfs = char.char_feature_sources.find(o => cfb.ancestries.find(o => o.true_id === cfb.source_true_id));
                    if (cfs) {
                      calc_steps.push(`Max HP Changed by ${cfb.name} on ${cfs.name} (${max_hit_points})`);
                    }
                  }
                }
              }
            } else if (mod.modifies === "AC") {
              if (mod.mod_type.includes("Add")) {
                armor_class_bonuses = get_amount(mod_type, armor_class_bonuses, +amount);
              } else {
                base_armor_class = get_amount(mod_type, base_armor_class, +amount);
              }
            } else if (mod.modifies === "Med Armor Max AC from DEX") {
              char_int.mind.max_ac_dex_bonus_for_med_armor = get_amount(mod_type, armor_class_bonuses, +amount);
            } else if (mod.modifies === "Speed") {
              if (amount === -1) {
                amount = char_int.speed.walk;
              }
              if (mod.modifies_details.includes("All")) {
                char_int.speed.walk = get_amount(mod_type, char_int.speed.walk, +amount);
                if (char_int.speed.swim > 0) {
                  char_int.speed.swim = get_amount(mod_type, char_int.speed.swim, +amount);
                }
                if (char_int.speed.fly > 0) {
                  char_int.speed.fly = get_amount(mod_type, char_int.speed.fly, +amount);
                }
                if (char_int.speed.climb > 0) {
                  char_int.speed.climb = get_amount(mod_type, char_int.speed.climb, +amount);
                }
                if (char_int.speed.burrow > 0) {
                  char_int.speed.burrow = get_amount(mod_type, char_int.speed.burrow, +amount);
                }
              } else {
                for (let i = 0; i < mod.modifies_details.length; i++) {
                  switch (mod.modifies_details[i]) {
                    case "Walking":
                      char_int.speed.walk = get_amount(mod_type, char_int.speed.walk, +amount);
                    break;
                    case "Swimming":
                      char_int.speed.swim = get_amount(mod_type, char_int.speed.swim, +amount);
                    break;
                    case "Flying":
                      char_int.speed.fly = get_amount(mod_type, char_int.speed.fly, +amount);
                    break;
                    case "Climbing":
                      char_int.speed.climb = get_amount(mod_type, char_int.speed.climb, +amount);
                    break;
                    case "Burrowing":
                      char_int.speed.burrow = get_amount(mod_type, char_int.speed.burrow, +amount);
                    break;
                  }
                }
              }
            } else if (mod.modifies === "Saving Throw") {
              const bonus = new Bonus();
              bonus.char_feature = cf;
              bonus.source = "Modifier";
              bonus.types = mod.modifies_details;
              if (!mod.rolls.flat.isBlank() || (!mod.rolls.count.isBlank() && !mod.rolls.size.isBlank())) {
                bonus.rolls = mod.rolls.clone();
              } else {
                bonus.rolls.flat.base = +amount;
              }
              saving_throw_bonuses.push(bonus);
            } else if (mod.modifies === "Ability Check") {
              const bonus = new Bonus();
              bonus.char_feature = cf;
              bonus.source = "Modifier";
              bonus.types = mod.modifies_details;
              if (!mod.rolls.flat.isBlank() || (!mod.rolls.count.isBlank() && !mod.rolls.size.isBlank())) {
                bonus.rolls = mod.rolls.clone();
              } else {
                bonus.rolls.flat.base = +amount;
              }
              check_bonuses.push(bonus);
            } else if (mod.modifies === "Skill Check") {
              const bonus = new Bonus();
              bonus.char_feature = cf;
              bonus.source = "Modifier";
              bonus.types = mod.modifies_details;
              if (!mod.rolls.flat.isBlank() || (!mod.rolls.count.isBlank() && !mod.rolls.size.isBlank())) {
                bonus.rolls = mod.rolls.clone();
              } else {
                bonus.rolls.flat.base = +amount;
              }
              check_bonuses.push(bonus);
            } else if (mod.modifies === "Initiative") {
              if (!mod.rolls.count.isBlank() && !mod.rolls.size.isBlank()) {
                console.error("Initiative Bonus Rolls Not Implemented");
                // bonus.rolls = mod.rolls.toRollPlus({ char, source_id });
              // } else {
              //   bonus.rolls.flat = +amount; 
              }
              char_int.mind.initiative_modifier = get_amount(mod.mod_type, char_int.initiative_modifier, +amount);
            } else if (mod.modifies === "Attack") {
              // console.log(mod);
              if ((mod.apply_to.length === 0 || 
                mod.apply_to.includes("Spells")) &&
                mod.rolls.isBlank()
              ) {
                if (char_int instanceof Character) {
                  if (mod.class_ids.includes("Parent")) {
                    const class_finder = char_int.spirit.classes.filter(o => o.true_id === source_true_id);
                    class_finder.forEach(char_class => {
                      char_class.spellcasting.spell_attack = get_amount(mod.mod_type, char_class.spell_attack, +amount);
                    });
                  } else if (mod.class_ids.includes("Any")) {
                    char_int.spirit.classes.forEach(char_class => {
                      char_class.spellcasting.spell_attack = get_amount(mod.mod_type, char_class.spell_attack, +amount);
                    });
                  } else {
                    if (mod.ability_scores.length === 0) {
                      const class_finder = (mod.class_ids.length === 0 || mod.class_ids.includes("Any")) ? 
                        char_int.spirit.classes : char_int.spirit.classes.filter(o => mod.class_ids.includes(o.source_id) || common_util.anyOverlaps(mod.class_ids, o.variant_ids));
                      for (const char_class of class_finder) {
                        char_class.spellcasting.spell_attack = get_amount(mod.mod_type, char_class.spell_attack, +amount);
                      }
                    } else {
                      const class_finder = char_int.spirit.classes.filter(o => mod.ability_scores.includes(o.spellcasting_ability));
                      for (const char_class of class_finder) {
                        char_class.spellcasting.spell_attack = get_amount(mod.mod_type, char_class.spell_attack, +amount);
                      }
                    }
                  }
                }
              } 
              if (mod.apply_to.length === 0 || 
                mod.apply_to.includes("Abilities") || 
                mod.apply_to.includes("Weapons")
              ) {
                const bonus = new Bonus();
                bonus.char_feature = cf;
                bonus.source = "Modifier";
                if (!mod.rolls.flat.isBlank() || (!mod.rolls.count.isBlank() && !mod.rolls.size.isBlank())) {
                  bonus.rolls = mod.rolls.clone(); //.toRollPlus({ char, source_id });
                } else {
                  bonus.rolls.flat.base = +amount;
                }
                if (cf instanceof CharacterFeature && cf.use_item_id !== "") {
                  let weapon_id = "";
                  if (["Weapon","Armor"].includes(cf.source_type)) {
                    weapon_id = source_id;
                  } else if (cf.use_item_id !== "") {
                    // Find the item to make sure it's a weapon
                    const item_finder = char_int instanceof Character ? char_int.inventory.items.filter(o => o.true_id === cf.use_item_id) : [];
                    if (item_finder.length === 1 && ["Weapon","Armor"].includes(item_finder[0].item_type)) {
                      weapon_id = cf.use_item_id;
                    }
                  }
                  bonus.weapon_id = weapon_id;
                }
                attack_bonuses.push(bonus);
              }
            } else if (mod.modifies === "Damage") {
              // If this is from a weapon, 
              // then this bonus only goes with that weapon.
              if (!mod.amount_unb.isBlank()) {
                const bonus = new Bonus();
                bonus.char_feature = cf;
                bonus.source = "Modifier";
                if (mod.amount_unb.isBasic()) {
                  bonus.rolls.flat.base = +amount;
                } else {
                  bonus.rolls.flat = mod.amount_unb.clone();
                }
                if (cf instanceof CharacterFeature && cf.use_item_id !== "") {
                  let weapon_id = "";
                  if (["Weapon","Armor"].includes(cf.source_type)) {
                    weapon_id = source_id;
                  } else if (cf.use_item_id !== "") {
                    // Find the item to make sure it's a weapon
                    const item_finder = char_int instanceof Character ? char_int.inventory.items.filter(o => o.true_id === cf.use_item_id) : [];
                    if (item_finder.length === 1 && ["Weapon","Armor"].includes(item_finder[0].item_type)) {
                      weapon_id = cf.use_item_id;
                    }
                  }
                  bonus.weapon_id = weapon_id;
                }
                damage_bonuses.push(bonus);
              } else {
                if (!mod.rolls.isBlank()) {
                  const bonus = new Bonus();
                  bonus.char_feature = cf;
                  bonus.source = "Modifier";
                  // bonus.types = mod.modifies_details;
                  // bonus.weapon_keywords = mod.weapon_keywords;
                  // bonus.excluded_weapon_keywords = mod.excluded_weapon_keywords;
                  // bonus.damage_types = [...mod.spell_limit.damage_types];
                  // if (bonus.damage_types.includes("Selectable")) {
                  //   if (cf instanceof CharacterFeature) {
                  //     const source = char.char_feature_sources.find(o => o.true_id === cf.source_true_id);
                  //     if (source) {
                  //       bonus.damage_types.push(source.selectable_hash[mod.damage_selectable_key][0]);
                  //     }
                  //   }
                  //   bonus.damage_types = bonus.damage_types.filter(o => o !== "Selectable");
                  // }
                  // bonus.magic_schools = mod.magic_schools;
                  // bonus.spell_list_ids = mod.spell_list_ids;
                  // if (!mod.slot_levels.includes("Any")) {
                  //   bonus.levels = mod.slot_levels.map(o => {
                  //     if (["Cantrip","Cantrips"].includes(o)) {
                  //       return 0;
                  //     } else {
                  //       return +o;
                  //     }
                  //   });
                  // }
                  bonus.rolls = mod.rolls.clone();
                  // If this is from a weapon, 
                  // then this bonus only goes with that weapon.
                  // if (["Weapon","Armor"].includes(source_type)) {
                  //   bonus.weapon_id = source_id;
                  // } else if (use_item_id !== "") {
                  //   // Find the item to make sure it's a weapon
                  //   const item_finder = char_int instanceof Character ? char_int.inventory.items.filter(o => o.true_id === use_item_id) : [];
                  //   if (item_finder.length === 1 && ["Weapon","Armor"].includes(item_finder[0].item_type)) {
                  //     bonus.weapon_id = use_item_id;
                  //   }
                  // }
                  damage_bonuses.push(bonus);
                }
              }
            } else if (mod.modifies === "Attunement Slots") {
              if (char_int instanceof Character) {
                char_int.mind.max_attuned_items = get_amount(mod.mod_type, char_int.mind.max_attuned_items, +amount);
              }
            } else if (mod.modifies === "Spell DC") {
              if (char_int instanceof Character) {
                // I probably need to move this to after the dc calcs are being done
                if (mod.class_ids.includes("Parent")) {
                  const class_finder = char_int.spirit.classes.filter(o => o.true_id === source_true_id);
                  class_finder.forEach(char_class => {
                    char_class.spellcasting.spell_dc = get_amount(mod.mod_type, char_class.spell_dc, +amount);
                  });
                } else if (mod.class_ids.includes("Any")) {
                  char_int.spirit.classes.forEach(char_class => {
                    char_class.spellcasting.spell_dc = get_amount(mod.mod_type, char_class.spell_dc, +amount);
                  });
                } else {
                  if (mod.ability_scores.length === 0) {
                    const class_finder = (mod.class_ids.length === 0 || mod.class_ids.includes("Any")) ? 
                      char_int.spirit.classes : char_int.spirit.classes.filter(o => mod.class_ids.includes(o.source_id) || common_util.anyOverlaps(mod.class_ids, o.variant_ids));
                    class_finder.forEach(char_class => {
                      char_class.spellcasting.spell_dc = get_amount(mod.mod_type, char_class.spell_dc, +amount);
                    });
                  } else {
                    const class_finder = char_int.spirit.classes.filter(o => mod.ability_scores.includes(o.spellcasting_ability));
                    for (const char_class of class_finder) {
                      char_class.spellcasting.spell_dc = get_amount(mod.mod_type, char_class.spell_dc, +amount);
                    }
                  }
                }
              }
            } else if (mod.modifies === "Passive Perception") {
              char_int.mind.passive_bonuses.perception = get_amount(mod.mod_type, char_int.mind.passive_bonuses.perception, +amount);
            } else if (mod.modifies === "Passive Insight") {
              char_int.mind.passive_bonuses.insight = get_amount(mod.mod_type, char_int.mind.passive_bonuses.insight, +amount);
            } else if (mod.modifies === "Passive Investigation") {
              char_int.mind.passive_bonuses.investigation = get_amount(mod.mod_type, char_int.mind.passive_bonuses.investigation, +amount);
            } else if (mod.modifies === "Size") {
              char_int.mind.size_modifier = +amount;
            } else if (mod.modifies === "Size Bonus For Carrying") {
              char_int.mind.size_bonus_for_carrying = get_amount(mod.mod_type, char_int.mind.size_bonus_for_carrying, +amount);
            } else if (mod.modifies === "Carrying Capacity") {
              char_int.mind.carrying_capacity_mult = get_amount(mod.mod_type, char_int.mind.carrying_capacity_mult, +amount);
            } else if (mod.modifies === "Range") {
              const spell_attack_types = ["Melee Spell","Ranged Spell","Save"];
              mod.modifies_details.forEach(detail => {
                const range_bonus: RangeBonus = {
                  attack_type: detail as AttackType,
                  attack_details: spell_attack_types.includes(detail) ? [...mod.magic_schools] : [...mod.weapon_keywords],
                  damage_types: mod.damage_types,
                  mod_type: mod.mod_type,
                  amount: +amount,
                  char_feature: cf
                };
                char_int.mind.range_bonuses.push(range_bonus);
              });
            } else if (mod.modifies === "Ability Score Max") {
              console.log("Ability Score Max Modifiers Not Implemented");
            } else {
              console.log(mod);
            }
          }
        }
      }
    }
    return {
      max_hp_bonuses, 
      max_hit_points,
      armor_class_bonuses,
      base_armor_class,
      saving_throw_bonuses,
      check_bonuses,
      attack_bonuses,
      damage_bonuses,
      calc_steps
    };
  }

  getSpellRangeBonuses(char: CharacterSheetInterface, spell: CharacterSpell | CharacterAbility) {
    const range_bonuses = char.mind.range_bonuses.filter(o => 
      spell.attack_types.includes(o.attack_type) && 
      (o.attack_details.length === 0 || 
        o.attack_details.includes("Any") || 
        o.attack_details.includes(spell.school)) && 
      (o.damage_types.length === 0 || 
        o.damage_types.includes("Any") || 
        common_util.anyOverlaps(o.damage_types, spell.damage_types)));
    const range_overrides = spell.use_spell_overrides.filter(o => o.range_override !== "Don't Override");
    for (const override of range_overrides) {
      if (override.range_override !== "Don't Override") {
        const new_bonus: RangeBonus = {
          attack_type: spell.attack_types[0],
          attack_details: [],
          damage_types: [],
          mod_type: override.range_override,
          amount: this.value(override.range_override_num, { obj: char }),
          char_feature: override.char_feature
        };
        range_bonuses.push(new_bonus);
      }
    }
    return range_bonuses;
  }

  getWeaponRangeBonuses(char: CharacterSheetInterface, char_weapon: CharacterWeapon, attack_type: AttackType) {
    const attack = char_weapon.attacks.find(o => o.attack_type === attack_type);
    const range_bonuses = attack ? char.mind.range_bonuses.filter(o => 
      o.attack_type === attack_type && 
      (o.attack_details.length === 0 || o.attack_details.includes("Any")) && 
      (o.damage_types.length === 0 || o.damage_types.includes("Any") || 
        common_util.anyOverlaps(o.damage_types, attack.damage_rolls.map(o => o.type)))) : [];
    return range_bonuses;
  }

  getNumericPieces(str: string, log_it = false) {
    const pieces: { piece: string, numeric: boolean }[] = [];
    let current_piece = "";
    let numeric = false;
    const num_chars = ["0","1","2","3","4","5","6","7","8","9"];
    if (log_it) {
      console.log(str);
    }
    for (let i = 0; i < str.length; ++i) {
      const ch = str[i];
      const is_numeric = num_chars.includes(ch);
      if (is_numeric) {
        if (!numeric) {
          pieces.push({ piece: current_piece, numeric });
          current_piece = "";
          numeric = true;
        }
        current_piece += ch;
      } else {
        if (numeric) {
          if (ch === ",") {
            // drop it, move on
          } else {
            if (ch === ".") {
              const next_ch = str[i+1];
              if (next_ch && num_chars.includes(next_ch)) {
                // It's a decimal place.  Probably never happen, but just in case
              } else {
                pieces.push({ piece: current_piece, numeric });
                current_piece = "";
                numeric = false;
              }
            } else {
              pieces.push({ piece: current_piece, numeric });
              current_piece = "";
              numeric = false;
            }
            current_piece += ch;
          }
        } else {
          current_piece += ch;
        }
      }
      if (log_it) {
        console.log(current_piece);
        console.log(ch);
      }
    }
    if (log_it) {
      console.log(current_piece);
    }
    if (current_piece !== "") {
      pieces.push({ piece: current_piece, numeric });
    }
    return pieces;
  }

  recalcSpellActions = async (char_int: CharacterSheetInterface, char: Character) => {
    char_int.mind.actions = char_int.mind.actions.filter(o => // Start of Spell Actions
      !["Spell","Spell as Ability","Spell As Ability","Extra Spell as Ability"].includes(o.type));
    for (const spell of char_int.mind.spells) {
      // if (spell.name.includes("Misty")) {
      //   debugger;
      // }
      spell.spell_overrides = [];
      const log_it = false; // spell.name === "Blindness/Deafness"; // 
      const attack = new Attack();
      if (ABILITY_SCORES.includes(spell.spellcasting_ability)) {
        attack.attack_stat = spell.spellcasting_ability as AbilityScoreType;
      }
      if (spell.the_spell) {
        // if (spell.name.includes("Booming")) {
        //   console.log(spell);
        // }
        for (const mod_obj of char_int.mind.spell_modifiers.filter(o => 
          this.fitCharSpellLimit({ char, obj: spell, limit: o.modifier.spell_limit, ancestries: o.ancestries }) // , spell.name.includes("Eldritch Blast")
        )) {
          const mod = mod_obj.modifier as SpellModifier;
          spell.spell_overrides.push(mod.spell_overrides);
        }
      }
      if (log_it) {
        console.log(spell);
        // console.log(range_bonuses);
        // console.log(range);
        debugger;
      }
      attack.type = "Spell";
      spell.attack = attack;
      const disabled_actions_feature = char_int.mind.disable_action_features.find(o => 
        o.floating_feature instanceof DisableActionsFeature && !o.floating_feature.spell_limit.isEmpty() &&
        this.fitCharSpellLimit({ char, obj: spell, limit: o.floating_feature.spell_limit, source_true_id: spell.source_true_id }));
      // Loop through the slot levels >= spell.level and add to actions
      if (spell.level === 0) {
        for (const casting_time of spell.casting_times) {
          const action = new CharacterAction();
          // action.range = range;
          action.type = "Spell";
          action.special_action_type = "Spell";
          action.action = spell;
          action.level = spell.level;
          action.lowest = true;
          action.casting_time = casting_time;
          action.special_casting_time = spell.the_spell?.special_casting_time??"";
          action.feature_disabled = disabled_actions_feature;
          this.getResourceStuff({ character: char_int, action, slot_type: "At Will" });
          char_int.mind.actions.push(action);
        }
      } else {
        if (spell.ritual) {
          const action = new CharacterAction();
          // action.range = range;
          action.ritual_only = true;
          action.type = "Spell";
          action.special_action_type = "Spell";
          action.action = spell;
          action.level = spell.level;
          action.lowest = true;
          action.casting_time = spell.the_spell ? spell.the_spell.casting_time : "A";
          action.special_casting_time = spell.the_spell?.special_casting_time??"";
          action.feature_disabled = disabled_actions_feature;
          this.getResourceStuff({ character: char_int, action, slot_type: "Ritual" });
          char_int.mind.actions.push(action);
        }
        if (!spell.ritual_only) {
          const slot_levels = Array.from(new Set(char_int.body.use_slots.filter(o => o.level >= spell.level).map(o => +o.level as SpellLevel).sort()));
          let lowest = true;
          for (const level of slot_levels) {
            const slots = char_int.body.use_slots.filter(o => o.level === level);
            for (const char_slot of slots) {
              for (const casting_time of spell.casting_times) {
                const action = new CharacterAction();
                // action.range = range;
                action.type = "Spell";
                action.special_action_type = "Spell";
                action.action = spell;
                action.level = level;
                action.lowest = lowest;
                lowest = false;
                action.casting_time = casting_time;
                action.special_casting_time = spell.spell?.special_casting_time??"";
                action.feature_disabled = disabled_actions_feature;
                this.getResourceStuff({ character: char_int, action, slot_type: char_slot.type_id });
                char_int.mind.actions.push(action);
              }
            }
          }
        }
      }
    }
    for (const spell of char_int.mind.ritual_only) {
      spell.spell_overrides = [];
      // const range_bonuses = this.get_spell_range_bonuses(char_int, spell);
      // let range = spell.range;
      // if (range_bonuses.length > 0) {
      //   // Get all the numeric pieces in the range and multiply them.
      //   const numeric_pieces = this.get_numeric_pieces(range);
      //   // I should make some kind of rule about the order of applying these for 
      //   // different mod_types (probably replaces, then multiplies, then adds), 
      //   // but I'm not going to worry about that for now because I'm pretty sure
      //   // multiply are the only ones currently in the game
      //   range_bonuses.forEach(range_bonus => {
      //     switch(range_bonus.mod_type) {
      //       case "Multiply": 
      //         numeric_pieces.filter(o => o.numeric).forEach(piece => {
      //           let num = +piece.piece;
      //           num *= range_bonus.amount;
      //           piece.piece = `${num}`;
      //         });
      //       break;
      //     }
      //   });
      //   range = "";
      //   numeric_pieces.forEach(piece => {
      //     range += piece.piece;
      //   });
      //   spell.calc_range = range;
      // }
      const disabled_actions_feature = char_int.mind.disable_action_features.find(o => 
        o.floating_feature instanceof DisableActionsFeature && !o.floating_feature.spell_limit.isEmpty() &&
        this.fitCharSpellLimit({ char, obj: spell, limit: o.floating_feature.spell_limit, source_true_id: spell.source_true_id }));
      const attack = new Attack();
      if (ABILITY_SCORES.includes(spell.spellcasting_ability)) {
        attack.attack_stat = spell.spellcasting_ability as AbilityScoreType;
      }
      if (spell.the_spell) {
        for (const mod_obj of char_int.mind.spell_modifiers.filter(o => 
          this.fitCharSpellLimit({ char, obj: spell, limit: o.modifier.spell_limit, ancestries: o.ancestries })
        )) {
          const mod = mod_obj.modifier as SpellModifier;
          spell.spell_overrides.push(mod.spell_overrides);
        }
      }
      attack.type = "Spell";
      spell.attack = attack;
      // Loop through the slot levels >= spell.level and add to actions
      const action = new CharacterAction();
      // action.range = range;
      action.type = "Spell";
      action.special_action_type = "Spell";
      action.action = spell;
      action.level = spell.level;
      action.lowest = true;
      action.casting_time = spell.the_spell ? spell.the_spell.casting_time : "A";
      action.special_casting_time = spell.the_spell?.special_casting_time??"";
      action.ritual_only = true;
      action.feature_disabled = disabled_actions_feature;
      this.getResourceStuff({ character: char_int, action, slot_type: "Ritual" });
      char_int.mind.actions.push(action);
    }
    // console.log(char_int.mind.spell_as_abilities);
    for (const char_ability of char_int.mind.spell_as_abilities) {
      // if (char_ability.name.includes("Detect Magic")) {
      //   debugger;
      // }
      char_ability.spell_overrides = [];
      const disabled_actions_feature = char_int.mind.disable_action_features.find(o => 
        o.floating_feature instanceof DisableActionsFeature && !o.floating_feature.spell_limit.isEmpty() &&
        this.fitCharSpellLimit({ char, obj: char_ability, limit: o.floating_feature.spell_limit, source_true_id: char_ability.source_true_id}));
      const attack = new Attack();
      if (ABILITY_SCORES.includes(char_ability.spellcasting_ability)) {
        attack.attack_stat = char_ability.spellcasting_ability as AbilityScoreType;
      }
      if (char_ability.the_spell) {
        for (const mod_obj of char_int.mind.spell_modifiers.filter(o => 
          this.fitCharSpellLimit({ char, obj: char_ability, limit: o.modifier.spell_limit, ancestries: o.ancestries })
        )) {
          const mod = mod_obj.modifier as SpellModifier;
          const overrides = mod.spell_overrides.clone();
          overrides.char_feature = mod_obj.char_feature;
          char_ability.spell_overrides.push(overrides);
        }
      }
      attack.type = "Spell";
      char_ability.attack = attack;
      // spell.recalc_attack_string(char.mind.current_ability_scores);
      // spell damages are based on levels, so calculated elsewhere
      // spell.recalc_damage_string(char.mind.current_ability_scores);
      if (char_ability.the_ability instanceof SpellsFromList) {
        const slot_override = char_ability.the_ability.spell_overrides.slot_override;
        if (char_ability.level === 0 || slot_override === "At Will") {
          for (const casting_time of char_ability.casting_times) {
            const action = new CharacterAction();
            // action.range = range;
            action.type = "Spell As Ability";
            action.special_action_type = "Spell";
            action.action = char_ability;
            action.level = char_ability.level;
            action.casting_time = casting_time;
            action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
            action.special_resource = false;
            action.lowest = true;
            action.feature_disabled = disabled_actions_feature;
            action.no_ritual = char_ability.the_ability.spell_overrides.ritual_override === "No Ritual";
            this.getResourceStuff({ character: char_int, action, slot_type: "At Will" });
            char_int.mind.actions.push(action);
          }
        } else if (slot_override === "Only Special Resource") {
          for (const casting_time of char_ability.casting_times) {
            const action = new CharacterAction();
            // action.range = range;
            action.type = "Spell As Ability";
            action.special_action_type = "Spell";
            action.action = char_ability;
            action.level = char_ability.level;
            action.casting_time = casting_time;
            action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
            action.special_resource = true;
            action.lowest = true;
            action.feature_disabled = disabled_actions_feature;
            action.no_ritual = char_ability.the_ability.spell_overrides.ritual_override === "No Ritual";
            this.getResourceStuff({ character: char_int, action, slot_type: "Special" });
            char_int.mind.actions.push(action);
          }
        } else if (slot_override === "Don't Override" || slot_override === "And Special Resource") {
          const slot_levels = Array.from(new Set(char_int.body.use_slots.filter(o => o.level >= char_ability.level).map(o => o.level)));
          const lowest_level = Math.min(...slot_levels);
          for (const level of slot_levels) {
            for (const casting_time of char_ability.casting_times) {
              const action = new CharacterAction();
              // action.range = range;
              action.type = "Spell As Ability";
              action.special_action_type = "Spell";
              action.action = char_ability;
              action.level = level;
              action.casting_time = casting_time;
              action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
              action.special_resource = slot_override === "And Special Resource";
              action.lowest = level === lowest_level;
              action.feature_disabled = disabled_actions_feature;
              action.no_ritual = char_ability.the_ability.spell_overrides.ritual_override === "No Ritual";
              this.getResourceStuff({ character: char_int, action, slot_type: "Slots" });
              char_int.mind.actions.push(action);
            }
          }
        } else if (slot_override === "Or Special Resource") {
          // console.log(slot_override);
          for (const casting_time of char_ability.casting_times) {
            const action = new CharacterAction();
            // action.range = range;
            action.type = "Spell As Ability";
            action.special_action_type = "Spell";
            action.action = char_ability;
            action.level = char_ability.level;
            action.casting_time = casting_time;
            action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
            action.special_resource = true;
            action.lowest = true;
            action.feature_disabled = disabled_actions_feature;
            action.no_ritual = char_ability.the_ability.spell_overrides.ritual_override === "No Ritual";
            this.getResourceStuff({ character: char_int, action, slot_type: "Special" });
            char_int.mind.actions.push(action);
          }
          
          const slot_levels = Array.from(new Set(char_int.body.use_slots.filter(o => o.level >= char_ability.level).map(o => o.level)));
          const lowest_level = Math.min(...slot_levels);
          for (const level of slot_levels) {
            for (const casting_time of char_ability.casting_times) {
              const action = new CharacterAction();
              // action.range = range;
              action.type = "Spell";
              action.special_action_type = "Spell";
              action.action = char_ability;
              action.casting_time = casting_time;
              action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
              action.level = level;
              action.lowest = level === lowest_level;
              action.feature_disabled = disabled_actions_feature;
              action.no_ritual = char_ability.the_ability.spell_overrides.ritual_override === "No Ritual";
              this.getResourceStuff({ character: char_int, action, slot_type: "Slots" });
              char_int.mind.actions.push(action);
            }
          }
        } else if (slot_override === "At Will or Slot Upcast") {
          // console.log(slot_override);
          for (const casting_time of char_ability.casting_times) {
            const action = new CharacterAction();
            // action.range = range;
            action.type = "Spell As Ability";
            action.special_action_type = "Spell";
            action.action = char_ability;
            action.level = char_ability.level;
            action.casting_time = casting_time;
            action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
            action.special_resource = true;
            action.lowest = true;
            action.feature_disabled = disabled_actions_feature;
            action.no_ritual = char_ability.the_ability.spell_overrides.ritual_override === "No Ritual";
            this.getResourceStuff({ character: char_int, action, slot_type: "At Will" });
            char_int.mind.actions.push(action);
          }
          
          const slot_levels = Array.from(new Set(char_int.body.use_slots.filter(o => o.level > char_ability.level).map(o => o.level)));
          const lowest_level = Math.min(...slot_levels);
          for (const level of slot_levels) {
            for (const casting_time of char_ability.casting_times) {
              const action = new CharacterAction();
              // action.range = range;
              action.type = "Spell";
              action.special_action_type = "Spell";
              action.action = char_ability;
              action.casting_time = casting_time;
              action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
              action.level = level;
              action.lowest = level === lowest_level;
              action.feature_disabled = disabled_actions_feature;
              action.no_ritual = char_ability.the_ability.spell_overrides.ritual_override === "No Ritual";
              this.getResourceStuff({ character: char_int, action, slot_type: "Slots" });
              char_int.mind.actions.push(action);
            }
          }
        }
        if (char_ability.ritual && char_ability.the_ability.spell_overrides.ritual_override !== "No Ritual") {
          for (const casting_time of char_ability.casting_times) {
            const action = new CharacterAction();
            // action.range = range;
            action.ritual_only = true;
            action.type = "Spell";
            action.special_action_type = "Spell";
            action.action = char_ability;
            action.level = char_ability.level;
            action.lowest = true;
            action.casting_time = casting_time;
            action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
            action.feature_disabled = disabled_actions_feature;
            this.getResourceStuff({ character: char_int, action, slot_type: "Ritual" });
            char_int.mind.actions.push(action);
          }
        }
      } else if (char_ability.the_ability instanceof SpellsFromListWithCosts && char_ability._spell) {
        const s = common_util.getSpellWithOverridableCostFromSFLWC(char_ability._spell, char_ability.the_ability);
        if (s) {
          const slot_override = s.cost_override.slot_override;
          if (char_ability.level === 0 || slot_override === "At Will") {
            for (const casting_time of char_ability.casting_times) {
              const action = new CharacterAction();
              // action.range = range;
              action.type = "Spell As Ability";
              action.special_action_type = "Spell";
              action.action = char_ability;
              action.level = char_ability.level;
              action.casting_time = casting_time;
              action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
              action.special_resource = false;
              action.lowest = true;
              action.feature_disabled = disabled_actions_feature;
              action.no_ritual = char_ability.the_ability.spell_overrides.ritual_override === "No Ritual";
              this.getResourceStuff({ character: char_int, action, slot_type: "At Will" });
              char_int.mind.actions.push(action);
            }
          } else if (slot_override === "Only Special Resource") {
            for (const casting_time of char_ability.casting_times) {
              const action = new CharacterAction();
              // action.range = range;
              action.type = "Spell As Ability";
              action.special_action_type = "Spell";
              action.action = char_ability;
              action.level = char_ability.level;
              action.casting_time = casting_time;
              action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
              action.special_resource = true;
              action.lowest = true;
              action.feature_disabled = disabled_actions_feature;
              action.no_ritual = char_ability.the_ability.spell_overrides.ritual_override === "No Ritual";
              this.getResourceStuff({ character: char_int, action, slot_type: "Special" });
              char_int.mind.actions.push(action);
            }
          } else if (slot_override === "Don't Override" || slot_override === "And Special Resource") {
            const slot_levels = Array.from(new Set(char_int.body.use_slots.filter(o => o.level >= char_ability.level).map(o => o.level)));
            const lowest_level = Math.min(...slot_levels);
            for (const level of slot_levels) {
              for (const casting_time of char_ability.casting_times) {
                const action = new CharacterAction();
                // action.range = range;
                action.type = "Spell As Ability";
                action.special_action_type = "Spell";
                action.action = char_ability;
                action.level = level;
                action.casting_time = casting_time;
                action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
                action.special_resource = slot_override === "And Special Resource";
                action.lowest = level === lowest_level;
                action.feature_disabled = disabled_actions_feature;
                action.no_ritual = char_ability.the_ability.spell_overrides.ritual_override === "No Ritual";
                this.getResourceStuff({ character: char_int, action, slot_type: "Slots" });
                char_int.mind.actions.push(action);
              }
            }
          } else if (slot_override === "Or Special Resource") {
            // console.log(slot_override);
            for (const casting_time of char_ability.casting_times) {
              const action = new CharacterAction();
              // action.range = range;
              action.type = "Spell As Ability";
              action.special_action_type = "Spell";
              action.action = char_ability;
              action.level = char_ability.level;
              action.casting_time = casting_time;
              action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
              action.special_resource = true;
              action.lowest = true;
              action.feature_disabled = disabled_actions_feature;
              action.no_ritual = char_ability.the_ability.spell_overrides.ritual_override === "No Ritual";
              this.getResourceStuff({ character: char_int, action, slot_type: "Special" });
              char_int.mind.actions.push(action);
            }
            
            const slot_levels = Array.from(new Set(char_int.body.use_slots.filter(o => o.level >= char_ability.level).map(o => o.level)));
            const lowest_level = Math.min(...slot_levels);
            for (const level of slot_levels) {
              for (const casting_time of char_ability.casting_times) {
                const action = new CharacterAction();
                // action.range = range;
                action.type = "Spell";
                action.special_action_type = "Spell";
                action.action = char_ability;
                action.casting_time = casting_time;
                action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
                action.level = level;
                action.lowest = level === lowest_level;
                action.feature_disabled = disabled_actions_feature;
                action.no_ritual = char_ability.the_ability.spell_overrides.ritual_override === "No Ritual";
                this.getResourceStuff({ character: char_int, action, slot_type: "Slots" });
                char_int.mind.actions.push(action);
              }
            }
          } else if (slot_override === "At Will or Slot Upcast") {
            // console.log(slot_override);
            for (const casting_time of char_ability.casting_times) {
              const action = new CharacterAction();
              // action.range = range;
              action.type = "Spell As Ability";
              action.special_action_type = "Spell";
              action.action = char_ability;
              action.level = char_ability.level;
              action.casting_time = casting_time;
              action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
              action.special_resource = true;
              action.lowest = true;
              action.feature_disabled = disabled_actions_feature;
              action.no_ritual = char_ability.the_ability.spell_overrides.ritual_override === "No Ritual";
              this.getResourceStuff({ character: char_int, action, slot_type: "At Will" });
              char_int.mind.actions.push(action);
            }
            
            const slot_levels = Array.from(new Set(char_int.body.use_slots.filter(o => o.level > char_ability.level).map(o => o.level)));
            const lowest_level = Math.min(...slot_levels);
            for (const level of slot_levels) {
              for (const casting_time of char_ability.casting_times) {
                const action = new CharacterAction();
                // action.range = range;
                action.type = "Spell";
                action.special_action_type = "Spell";
                action.action = char_ability;
                action.casting_time = casting_time;
                action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
                action.level = level;
                action.lowest = level === lowest_level;
                action.feature_disabled = disabled_actions_feature;
                action.no_ritual = char_ability.the_ability.spell_overrides.ritual_override === "No Ritual";
                this.getResourceStuff({ character: char_int, action, slot_type: "Slots" });
                char_int.mind.actions.push(action);
              }
            }
          }
          if (char_ability.ritual && char_ability.the_ability.spell_overrides.ritual_override !== "No Ritual") {
            for (const casting_time of char_ability.casting_times) {
              const action = new CharacterAction();
              // action.range = range;
              action.ritual_only = true;
              action.type = "Spell";
              action.special_action_type = "Spell";
              action.action = char_ability;
              action.level = char_ability.level;
              action.lowest = true;
              action.casting_time = casting_time;
              action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
              action.feature_disabled = disabled_actions_feature;
              this.getResourceStuff({ character: char_int, action, slot_type: "Ritual" });
              char_int.mind.actions.push(action);
            }
          }
        }
      } else if (char_ability.sidekick_ability) {
        // if (spell.name.includes("Cure")) {
        //   console.log(spell);
        // }
        if (char_ability.level === 0) {
          for (const casting_time of char_ability.casting_times) {
            const action = new CharacterAction();
            // action.range = range;
            action.type = "Spell As Ability";
            action.special_action_type = "Spell";
            action.action = char_ability;
            action.level = char_ability.level;
            action.casting_time = casting_time;
            action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
            action.special_resource = false;
            action.lowest = true;
            action.feature_disabled = disabled_actions_feature;
            this.getResourceStuff({ character: char_int, action, slot_type: "At Will" });
            char_int.mind.actions.push(action);
          }
        } else {
          switch (char_ability.sidekick_cast_type) {
            case "Slot":
              if (true) { // Add it as a 1/Day in addition to slots
                for (const casting_time of char_ability.casting_times) {
                  const action = new CharacterAction();
                  // action.range = range;
                  action.type = "Spell As Ability";
                  action.special_action_type = "Spell";
                  action.action = char_ability;
                  action.level = char_ability.level;
                  action.casting_time = casting_time;
                  action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
                  action.special_resource = true;
                  action.lowest = true;
                  action.feature_disabled = disabled_actions_feature;
                  this.getResourceStuff({ character: char_int, action, slot_type: "Special" });
                  char_int.mind.actions.push(action);
                }
              }
              const slot_levels = Array.from(new Set(char_int.body.use_slots.filter(o => o.level >= char_ability.level).map(o => o.level)));
              const lowest_level = Math.min(...slot_levels);
              for (const level of slot_levels) {
                for (const casting_time of char_ability.casting_times) {
                  const action = new CharacterAction();
                  // action.range = range;
                  action.type = "Spell As Ability";
                  action.special_action_type = "Spell";
                  action.action = char_ability;
                  action.level = level;
                  action.casting_time = casting_time;
                  action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
                  if (char_ability.the_ability instanceof SpellsFromList) {
                    action.special_resource = char_ability.the_ability.spell_overrides.slot_override === "And Special Resource";
                  } else if (char_ability.the_ability instanceof SpellsFromListWithCosts && char_ability._spell) {
                    const s = common_util.getSpellWithOverridableCostFromSFLWC(char_ability._spell, char_ability.the_ability);
                    
                    if (s) {
                      action.special_resource = s.cost_override.slot_override === "And Special Resource";
                    }
                  }
                  action.lowest = level === lowest_level;
                  action.feature_disabled = disabled_actions_feature;
                  this.getResourceStuff({ character: char_int, action, slot_type: "Slots" });
                  char_int.mind.actions.push(action);
                }
              }
            break;
            case "At Will":
              if (true) {
                for (const casting_time of char_ability.casting_times) {
                  const action = new CharacterAction();
                  // action.range = range;
                  action.type = "Spell As Ability";
                  action.special_action_type = "Spell";
                  action.action = char_ability;
                  action.level = char_ability.level;
                  action.casting_time = casting_time;
                  action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
                  action.special_resource = false;
                  action.lowest = true;
                  action.feature_disabled = disabled_actions_feature;
                  this.getResourceStuff({ character: char_int, action, slot_type: "At Will" });
                  char_int.mind.actions.push(action);
                }
              }
            break;
            case "Ritual":
              if (true) {
                const action = new CharacterAction();
                // action.range = range;
                action.ritual_only = true;
                action.type = "Spell";
                action.special_action_type = "Spell";
                action.action = char_ability;
                action.level = char_ability.level;
                action.lowest = true;
                action.casting_time = char_ability.the_spell ? char_ability.the_spell.casting_time : "A";
                action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
                action.feature_disabled = disabled_actions_feature;
                this.getResourceStuff({ character: char_int, action, slot_type: "Ritual" });
                char_int.mind.actions.push(action);
              }
            break;
            default:
              const x_per_day = +char_ability.sidekick_cast_type;
              if (!isNaN(x_per_day)) { // x_per_day attached to spell previously
                for (const casting_time of char_ability.casting_times) {
                  const action = new CharacterAction();
                  // action.range = range;
                  action.type = "Spell As Ability";
                  action.special_action_type = "Spell";
                  action.action = char_ability;
                  action.level = char_ability.level;
                  action.casting_time = casting_time;
                  action.special_casting_time = char_ability.the_spell?.special_casting_time??"";
                  action.special_resource = true;
                  action.lowest = true;
                  action.feature_disabled = disabled_actions_feature;
                  this.getResourceStuff({ character: char_int, action, slot_type: "Special" });
                  char_int.mind.actions.push(action);
                }
              }
            break;
          }
        }
      }
    }
    
    if (char_int instanceof Character) {
      for (const item of char_int.inventory.items.filter(o => o.spell_storing_spell.spell_id !== "")) {
        const stored_spell = item.spell_storing_spell;
        let spell = stored_spell.the_spell;
        stored_spell.item_id = item.true_id;
        if (!spell) {
          spell = data_util.getSpell(stored_spell.spell_id);
          stored_spell.the_spell = spell;
        }
        if (stored_spell.attack.attack_rolls.length === 0) {
          const attack_roll = new RollPlus();
          attack_roll.flat = stored_spell.spell_attack;
          stored_spell.attack.attack_rolls.push(attack_roll);
          stored_spell.attack.recalc_attack_string(null);
        }
        if (spell) {
          const action = new CharacterAction();
          // action.range = range;
          action.type = "Spell As Ability";
          action.special_action_type = "Spell";
          action.action = stored_spell;
          action.level = stored_spell.level;
          action.casting_time = spell.casting_time;
          action.special_casting_time = spell.special_casting_time;
          action.special_resource = true;
          action.lowest = true;
          action.dc = stored_spell.spell_dc;
          action.attack_mod = stored_spell.spell_attack;
          char_int.mind.actions.push(action);
        }
      }
      for (const item of char_int.inventory.items.filter(o => o.stored_spells.length > 0)) {
        for (const stored_spell of item.stored_spells) {
          let spell = stored_spell.the_spell;
          stored_spell.item_id = item.true_id;
          if (!spell) {
            spell = data_util.getSpell(stored_spell.spell_id);
            stored_spell.the_spell = spell;
          }
          if (stored_spell.attack.attack_rolls.length === 0) {
            const attack_roll = new RollPlus();
            attack_roll.flat = stored_spell.spell_attack;
            stored_spell.attack.attack_rolls.push(attack_roll);
            stored_spell.attack.recalc_attack_string(null);
          }
          if (spell) {
            const action = new CharacterAction();
            // action.range = range;
            action.type = "Spell As Ability";
            action.special_action_type = "Spell";
            action.action = stored_spell;
            action.level = stored_spell.level;
            action.casting_time = spell.casting_time;
            action.special_casting_time = spell.special_casting_time;
            action.special_resource = true;
            action.lowest = true;
            action.dc = stored_spell.spell_dc;
            action.attack_mod = stored_spell.spell_attack;
            char_int.mind.actions.push(action);
          }
        }
      }

      for (const cf of char_int.mind.spell_damage_options) {
        const sdo = cf.floating_feature;
        if (sdo instanceof SpellDamageOptions) {
          const spell_limit = sdo.spell_limit;
          if (sdo.learning) {
            const learning_limit = sdo.learning_limit;
            if (sdo.level_by_level) {
              const damage_types_by_level: { [level: number]: DamageType[] } = {};
              for (const spell of char_int.mind.spellbook_spells) {
                if (damage_types_by_level[spell.level] === undefined) {
                  damage_types_by_level[spell.level] = [];
                }
                if (!common_util.list1ContainsList2(damage_types_by_level[spell.level], spell.base_damage_types) && this.fitCharSpellLimit({ char, obj: spell, limit: learning_limit, source_true_id: spell.source_true_id})) {
                  damage_types_by_level[spell.level] = [...damage_types_by_level[spell.level],...spell.base_damage_types];
                }
              }
              for (const spell of char_int.mind.spells) {
                if (damage_types_by_level[spell.level] === undefined) {
                  damage_types_by_level[spell.level] = [];
                }
                if (!common_util.list1ContainsList2(damage_types_by_level[spell.level], spell.base_damage_types) && this.fitCharSpellLimit({ char, obj: spell, limit: learning_limit, source_true_id: spell.source_true_id})) {
                  damage_types_by_level[spell.level] = [...damage_types_by_level[spell.level],...spell.base_damage_types];
                }
              }
              for (const spell of char_int.mind.spell_as_abilities) {
                if (damage_types_by_level[spell.level] === undefined) {
                  damage_types_by_level[spell.level] = [];
                }
                if (!common_util.list1ContainsList2(damage_types_by_level[spell.level], spell.base_damage_types) && this.fitCharSpellLimit({ char, obj: spell, limit: learning_limit, source_true_id: spell.source_true_id})) {
                  damage_types_by_level[spell.level] = [...damage_types_by_level[spell.level],...spell.base_damage_types];
                }
              }

              const spell_actions = char_int.mind.actions.filter(o => ["Spell","Spell as Ability","Spell As Ability","Extra Spell as Ability"].includes(o.type));

              for (const spell_action of spell_actions) {
                if (damage_types_by_level[spell_action.level]) {
                  if ((spell_action.action instanceof CharacterSpell || spell_action.action instanceof CharacterAbility) && this.fitCharSpellLimit({ char, obj: spell_action.action, limit: spell_limit, source_true_id: spell_action.action.source_true_id})) {
                    spell_action.damage_type_options = common_util.unique_array([...spell_action.action.base_damage_types,...spell_action.damage_type_options,...damage_types_by_level[spell_action.level]]);
                  }
                }
              }
            } else {
              let damage_types: DamageType[] = [];
              for (const spell of char_int.mind.spells) {
                if (!common_util.list1ContainsList2(damage_types, spell.base_damage_types) && this.fitCharSpellLimit({ char, obj: spell, limit: learning_limit, source_true_id: spell.source_true_id})) {
                  damage_types = [...damage_types,...spell.base_damage_types];
                }
              }
              for (const spell of char_int.mind.spell_as_abilities) {
                if (!common_util.list1ContainsList2(damage_types, spell.base_damage_types) && this.fitCharSpellLimit({ char, obj: spell, limit: learning_limit, source_true_id: spell.source_true_id})) {
                  damage_types = [...damage_types,...spell.base_damage_types];
                }
              }

              const spell_actions = char_int.mind.actions.filter(o => ["Spell","Spell as Ability","Spell As Ability","Extra Spell as Ability"].includes(o.type));

              for (const spell_action of spell_actions) {
                if ((spell_action.action instanceof CharacterSpell || spell_action.action instanceof CharacterAbility) && this.fitCharSpellLimit({ char, obj: spell_action.action, limit: spell_limit, source_true_id: spell_action.action.source_true_id})) {
                  spell_action.damage_type_options = common_util.unique_array([...spell_action.action.base_damage_types,...spell_action.damage_type_options,...damage_types]);
                }
              }
            }
          } else {
            let damage_types = sdo.damage_type_options;
            if (damage_types.includes("Selectable")) {
              damage_types = damage_types.filter(o => o !== "Selectable");
              
              const ancestries = cf.ancestries;
              const source_true_ids = ancestries.map(o => o.true_id);
              const cfss = char.char_feature_sources.filter(o => source_true_ids.includes(o.true_id));
              let found = false;
              for (const cfs of cfss) {
                const selectables = cfs.selectable_hash[sdo.selectable_key];
                if (selectables) {
                  for (const dt of selectables) {
                    if (isDamageType(dt)) {
                      damage_types.push(dt);
                    } else {
                      // Might be a Dragon Breed, with an associated Damage Type
                      const draconic_dt = DRACONIC_DAMAGE_TYPES_ANY[dt];
                      if (draconic_dt) {
                        damage_types.push(draconic_dt);
                      }
                    }
                  }
                  found = true;
                  break;
                }
              }
              if (!found) {
                // It could be a feature from a main cfs that has the selectable set in a special_feature
                const cfs = char.char_feature_sources.find(o => o.source_type === "SpecialFeature" && o.selectable_hash[sdo.selectable_key] !== undefined);
                if (cfs) {
                  const selectables = cfs.selectable_hash[sdo.selectable_key];
                  if (selectables) {
                    for (const dt of selectables) {
                      if (isDamageType(dt)) {
                        damage_types.push(dt);
                      } else {
                        // Might be a Dragon Breed, with an associated Damage Type
                        const draconic_dt = DRACONIC_DAMAGE_TYPES_ANY[dt];
                        if (draconic_dt) {
                          damage_types.push(draconic_dt);
                        }
                      }
                    }
                  }
                }
              }
            }

            const spell_actions = char_int.mind.actions.filter(o => // End of Spell Actions
              ["Spell","Spell as Ability","Spell As Ability","Extra Spell as Ability"].includes(o.type));

            for (const spell_action of spell_actions) {
              if ((spell_action.action instanceof CharacterSpell || spell_action.action instanceof CharacterAbility) && this.fitCharSpellLimit({ char, obj: spell_action.action, limit: spell_limit, source_true_id: spell_action.action.source_true_id})) {
                spell_action.damage_type_options = common_util.unique_array([...spell_action.action.base_damage_types,...spell_action.damage_type_options,...(damage_types.filter(o => o !== "Selectable") as DamageType[])]);
              }
            }
          }
        }
      }
    }
  }

  recalcWeaponActions(char: Character) {
    char.mind.actions = char.mind.actions.filter(o => // Weapon Actions
      o.type !== "Weapon");
    
    // Go through weapons
    const item_actions = char.inventory.items.filter(o =>
      o.base_item &&
      o.base_item.item_type === "Weapon" &&
      o.equipped);
    let two_handed_id = "";
    const two_handed_finder = WEAPON_KEYWORDS.filter(o => o.name === "Two-Handed");
    if (two_handed_finder.length === 1) {
      two_handed_id = two_handed_finder[0]._id;
    }
    const weapon_actions = item_actions.filter(o => o.item_type === "Weapon" && o instanceof CharacterWeapon);
    for (const char_item of weapon_actions) {
      const char_weapon = char_item as CharacterWeapon;
      const disabled_actions_feature = char.mind.disable_action_features.find(o => 
        o.floating_feature instanceof DisableActionsFeature && !o.floating_feature.weapon_limit.isEmpty() &&
        this.fitCharWeaponLimit(char, char_weapon, o.floating_feature.weapon_limit));
      const { weapon_keywords, wkus, wku2s } = this.getWeaponKeywordsForWeapon(char, char_weapon);
      char_weapon.weapon_keywords = weapon_keywords;
      char_weapon.weapon_keyword_upgrades = wkus;
      char_weapon.weapon_keyword_upgrade2s = wku2s;
      if (char_weapon.weapon_keywords.filter(o => 
        o.name === "Range" || o.name === "Ranged").length > 0 &&
        char.spirit.feats.filter(o => o.name === "Sharpshooter").length > 0) {
        char_weapon.range_override = char_weapon.range2;
        console.log("TODO: This should be changed");
      }
      char_weapon.attacks = this.getWeaponAttacks(char_weapon, char, two_handed_id);
      if (char_weapon.attacks.find(o => !o.bonus_action)) {
        const action = new CharacterAction();
        action.type = "Weapon";
        action.special_action_type = "Attack";
        action.action = char_weapon;
        action.casting_time = "Attack";
        action.lowest = true;
        action.feature_disabled = disabled_actions_feature;
        this.getResourceStuff({ character: char, action, slot_type: "" });
        char.mind.actions.push(action);
      }
      if (this.canBonusActionAttack(char_weapon, char) && char_weapon.attacks.find(o => o.bonus_action)) {
        const action = new CharacterAction();
        action.type = "Weapon";
        action.special_action_type = "Attack";
        action.action = char_weapon;
        action.casting_time = "BA";
        action.lowest = true;
        action.feature_disabled = disabled_actions_feature;
        this.getResourceStuff({ character: char, action, slot_type: "" });
        char.mind.actions.push(action);
      }
      if (this.canReactionAttack(char_weapon, char) && char_weapon.attacks.find(o => !o.bonus_action)) {
        const action = new CharacterAction();
        action.type = "Weapon";
        action.special_action_type = "Attack";
        action.action = char_weapon;
        action.casting_time = "RA";
        action.lowest = true;
        action.feature_disabled = disabled_actions_feature;
        this.getResourceStuff({ character: char, action, slot_type: "" });
        char.mind.actions.push(action);  
      }
      // If they can do it as a bonus action or reaction then add
    }
  }

  recalcUnarmedStrikeActions(char: CharacterSheetInterface) {
    const unarmed_strikes = this.getUnarmedStrikes(char);
    // console.log(unarmed_strikes);
    for (const us of unarmed_strikes) {
      const action = new CharacterAction();
      action.type = "Weapon";
      action.special_action_type = "Attack";
      action.action = us;
      action.casting_time = us.bonus_action ? "BA" : "Attack";
      action.lowest = true;
      // action.feature_disabled = disabled_actions_feature;
      this.getResourceStuff({ character: char, action, slot_type: "" });
      char.mind.actions.push(action); // Unarmed Strikes
    }
  }

  recalcAbilityActions(char: CharacterSheetInterface) {
    // debugger;
    // console.log(char.mind.abilities);
    char.mind.actions = char.mind.actions.filter(o => o.type !== "Ability");
    for (const char_ability of char.mind.abilities) {
      const disabled_actions_feature = char.mind.disable_action_features.find(o => 
        o.floating_feature instanceof DisableActionsFeature && !o.floating_feature.ability_limit.isEmpty() &&
        this.fitCharAbilityLimit(char, char_ability, o.floating_feature.ability_limit, o.item_id));
      if (char_ability.ability_type === "Ability" && 
        char_ability.the_ability instanceof Ability) {
        if (char.mind.actions.filter(o => 
          o.action && o.action instanceof CharacterAbility && 
          o.action.true_id === char_ability.true_id).length === 0) {
          const the_ability = char_ability.the_ability as Ability;
          const attack = new Attack();
          if (ABILITY_SCORES.includes(char_ability.spellcasting_ability)) {
            attack.attack_stat = char_ability.spellcasting_ability as AbilityScoreType;
          }
          attack.type = "Ability";
          // Check for modifiers that affect it
          char_ability.attack = attack;
          if (the_ability.consumed_resource.resource_consumed === "Slot") {
            const min_level = the_ability.consumed_resource.slot_level;
            let first_action: CharacterAction | null = null;
            for (const slot of char.body.use_slots.filter(o => o.level >= min_level)) {
              for (const casting_time of char_ability.casting_times) {
                const action = new CharacterAction();
                action.type = "Ability";
                action.action = char_ability;
                action.level = slot.level;
                action.feature_disabled = disabled_actions_feature;
                action.casting_time = casting_time;
                // action.creature_fb_type = 
                if (the_ability instanceof Ability) {
                  action.special_casting_time = the_ability.special_casting_time;
                }
                if (char_ability.the_ability && 
                  char_ability.the_ability instanceof Ability && 
                  char_ability.the_ability.special_action_type !== "Inherit") {
                  action.special_action_type = char_ability.the_ability.special_action_type;
                } else {
                  if (char_ability.char_feature && 
                    char_ability.char_feature.root_type.toLowerCase().includes("item")) {
                    action.special_action_type = "Item Action";
                  } else {
                    action.special_action_type = "Ability";
                  }
                }
                action.lowest = slot.level === min_level;
                // action.char_effects
                if (first_action) {
                  first_action.extra_actions.push(action);
                } else {
                  first_action = action;
                }
                this.getResourceStuff({ character: char, action, slot_type: "" });
              }
            }
            if (first_action) {
              char.mind.actions.push(first_action); // First Ability Action
            }
          } else {
            for (const casting_time of char_ability.casting_times) {
              const action = new CharacterAction();
              action.type = "Ability";
              if (char_ability.the_ability && 
                char_ability.the_ability instanceof Ability && 
                char_ability.the_ability.special_action_type !== "Inherit") {
                action.special_action_type = char_ability.the_ability.special_action_type;
              } else {
                if (char_ability.char_feature && 
                  char_ability.char_feature.root_type.toLowerCase().includes("item")) {
                  action.special_action_type = "Item Action";
                } else {
                  action.special_action_type = "Ability";
                }
              }
              action.action = char_ability;
              action.casting_time = casting_time;
              action.special_casting_time = the_ability.special_casting_time;
              action.lowest = true;
              action.feature_disabled = disabled_actions_feature;
              this.getResourceStuff({ character: char, action, slot_type: "" });
              char.mind.actions.push(action);
              if (char instanceof Character && char.c_options.potions_ba && 
                char_ability.char_feature && 
                char_ability.char_feature.feature && 
                action.action.effects.length === 1 && 
                action.action.effects[0].type === "Healing" && 
                char_ability.source_name.includes("Healing")) {
                const ba = new CharacterAction();
                const ba_char_ability = char_ability.clone();
                ba_char_ability.override_casting_time = "BA";
                ba.type = "Ability";
                if (char_ability.the_ability && 
                  char_ability.the_ability instanceof Ability && 
                  char_ability.the_ability.special_action_type !== "Inherit") {
                  ba.special_action_type = char_ability.the_ability.special_action_type;
                } else {
                  if (char_ability.char_feature.root_type.toLowerCase().includes("item")) {
                    ba.special_action_type = "Item Action";
                  } else {
                    ba.special_action_type = "Ability";
                  }
                }
                ba.action = ba_char_ability;
                ba.casting_time = "BA";
                ba.lowest = true;
                action.feature_disabled = disabled_actions_feature;
                this.getResourceStuff({ character: char, action, slot_type: "" });
                char.mind.actions.push(ba);
              }
            }
          }
        }
      } else if (char_ability.ability_type === "Creature Ability" && 
        char_ability.the_ability instanceof CreatureAbility) {
        if (char.mind.actions.filter(o => 
          o.action && o.action instanceof CharacterAbility && 
          o.action.true_id === char_ability.true_id).length === 0) {
          const the_ability = char_ability.the_ability as CreatureAbility;
          const action = new CharacterAction();
          action.type = "Ability";
          action.creature_fb_type = char_ability.creature_fb_type;
          if (char_ability.char_feature && 
            char_ability.char_feature.root_type.toLowerCase().includes("item")) {
            action.special_action_type = "Item Action";
          } else {
            action.special_action_type = "Ability";
          }
          action.action = char_ability;
          action.casting_time = the_ability.casting_time;
          action.special_casting_time = the_ability.special_casting_time;
          action.lowest = true;
          if (char instanceof TransformInstance && char.creature &&
            the_ability.attack_bonus.isBasic() && the_ability.dc.isBasic()) {
            // TODO: use this same method for being able to make more Creature's have adjustable CRs
            // Need to calculate the attack mod, DC, and flat on potence to use.
            const creature = char.creature;
            const prof_diff = char.mind.proficiency_modifier - creature.proficiency_modifier;
            let attack = the_ability.attack_bonus.base;
            const attack_diff = attack - creature.proficiency_modifier;
            let dc = the_ability.dc.base;
            const dc_diff = dc - creature.proficiency_modifier - 8;
            // Figure out attack ability score
            let use_ability_score: AbilityScoreType | "None" = "None";
            const attack_types = the_ability.effects.map(o => o.attack_type);
            if (attack_types.length > 0) {
              const main_attack_type = attack_types[0];
              switch (main_attack_type) {
                case "Melee Spell": case "Ranged Spell":
                  // It's going to be INT, WIS, or CHA
                  if (attack_diff > 0) {
                    if (creature.getBasicModifier("INT") === attack_diff) {
                      use_ability_score = "INT";
                    } else if (creature.getBasicModifier("WIS") === attack_diff) {
                      use_ability_score = "WIS";
                    } else if (creature.getBasicModifier("CHA") === attack_diff) {
                      use_ability_score = "CHA";
                    }
                  }
                break;
                case "Save":
                  // It could be anything, but it's probably INT, WIS, or CHA.
                  // Check them first
                  if (dc_diff > 0) {
                    if (creature.getBasicModifier("INT") === dc_diff) {
                      use_ability_score = "INT";
                    } else if (creature.getBasicModifier("WIS") === dc_diff) {
                      use_ability_score = "WIS";
                    } else if (creature.getBasicModifier("CHA") === dc_diff) {
                      use_ability_score = "CHA";
                    } else if (creature.getBasicModifier("STR") === dc_diff) {
                      use_ability_score = "STR";
                    } else if (creature.getBasicModifier("DEX") === dc_diff) {
                      use_ability_score = "DEX";
                    } else if (creature.getBasicModifier("CON") === dc_diff) {
                      use_ability_score = "CON";
                    }
                  }
                break;
                case "Ranged": case "Thrown":
                  // It's DEX
                  use_ability_score = "DEX";
                break;
                case "None":
                  // It doesn't have one, but if it's a Healing effect 
                  // then we might want to find the spellcasting_mod for the potence
                  if (the_ability.effects[0].type === "Healing") {
                    const potence = the_ability.effects[0].potences[0];
                    if (potence && potence.rolls.flat.isBasic() && potence.rolls.flat.base !== 0) {
                      const flat = potence.rolls.flat.base;
                      if (creature.getBasicModifier("INT") === flat) {
                        use_ability_score = "INT";
                      } else if (creature.getBasicModifier("WIS") === flat) {
                        use_ability_score = "WIS";
                      } else if (creature.getBasicModifier("CHA") === flat) {
                        use_ability_score = "CHA";
                      }
                    }
                  }
                break;
                default: 
                  // It's probably STR or DEX, but could be a Hexblade or Shillelagh situation
                  if (attack_diff > 0) {
                    if (creature.getBasicModifier("STR") === attack_diff) {
                      use_ability_score = "STR";
                    } else if (creature.getBasicModifier("DEX") === attack_diff) {
                      use_ability_score = "DEX";
                    } else if (creature.getBasicModifier("INT") === attack_diff) {
                      use_ability_score = "INT";
                    } else if (creature.getBasicModifier("WIS") === attack_diff) {
                      use_ability_score = "WIS";
                    } else if (creature.getBasicModifier("CHA") === attack_diff) {
                      use_ability_score = "CHA";
                    }
                  }
                break;
              }
            }
            // Update attack and dc with prof_diff
            if (prof_diff !== 0) {
              if (attack >= creature.proficiency_modifier) {
                attack += prof_diff;
              }
              if (dc >= creature.proficiency_modifier) {
                dc += prof_diff;
              }
            }
            if (use_ability_score !== "None") {
              const old_mod = creature.getBasicModifier(use_ability_score);
              const new_mod = char.mind.current_ability_scores.getModifier(use_ability_score);
              action.mod_flat = new_mod - old_mod;
              if (attack_diff === old_mod) {
                attack += action.mod_flat;
              }
              if (dc_diff === old_mod) {
                dc += action.mod_flat;
              }
            }
            action.attack_mod = attack;
            action.dc = dc;
          }
          action.feature_disabled = disabled_actions_feature;
          this.getResourceStuff({ character: char, action, slot_type: "" });
          char.mind.actions.push(action);
        }
      } else if (char_ability.ability_type === "Minion Ability" && 
        char_ability.the_ability instanceof MinionAbility) {
        if (char.mind.actions.filter(o => 
          o.action && o.action instanceof CharacterAbility && 
          o.action.true_id === char_ability.true_id).length === 0) {
          const the_ability = char_ability.the_ability;
          const action = new CharacterAction();
          action.type = "Ability";
          action.creature_fb_type = char_ability.creature_fb_type;
          if (char_ability.char_feature && 
            char_ability.char_feature.root_type.toLowerCase().includes("item")) {
            action.special_action_type = "Item Action";
          } else {
            action.special_action_type = "Ability";
          }
          action.action = char_ability;
          action.casting_time = the_ability.casting_time;
          action.special_casting_time = the_ability.special_casting_time;
          action.lowest = true;
          if (char instanceof TransformInstance && char.creature &&
            the_ability.attack_bonus.isBasic() && the_ability.dc.isBasic()) {
            // TODO: use this same method for being able to make more Creature's have adjustable CRs
            // Need to calculate the attack mod, DC, and flat on potence to use.
            const creature = char.creature;
            const prof_diff = char.mind.proficiency_modifier - creature.proficiency_modifier;
            let attack = the_ability.attack_bonus.base;
            const attack_diff = attack - creature.proficiency_modifier;
            let dc = the_ability.dc.base;
            const dc_diff = dc - creature.proficiency_modifier - 8;
            // Figure out attack ability score
            let use_ability_score: AbilityScoreType | "None" = "None";
            const attack_types = the_ability.effects.map(o => o.attack_type);
            if (attack_types.length > 0) {
              const main_attack_type = attack_types[0];
              switch (main_attack_type) {
                case "Melee Spell": case "Ranged Spell":
                  // It's going to be INT, WIS, or CHA
                  if (attack_diff > 0) {
                    if (creature.getBasicModifier("INT") === attack_diff) {
                      use_ability_score = "INT";
                    } else if (creature.getBasicModifier("WIS") === attack_diff) {
                      use_ability_score = "WIS";
                    } else if (creature.getBasicModifier("CHA") === attack_diff) {
                      use_ability_score = "CHA";
                    }
                  }
                break;
                case "Save":
                  // It could be anything, but it's probably INT, WIS, or CHA.
                  // Check them first
                  if (dc_diff > 0) {
                    if (creature.getBasicModifier("INT") === dc_diff) {
                      use_ability_score = "INT";
                    } else if (creature.getBasicModifier("WIS") === dc_diff) {
                      use_ability_score = "WIS";
                    } else if (creature.getBasicModifier("CHA") === dc_diff) {
                      use_ability_score = "CHA";
                    } else if (creature.getBasicModifier("STR") === dc_diff) {
                      use_ability_score = "STR";
                    } else if (creature.getBasicModifier("DEX") === dc_diff) {
                      use_ability_score = "DEX";
                    } else if (creature.getBasicModifier("CON") === dc_diff) {
                      use_ability_score = "CON";
                    }
                  }
                break;
                case "Ranged": case "Thrown":
                  // It's DEX
                  use_ability_score = "DEX";
                break;
                case "None":
                  // It doesn't have one, but if it's a Healing effect 
                  // then we might want to find the spellcasting_mod for the potence
                  if (the_ability.effects[0].type === "Healing") {
                    const potence = the_ability.effects[0].potences[0];
                    if (potence && potence.rolls.flat.isBasic() && potence.rolls.flat.base !== 0) {
                      const flat = potence.rolls.flat.base;
                      if (creature.getBasicModifier("INT") === flat) {
                        use_ability_score = "INT";
                      } else if (creature.getBasicModifier("WIS") === flat) {
                        use_ability_score = "WIS";
                      } else if (creature.getBasicModifier("CHA") === flat) {
                        use_ability_score = "CHA";
                      }
                    }
                  }
                break;
                default: 
                  // It's probably STR or DEX, but could be a Hexblade or Shillelagh situation
                  if (attack_diff > 0) {
                    if (creature.getBasicModifier("STR") === attack_diff) {
                      use_ability_score = "STR";
                    } else if (creature.getBasicModifier("DEX") === attack_diff) {
                      use_ability_score = "DEX";
                    } else if (creature.getBasicModifier("INT") === attack_diff) {
                      use_ability_score = "INT";
                    } else if (creature.getBasicModifier("WIS") === attack_diff) {
                      use_ability_score = "WIS";
                    } else if (creature.getBasicModifier("CHA") === attack_diff) {
                      use_ability_score = "CHA";
                    }
                  }
                break;
              }
            }
            // Update attack and dc with prof_diff
            if (prof_diff !== 0) {
              if (attack >= creature.proficiency_modifier) {
                attack += prof_diff;
              }
              if (dc >= creature.proficiency_modifier) {
                dc += prof_diff;
              }
            }
            if (use_ability_score !== "None") {
              const old_mod = creature.getBasicModifier(use_ability_score);
              const new_mod = char.mind.current_ability_scores.getModifier(use_ability_score);
              action.mod_flat = new_mod - old_mod;
              if (attack_diff === old_mod) {
                attack += action.mod_flat;
              }
              if (dc_diff === old_mod) {
                dc += action.mod_flat;
              }
            }
            action.attack_mod = attack;
            action.dc = dc;
          }
          action.feature_disabled = disabled_actions_feature;
          this.getResourceStuff({ character: char, action, slot_type: "" });
          char.mind.actions.push(action);
        }
      } else if (char_ability.ability_type === "Skill as Ability" &&
        char_ability.the_ability instanceof SkillAsAbility) {
        if (char.mind.actions.filter(o => 
          o.action && o.action instanceof CharacterAbility && 
          o.action.true_id === char_ability.true_id).length === 0) {
          const action = new CharacterAction();
          action.type = "Skill as Ability";
          action.action = char_ability;
          action.lowest = true;
          if (char_ability.the_ability && 
            char_ability.the_ability instanceof Ability && 
            char_ability.the_ability.special_action_type !== "Inherit") {
            action.special_action_type = char_ability.the_ability.special_action_type;
          } else {
            action.special_action_type = "Ability";
          }
          action.casting_time = char_ability.the_ability instanceof SkillAsAbility ? char_ability.the_ability.casting_time : "A";
          this.getResourceStuff({ character: char, action, slot_type: "" });
          char.mind.actions.push(action);
        }
      }
    }
    if (char instanceof Character) {
      const light_attack_actions = char.mind.actions.filter(o => 
        o.casting_time === "Light Attack" &&
        o.action instanceof CharacterAbility &&
        o.action.the_ability instanceof Ability &&
        o.action.the_ability.counts_as_weapon !== ""
      );
      if (light_attack_actions.length > 0) {
        if (char.c_options.light_melee_action === "Action") {
          for (const action of light_attack_actions) {
            action.casting_time = "Attack";
          }
        } else {
          // let weapon_masteries = char.mind.weapon_masteries.filter(o => 
          //   // o.item_true_id === "" &&
          //   o.char_feature_bases.find(o2 => 
          //     o2.features.find(o3 => 
          //       o3.floating_feature instanceof WeaponKeywordUpgradeFeature && 
          //       o3.floating_feature.base_wk_ids.length === 1 && 
          //       o3.floating_feature.base_wk_ids.includes("5fd12ca47a9c0d15f0a8783b") && 
          //       o3.floating_feature.added_wk_ids.length === 0)));
          // if (weapon_masteries.length > 0) {
          //   for (const action of light_attack_actions) {
          //     if (action.action instanceof CharacterAbility && 
          //       action.action.the_ability instanceof Ability) {
          //       const counts_as_weapon = action.action.the_ability.counts_as_weapon;
          //       const weapon_mastery = weapon_masteries.find(o => o.base_item_id === counts_as_weapon);
          //       if (weapon_mastery) {
          //         action.casting_time = "Attack";
          //       } else {
          //         action.casting_time = "BA";
          //       }
          //     }
          //   }
          // }
        } 
      }
    }
  }

  getResourceStuff({
    character, 
    action, 
    obj: the_obj, 
    slot_type = "Slots",
    log_it = false
  }: {
    character: CharacterSheetInterface, 
    action: CharacterAction, 
    obj?: CharacterAbility | CharacterSpell | StoredSpell | CharacterExtraEffects, 
    slot_type?: string,
    log_it?: boolean
  }) {
    if (log_it) {
      console.log(action);
    }
    let resource_consumed = action.resource_consumed;
    let amount_consumed = action.amount_consumed;
    let and_special = action.and_special;
    let slot = action.slot;
    let disabled = false;
    let special_resource_amount = 0;
    const obj = the_obj ? the_obj : action.action;
    if (obj instanceof StoredSpell) {
      resource_consumed = "Stored Spell";
      amount_consumed = 1;
    } else {
      // const type = action.type;
      let true_id = "";
      if (obj && !(obj instanceof Attack) && !(obj instanceof StoredSpell)) { 
        // if (obj.name.includes("Anom")) {
        //   debugger;
        // }
        true_id = obj.true_id;
        if (obj instanceof CharacterExtraEffects) {
          resource_consumed = obj.resource_consumed;
          amount_consumed = obj.amount_consumed;
          special_resource_amount = obj.special_resource_amount;
          // action.tot
        } else if (resource_consumed === "") {
          if (obj instanceof CharacterSpell) {
            resource_consumed = "Slot";
          } else if (obj instanceof CharacterAbility) { 
            const stuff = obj.getResourceStuff(action, slot_type);
            resource_consumed = stuff.resource_consumed;
            amount_consumed = stuff.amount_consumed;
            slot = stuff.slot;
            and_special = stuff.and_special;
            special_resource_amount = obj.special_resource_amount;
          } else if (obj instanceof CharacterItem) {
            if (obj instanceof CharacterWeapon) {
              // if (obj.ammunition_type !== "None") {
              //   // Ammunition buttons don't use this
              // }
            } else {
              console.error("Not Implemented");
              console.log(obj);
            }
          } 
          action.resource_consumed = resource_consumed;
          action.amount_consumed = amount_consumed;
          action.slot = slot;
          action.and_special = and_special;
        } else if (obj instanceof CharacterAbility && 
          resource_consumed === "Special") { 
          const stuff = obj.getResourceStuff(action, slot_type);
          resource_consumed = stuff.resource_consumed;
          amount_consumed = stuff.amount_consumed;
          slot = stuff.slot;
          and_special = stuff.and_special;
          special_resource_amount = obj.special_resource_amount;
        }
      } 
      if (resource_consumed === "Charge" && obj instanceof CharacterAbility && character instanceof Character) {
        const item_id = obj.char_feature?.use_item_id ?? "";
        const item = character.inventory.items.find(o => o.true_id === item_id);
        if (item) {
          if (item.max_charges === 0) {
            // This means that the item is consumed, so we need to instead check the count.
            disabled = item.count < amount_consumed;
          } else {
            disabled = item.charges_used + amount_consumed > item.max_charges;
          }
        }
      } else if (resource_consumed === "Special") {
        const special_resource_used = character.body.resource_holder.getSpecialResourceUsed(true_id);
        disabled = special_resource_used + amount_consumed > special_resource_amount;
      } else if ((resource_consumed === "Slot" || resource_consumed === "Pact") && 
        obj instanceof CharacterAbility) {
        let level = action.level;
        const the_ability = obj.the_ability;
        let slot_type = ""; // the_ability instanceof Ability ? the_ability.consumed_resource.slot_type : the_ability.spell_overrides.consumed_resource.slot_type;
        if (level === -1) {
          if (the_ability instanceof Ability || 
            the_ability instanceof SpellsFromList) {
            level = the_ability.consumed_resource.slot_level;
            slot_type = the_ability.consumed_resource.slot_type;
          } else if (the_ability instanceof SpellsFromListWithCosts && obj._spell) {
            const s = common_util.getSpellWithOverridableCostFromSFLWC(obj._spell, the_ability);
            if (s) {
              level = s.cost_override.consumed_resource.slot_level;
              slot_type = s.cost_override.consumed_resource.slot_type;
            }
          }
        }
        const filtered_slots = character instanceof BasicCreatureInstance ? [] : 
          (resource_consumed === "Pact" ?
            character.body.use_slots.filter(o => 
              o.level === level &&
              o.slot_name.includes("Pact")
            )
          : character.body.use_slots.filter(o => 
              o.level === level && 
              (slot_type === "" || o.type_id === slot_type)
            )
          );
        if (filtered_slots.length === 1) {
          const slot = filtered_slots[0];
          disabled = slot.used + +amount_consumed > slot.total;
        } else {
          disabled = false;
        }
      } else if (resource_consumed !== "") {
        const char_resource = character.body.resource_holder.getCharacterResource(resource_consumed);
        if (char_resource) {
          disabled = char_resource.used + amount_consumed > char_resource.total;
        }
      }
    }
    return { resource_consumed, amount_consumed, slot, and_special, disabled };
  }

  resourcesChanged = async (character: Character) => {
    await this.recalcSpellSlots(character);
    await this.recalcResources(character);
    await this.recalcActions(character, character);
    character.subscription_holder.resourcesChanged();
  }

  recalcActions = async (char_int: CharacterSheetInterface, char: Character) => {
    const action_ids = char_int.mind.actions.map(o => o.true_id); // Start of recalcActions
    char_int.mind.actions = [];
    if (char_int instanceof Character) {
      char_int.mind.full_actions = [...ACTION_TYPES.filter(o => o.casting_times.includes("A"))];
      char_int.mind.bonus_actions = [
        ...ACTION_TYPES.filter(o => 
          o.casting_times.includes("BA") || 
          char_int.mind.action_type_upgrades.filter(o2 => 
            !o2.reaction && o2.action_types.includes(o._id)).length > 0),
      ];
      char_int.mind.reactions = [
        ...ACTION_TYPES.filter(o => 
          o.casting_times.includes("RA") || 
          char_int.mind.action_type_upgrades.filter(o2 => 
            o2.reaction && o2.action_types.includes(o._id)).length > 0)
      ];
    }
    await this.connectSpellsAndAbilities(char_int, char);
    if (char_int instanceof Character) {
      this.recalcWeaponActions(char_int);
    }
    this.recalcUnarmedStrikeActions(char_int);
    await this.recalcSpellActions(char_int, char);
    this.recalcAbilityActions(char_int);
    for (const action of char_int.mind.actions) {
      action.char_effects = [];
      if (action.action instanceof CharacterSpell || action.action instanceof CharacterAbility) {
        for (const effect of action.action.effects) {
          const attack = this.getAttack({ char_int, spell: action.action, effect, action });
          const dc = this.getDC({ char_int, spell: action.action, effect, action }); // , log_it: action.name.includes("Flame Strike")
          action.char_effects.push({ effect, attack, dc });
        }
      } else if (action.action instanceof CharacterWeapon) {
        // debugger;
        for (const attack of action.action.attacks) {
          action.char_effects.push({ attack, dc: 0 });
        }
      }
    }
    if (!common_util.listsMatch(action_ids, char_int.mind.actions.map(o => o.true_id))) { // End of recalcActions
      char_int.subscription_holder.actionsChanged();
    }
  }

  recalcChecksAndThrows(char: CharacterSheetInterface) {
    // TODO: Move advantages over into these, same for attacks
    const ability_score_types = ["STR","DEX","CON","INT","WIS","CHA"];
    const ability_checks: { 
      STR: CharacterRoll, 
      DEX: CharacterRoll, 
      CON: CharacterRoll, 
      INT: CharacterRoll, 
      WIS: CharacterRoll, 
      CHA: CharacterRoll 
    } = { 
      STR: new CharacterRoll(), 
      DEX: new CharacterRoll(), 
      CON: new CharacterRoll(), 
      INT: new CharacterRoll(), 
      WIS: new CharacterRoll(), 
      CHA: new CharacterRoll()
    };
    const initiative_check: CharacterRoll = new CharacterRoll();
    const saving_throws: { 
      [ability_score: string]: CharacterRoll
    } = { 
      STR: new CharacterRoll(), 
      DEX: new CharacterRoll(), 
      CON: new CharacterRoll(), 
      INT: new CharacterRoll(), 
      WIS: new CharacterRoll(), 
      CHA: new CharacterRoll()
    };
    const skill_checks: { skill_id: string, skill_check: CharacterRoll }[] = [];
    // Loop through the ability scores, get relevant proficiencies (basically just jack of all trades), and add relevant check bonuses, and put them into the char's ability checks
    // In same loop do the saving throws, get relevant proficiencies, and add relevant save bonuses, and put them into the char's saving throws
    for (const ability of ability_score_types) {
      let save_prof_override = -1;
      // const customization = char.mind.saving_throw_customizations[ability];
      // if (customization && customization["Proficiency Override"] && customization["Proficiency Override"].value) {
      //   save_prof_override = customization["Proficiency Override"].value;
      // }
      const ability_check = new CharacterRoll();
      const saving_throw = new CharacterRoll();
      const modifier = char.mind.current_ability_scores.getModifier(ability) as number;
      
      if (char.mind.jack_of_all_trades) {
        ability_check.proficiency = 0.5;
        ability_check.modifier = modifier + Math.floor(char.mind.proficiency_modifier * 0.5);
      } else {
        ability_check.modifier = modifier;
      }
      saving_throw.modifier = modifier;
      for (const bonus of char.mind.check_bonuses.filter(o => o.types.length === 0 || o.types.includes(ability))) {
        const roll_plus = this.toRollPlus(bonus.rolls, { obj: char, item_id: "" });
        roll_plus.recalculate_string();
        ability_check.rolls.push(roll_plus);
      }
      
      (ability_checks as any)[ability] = ability_check;

      if (ability === "DEX") {
        initiative_check.modifier = ability_check.modifier;
        initiative_check.rolls = [...ability_check.rolls];
        // TODO: Initiative Specific bonuses should go here
      }
      if (char.mind.saving_throw_proficiencies.filter(o => o.proficiency_id === ability).length > 0 && save_prof_override === -1) {
        saving_throw.proficiency = 1;
        saving_throw.modifier += char.mind.proficiency_modifier;
      } else if (save_prof_override > 0) {
        saving_throw.proficiency = save_prof_override;
        saving_throw.modifier += char.mind.proficiency_modifier * save_prof_override;
      }

      for (const bonus of char.mind.saving_throw_bonuses.filter(o => o.types.length === 0 || o.types.includes(ability))) {
        const roll_plus = this.toRollPlus(bonus.rolls, { obj: char, item_id: "" });
        roll_plus.recalculate_string();
        saving_throw.rolls.push(roll_plus);
      }
      saving_throws[ability] = saving_throw;
    }
    // Loop through all the skills, get relevant proficiencies, and add relevant check bonuses, and put them into the char's skill checks
    for (const skill of SKILLS) {
      let use_ability_score = skill.use_ability_score;
      const override_feature = char.mind.skill_ability_overrides.find(o => o.skill_ids.includes(skill._id));
      if (override_feature) {
        use_ability_score = override_feature.ability_score;
      }
      if (ability_score_types.includes(use_ability_score)) {
        const skill_check = new CharacterRoll();
        
        const { modifier, proficiency_multiplier } = this.skillModifier(char, skill);
        skill_check.modifier = modifier;
        skill_check.proficiency = proficiency_multiplier;
        char.mind.check_bonuses.filter(o => 
          o.types.length === 0 || 
          o.types.includes(use_ability_score) || 
          o.types.includes(skill._id)).forEach(bonus => {
          const roll_plus = this.toRollPlus(bonus.rolls, { obj: char, item_id: "" });
          roll_plus.recalculate_string();
          skill_check.rolls.push(roll_plus);
        });
        skill_checks.push({ skill_id: skill._id, skill_check });
      }
    }
    char.mind.ability_checks = ability_checks;
    char.mind.initiative_check = initiative_check;
    // for (const ability of Object.keys(char.saving_throw_customizations)) {
    //   const customization = char.saving_throw_customizations[ability];
    //   const override = customization["Override"];
    //   if (override && override.value !== null) {
    //     const save = saving_throws[ability];
    //     if (save) {
    //       save.modifier = override.value;
    //     }
    //   } else {
    //     const modifier = customization["Modifier"];
    //     if (modifier && modifier.value) {
    //       const save = saving_throws[ability];
    //       if (save) {
    //         save.modifier += modifier.value;
    //       }
    //     }
    //   }
    // }
    char.mind.saving_throws = saving_throws;
    char.mind.skill_checks = skill_checks;
  }

  recalcLanguages(char: CharacterSheetInterface) {
    const clfs: CharacterLanguageFeature[] = [];
    let languages_known: string[] = [];
    // if (char instanceof Character && char.spirit.sidekick && char.spirit.sidekick_ci) {
    //   const ci = char.spirit.sidekick_ci;
    //   for (const language of LANGUAGES) {
    //     if (ci.languages.includes(language.name)) {
    //       languages_known.push(language._id);
    //     }
    //   }
    // }
    for (const cf of char.mind.language_features) {
      const opt = cf.feature_options[0] as CharacterLanguageFeature;
      clfs.push(opt);
      languages_known = [...languages_known, ...opt.language_ids];
    }
    // let languages_known = clfs.map(o => o.language_id);
    // const prof_types = Object.keys(char.non_skill_prof_customizations);
    // for (const prof_type of prof_types) {
    //   for (const cust of char.non_skill_prof_customizations[prof_type]) {
    //     if (prof_type === "Language") {
    //       if (cust.proficiency === true) {
    //         const prof = languages_known.find(o => o === cust.id);
    //         if (prof === undefined) {
    //           languages_known.push(cust.id);
    //         }
    //       } else if (cust.proficiency === false) {
    //         languages_known = languages_known.filter(o => o !== cust.id);
    //       }
    //     }
    //   }
    // }
    char.mind.languages_known = languages_known;
    // if (char.spirit.transform && char.spirit.transform.transform && char.spirit.transform.transform.languages_understood) {
    //   char.spirit.transform.languages_known = [...languages_known];
    // }
  }

  recalcKnowledge = async (char: Character) => {
    // debugger;
    char.spirit.knowledge = char.spirit.knowledge.filter(o => [undefined,""].includes(o.cf_id));
    for (const cf of char.mind.knowledge_features) {
      if (char && cf.floating_feature instanceof KnowledgeFeature) {
        const kf = cf.floating_feature;
        const count = this.value(kf.count, { obj: char, source_id: cf.source_true_id, root_id: cf.source_true_id, item_id: cf.item_id });
        const repopKnowledge = async () => {
          const objects = await data_util.getObjects(kf.type);
          if (kf.type === "Spell") {

          } else if (kf.type === "Creature") {

          }
          if (objects.length === count) {
            cf.feature_options = [];
            for (const obj of objects) {
              const knowledge: CharacterKnowledge = {
                type: kf.type,
                usage: kf.usage_key,
                obj_id: obj._id,
                notes: "",
                cf_id: cf.true_id,
                cfs_id: cf.source_true_id
              };
              
              cf.feature_options.push(knowledge);
            }
          } else {
            while (cf.feature_options.length > count) {
              cf.feature_options.splice(-1, 1);
            }
            while (cf.feature_options.length < count) {
              const knowledge: CharacterKnowledge = {
                type: kf.type,
                usage: kf.usage_key,
                obj_id: "",
                notes: "",
                cf_id: cf.true_id,
                cfs_id: cf.source_true_id
              };
              
              cf.feature_options.push(knowledge);
            }
          }
        }
        if (cf.feature_options.length !== count) {
          await repopKnowledge();
        } else {
          const empty_feature_options = (cf.feature_options as CharacterKnowledge[]).filter(o => o.obj_id === "");
          if (empty_feature_options.length === cf.feature_options.length) {
            repopKnowledge();
          }
        }
        // A bug elsewhere made it so some existing characters will have duplicates of knowledge. 
        // This is the best place to clear their data.
        const found_knowledge: string[] = [];
        for (let i = 0; i < cf.feature_options.length; ++i) {
          const knowledge = cf.feature_options[i] as CharacterKnowledge;
          if (found_knowledge.includes(knowledge.obj_id)) {
            knowledge.obj_id = "";
          } else if (knowledge.obj_id !== "") {
            found_knowledge.push(knowledge.obj_id);
          }
        }
      }
      const char_knowledges: CharacterKnowledge[] = cf.feature_options;
      for (const char_knowledge of char_knowledges) {
        if (char_knowledge.obj_id !== "") {
          char.spirit.knowledge.push(char_knowledge);
        }
      }
    }
  }

  recalcSpellSlots = async (char: Character) => {
    const type_levels: any = {};
    const classes = char.spirit.classes.filter(o => o.spell_table !== "");
    if (classes.length > 0) {
      const types = await data_util.getSpellSlotTypes();
      for (const char_class of classes) {
        const class_level = char_class.spellcasting_ability === "None" ? 0 : Math.max(char_class.level, 1);
        // const caster_level = Math.floor((class_level + char_class.spellcasting_level_bonus) * char_class.spellcasting_level);
        
        const caster_level = Math.ceil(class_level * char_class.spellcasting_level);
        if (!type_levels[char_class.spell_table]) {
          type_levels[char_class.spell_table] = {
            level: 0
          };
          const type_finder = types.find(o => o._id === char_class.spell_table);
          if (type_finder) {
            type_levels[char_class.spell_table].table = type_finder;
          }
        }
        type_levels[char_class.spell_table].level += caster_level;
      }
    }
    const slots: CharacterSlot[] = [];
    const type_ids = Object.keys(type_levels);
    for (const type_id of type_ids) {
      const type_obj = type_levels[type_id];
      const table: SpellSlotType = type_obj.table;
      if (table) {
        const highest_level = Math.max(0,...table.entries.filter(o => o.level <= type_obj.level).map(o => o.level));
        const entry = table.entries.find(o => o.level === highest_level);
        if (entry) {
          const keys = Object.keys(entry.slots_per_level);
          for (const sl of keys) {
            const slot_level = +sl;
            const slot = new CharacterSlot();
            (slot as any).level = slot_level;
            slot.total = entry.slots_per_level[slot_level];
            slot.type_id = table._id;
            slot.slot_name = table.slot_name;
            slots.push(slot);
          }
        }
      }
    }
    for (const slot of slots) {
      const slot_finder = char.body.slots.filter(o => o.type_id === slot.type_id && o.level === slot.level);
      if (slot_finder.length === 1) {
        slot.created = slot_finder[0].created;
        slot.used = slot_finder[0].used;
      }
    }
    for (const slot of char.body.slots.filter(o => o.type_id.includes("Created") && o.true_created > 0)) {
      slot.slot_name = slot.type_id;
      slots.push(slot);
    }
    char.body.resource_holder.slots = slots;
    if (char.spirit.transform && char.spirit.transform.transform) {
      const slots = char.spirit.transform.transform.slots;
      char.spirit.transform.resource_holder.slots = slots.includes("All") ? [...char.body.resource_holder.slots] : char.body.resource_holder.slots.filter(o => slots.includes(o.type_id));
    }
  }

  recalcSenses(char: Character) {
    const senses: CharacterSense[] = [];
    // if (char.spirit.sidekick && char.spirit.sidekick_ci) {
    //   const ci = char.spirit.sidekick_ci;
    //   for (const sense of SENSES) {
    //     if (ci.senses[sense._id]) {
    //       const char_sense = new CharacterSense();
    //       char_sense.sense_id = sense._id;
    //       char_sense.range = ci.senses[sense._id];
    //       senses.push(char_sense);
    //     }
    //   }
    // }
    char.mind.sense_features.forEach(cf => {
      const sf = cf.floating_feature as SenseFeature;
      const sense_finder = senses.filter(o => o.sense_id === sf.sense_id);
      if (sense_finder.length === 0) {
        const sense = new CharacterSense();
        sense.sense_id = sf.sense_id;
        sense.range = sf.range;
        sense.features.push(sf);
        senses.push(sense);
      } else {
        const sense = sense_finder[0];
        sense.range = Math.max(sf.range, sense.range);
        sense.features.push(sf);
      }
    });
    senses.filter(o => o.features.length > 1).forEach(s => {
      const or_adds = s.features.filter(o => o.or_add > 0).map(o => o.or_add);
      const or_add_total = or_adds.reduce((a, b) => a + b, 0);
      s.range += or_add_total;
    });
    // for (const sense_id of Object.keys(char.sense_customizations)) {
    //   const customization = char.sense_customizations[sense_id];
    //   let sense = senses.find(o => o.sense_id === sense_id);
    //   if (sense) {
    //     if (customization["Override"] && customization["Override"].value) {
    //       sense.range = customization["Override"].value;
    //     } else if (customization["Modifier"] && customization["Modifier"].value) {
    //       sense.range += customization["Modifier"].value;
    //     }
    //   } else {
    //     sense = new CharacterSense();
    //     sense.sense_id = sense_id;
    //     if (customization["Override"] && customization["Override"].value) {
    //       sense.range = customization["Override"].value;
    //       senses.push(sense);
    //     } else if (customization["Modifier"] && customization["Modifier"].value) {
    //       sense.range = customization["Modifier"].value;
    //       senses.push(sense);
    //     }
    //   }
    // }
    char.mind.senses = senses;
  }

  recalcWeights(char: Character) {
    char.inventory.containers.forEach(container => {
      this.calcWeight(char, container);
    });
    // const weight_carried = char.weight_carried;
    // let encumbrance_level = 0;
    const size_for_carrying = char.mind.use_size + char.mind.size_bonus_for_carrying;
    let str_multiplier = 1;
    if (size_for_carrying === 1) {
      str_multiplier = 0.5;
    } else if (size_for_carrying > 3) {
      str_multiplier = 2 ^ (size_for_carrying - 3);
    }
    str_multiplier *= char.mind.current_ability_scores.strength * char.mind.carrying_capacity_mult;
    char.mind.max_carrying_capacity = 15 * str_multiplier;
    // if (char.c_options.use_encumbrance_effects) {
    //   const encumbrance_condition = this.getEncumbranceCondition(char);
    //   if (encumbrance_condition) {
    //     encumbrance_level = encumbrance_condition.encumbrance_levels.filter(o => 
    //       (o.threshold * str_multiplier) < weight_carried).length;
    //     char.encumbrance_level = encumbrance_level;
    //     char.condition_hash[encumbrance_condition._id].level = encumbrance_level;
    //     encumbrance_condition.feature_bases.filter(o => 
    //       o.level <= encumbrance_level).forEach(fb => {
    //       fb.features.forEach(f => {
    //         // Currently only need to worry about modifiers and advantage here
    //         if (f.feature_type === "Modifier") {
    //           // const response = 
    //           this.applyModifier(char, char, f,
    //             0, char.hp.max,
    //             0, char.base_armor_class,
    //             [], [], [], []);
    //           // console.log(response);
    //           // char.hp.max = max_hit_points + max_hp_bonuses;
    //           // char.base_armor_class = base_armor_class;
    //           // char.armor_class = base_armor_class + armor_class_bonuses;
    //           // char.mind.saving_throw_bonuses = saving_throw_bonuses;
    //           // char.mind.check_bonuses = check_bonuses;
    //           // char.mind.attack_bonuses = attack_bonuses;
    //           // char.mind.damage_bonuses = damage_bonuses;
    //         } else if (f.feature_type === "Advantage") {
    //           if (f.floating_feature instanceof Advantage) {
    //             char.mind.advantages.push({
    //               true_id: uuidv4().toString(),
    //               advantage: f.floating_feature as Advantage,
    //               source_id: encumbrance_condition._id,
    //               source_type: "Condition",
    //               source_name: encumbrance_condition.name,
    //               cfb_id: encumbrance_condition.name,
    //               cfb_name: encumbrance_condition.name,
    //             });
    //           }
    //         }
    //       });
    //     });
    //   }
    // }
  }

  getEncumbranceCondition(char: Character) {
    const cond = data_util.conditions.find(o => char.c_options.encumbrance_id === o._id);
    if (cond) {
      return cond;
    }
    return null;
  }

  connectSpellsAndAbilities = async (char_int: CharacterSheetInterface, char: Character) => {
    const log_it = false;
    // Remove spells that no longer have sources.  They're remnants of removed sources
    const cfs_ids = char.char_feature_sources.map(o => { return o.true_id; });
    // console.log(cfs_ids);
    // console.log(char.mind.spells.map(o => o.name));
    char.mind.spells = char.mind.spells.filter(o => cfs_ids.includes(o.source_true_id));
    // console.log(char.mind.spells.map(o => o.name));
    // Connect sources
    char.mind.spells.filter(o => o.spellcasting_ability === "").forEach(char_spell => {
      const class_finder = char.spirit.classes.filter(o => o.source_id === char_spell.source_id);
      if (class_finder.length === 1) {
        char_spell.connectSource(class_finder[0]);
      } else {
        console.log(char_spell);
      }
    });
    const old_abilities = char_int.mind.abilities;
    const abilities: CharacterAbility[] = [];
    const old_spell_as_abilities = char_int.mind.spell_as_abilities;
    const spell_as_abilities: CharacterAbility[] = [];
    // const do_iaas = char.item_affecting_abilities.length === 0 && char.item_affecting_abilities_type2.length === 0;
    
    // if (char instanceof Character && char.spirit.sidekick && char.spirit.sidekick_ci && char.spirit.sidekick_creature) {
    //   const ci = char.spirit.sidekick_ci;
    //   const spell_levels = Object.keys(ci.use_spells).map(o => +o);
    //   // console.log(spell_levels);
    //   for (const level of spell_levels) {
    //     const spells = ci.use_spells.filter(o => o.spell_level === level);
    //     for (const ci_spell of spells) {
    //       const spell = data_util.spells.find(o => o._id === ci_spell.spell_id);
    //       if (spell) {
    //         await data_util.loadObject(spell);
    //         let char_ability = new CharacterAbility();
    //         char_ability.name = spell.name;
    //         const true_id = char.spirit.sidekick_creature_id + "_" + spell._id;
    //         const ability_finder = old_spell_as_abilities.filter(o => o.true_id === true_id);
    //         if (ability_finder.length === 1) {
    //           char_ability = ability_finder[0];
    //           if (ci_spell.cast_type === "X/Day") {
    //             const x_per_day = ci.x_per_day_for(ci_spell.spell_id);
    //             char_ability.special_resource_amount = x_per_day;
    //             char_ability.special_resource_refresh_rule = "Long Rest";
    //           } else if (ci_spell.cast_type === "Slot") { 
    //             // The actual creature is supposed to have slots.
    //             // Whether the sidekick is given a class with spellcasting or not, 
    //             // we want them to be able to do these 1/Day for free, and also with slots.
    //             char_ability.special_resource_amount = 1;
    //             char_ability.special_resource_refresh_rule = "Long Rest";
    //           }
    //         } else {
    //           if (ci_spell.cast_type === "X/Day") {
    //             const x_per_day = ci.x_per_day_for(ci_spell.spell_id);
    //             // char_ability.special_resource_used = 0;
    //             char_ability.special_resource_amount = x_per_day;
    //             char_ability.special_resource_refresh_rule = "Long Rest";
    //           } else if (ci_spell.cast_type === "Slot") { 
    //             // The actual creature is supposed to have slots.
    //             // Whether the sidekick is given a class with spellcasting or not, 
    //             // we want them to be able to do these 1/Day for free, and also with slots.
    //             // char_ability.special_resource_used = 0;
    //             char_ability.special_resource_amount = 1;
    //             char_ability.special_resource_refresh_rule = "Long Rest";
    //           }
    //         }
    //         char_ability.true_id = true_id;
            
    //         char_ability._spell_id = spell._id;
    //         char_ability.spellcasting_ability = ci.spellcasting_ability;
    //         char_ability.spell_dc = 0;
    //         char_ability.spell_attack = 0;
    //         char_ability._spell = spell;
    //         char_ability.base_slot_level = spell.level;
    //         char_ability.sidekick_ability = true;
    //         char_ability.sidekick_cast_type = ci_spell.cast_type;
    //         spell_as_abilities.push(char_ability);
    //       }
    //     }
    //   }
    // }
    // debugger;
    // log_it = char_int instanceof TransformInstance;
    for (const cf of char_int.mind.ability_features) {
      // log_it = cf.name.includes("Flame Strike");
      if (log_it) {
        // debugger;
        console.log(cf);
      }
      if (cf.floating_feature) {
        if (cf.floating_feature instanceof Ability) {
          // if (cf.floating_feature.name.includes("Mutation")) {
          //   debugger;
          // }
          let char_ability = new CharacterAbility();
          char_ability.copyFeature(cf, char_int, char);
          const ability_finder = old_abilities.filter(o => o.true_id === cf.true_id);
          if (log_it) {
            console.log(char_int);
            console.log(cf);
            console.log(char_ability);
            console.log(old_abilities.filter(o => o.true_id === cf.true_id));
            console.log(ability_finder);
            debugger;
          }
          if (ability_finder.length === 1) {
            char_ability = ability_finder[0];
            char_ability.connectFeature(cf, char_int, char);
          }
          if (SOURCE_BOOK_TYPES.includes(cf.root_type)) {
            char_ability.source_type = cf.source_type;
            char_ability.source_id = cf.use_source_id; // (source_type === "Class" ? source_id : source_id2);
            char_ability.source_id2 = cf.use_source_id;
            char_ability.source_name = cf.use_source_name;
          } else {
            char_ability.source_type = cf.root_type;
            char_ability.source_id = cf.root_id; // (source_type === "Class" ? source_id : source_id2);
            char_ability.source_id2 = cf.use_source_id;
            char_ability.source_name = cf.root_name;
          }
          // char_ability.source_id2 = source_id2;
          if (log_it) {
            console.log(char_ability.source_id2);
          }
          abilities.push(char_ability);
        } else if (cf.floating_feature instanceof CreatureAbility) {
          let char_ability = new CharacterAbility();
          char_ability.copyFeature(cf, char_int, char);
          const ability_finder = old_abilities.filter(o => o.true_id === cf.true_id);
          if (log_it) {
            console.log(char_int);
            console.log(cf);
            console.log(char_ability);
            console.log(old_abilities.filter(o => o.true_id === cf.true_id));
            console.log(ability_finder);
            debugger;
          }
          if (ability_finder.length === 1) {
            char_ability = ability_finder[0];
            char_ability.connectFeature(cf, char_int, char);
          }
          if (SOURCE_BOOK_TYPES.includes(cf.root_type)) {
            char_ability.source_type = cf.source_type;
            char_ability.source_id = cf.use_source_id; // (source_type === "Class" ? source_id : source_id2);
            char_ability.source_id2 = cf.use_source_id;
            char_ability.source_name = cf.use_source_name;
          } else {
            char_ability.source_type = cf.root_type;
            char_ability.source_id = cf.root_id; // (source_type === "Class" ? source_id : source_id2);
            char_ability.source_id2 = cf.use_source_id;
            char_ability.source_name = cf.root_name;
          }
          // char_ability.source_id2 = source_id2;
          if (log_it) {
            console.log(char_ability.source_id2);
          }
          abilities.push(char_ability);
        } else if (cf.floating_feature instanceof SkillAsAbility) {
          let char_ability = new CharacterAbility();
          char_ability.copyFeature(cf, char_int, char);
          const ability_finder = old_abilities.filter(o => o.true_id === cf.true_id);
          if (log_it) {
            console.log(char_int);
            console.log(cf);
            console.log(char_ability);
            console.log(old_abilities.filter(o => o.true_id === cf.true_id));
            console.log(ability_finder);
          }
          if (ability_finder.length === 1) {
            char_ability = ability_finder[0];
            char_ability.connectFeature(cf, char_int, char);
          }
          if (SOURCE_BOOK_TYPES.includes(cf.root_type)) {
            char_ability.source_type = cf.source_type;
            char_ability.source_id = cf.use_source_id; // (source_type === "Class" ? source_id : source_id2);
            char_ability.source_id2 = cf.use_source_id;
            char_ability.source_name = cf.use_source_name;
          } else {
            char_ability.source_type = cf.root_type;
            char_ability.source_id = cf.root_id; // (source_type === "Class" ? source_id : source_id2);
            char_ability.source_id2 = cf.use_source_id;
            char_ability.source_name = cf.root_name;
          }
          // char_ability.source_id2 = source_id2;
          if (log_it) {
            console.log(char_ability.source_id2);
          }
          abilities.push(char_ability);
        } else {
          if (cf.floating_feature instanceof SpellsFromList) {
            const sfl = cf.floating_feature;
            const count = this.value(sfl.count, { obj: char, source_id: cf.source_true_id });

            if (sfl.spell_limit.use_selectable === false) {
              if (cf.feature_options.length !== count) {
                while (cf.feature_options.length > count) {
                  cf.feature_options.splice(cf.feature_options.length - 1, 1);
                }
                while (cf.feature_options.length < count) {
                  cf.feature_options.push("");
                }
              }
            } else {
              cf.feature_options = [];
            }

            let spell_ids: string[] = [];
            let spell_dc = 8;
            // console.log(spell_dc);
            let spell_attack = 0;
            let spellcasting_ability = sfl.spell_overrides.spellcasting_ability;
            // if (sfl.name.includes("Disintegrate")) {
            //   debugger;
            //   for (const char_class of char.spirit.classes) {
            //     console.log(char_class.spell_dc);
            //   }
            // }
            if (sfl.saa_type === "Extra") {
              // debugger;
              // Check the item it's from 
              const char_item = char.inventory.items.find(o => o.true_id === cf.item_id);
              if (char_item) {
                spell_ids.push(char_item.extra);
                if (!char_item.spell_dc.isBlank()) {
                  spell_dc = this.value(char_item.spell_dc, { obj: char });
                  // console.log(spell_dc);
                }
                if (!char_item.spell_attack.isBlank()) {
                  spell_attack = this.value(char_item.spell_attack, { obj: char });
                  // console.log(spell_attack);
                }
                // const spell = data_util.spells.find(o => o._id === char_item.extra);
                // if (spell) {
                //   char_ability._spell = spell;
                // }
              }
            } else if (sfl.spell_limit.use_selectable) {
              const cfs = char.char_feature_sources.find(o => o.true_id === cf.source_true_id);
              if (cfs) {
                const selectables = cfs.selectable_hash[sfl.spell_limit.selectable_key];
                if (selectables) {
                  spell_ids = selectables.filter(o => o !== "");
                }
              }
            } else {
              spell_ids = cf.feature_options;
            }
            if (sfl.saa_type === "Extra") {

            } else {
              if (sfl.spell_overrides.count_as_class_id === "" || 
                sfl.spell_overrides.count_as_class_id === "None" || 
                sfl.spell_overrides.count_as_class_id === "Don't Override") {
                if (spellcasting_ability === "Spellcasting") {
                  let char_class = char.spirit.classes.find(o => o.true_id === cf.source_true_id);
                  if (!char_class) {
                    // It's probably from an item, feat, or gift that is meant to attach to 
                    // whatever Spellcasting feature the character may already have.
                    // Look through all their classes, and get the best one.
                    const dcs = char.spirit.classes.map(o => o.spell_dc);
                    const best_dc = Math.max(...dcs);
                    if (dcs.filter(o => o === best_dc).length === 1) {
                      char_class = char.spirit.classes.find(o => o.spell_dc === best_dc);
                    } else {
                      const spell_attacks = char.spirit.classes.filter(o => o.spell_dc === best_dc).map(o => o.spell_attack);
                      const best_attack = Math.max(...spell_attacks);
                      char_class = char.spirit.classes.find(o => o.spell_dc === best_dc && o.spell_attack === best_attack);
                    }
                  }
                  if (char_class) {
                    spellcasting_ability = char_class.spellcasting_ability;
                    spell_dc = char_class.spell_dc;
                    // console.log(spell_dc);
                    spell_attack = char_class.spell_attack;
                  }
                } else {
                  if (spellcasting_ability === "Same as Feat") {
                    let asi_finder = char_int.mind.asi_features.filter(o => o.source_true_id === cf.source_true_id);
                    if (asi_finder.length !== 1) {
                      const ancestry_ids = cf.ancestries.map(o => o.true_id);
                      asi_finder = char_int.mind.asi_features.filter(o => common_util.listsMatch(o.ancestries.map(o => o.true_id), ancestry_ids));
                    }
                    if (asi_finder.length > 0) {
                      const char_asi_base_feature = asi_finder[0].feature_options[0] as CharacterASIBaseFeature;
                      if (char_asi_base_feature && 
                        char_asi_base_feature.asi_features.length > 0 && 
                        ABILITY_SCORES.includes(char_asi_base_feature.asi_features[0].selected_option)) {
                        spellcasting_ability = char_asi_base_feature.asi_features[0].selected_option as AbilityScoreType;
                      }
                    }
                  } else if (spellcasting_ability === "Selectable") {
                    const source = char.char_feature_sources.find(o => o.true_id === cf.source_true_id);
                    if (source && source.selectable_hash[sfl.spell_overrides.spellcasting_ability_selectable_key] && source.selectable_hash[sfl.spell_overrides.spellcasting_ability_selectable_key].length > 0 && source.selectable_hash[sfl.spell_overrides.spellcasting_ability_selectable_key][0] !== "") {
                      spellcasting_ability = source.selectable_hash[sfl.spell_overrides.spellcasting_ability_selectable_key][0] as AbilityScoreType;
                    }
                  }
                  const modifier = char_int.mind.current_ability_scores.getModifier(spellcasting_ability);
                  if (modifier > -20) {
                    spell_dc += char_int.mind.proficiency_modifier + modifier;
                    // console.log(spell_dc);
                    spell_attack += char_int.mind.proficiency_modifier + modifier;
                  } else {
                    console.log(spellcasting_ability);
                    console.log(cf);
                    console.log(char.char_feature_sources.filter(o => o.true_id === cf.source_true_id));
                  }
                }
              } else {
                let class_finder = char.spirit.classes.filter(o => o.source_id === sfl.spell_overrides.count_as_class_id);
                if (class_finder.length === 0) {
                  class_finder = char.spirit.classes.filter(o => o.variant_ids.includes(sfl.spell_overrides.count_as_class_id));
                }
                if (class_finder.length === 1) {
                  const char_class = class_finder[0];
                  spellcasting_ability = char_class.spellcasting_ability;
                  spell_dc = char_class.spell_dc;
                  // console.log(spell_dc);
                  spell_attack = char_class.spell_attack;
                }
              }
            }
            if (sfl.spell_overrides.override_dc_atk_mod) {
              spell_attack = this.value(sfl.spell_overrides.spell_attack, { obj: char });
              spell_dc = this.value(sfl.spell_overrides.spell_dc, { obj: char });
              // TODO: Make the mod set on here as well.
            }
            if (log_it) {
              console.log(sfl);
              console.log(cf);
              console.log(spell_ids);
              for (const spell_id of sfl.suggestions) {
                const spell = data_util.spells.find(o => o._id === spell_id);
                console.log(spell);
              }
            }

            if (spell_ids.includes("")) {
              if (sfl.suggestions.length > 0) {
                let suggestions = sfl.suggestions;
                suggestions = suggestions.filter(o => char_int.mind.spells.filter(o2 => o2.true_id === o).length === 0);
                suggestions = suggestions.filter(o => char_int.mind.spell_as_abilities.filter(o2 => o2.spell_id === o).length === 0);
                suggestions = suggestions.filter(o => !spell_ids.includes(o));
                if (suggestions.length > 0) {
                  for (let i = 0; i < spell_ids.length; ++i) {
                    if (spell_ids[i] === "") {
                      spell_ids[i] = suggestions[0];
                      suggestions = suggestions.slice(1);
                    }
                  }
                  cf.feature_options = spell_ids;
                }
              }
              if (spell_ids.includes("")) {
                // Look for eligible spells
                const elligible_spells = data_util.spells.filter(o => this.fitCharSpellLimit2(char, o, sfl.spell_limit));
                // Check how many variant groups there are
                const variant_group_ids = common_util.unique_array(elligible_spells.map(o => o.variant_group_id));
                if (variant_group_ids.length === count) {
                  // Get the dominant for each group, skipping any that have a variant already in spell_ids
                  for (const group_id of variant_group_ids) {
                    const variants = elligible_spells.filter(o => o.variant_group_id === group_id);
                    if (common_util.anyOverlaps(spell_ids, variants.map(o => o._id))) {
                      // It's already set, so skip this one.
                    } else {
                      // Get the dominant variant
                      const dominant = data_util.getDominant(variants);
                      const first_empty_index = spell_ids.findIndex(o => {
                        if (o === "") {
                          return true;
                        }
                        return false;
                      });
                      if (dominant && first_empty_index > -1) {
                        spell_ids[first_empty_index] = dominant._id;
                      }
                    }
                  }
                  cf.feature_options = spell_ids;
                }
              }
            }
            for (const id of spell_ids.filter(o => o !== "")) {
              let char_ability = new CharacterAbility();
              const true_id = `${cf.true_id}_${id}`;
              const ability_finder = old_spell_as_abilities.filter(o => o.true_id === true_id);
              if (ability_finder.length === 1) {
                char_ability = ability_finder[0];
              }
              char_ability.connectFeature(cf, char_int, char);
              char_ability.true_id = true_id;
              let spell = data_util.spells.find(o => o._id === id);
              if (!spell) {
                const dom_spell = data_util.getDominantSpell(id);
                if (dom_spell) {
                  spell = dom_spell;
                }
              }
              if (spell) {
                await data_util.loadObject(spell);
                char_ability.the_spell = spell;
              }
              // console.log(spell_dc);
              char_ability.spell_dc = spell_dc;
              char_ability.spell_attack = spell_attack;
              char_ability.spellcasting_ability = spellcasting_ability;
              char_ability._spell_id = id;
              spell_as_abilities.push(char_ability);
            }
            if (cf.feature_options.filter(o => o === "").length > 0) {
              this.recalcAttention(char);
            }
          } else if (cf.floating_feature instanceof SpellsFromListWithCosts) {
            const sfl = cf.floating_feature;

            let spell_dc = 8;
            // console.log(spell_dc);
            let spell_attack = 0;
            let spellcasting_ability = sfl.spell_overrides.spellcasting_ability;
            if (sfl.spell_overrides.count_as_class_id === "" || 
              sfl.spell_overrides.count_as_class_id === "None" || 
              sfl.spell_overrides.count_as_class_id === "Don't Override") {
              if (spellcasting_ability === "Spellcasting") {
                let char_class = char.spirit.classes.find(o => o.true_id === cf.source_true_id);
                if (!char_class) {
                  // It's probably from an item, feat, or gift that is meant to attach to 
                  // whatever Spellcasting feature the character may already have.
                  // Look through all their classes, and get the best one.
                  const dcs = char.spirit.classes.map(o => o.spell_dc);
                  const best_dc = Math.max(...dcs);
                  if (dcs.filter(o => o === best_dc).length === 1) {
                    char_class = char.spirit.classes.find(o => o.spell_dc === best_dc);
                  } else {
                    const spell_attacks = char.spirit.classes.filter(o => o.spell_dc === best_dc).map(o => o.spell_attack);
                    const best_attack = Math.max(...spell_attacks);
                    char_class = char.spirit.classes.find(o => o.spell_dc === best_dc && o.spell_attack === best_attack);
                  }
                }
                if (char_class) {
                  spellcasting_ability = char_class.spellcasting_ability;
                  spell_dc = char_class.spell_dc;
                  // console.log(spell_dc);
                  spell_attack = char_class.spell_attack;
                }
              } else {
                if (spellcasting_ability === "Same as Feat") {
                  let asi_finder = char_int.mind.asi_features.filter(o => o.source_true_id === cf.source_true_id);
                  if (asi_finder.length !== 1) {
                    const ancestry_ids = cf.ancestries.map(o => o.true_id);
                    asi_finder = char_int.mind.asi_features.filter(o => common_util.listsMatch(o.ancestries.map(o => o.true_id), ancestry_ids));
                  }
                  if (asi_finder.length > 0) {
                    const char_asi_base_feature = asi_finder[0].feature_options[0] as CharacterASIBaseFeature;
                    if (char_asi_base_feature && 
                      char_asi_base_feature.asi_features.length > 0 && 
                      ABILITY_SCORES.includes(char_asi_base_feature.asi_features[0].selected_option)) {
                      spellcasting_ability = char_asi_base_feature.asi_features[0].selected_option as AbilityScoreType;
                    }
                  }
                } else if (spellcasting_ability === "Selectable") {
                  const source = char.char_feature_sources.find(o => o.true_id === cf.source_true_id);
                  if (source && source.selectable_hash[sfl.spell_overrides.spellcasting_ability_selectable_key] && source.selectable_hash[sfl.spell_overrides.spellcasting_ability_selectable_key].length > 0 && source.selectable_hash[sfl.spell_overrides.spellcasting_ability_selectable_key][0] !== "") {
                    spellcasting_ability = source.selectable_hash[sfl.spell_overrides.spellcasting_ability_selectable_key][0] as AbilityScoreType;
                  }
                }
                const modifier = char_int.mind.current_ability_scores.getModifier(spellcasting_ability);
                if (modifier > -20) {
                  spell_dc += char_int.mind.proficiency_modifier + modifier;
                  // console.log(spell_dc);
                  spell_attack += char_int.mind.proficiency_modifier + modifier;
                } else {
                  console.log(spellcasting_ability);
                  console.log(cf);
                  console.log(char.char_feature_sources.filter(o => o.true_id === cf.source_true_id));
                }
              }
            } else {
              let class_finder = char.spirit.classes.filter(o => o.source_id === sfl.spell_overrides.count_as_class_id);
              if (class_finder.length === 0) {
                class_finder = char.spirit.classes.filter(o => o.variant_ids.includes(sfl.spell_overrides.count_as_class_id));
              }
              if (class_finder.length === 1) {
                const char_class = class_finder[0];
                spellcasting_ability = char_class.spellcasting_ability;
                spell_dc = char_class.spell_dc;
                // console.log(spell_dc);
                spell_attack = char_class.spell_attack;
              }
            }
            if (sfl.spell_overrides.override_dc_atk_mod) {
              spell_attack = this.value(sfl.spell_overrides.spell_attack, { obj: char });
              spell_dc = this.value(sfl.spell_overrides.spell_dc, { obj: char });
              // TODO: Make the mod set on here as well.
            }
            if (log_it) {
              console.log(sfl);
              console.log(cf);
            }

            for (const s of sfl.spells) {
              const id = s.spell_id;
              let char_ability = new CharacterAbility();
              const true_id = `${cf.true_id}_${id}`;
              const ability_finder = old_spell_as_abilities.filter(o => o.true_id === true_id);
              if (ability_finder.length === 1) {
                char_ability = ability_finder[0];
              }
              char_ability.connectFeature(cf, char_int, char);
              char_ability.true_id = true_id;
              let spell = data_util.spells.find(o => o._id === id);
              if (!spell) {
                const dom_spell = data_util.getDominantSpell(id);
                if (dom_spell) {
                  spell = dom_spell;
                }
              }
              if (spell) {
                await data_util.loadObject(spell);
                char_ability.the_spell = spell;
              }
              // console.log(spell_dc);
              char_ability.spell_dc = spell_dc;
              char_ability.spell_attack = spell_attack;
              char_ability.spellcasting_ability = spellcasting_ability;
              char_ability._spell_id = id;
              spell_as_abilities.push(char_ability);
            }
            if (cf.feature_options.filter(o => o === "").length > 0) {
              this.recalcAttention(char);
            }
          } else {
            console.log(cf);
          }
        }
      }
    }
    // debugger;
    for (const ability of abilities) {
      ability.calc_special_resource_amount(char);
      const a_finder = char_int.mind.abilities.filter(o =>
        o.source_type === ability.source_type &&
        o.source_id === ability.source_id &&
        o.ability_type === ability.ability_type &&
        o.true_id === ability.true_id);
      if (a_finder.length === 1) {
        ability.customizations = a_finder[0].customizations;
        // ability.favorite_options = a_finder[0].favorite_options;
      }
    }
    char_int.mind.abilities = abilities.filter(o => o.the_ability);

    if (true) {
      // With the new Potent Dragonmark feat, 
      // it's possible to have Dragonmark Spells without having actual spellcasting from a class
      // Classless Bonus Spells for Dragonmarks
      const upgraded_bonus_spells = char.mind.spellcasting_features.filter(o => 
        o.feature_type === "Bonus Spells Upgrade"
      );
      const upgrade_keys = upgraded_bonus_spells.map(o => (o.floating_feature as BonusSpellsUpgrade).upgrade_key);
      const bonus_spells_features = char.mind.spellcasting_features.filter(o => 
        o.floating_feature instanceof BonusSpells &&
        o.floating_feature.upgrade_key !== "" && upgrade_keys.includes(o.floating_feature.upgrade_key) &&
        char.spirit.classes.filter(o2 => o2.ancestries.find(o3 => o3.true_id === o2.true_id)).length === 0);
      const max_spell_level = Math.max(...char.body.slots.map(o => o.level));
      // console.log(bonus_spells_features);
      for (const cf of bonus_spells_features) {
        const bonus_spells = cf.floating_feature as BonusSpells;
        const upgrade_key = bonus_spells.upgrade_key;
        const upgrade = upgraded_bonus_spells.find(o => (o.floating_feature as BonusSpellsUpgrade).upgrade_key === upgrade_key);
        if (upgrade) {
          const char_bs = cf.feature_options[0] as CharacterBonusSpells;
          
          const spell_ids = bonus_spells.spells.map(o => o.spell_id);
          const actual_spell_ids: string[] = [];
          for (const id of spell_ids) {
            // If they don't already have the spell, and they're able to cast it, add it.
            const selected_spell_id = char_bs.selected_spell_id_for_given_id[id];
            const obj_finder = data_util.all_spells.find(o => o._id === selected_spell_id);
            if (obj_finder && obj_finder.level <= max_spell_level) {
              actual_spell_ids.push(selected_spell_id);
              const spell_id = obj_finder._id;
              const char_spell_finder = char.mind.spells.filter(o => 
                o.cf_id === char_bs.cf_id &&
                o.spell_id === spell_id);
              if (char_spell_finder.length === 0) {
                // const char_spell = new CharacterSpell();
                // char_spell.copySpell(obj_finder);
                // char_spell.always_known = true;
                // char_spell.connectSource(char_class);
                // char_spell.cf_id = cf.true_id;
                // char_spell.ff_id = cf.floating_feature._id;
                // char.mind.spells.push(char_spell);
                
                let char_ability = new CharacterAbility();
                const true_id = `${cf.true_id}_${id}`;
                const ability_finder = old_spell_as_abilities.filter(o => o.true_id === true_id);
                if (ability_finder.length === 1) {
                  char_ability = ability_finder[0];
                }
                char_ability.connectFeature(cf, char_int, char);
                char_ability.true_id = true_id;
                let spell = data_util.spells.find(o => o._id === id);
                if (!spell) {
                  const dom_spell = data_util.getDominantSpell(id);
                  if (dom_spell) {
                    spell = dom_spell;
                  }
                }
                if (spell) {
                  await data_util.loadObject(spell);
                  char_ability.the_spell = spell;
                }
                const sc_stuff = this.getAbilityModDCAndAttack({ char, cf });
                // console.log(spell_dc);
                char_ability.spell_dc = sc_stuff.dc;
                char_ability.spell_attack = sc_stuff.attack;
                char_ability.spellcasting_ability = sc_stuff.ability;
                char_ability._spell_id = id;
                spell_as_abilities.push(char_ability);
              }
            }
          }
        }
      }
    }
    for (const ability of spell_as_abilities) {
      // if (ability.name.includes("Prest")) {
      //   debugger;
      // }
      const a_finder = char_int.mind.spell_as_abilities.filter(o =>
        o.source_type === ability.source_type &&
        o.source_id === ability.source_id &&
        o.true_id === ability.true_id);
      if (a_finder.length === 1) {
        ability.customizations = a_finder[0].customizations;
      }
      const spellcasting_ability_modifier = char_int.mind.current_ability_scores.getModifier(ability.spellcasting_ability);
      // if (ability.name.includes("Cast")) {
      //   debugger;
      // }
      if (spellcasting_ability_modifier > -20 && ability.spell_dc < 9) {
        ability.spell_dc = 8 + char_int.mind.proficiency_modifier + spellcasting_ability_modifier;
        ability.spell_attack = char_int.mind.proficiency_modifier + spellcasting_ability_modifier;
      }
      ability.calc_special_resource_amount(char_int);
    }
    // console.log(spell_as_abilities);
    // console.log(spell_as_abilities.map(o => o.name));
    char_int.mind.spell_as_abilities = spell_as_abilities.filter(o => (o.the_ability || o.sidekick_ability) && o.the_spell);
    if (char.body.concentrating_on) {
      if (char.body.concentrating_on instanceof CharacterSpell) {
        const spell_id = char.body.concentrating_on.spell_id;
        const spell = data_util.spells.find(o => o._id === spell_id);
        if (spell) {
          await data_util.loadObject(spell);
          char.body.concentrating_on.connectSpell(spell);
        }
      } 
    }
  }

  getSelectableAbility({ char, cf, key }: { char: Character, cf: CharacterFeature, key: string }) {
    let source = this.getCFS({ char, cf });
    if (!source || !source.selectable_hash[key]) {
      // It could be a key that is on one cfs that relies on another,
      // This is currently only being done for some Dragonmark related Feats 
      source = char.char_feature_sources.find(o => o.selectable_hash[key] !== undefined);
    }
    if (source && source.selectable_hash[key]) {
      const ability = source.selectable_hash[key][0];
      if (ability && ABILITY_SCORES.includes(ability)) {
        return ability as AbilityScoreExpandedType;
      }
    }
    return "None";
  }

  getCF({ char, cf }: { char: Character, cf: CharacterFeature }) {
    const cfb = this.getCFB({ char, cf });
    if (cfb) {
      return cfb.features.find(o => o.true_id === cf.true_id);
    }
    return undefined;
  }

  getCFB({ char, cf }: { char: Character, cf: CharacterFeature }) {
    const cfs = this.getCFS({ char, cf });
    if (cfs) {
      return cfs.char_feature_bases.find(o => o.true_id === cf.cfb_id);
    }
    return undefined;
  }

  getCFS({ char, cf }: { char: Character, cf: CharacterFeature }) {
    return char.char_feature_sources.find(o => o.true_id === cf.source_true_id);
  }

  getAbility({ char, cf }: { char: Character, cf: CharacterFeature }) {
    const ff = cf.floating_feature;
    let use_ability: AbilityScoreExpandedType = "None";
    let key = "";
    if (ff instanceof SpellcastingFeature) {
      use_ability = ff.ability;
      key = ff.ability_selectable_key;
    } else if (ff instanceof BonusSpellsUpgrade) {
      use_ability = ff.spellcasting_ability;
      key = ff.spellcasting_ability_key;
    }
    if (use_ability === "CHA" || use_ability === "WIS" || use_ability === "INT" || use_ability === "CON" || use_ability === "STR" || use_ability === "DEX") {
      // We're good, will usually come here
    } else if (use_ability === "Spellcasting") {
      let cfs = char.char_feature_sources.find(o => o.true_id === cf.source_true_id);
      if (cfs) {
        if (cfs instanceof CharacterSubclass) {
          const true_id = cfs.true_id;
          cfs = char.spirit.classes.find(o => o.char_subclass && o.char_subclass.true_id === true_id);
        }
        if (cfs) {
          use_ability = cfs.spellcasting.spellcasting_ability;
        }
      }
    } else if (use_ability === "Selectable") {
      use_ability = this.getSelectableAbility({ char, cf, key });
    } else if (use_ability === "INT, WIS, or CHA") {
      const int = char.mind.current_ability_scores.intelligence;
      const wis = char.mind.current_ability_scores.wisdom;
      const cha = char.mind.current_ability_scores.charisma;
      if (cha >= int) {
        if (cha >= wis) {
          use_ability = "CHA";
        } else {
          use_ability = "WIS";
        }
      } else {
        if (int >= wis) {
          use_ability = "CHA";
        } else {
          use_ability = "WIS";
        }
      }
    } else if (use_ability === "STR or DEX") {
      const str = char.mind.current_ability_scores.strength;
      const dex = char.mind.current_ability_scores.dexterity;
      if (str >= dex) {
        use_ability = "STR";
      } else {
        use_ability = "DEX";
      }
    } else if (use_ability === "Same as Feat") {
      const cfs = char.char_feature_sources.find(o => o.true_id === cf.source_true_id);
      if (cfs) {
        const asi_cfb = cfs.all_char_feature_bases.find(o => o.features.filter(o2 => o2.floating_feature instanceof ASIBaseFeature).length > 0);
        if (asi_cfb) {
          const asi_cf = asi_cfb.features.find(o => o.floating_feature instanceof ASIBaseFeature);
          if (asi_cf && asi_cf.floating_feature instanceof ASIBaseFeature) {
            const asi = asi_cf.feature_options[0];
            if (typeof asi === "string" && asi.length > 0 && ABILITY_SCORES.includes(asi)) {
              use_ability = asi as AbilityScoreType;
            }
          }
        }
      }
    } else {
      console.error("Not Implemented");
    }
    return use_ability;
  }

  getAbilityModDCAndAttack({ char, cf }: { char: Character, cf: CharacterFeature }) {
    const use_ability = this.getAbility({ char, cf });
    let mod = -5;
    let dc = 0;
    let attack = -5;
    if (ABILITY_SCORES.includes(use_ability)) {
      const cfs = this.getCFS({ char, cf });
      mod = char.mind.current_ability_scores.getModifier(use_ability);
      if (cfs && cfs.spellcasting.spellcasting_ability === use_ability) {
        dc = cfs.spellcasting.spell_dc;
        attack = cfs.spellcasting.spell_attack;
      } else {
        dc = 8 + mod + char.mind.proficiency_modifier;
        attack = mod + char.mind.proficiency_modifier;
      }
    }
    return { ability: use_ability, mod, dc, attack };
  }

  getResourceName = async (cr: CharacterResourceWithUsed) => {
    if (cr.is_slot) {
      let name = cr.resource_feature ? cr.resource_feature.slot_name : "";
      if (name === "") { 
        const types = await data_util.getSpellSlotTypes();
        const resource_finder = types.find(o => o._id === cr.type_id);
        if (resource_finder) {
          name = resource_finder.name;
        }
      }
      return name;
    } else {
      const resource_finder = data_util.resources.find(o => o._id === cr.type_id);
      let name = "";
      if (resource_finder) {
        name = resource_finder.name;
      }
      return name;
    }
  }
  getResourceSingular = async (cr: CharacterResourceWithUsed) => {
    if (cr.is_slot) {
      const types = await data_util.getSpellSlotTypes();
      const resource_finder = types.find(o => o._id === cr.type_id);
      let name = "";
      if (resource_finder) {
        name = resource_finder.name;
      }
      return name;
    } else {
      const resource_finder = data_util.resources.filter(o => o._id === cr.type_id);
      let singular = "";
      if (resource_finder.length === 1) {
        singular = resource_finder[0].singular;
      }
      return singular;
    }
  }

  recalcResources = async (char: Character) => {
    const resources: CharacterResourceWithUsed[] = [];
    const non_stacking = char.mind.resource_features.filter(o => 
      !(o.floating_feature as ResourceFeature).stacks);
    for (const cf of non_stacking) {
      const rf = cf.floating_feature as ResourceFeature;
      const root_id = cf.root_type === "GameClass" ? cf.root_id : "";
      const resource_finder = cf.root_type === "GameClass" ? resources.find(o => o.type_id === rf.type_id && o.class_id === root_id) : resources.find(o => o.type_id === rf.type_id);
      if (resource_finder) {
        const char_resource = resource_finder;
        char_resource.copyResource(rf, char, root_id, cf.source_name);
        char_resource.name = await this.getResourceName(char_resource);
        char_resource.singular = await this.getResourceSingular(char_resource);
      } else {
        const char_resource = new CharacterResourceWithUsed();
        char_resource.copyResource(rf, char, root_id, cf.source_name);
        char_resource.name = await this.getResourceName(char_resource);
        char_resource.singular = await this.getResourceSingular(char_resource);
        resources.push(char_resource);
      }
    }
    const stacking = char.mind.resource_features.filter(o => 
      (o.floating_feature as ResourceFeature).stacks);
    // debugger;
    for (const cf of stacking) {
      const rf = cf.floating_feature as ResourceFeature;
      const root_id = cf.root_type === "GameClass" ? cf.root_id : "";
      const resource_finder = cf.root_type === "GameClass" ? resources.find(o => o.type_id === rf.type_id && o.class_id === root_id) : resources.find(o => o.type_id === rf.type_id);
      // if (!rf.name.includes("Ki")) {
      //   console.log(rf);
      //   console.log(resource_finder);
      // }
      if (resource_finder) {
        const char_resource = resource_finder;
        char_resource.copyResource(rf, char, root_id, cf.source_name);
      } else {
        const char_resource = new CharacterResourceWithUsed();
        char_resource.copyResource(rf, char, root_id, cf.source_name);
        resources.push(char_resource);
      }
    }
    // TODO: I think this loop is redundant, 
    // but I don't want to remove it yet.  
    // Testing other things at the moment.
    for (const r of resources) {
      const r_finder = char.body.resource_holder.resources.filter(o => o.type_id === r.type_id);
      if (r_finder.length === 1) {
        r.created = r_finder[0].created;
        r.used = r_finder[0].used;
      }
      r.show_source_name = resources.filter(o => o.name === r.name).length > 1;
    }
    char.body.resource_holder.resources = resources;
    if (char.spirit.transform && char.spirit.transform.transform) {
      for (const char_resource of char.spirit.transform.resource_holder.resources.filter(o => o.name === "")) {
        char_resource.name = await this.getResourceName(char_resource);
        char_resource.singular = await this.getResourceSingular(char_resource);
      }
      this.applyTransformResources(char, char.spirit.transform.transform);
    }
  }

  damageTypeForMultiplier(char: CharacterSheetInterface, char_feature: CharacterFeature, dm: DamageMultiplier, damage_type: DamageType | "Selectable Key" | "Use Extra") {
    if (damage_type === "Selectable Key") {
      if (char instanceof Character) {
        const key = dm.selectable_key;
        const cfs = char.char_feature_sources.find(o => o.true_id === char_feature.source_true_id);
        // let cfs: CharacterFeatureSource | null = null;
        // switch (char_feature.source_type) {
        //   case "Race": cfs = char.spirit.race; break;
        //   default:
        //     console.log(key);
        //     console.log(dm);
        //     console.log(char);
        //     console.log(char_feature);
        //   break;
        // }
        if (cfs && cfs.selectable_hash[key]) {
          const selectable = cfs.selectable_hash[key][0];
          if (ALL_DRAGONS.includes(selectable)) {
            damage_type = DRACONIC_DAMAGE_TYPES_ANY[selectable];
          } else if (isDamageType(selectable)) {
            damage_type = selectable;
          }
        } else {
          console.error(dm);
        }
      } else {
        console.error(dm);
      }
    } else if (damage_type === "Use Extra") {
      if (char instanceof Character) {
        const cfs = char.char_feature_sources.find(o => o.true_id === char_feature.source_true_id);
        if ((cfs instanceof CharacterItem || cfs instanceof CharacterMagicItemKeyword) && cfs.extra !== "") {
          const selectable = cfs.extra;
          if (ALL_DRAGONS.includes(selectable)) {
            damage_type = DRACONIC_DAMAGE_TYPES_ANY[selectable];
          } else if (isDamageType(selectable)) {
            damage_type = selectable;
          }
        } else {
          console.error(dm);
        }
      } else {
        console.error(dm);
      }
    }
    if (!isDamageType(damage_type)) {
      console.error(dm);
      return "Same as Main";
    } else {
      return damage_type;
    }
  }

  recalcMisc(char_int: CharacterSheetInterface, char: Character) {
    const attack_bonuses = char_int.mind.attack_bonuses.filter(o => o.source !== "Misc");
    const damage_bonuses = char_int.mind.damage_bonuses.filter(o => o.source !== "Misc");
    // const damage_multipliers: DamageMultiplier[] = [];
    const damage_multiplier_simples: DamageMultiplierSimple[] = [];
    if (char_int instanceof Character) {
      char_int.mind.merged_special_feature_types = [];
    } else {
      // debugger;
    }
    if (char_int instanceof Character && char_int.spirit.sidekick) {
      // if (char_int.spirit.sidekick_ci) {
      //   for (const dm of char_int.spirit.sidekick_ci.damage_vulnerabilities) {
      //     const dms = new DamageMultiplierSimple();
      //     dms.damage_type = dm;
      //     dms.multiplier = 2;
      //     dms.details = `From ${char_int.spirit.sidekick_ci.name}`;
      //     damage_multiplier_simples.push(dms);
      //   }
      //   for (const dm of char_int.spirit.sidekick_ci.damage_resistances) {
      //     const dms = new DamageMultiplierSimple();
      //     dms.damage_type = dm;
      //     dms.multiplier = 0.5;
      //     dms.details = `From ${char_int.spirit.sidekick_ci.name}`;
      //     damage_multiplier_simples.push(dms);
      //   }
      //   for (const dm of char_int.spirit.sidekick_ci.damage_immunities) {
      //     const dms = new DamageMultiplierSimple();
      //     dms.damage_type = dm;
      //     dms.multiplier = 0;
      //     dms.details = `From ${char_int.spirit.sidekick_ci.name}`;
      //     damage_multiplier_simples.push(dms);
      //   }
      // }
    }
    char_int.mind.creature_type = char_int.spirit.race.creature_type;
    for (const cf of char_int.mind.misc_features) {
      // console.log(cf);
      if (cf.feature_type === "Damage Multiplier" && cf.floating_feature instanceof DamageMultiplier) {
        // damage_multipliers.push(cf.floating_feature);
        // damage_multipliers.forEach(dm => {
        const dm = cf.floating_feature;
        const damage_types = cf.floating_feature.the_damage_types;
        // if (dm.the_damage_types.includes("Use Extra")) {
        //   debugger;
        // }
        for (const dt of damage_types) {
          const dms = new DamageMultiplierSimple();
          dms.damage_type = this.damageTypeForMultiplier(char_int, cf, dm, dt);
          dms.multiplier = dm.multiplier;
          dms.from_feature = true;
          damage_multiplier_simples.push(dms);
        }
      } else if (cf.feature_type === "Extra Attacks" && cf.floating_feature instanceof NumberFeature) {
        char_int.mind.extra_attacks = Math.max(char_int.mind.extra_attacks, cf.floating_feature.num);
      } else if (cf.feature_type === "Extra IAA Slots") {
        // Doesn't need to do anything here.  
        // Just having it on the char_item will make it 
        // work in the CharacterIAAType2IAAOptionDetails.tsx control
      } else if (cf.feature_type === "Special Feature List Merge" && cf.floating_feature instanceof SFMergeFeature) {
        if (char_int instanceof Character) {
          char_int.mind.merged_special_feature_types.push(cf.floating_feature.special_feature_types);
        }
      } else if (cf.feature_type === "Unarmed Strikes" && cf.floating_feature instanceof UnarmedStrikesFeature) {
        const usf = cf.floating_feature;
        
        if (!["STR","None"].includes(usf.use_ability_score)) {
          if (usf.use_ability_score === "Spellcasting") {
            console.log("Not Implemented");
            console.log(usf);
            
          // if (type === "Spellcasting") {
          //   const class_finder = char.spirit.classes.filter(o => 
          //     source_id === o.source_id || 
          //     source_id === o.subclass_id);
          //   if (class_finder.length === 1) {
          //     type = `${class_finder[0].spellcasting_ability}`;
          //   }
          // }
          } else if (usf.use_ability_score === "Same as Feat") {
            console.log("Not Implemented");
            console.log(usf);
          } else if (!char_int.mind.unarmed_strike_scores.includes(usf.use_ability_score)) {
            char_int.mind.unarmed_strike_scores.push(usf.use_ability_score);
          }
        }
        if (usf.add_attack_mod) {
          char_int.mind.unarmed_strike_add_attack_to_dmg = true;
        }
        if (usf.bonus_action_attack) {
          char_int.mind.unarmed_strike_bonus_action = true;
        }
        // Add missing damage types
        char_int.mind.unarmed_strike_damage_types = common_util.unique_array([...char_int.mind.unarmed_strike_damage_types,...usf.dts]);
        const source_id = cf.source_true_id;
        const count = this.value(usf.damage_rolls.count, { obj: char_int, source_id, item_id: "" });
        if (count > 0) {
          const size = this.value(usf.damage_rolls.size, { obj: char_int, source_id, item_id: "" });

          char_int.mind.unarmed_strike_count = Math.max(char_int.mind.unarmed_strike_count, count);
          char_int.mind.unarmed_strike_size = Math.max(char_int.mind.unarmed_strike_size, size);
        }
      } else if (cf.feature_type === "Resource Refresh Rule Change" && cf.floating_feature instanceof StringsFeature) {
        // console.log(cf);
        const ssf = cf.floating_feature as StringsFeature;
        const resource_type = ssf.strings[0];
        const char_resource_finder = char_int.body.resource_holder.resources.filter(o => o.type_id === resource_type);
        if (char_resource_finder.length === 1) {
          const char_resource = char_resource_finder[0];
          char_resource._refresh_rule = ssf.strings[1];
        }
      } else if (cf.feature_type === "Replace Ability Score for Attacks" && cf.floating_feature instanceof ReplaceAbilityScoreFeature) {
        const rasf = cf.floating_feature as ReplaceAbilityScoreFeature;
        // debugger;
        const source_id = cf.use_item_id === "" ? cf.root_id : cf.use_item_id;
        
        const attack_bonus = new Bonus();
        const damage_bonus = new Bonus();
        attack_bonus.char_feature = cf;
        damage_bonus.char_feature = cf;
        attack_bonus.source = "Misc";
        damage_bonus.source = "Misc";
        let type = rasf.use_ability_score;
        if (type === "Spellcasting") {
          if (char_int instanceof Character) {
            let class_finder = char_int.spirit.classes.find(o => 
              o.source_id === rasf.game_class_id);
            if (!class_finder) {
              class_finder = char_int.spirit.classes.find(o => 
                o.source && o.source.variant_ids.includes(rasf.game_class_id));
            }
            if (class_finder) {
              type = `${class_finder.spellcasting_ability}`;
            }
          }
        }
        if (ABILITY_SCORES.includes(type)) {
          attack_bonus.replace_asm = type as AbilityScoreType;
          damage_bonus.replace_asm = type as AbilityScoreType;
        }
        if (cf.use_item_id !== "") {
          let weapon_id = "";
          if (["Weapon","Armor"].includes(cf.source_type)) {
            weapon_id = source_id;
          } else if (cf.use_item_id !== "") {
            // Find the item to make sure it's a weapon
            const item_finder = char_int instanceof Character ? char_int.inventory.items.filter(o => o.true_id === cf.use_item_id) : [];
            if (item_finder.length === 1 && ["Weapon","Armor"].includes(item_finder[0].item_type)) {
              weapon_id = cf.use_item_id;
            }
          }
          attack_bonus.weapon_id = weapon_id;
          damage_bonus.weapon_id = weapon_id;
        }

        attack_bonus.weapon_keywords = rasf.weapon_keyword_ids;
        damage_bonus.weapon_keywords = rasf.weapon_keyword_ids;
        
        attack_bonus.magical_weapons_only = rasf.magical_weapons_only;
        damage_bonus.magical_weapons_only = rasf.magical_weapons_only;

        attack_bonuses.push(attack_bonus);
        damage_bonuses.push(damage_bonus);
      } else if (cf.feature_type === "Creature Type" && cf.floating_feature instanceof CreatureTypeFeature) {
        char_int.mind.creature_type = cf.floating_feature.creature_type;
      } else {
        console.log(cf);
      }
    }
    if (char_int instanceof Character) {
      // I'm pretty sure this was a customization
      // char_int.mind.extra_damage_multipliers.forEach(dm => {
      //   damage_multiplier_simples.push(dm);
      // });
    }
    char_int.mind.damage_multipliers = damage_multiplier_simples;
    char_int.mind.attack_bonuses = attack_bonuses;
    char_int.mind.damage_bonuses = damage_bonuses;
    
    // if (char.unarmed_strike_customizations.bonus_action === "True") {
    //   char.unarmed_strike_bonus_action = true;
    // } else if (char.unarmed_strike_customizations.bonus_action === "False") {
    //   char.unarmed_strike_bonus_action = false;
    // }
    // if (char.unarmed_strike_customizations.add_attack_to_dmg === "True") {
    //   char.unarmed_strike_add_attack_to_dmg = true;
    // } else if (char.unarmed_strike_customizations.add_attack_to_dmg === "False") {
    //   char.unarmed_strike_add_attack_to_dmg = false;
    // }
    // if (char.unarmed_strike_customizations.scores) {
    //   char.unarmed_strike_scores = [...char.unarmed_strike_customizations.scores];
    // }
    // if (char.unarmed_strike_customizations.damage_types) {
    //   char.unarmed_strike_damage_types = [...char.unarmed_strike_customizations.damage_types];
    // }
    // if (char.unarmed_strike_customizations.size !== undefined) {
    //   char.unarmed_strike_size = char.unarmed_strike_customizations.size;
    // }
    // if (char.unarmed_strike_customizations.count !== undefined) {
    //   char.unarmed_strike_count = char.unarmed_strike_customizations.count;
    // }
  }

  recalcAttention(char: Character) {
    for (const cfb of char.mind.char_feature_bases) {
      const log_it = false; // cfb.name.includes("Death Mage"); // cfb.source_type === "GameClass" && cfb.name.includes("astery"); // 
      if (log_it) {
        debugger;
      }
      // console.log(cfb.source_type);
      cfb.calcAttention(log_it);
    }
    for (const cfs of char.char_feature_sources) {
      const use_features = this.useFeatures2(char, cfs, true);
      cfs.needs_attention = use_features.filter(o => o.display && o.needs_attention).length > 0;
    }
    // char.spirit.recalc_time = common_util.get_time_number();
  }

  canAttune(character: Character, char_item: CharacterItem): string {
    const base_item = char_item.base_item;
    const magic_item_keywords: MagicItemKeyword[] = [];
    for (const cmik of char_item.char_magic_item_keywords) {
      if (cmik.source) {
        magic_item_keywords.push(cmik.source);
      }
    }
    return this.fitLimits(character, api.getMagicItemLimits(base_item, magic_item_keywords), "item", "");
  }

  fitLimits(character: Character, limits: CharacterLimitation[], for_object_type: string, for_id: string, log_it = false): string {
    let results = "";
    if (log_it) {
      // debugger;
      console.log(character);
      console.log(limits);
    }
    const spoofs = character.mind.limit_spoof_features.filter(o => o.floating_feature instanceof LimitSpoofFeature && o.floating_feature.limits_for.includes(for_object_type));
    for (const limit of limits) {
      let spoofed = false;
      const subspoofs = spoofs.filter(o => o.floating_feature instanceof LimitSpoofFeature && o.floating_feature.limit_spoof.type === limit.type);
      for (const cf of subspoofs) {
        const spoof = cf.floating_feature as LimitSpoofFeature;
        if (limit.type === spoof.limit_spoof.type) {
          switch (limit.type) {
            case "game_class": 
            case "subclass":
              if (spoof.limit_spoof.ids.length === 0 || 
                common_util.anyOverlaps(spoof.limit_spoof.ids, limit.ids)) {
                const limit_level = +limit.values[0];
                if (limit_level <= 1) {
                  spoofed = true;
                } else {
                  const spoof_level = spoof.limit_spoof.values[0];
                  if (spoof_level === 0) {
                    // Use the level of the source
                    const cfs = character.char_feature_sources.find(o => 
                      o.true_id === cf.source_true_id);
                    if (cfs) {
                      const level = cfs.level;
                      if (level >= limit_level) {
                        spoofed = true;
                      }
                    }
                  } else {
                    if (spoof_level >= limit_level) {
                      spoofed = true;
                    }
                  }
                }
              }
            break;
            case "race": 
            case "subrace": 
            case "gift":
            case "pact_boon":
            case "eldritch_invocation":
              spoofed = spoof.limit_spoof.ids.length === 0 || 
                common_util.anyOverlaps(spoof.limit_spoof.ids, limit.ids);
            break;
            default: 
              console.error(`Spoof not supported for ${limit.type}`);
            break;
          }
        }
      }
      if (!spoofed) {
        if (CHARACTER_LIMITATION_TYPES_SANS_VARIANT_SPECIFIC.includes(limit.type)) {
          switch (limit.type) {
            case "level":
              if (limit.exclusive) {
                if (limit.values[0] <= character.mind.character_level) {
                  results += "Level requirement not met\n";
                }
              } else {
                if (limit.values[0] > character.mind.character_level) {
                  results += "Level requirement not met\n";
                }
              }
            break;
            case "class_group": 
              let class_group_level = 0;
              for (let i = 0; i < character.spirit.classes.length; ++i) {
                const char_class = character.spirit.classes[i];
                if (char_class.source && 
                  limit.ids.includes(char_class.source.class_group)) {
                  class_group_level += char_class.level;
                }
              }
              if (limit.exclusive) {
                if (class_group_level >= limit.values[0]) {
                  results += "Class Group requirements not met\n";
                }
              } else {
                if (class_group_level < limit.values[0]) {
                  results += "Class Group requirements not met\n";
                }
              }
            break;
            case "class_or_class_group": 
              let class_or_class_group_level = 0;
              for (let i = 0; i < character.spirit.classes.length; ++i) {
                const char_class = character.spirit.classes[i];
                if (char_class.source && 
                  (limit.ids.includes(char_class.variant_group_id) ||
                  limit.ids.includes(char_class.source.class_group))) {
                    class_or_class_group_level += char_class.level;
                }
              }
              if (limit.exclusive) {
                if (class_or_class_group_level >= limit.values[0]) {
                  results += "Class or Class Group requirements not met\n";
                }
              } else {
                if (class_or_class_group_level < limit.values[0]) {
                  results += "Class or Class Group requirements not met\n";
                }
              }
            break;
            case "alignment": 
              // I haven't implemented alignment yet
            break;
            case "min_ability_score":
              let sufficient_ability_score = false;
              for (let i = 0; i < limit.ids.length; ++i) {
                const score = character.mind.current_ability_scores.getAbilityScore(limit.ids[i]);
                if (score && score > limit.values[0]) {
                  sufficient_ability_score = true;
                  break;
                }
              }
              if (limit.exclusive) {
                if (sufficient_ability_score) {
                  results += "Minimum Ability Score requirements not met\n";
                }
              } else {
                if (!sufficient_ability_score) {
                  results += "Minimum Ability Score requirements not met\n";
                }
              }
            break;
            case "spellcaster":
              let spellcaster = false;
              if (limit.ids.length === 0) {
                // They need to have a spellcasting feature.
                if (character.mind.spellcasting_features.filter(o => o.feature_type === "Spellcasting").length > 0) {
                  spellcaster = true;
                } 
              } else {
                for (let i = 0; i < limit.ids.length; ++i) {
                  const spellcasting_type = limit.ids[i];
                  if (spellcasting_type === "At least 1 Spell") {
                    if (character.mind.spells.length > 0 || 
                      character.mind.spell_as_abilities.length > 0) {
                      spellcaster = true;
                      break;
                    }
                  } else if (spellcasting_type === "Ritual") {
                    // TODO: I should add this type sometime
                  } else if (character.mind.spellcasting_features.filter(o => 
                    o.name.includes(spellcasting_type)).length > 0) {
                    spellcaster = true;
                    break;
                  }
                }
              }
              if (limit.exclusive) {
                if (spellcaster) {
                  results += "Spellcasting requirements not met\n";
                }
              } else {
                if (!spellcaster) {
                  results += "Spellcasting requirements not met\n";
                }
              }
            break;
            case "spells_of_schools":
              let spells_of_schools = character.mind.spells.filter(o => 
                o.the_spell && o.the_spell.school && (limit.ids.includes("Any") || limit.ids.includes(o.the_spell.school)) &&
                o.the_spell.level >= limit.values[1]).length;
              spells_of_schools += character.mind.spell_as_abilities.filter(o => 
                o.the_spell && o.the_spell.school && (limit.ids.includes("Any") || limit.ids.includes(o.the_spell.school)) &&
                o.the_spell.level >= limit.values[1]).length;
              if (limit.exclusive) {
                if (spells_of_schools >= limit.values[0]) {
                  results += "Spells of Schools requirements not met\n";
                }
              } else {
                if (spells_of_schools < limit.values[0]) {
                  results += "Spells of Schools requirements not met\n";
                }
              }
            break;
            case "at_least_1_weapon":
              let weapon_found = character.mind.weapon_proficiencies.filter(o => limit.ids.includes(o.proficiency_id)).length > 0;
              if (!weapon_found) {
                for (let i = 0; i < character.mind.weapon_proficiencies.length; ++i) {
                  const prof = character.mind.weapon_proficiencies[i];
                  weapon_found = data_util.items.filter(o => {
                    if (o instanceof Weapon) {
                      const weapon_keyword_ids = this.getWeaponKeywordIds(character, o);
                      return weapon_keyword_ids.includes(prof.proficiency_id) && 
                        common_util.anyOverlaps(weapon_keyword_ids, limit.ids);
                    }
                    return false;
                  }).length > 0;
                  if (weapon_found) {
                    break;
                  }
                }
              }
              if (!weapon_found) {
                const special_prof_ids = character.mind.special_proficiencies.map(o => { return o.proficiency_id; });
                if (special_prof_ids.length > 0) {
                  weapon_found = data_util.items.filter(o => 
                    o instanceof Weapon && 
                    special_prof_ids.includes(o._id) && 
                    common_util.anyOverlaps(this.getWeaponKeywordIds(character, o), limit.ids)).length > 0;
                }
              }
              if (limit.exclusive) {
                if (weapon_found) {
                  results += "Weapon Proficiency requirements not met\n";
                }
              } else {
                if (!weapon_found) {
                  results += "Weapon Proficiency requirements not met\n";
                }
              }
            break;
            case "at_least_1_language":
              const language_known = character.mind.languages_known.length > 0;
              if (limit.exclusive) {
                if (language_known) {
                  results += "Language requirements not met\n";
                }
              } else {
                if (!language_known) {
                  results += "Language requirements not met\n";
                }
              }
            break;
            
            case "tags":
              let cfss = character.char_feature_sources.filter(o => o.true_id !== for_id);
              if (limit.from_source_types.length > 0) {
                cfss = cfss.filter(o => 
                  limit.from_source_types.includes(o.data_type)
                );
              }
              const fs_tags = cfss.flatMap(o => o.tags);
              const has_tag = common_util.anyOverlaps(limit.ids, fs_tags);
              if (limit.exclusive === has_tag) {
                results += "Requirements not met\n";
              }
            break;
            case "dragonmark":
              if (limit.exclusive) {
                if (character.mind.dragonmarked_source_id !== "" && character.mind.dragonmarked_source_id !== for_id) {
                  results += "Already Dragonmarked\n";
                }
              } else {
                if (character.mind.dragonmarked_source_id !== "") {
                  results += "Not Dragonmarked\n";
                }
              }
            break;
            case "wild_talent":
              if (character.mind.wild_talent_source_id !== "" && character.mind.wild_talent_source_id !== for_id) {
                results += "Already Wild Talented\n";
              }
            break;
            case "proficiency":
              let proficient = false;
              if (character.mind.skill_proficiencies.filter(o => 
                limit.ids.includes(o.proficiency_id)).length === 1) {
                proficient = true;
              } else if (character.mind.tool_proficiencies.filter(o => 
                limit.ids.includes(o.proficiency_id)).length === 1) {
                proficient = true;
              } else if (character.mind.armor_proficiencies.filter(o => 
                limit.ids.includes(o.proficiency_id)).length === 1) {
                proficient = true;
              } else if (character.mind.weapon_proficiencies.filter(o => 
                limit.ids.includes(o.proficiency_id)).length === 1) {
                proficient = true;
              } else if (character.saving_throw_proficiencies.filter(o => 
                limit.ids.includes(o.proficiency_id)).length === 1) {
                proficient = true;
              } else if (character.mind.special_proficiencies.filter(o =>
                limit.ids.includes(o.proficiency_id)).length === 1) {
                proficient = true;
              }
              if (limit.exclusive) {
                if (proficient) {
                  results += "Proficiency requirements not met\n";
                }
              } else {
                if (!proficient) {
                  results += "Proficiency requirements not met\n";
                }
              }
            break;
              
            case "feature_of_type":
              if (true) {
                // Check if they have any features of those types.
                const have_f_of_type = character.mind.features.some(o => limit.ids.includes(o.feature_type));
                
                if (limit.exclusive) {
                  if (have_f_of_type) {
                    results += `${limit.ids.join(", ")} requirement not met\n`;
                  }
                } else {
                  if (!have_f_of_type) {
                    results += `${limit.ids.join(", ")} requirement not met\n`;
                  }
                }
              }
            break;
            default:
              console.log(limit);
              console.log(character);
            break;
          }
        } else {
          if (limit.variant_specific) {
            switch (limit.type) {
              case "game_class":
                if (true) {
                  let has_class = false;
                  const class_level_required = +limit.values[0];
                  let class_ids = character.spirit.classes.filter(o => o.level >= class_level_required).map(o => o.source_id);
                  let overlaps = common_util.findOverlaps(limit.ids, class_ids);
                  if (log_it) {
                    console.log(class_level_required);
                    console.log(class_ids);
                    console.log(overlaps);
                  }
                  if (overlaps.length > 0) {
                    has_class = true;
                  }
                  if (limit.exclusive) {
                    if (has_class) {
                      results += "Class requirements not met\n";
                    }
                  } else if (!has_class) {
                    class_ids = character.spirit.classes.map(o => o.source_id);
                    overlaps = common_util.findOverlaps(limit.ids, class_ids);
                    if (overlaps.length === 0) {
                      results += "Class requirements not met\n";
                    } else if (overlaps.length > 0) {
                      results += `Class Level (${class_level_required}) requirements not met\n`;
                    }
                  }
                }
              break;
              case "subclass":
                if (true) {
                  let has_it = false;
                  const subclass_ids = character.spirit.classes.map(o => {
                    if (o.char_subclass) {
                      return o.char_subclass.source_id;
                    }
                    return "";
                  }).filter(o => o !== "");
                  const overlaps = common_util.findOverlaps(limit.ids, subclass_ids);
                  if (log_it) {
                    console.log(subclass_ids);
                    console.log(overlaps);
                  }
                  if (overlaps.length > 0) {
                    has_it = true;
                  }
                  if (limit.exclusive) {
                    if (has_it) {
                      results += "Subclass requirements not met\n";
                    }
                  } else if (!has_it) {
                    results += "Subclass requirements not met\n";
                  }
                }
              break;
              case "race":
                if (true) {
                  const source_id = character.spirit.race.source_id;
                  const has_race = limit.ids.includes(source_id);
                  if (limit.exclusive) {
                    if (has_race) {
                      results += `${character.c_options.races_called} requirements not met\n`;
                    }
                  } else {
                    if (!has_race) {
                      results += `${character.c_options.races_called} requirements not met\n`;
                    }
                  }
                }
              break;
              case "subrace":
                if (true) {
                  const source_id = character.spirit.race.char_subrace ? character.spirit.race.char_subrace.source_id : "";
                  const has_race = limit.ids.includes(source_id);
                  if (limit.exclusive) {
                    if (has_race) {
                      if (character.c_options.races_called === "Race") {
                        results += "Subrace requirements not met\n";
                      } else {
                        results += "Lineage requirements not met\n";
                      }
                    }
                  } else {
                    if (!has_race) {
                      if (character.c_options.races_called === "Race") {
                        results += "Subrace requirements not met\n";
                      } else {
                        results += "Lineage requirements not met\n";
                      }
                    }
                  }
                }
                // if (limit.exclusive) {
                //   if (character.spirit.race.char_subrace && limit.ids.includes(character.spirit.race.char_subrace.variant_group_id)) {
                //     results += "Subrace requirements not met\n";
                //   }
                // } else {
                //   if (!character.spirit.race.char_subrace || !limit.ids.includes(character.spirit.race.char_subrace.variant_group_id)) {
                //     results += "Subrace requirements not met\n";
                //   }
                // }
              break;
              case "gift":
                const has_gift = character.spirit.gifts.filter(o => limit.ids.includes(o.source_id)).length > 0; 
                if (limit.exclusive) {
                  if (has_gift) {
                    results += "Gift requirements not met\n";
                  }
                } else {
                  if (!has_gift) {
                    results += "Gift requirements not met\n";
                  }
                }
              break;
              case "pact_boon":
                let has_boon = character.mind.pact_boon && limit.ids.includes(character.mind.pact_boon.source_id);
                if (!has_boon && data_util.pact_boons.length > 0) {
                  const pact_boons = data_util.pact_boons;
                  // It's possible that they have an Eldritch Invocation which replaces the old Pact Boon.
                  for (const id of limit.ids) {
                    const pact_boon = pact_boons.find(o => o._id === id);
                    if (pact_boon) {
                      const ei_pact_boon = character.mind.eldritch_invocations.find(o => o.source_name === pact_boon.name);
                      if (ei_pact_boon) {
                        has_boon = true;
                        break;
                      }
                    }
                  }
                }
                if (limit.exclusive) {
                  if (has_boon) {
                    results += "Pact Boon requirements not met\n";
                  }
                } else {
                  if (!has_boon) {
                    results += "Pact Boon requirements not met\n";
                  }
                }
              break;
              case "eldritch_invocation":
                if (true) {
                  let has_it = false;
                  const source_id = character.mind.eldritch_invocations.map(o => o.source_id);
                  const overlaps = common_util.findOverlaps(limit.ids, source_id);
                  if (log_it) {
                    console.log(source_id);
                    console.log(overlaps);
                  }
                  if (overlaps.length > 0) {
                    has_it = true;
                  }
                  if (limit.exclusive) {
                    if (has_it) {
                      results += "Eldritch Invocation requirements not met\n";
                    }
                  } else if (!has_it) {
                    results += "Eldritch Invocation requirements not met\n";
                  }
                }
              break;
              case "feat":
                const has_feat = character.mind.feats.filter(o => limit.ids.includes(o.source_id)).length > 0;
                if (limit.exclusive) {
                  if (has_feat) {
                    results += "Feat requirements not met\n";
                  }
                } else {
                  if (!has_feat) {
                    results += "Feat requirements not met\n";
                  }
                }
              break;
              case "spell":
                if (true) {
                  const source_id = character.mind.spells.map(o => o.spell_id);
                  const overlaps = common_util.findOverlaps(limit.ids, source_id);
                  if (log_it) {
                    console.log(source_id);
                    console.log(overlaps);
                  }
                  const has_spell = overlaps.length > 0;
                  if (limit.exclusive) {
                    if (has_spell) {
                      results += "Spell requirements not met\n";
                    }
                  } else if (!has_spell) {
                    results += "Spell requirements not met\n";
                  }
                }
              break;
              
              case "feature_of_type":
                if (true) {
                  // Check if they have any features of those types.
                  const have_f_of_type = character.mind.features.some(o => limit.ids.includes(o.feature_type));
                  
                  if (limit.exclusive) {
                    if (have_f_of_type) {
                      results += `${limit.ids.join(", ")} requirement not met\n`;
                    }
                  } else {
                    if (!have_f_of_type) {
                      results += `${limit.ids.join(", ")} requirement not met\n`;
                    }
                  }
                }
              break;
              default:
                console.log(limit);
                console.log(character);
              break;
            }
          } else {
            switch (limit.type) {
              case "game_class":
                if (true) {
                  let has_class = false;
                  const class_level_required = +limit.values[0];
                  let class_variant_group_ids = character.spirit.classes.filter(o => o.level >= class_level_required).map(o => o.variant_group_id);
                  const variant_group_ids = data_util.getVariantGroupIds("game_class", limit.ids);
                  let overlaps = common_util.findOverlaps(variant_group_ids, class_variant_group_ids);
                  if (log_it) {
                    console.log(class_level_required);
                    console.log(class_variant_group_ids);
                    console.log(overlaps);
                  }
                  if (overlaps.length > 0) {
                    has_class = true;
                  }
                  if (limit.exclusive) {
                    if (has_class) {
                      results += "Class requirements not met\n";
                    }
                  } else if (!has_class) {
                    class_variant_group_ids = character.spirit.classes.map(o => o.variant_group_id);
                    overlaps = common_util.findOverlaps(variant_group_ids, class_variant_group_ids);
                    if (overlaps.length === 0) {
                      results += "Class requirements not met\n";
                    } else if (overlaps.length > 0) {
                      results += `Class Level (${class_level_required}) requirements not met\n`;
                    }
                  }
                }
              break;
              case "subclass":
                if (true) {
                  let has_it = false;
                  const class_variant_group_ids = character.spirit.classes.map(o => {
                    if (o.char_subclass) {
                      return o.char_subclass.variant_group_id;
                    }
                    return "";
                  }).filter(o => o !== "");
                  const variant_group_ids = data_util.getVariantGroupIds("subclass", limit.ids);
                  const overlaps = common_util.findOverlaps(variant_group_ids, class_variant_group_ids);
                  if (log_it) {
                    console.log(class_variant_group_ids);
                    console.log(overlaps);
                  }
                  if (overlaps.length > 0) {
                    has_it = true;
                  }
                  if (limit.exclusive) {
                    if (has_it) {
                      results += "Subclass requirements not met\n";
                    }
                  } else if (!has_it) {
                    results += "Subclass requirements not met\n";
                  }
                }
              break;
              case "race":
                if (true) {
                  const variant_group_id = character.spirit.race.variant_group_id;
                  const variant_group_ids = data_util.getVariantGroupIds("race", limit.ids);
                  const has_race = variant_group_ids.includes(variant_group_id);
                  if (limit.exclusive) {
                    if (has_race) {
                      results += `${character.c_options.races_called} requirements not met\n`;
                    }
                  } else {
                    if (!has_race) {
                      results += `${character.c_options.races_called} requirements not met\n`;
                    }
                  }
                }
              break;
              case "subrace":
                if (true) {
                  const variant_group_id = character.spirit.race.char_subrace ? character.spirit.race.char_subrace.variant_group_id : "";
                  const variant_group_ids = data_util.getVariantGroupIds("subrace", limit.ids);
                  const has_race = variant_group_ids.includes(variant_group_id);
                  if (limit.exclusive) {
                    if (has_race) {
                      if (character.c_options.races_called === "Race") {
                        results += "Subrace requirements not met\n";
                      } else {
                        results += "Lineage requirements not met\n";
                      }
                    }
                  } else {
                    if (!has_race) {
                      if (character.c_options.races_called === "Race") {
                        results += "Subrace requirements not met\n";
                      } else {
                        results += "Lineage requirements not met\n";
                      }
                    }
                  }
                }
              break;
              case "gift":
                if (true) {
                  const variant_group_ids = data_util.getVariantGroupIds("gift", limit.ids);
                  const has_gift = character.spirit.gifts.filter(o => variant_group_ids.includes(o.variant_group_id)).length > 0; // false;
                  if (limit.exclusive) {
                    if (has_gift) {
                      results += "Gift requirements not met\n";
                    }
                  } else {
                    if (!has_gift) {
                      results += "Gift requirements not met\n";
                    }
                  }
                }
              break;
              case "pact_boon":
                if (true) {
                  const variant_group_ids = data_util.getVariantGroupIds("pact_boon", limit.ids);
                  let has_boon = character.mind.pact_boon && variant_group_ids.includes(character.mind.pact_boon.variant_group_id);
                  if (!has_boon && data_util.pact_boons.length > 0) {
                    const pact_boons = data_util.pact_boons;
                    // It's possible that they have an Eldritch Invocation which replaces the old Pact Boon.
                    for (const id of variant_group_ids) {
                      const pact_boon = pact_boons.find(o => o._id === id);
                      if (pact_boon) {
                        const ei_pact_boon = character.mind.eldritch_invocations.find(o => o.source_name === pact_boon.name);
                        if (ei_pact_boon) {
                          has_boon = true;
                          break;
                        }
                      }
                    }
                  }
                  if (limit.exclusive) {
                    if (has_boon) {
                      results += "Pact Boon requirements not met\n";
                    }
                  } else {
                    if (!has_boon) {
                      results += "Pact Boon requirements not met\n";
                    }
                  }
                }
              break;
              case "eldritch_invocation":
                if (true) {
                  let has_it = false;
                  const class_variant_group_ids = character.mind.eldritch_invocations.map(o => o.variant_group_id);
                  const variant_group_ids = data_util.getVariantGroupIds("eldritch_invocation", limit.ids);
                  const overlaps = common_util.findOverlaps(variant_group_ids, class_variant_group_ids);
                  if (log_it) {
                    console.log(class_variant_group_ids);
                    console.log(overlaps);
                  }
                  if (overlaps.length > 0) {
                    has_it = true;
                  }
                  if (limit.exclusive) {
                    if (has_it) {
                      results += "Eldritch Invocation requirements not met\n";
                    }
                  } else if (!has_it) {
                    results += "Eldritch Invocation requirements not met\n";
                  }
                }
              break;
              case "feat":
                if (true) {
                  const variant_group_ids = data_util.getVariantGroupIds("feat", limit.ids);
                  const has_feat = character.mind.feats.filter(o => variant_group_ids.includes(o.variant_group_id)).length > 0; // false;
                  if (limit.exclusive) {
                    if (has_feat) {
                      results += "Feat requirements not met\n";
                    }
                  } else {
                    if (!has_feat) {
                      results += "Feat requirements not met\n";
                    }
                  }
                }
              break;
              case "spell":
                if (true) {
                  const variant_group_ids = character.mind.spells.map(o => o.variant_group_id);
                  const variant_group_ids2 = data_util.getVariantGroupIds("spell", limit.ids);
                  const overlaps = common_util.findOverlaps(variant_group_ids2, variant_group_ids);
                  if (log_it) {
                    console.log(variant_group_ids);
                    console.log(overlaps);
                  }
                  const has_spell = overlaps.length > 0;
                  if (limit.exclusive) {
                    if (has_spell) {
                      results += "Spell requirements not met\n";
                    }
                  } else if (!has_spell) {
                    results += "Spell requirements not met\n";
                  }
                }
              break;
              
              case "feature_of_type":
                if (true) {
                  // Check if they have any features of those types.
                  const have_f_of_type = character.mind.features.some(o => limit.ids.includes(o.feature_type));
                  
                  if (limit.exclusive) {
                    if (have_f_of_type) {
                      results += `${limit.ids.join(", ")} requirement not met\n`;
                    }
                  } else {
                    if (!have_f_of_type) {
                      results += `${limit.ids.join(", ")} requirement not met\n`;
                    }
                  }
                }
              break;
              default:
                console.log(limit);
                console.log(character);
              break;
            }
          }
        }
      }
      if (log_it) {
        console.log(limit);
        console.log(character);
        console.log(results);
      }
    }
    return results === "" ? "true" : results;
  }

  fitWeaponLimit2(char: Character, weapon: CharacterWeapon | Attack, obj: CharacterFeature | CharacterExtraEffects, attack_type = "", log_it = false) {
    // log_it = o.floating_feature instanceof ExtraEffectTypeFeature && (weapon instanceof CharacterWeapon && weapon.name.includes("Venomous"));
    // log_it = weapon instanceof CharacterWeapon && weapon.name.includes("Crossbow") && obj.name.includes("Vex");
    // log_it = weapon instanceof Attack && obj instanceof CharacterExtraEffects && obj.name.includes("Vex");
    
    if (log_it) {
      console.log(obj);
      console.log(weapon);
      console.log(char.mind.weapon_masteries.find(o => obj.ancestries.filter(o2 => o2.true_id === o.true_id).length > 0));
      // debugger;
    }
    let floating_feature: FloatingFeature | null = null;
    if (obj instanceof CharacterExtraEffects) {
      floating_feature = obj.main_ff;
    } else {
      floating_feature = obj.floating_feature;
    }
    if (floating_feature instanceof AttackUpgradeFeature || floating_feature instanceof WeaponDamageUpgradeFeature ||
      ((floating_feature instanceof ExtraEffectsFeature || floating_feature instanceof ExtraEffectTypeFeature) && 
        floating_feature.apply_to.includes("Weapons"))) {
      if (weapon instanceof CharacterWeapon) {
        if (obj.item_id !== "") { 
          if (log_it) {
            console.log(obj);
            console.log(weapon);
            // debugger;
          }
          if (obj.item_id === weapon.true_id) {
            return true;
          } else if (weapon.ammunition_type !== "None") {
            const item = char.inventory.ammunitions.find(o => o.true_id === obj.item_id);
            if (log_it) {
              console.log(obj.item_id);
              console.log(item);
              console.log(char.inventory.ammunitions.map(o => o.true_id));
              // debugger;
            }
            if (item && item.ammunition_type === weapon.ammunition_type) {
              return true;
            }
          }
        } else if (obj.source_type === "WeaponMasteryProperty") {
          const cwm = char.mind.weapon_masteries.find(o => obj.ancestries.filter(o2 => o2.true_id === o.true_id).length > 0);
          if (log_it) {
            console.log(cwm);
            console.log(obj);
            console.log(char.mind.weapon_masteries);
            // debugger;
          }
          if (cwm) {
            // I THINK THIS COMMENTED PART IS SUPPOSED TO BE FOR THINGS LIKE THE FIGHTER FEATURE TO 
            // ADD EXTRA WEAPON MASTERIES TO A WEAPON, BUT IT'S NOT WORKING.
            // if (weapon.weapon_mastery_property_ids.includes(cwm.source_id)) {
            //   return true;
            // } else {
            for (const weapon_limit of cwm.weapon_limits) {
              if (this.fitCharWeaponLimit(char, weapon, weapon_limit, attack_type, log_it)) {
                return true;
              }
            }
            // }
          }
          return false;
        } else {
          if (!floating_feature.weapon_limit.isEmpty()) {
            return this.fitCharWeaponLimit(char, weapon, floating_feature.weapon_limit, attack_type, log_it);
          } else {
            return true; // Applies to all weapons
          }
        }
      } else {
        if (obj.item_id !== "") { 
          return false;
        } else if (obj.source_type === "WeaponMasteryProperty") {
          // const cwm = char.mind.weapon_masteries.find(o => o.true_id === obj.source_true_id);
          // if (cwm) {
          //   // It's from a Weapon Mastery, so we need to check if the cwm goes with it
          //   if (cwm.cmik_id === "") {
          //     return cwm.base_item_id === weapon.base_item_id; // The base item of the weapon is one that they chose.
          //   } else {
          //     return weapon.char_magic_item_keywords.filter(o => o.true_id === cwm.cmik_id).length > 0; // They get the property as part of Magic Item Keyword (like Pact of the Blade)
          //   }
          // }
          // Currently, no Weapon Masteries work with Unarmed Strikes.
          return false;
        } else if (!floating_feature.weapon_limit.isEmpty()) {
          return api.fitWeaponLimit(weapon, floating_feature.weapon_limit, attack_type, log_it);
        } else {
          return true; // Applies to all weapon attacks.  Might need to be changed later.
        }
      }
    }
    return false;
  }

  fitCharWeaponLimit(char: CharacterSheetInterface, char_weapon: CharacterWeapon | Weapon | Attack, limit: WeaponLimitation, attack_type = "", log_it = false): boolean {
    if (char_weapon instanceof Attack) {
      if (!limit.isEmpty()) {
        return api.fitWeaponLimit(char_weapon, limit, attack_type, log_it);
      } else {
        return true; // Applies to all weapon attacks.  Might need to be changed later.
      }
    } else {
      const weapon = char_weapon instanceof Weapon ? char_weapon : char_weapon.base_item;
      if (weapon instanceof Weapon) {
        if (log_it) {
          // if (weapon instanceof Weapon && weapon.name.includes("Club")) {
          //   debugger;
          // }
          console.log(limit);
          console.log(weapon);
        }
        if (limit.item_ids.length > 0) {
          if (limit.item_ids.includes(weapon._id)) {
            return true;
          } else if (limit.isEmpty(["item_ids"])) {
            return false;
          }
        }
        let good = true;
        if (limit.weapon_keyword_ids.length > 0) {
          const weapon_keyword_ids = this.getWeaponKeywordIds(char, char_weapon);
          good = common_util.anyOverlaps(limit.weapon_keyword_ids, weapon_keyword_ids);
        }
        if (good && limit.excluded_keyword_ids.length > 0) {
          const weapon_keyword_ids = this.getWeaponKeywordIds(char, char_weapon);
          good = !common_util.anyOverlaps(limit.excluded_keyword_ids, weapon_keyword_ids);
        }
        if (good && limit.mik_ids.length > 0) {
          if (char_weapon instanceof Weapon) {
            good = false;
          } else {
            const mik_ids = char_weapon.magic_item_keyword_ids;
            good = common_util.anyOverlaps(limit.mik_ids, mik_ids);
          }
        }
        if (good && limit.excluded_mik_ids.length > 0) {
          if (char_weapon instanceof Weapon) {
            good = false;
          } else {
            const mik_ids = char_weapon.magic_item_keyword_ids;
            good = !common_util.anyOverlaps(limit.excluded_mik_ids, mik_ids);
          }
        }
        if (log_it) {
          console.log(good);
        }
        if (good && (limit.attack_types.length > 0 || limit.damage_types.length > 0)) {
          const the_attacks = weapon.attacks;
          const damage_types: string[] = [];
          let damages: RollPlus[] = [];
          if (log_it) {
            console.log(the_attacks);
          }
          for (const key of Object.keys(the_attacks)) {
            const attack = the_attacks[key];
            damages = [...damages, ...attack.rolls];
          }
          for (const damage of damages) {
            damage_types.push(damage.type);
          }
          if (limit.attack_types.length > 0) {
            if (attack_type !== "") {
              good = limit.attack_types.includes(attack_type as AttackType);
            } else {
              const attack_types = Object.keys(weapon.attacks);
              for (const at of attack_types) {
                const new_damages: any = the_attacks[at];
                if (new_damages.rolls) {
                  damages = [...new_damages.rolls];
                } else {
                  damages = [...new_damages];
                }
              }
              good = common_util.anyOverlaps(limit.attack_types, attack_types);
            }
          }
          if (good) {
            if (limit.damage_types.length > 0) {
              good = common_util.anyOverlaps(limit.damage_types, damage_types);
            }
          }
        }
        if (good && limit.proficient !== "Ignore") {
          good = this.proficient(char, char_weapon) === (limit.proficient === "Yes");
        }
        if (good && limit.attack_mods.length > 0) {
          if (char_weapon instanceof CharacterWeapon) {
            good = limit.attack_mods.includes(char_weapon.use_ability_score);
          } else {
            console.log("Attack Mod Limits in Progress");
            console.log(limit.attack_mods);
            console.log(char_weapon);
          }
        }
        if (good && limit.have_weapon_mastery !== "Ignore" && char instanceof Character) {
          let has_cwm = false;
          const cwm = char.mind.weapon_masteries.find(o => o.source_id === weapon.weapon_mastery_property_id);
          if (cwm) {
            const limit = cwm.weapon_limits.find(o => o.isEmpty(["item_ids"]));
            if (limit && limit.item_ids.includes(weapon._id)) {
              has_cwm = true;
            }
          }
          if (has_cwm) {
            good = limit.have_weapon_mastery === "Yes";
          } else {
            good = limit.have_weapon_mastery === "No";
          }
        }
        return good;
      } else if (char_weapon instanceof CharacterWeapon) {
        if (log_it) {
          // if (weapon instanceof Weapon && weapon.name.includes("Club")) {
          //   debugger;
          // }
          console.log(limit);
          console.log(weapon);
        }
        if (limit.item_ids.length > 0) {
          return false;
        }
        let good = true;
        if (limit.weapon_keyword_ids.length > 0) {
          const weapon_keyword_ids = char_weapon.weapon_keywords.map(o => o._id);
          good = common_util.anyOverlaps(limit.weapon_keyword_ids, weapon_keyword_ids);
        }
        if (good && limit.excluded_keyword_ids.length > 0) {
          const weapon_keyword_ids = char_weapon.weapon_keywords.map(o => o._id);
          good = !common_util.anyOverlaps(limit.excluded_keyword_ids, weapon_keyword_ids);
        }
        if (good && limit.mik_ids.length > 0) {
          const mik_ids = char_weapon.magic_item_keyword_ids;
          good = common_util.anyOverlaps(limit.mik_ids, mik_ids);
        }
        if (good && limit.excluded_mik_ids.length > 0) {
          const mik_ids = char_weapon.magic_item_keyword_ids;
          good = !common_util.anyOverlaps(limit.excluded_mik_ids, mik_ids);
        }
        if (log_it) {
          console.log(good);
        }
        if (good && (limit.attack_types.length > 0 || limit.damage_types.length > 0)) {
          // const the_attacks = weapon.attacks;
          // const damage_types: string[] = [];
          // let damages: RollPlus[] = [];
          // if (log_it) {
          //   console.log(the_attacks);
          // }
          // for (const key of Object.keys(the_attacks)) {
          //   const attack = the_attacks[key];
          //   damages = [...damages, ...attack.rolls];
          // }
          // for (const damage of damages) {
          //   damage_types.push(damage.type);
          // }
          // if (limit.attack_types.length > 0) {
          //   if (attack_type !== "") {
          //     good = limit.attack_types.includes(attack_type as AttackType);
          //   } else {
          //     const attack_types = Object.keys(weapon.attacks);
          //     for (const at of attack_types) {
          //       const new_damages: any = the_attacks[at];
          //       if (new_damages.rolls) {
          //         damages = [...new_damages.rolls];
          //       } else {
          //         damages = [...new_damages];
          //       }
          //     }
          //     good = common_util.any_overlaps(limit.attack_types, attack_types);
          //   }
          // }
          // if (good) {
          //   if (limit.damage_types.length > 0) {
          //     good = common_util.any_overlaps(limit.damage_types, damage_types);
          //   }
          // }
        }
        // This is from an ability that counts as a weapon. 
        // Chars are always proficient in these.
        // if (good && limit.proficient !== "Ignore") {
        //   good = this.proficient(char, char_weapon) === (limit.proficient === "Yes");
        // }
        if (good && limit.attack_mods.length > 0) {
          good = limit.attack_mods.includes(char_weapon.use_ability_score);
        }
        if (good && limit.have_weapon_mastery !== "Ignore" && char instanceof Character) {
          good = limit.have_weapon_mastery === "No";
        }
        return good;
      }
    }
    return false;
  }

  spellsThatFitLimit(char: CharacterSheetInterface, limit: SpellLimitation) {
    return data_util.spells.filter(o => this.fitCharSpellLimit2(char, o, limit))
  }

  fitCharItemLimit({ char, char_item, limit, log_it = false}: 
    { char: Character, char_item: CharacterItem, limit: ItemLimitation, log_it?: boolean }): boolean {
    const item = char_item.base_item;
    if (item) {
      if (log_it) {
        // if (weapon instanceof Weapon && weapon.name.includes("Club")) {
        //   debugger;
        // }
        console.log(limit);
        console.log(item);
      }
      return api.fitItemLimit(char_item, limit);
    }
    return false;
  }

  fitCharSpellLimit({
    char, 
    obj, 
    limit, 
    source_true_id, 
    ancestries,
    log_it = false
  }: {
    char?: CharacterSheetInterface, 
    obj: CharacterSpell | CharacterAbility | Spell, 
    limit: SpellLimitation, 
    source_true_id?: string, 
    ancestries?: FeatureAncestry[],
    log_it?: boolean
  }): boolean {
    const spell = obj instanceof Spell ? obj : obj.the_spell;
    if (spell) {
      if (log_it) {
        console.log(limit);
        console.log(spell);
        debugger;
      }
      if (limit.use_selectable) { 
        if (!(obj instanceof Spell)) {
          if (ancestries) {
            // debugger;
            if (log_it) {
              console.log(ancestries);
            }
            for (const ancestry of ancestries) {
              const cfs = char instanceof Character ? char.char_feature_sources.find(o => o.true_id === ancestry.true_id) : undefined;
              if (cfs) {
                if (log_it) {
                  console.log(cfs);
                  console.log(limit.selectable_key);
                }
                const selectable_maybe = cfs.selectable_hash[limit.selectable_key];
                if (selectable_maybe) {
                  return selectable_maybe.includes(spell._id) || selectable_maybe.includes(obj.true_id);
                }
              } 
            }
          } else if (source_true_id) {
            const cfs = char instanceof Character ? char.char_feature_sources.find(o => o.true_id === source_true_id) : undefined;
            if (cfs) {
              if (log_it) {
                console.log(cfs);
                console.log(limit.selectable_key);
              }
              const selectable_maybe = cfs.selectable_hash[limit.selectable_key];
              if (selectable_maybe) {
                return selectable_maybe.includes(spell._id) || selectable_maybe.includes(obj.true_id);
              }
            } 
          } 
        }
      } else {
        // if (spell.name.includes("Dissonant")) {
        //   debugger;
        // }
        if (limit.source_type === "Any" && limit.source_ids.length === 0) {
          return this.fitCharSpellLimit2(char, obj, limit, log_it);
        } else if (limit.source_ids.length > 0) {
          if (!(obj instanceof Spell)) {
            const cfs = char instanceof Character ? char.char_feature_sources.find(o => o.true_id === obj.source_true_id) : undefined;
            if (cfs && cfs.source) {
              const source_id = cfs.source._id;
              if ((limit.source_type === "game_class" || limit.source_type === "subclass") && obj instanceof CharacterAbility) {
                // It could be from a feat, in which case obj.source_id might point to the class, but we don't want it to work.
                const feat = char instanceof Character ? char.spirit.feats.find(o => o.source_id === obj.source_id2) : undefined;
                if (feat) {
                  return false;
                } else if (limit.source_ids.includes(source_id) || common_util.anyOverlaps(limit.source_ids, cfs.variant_ids)) {
                  return this.fitCharSpellLimit2(char, obj, limit, log_it);
                }
              } else if (limit.source_ids.includes(source_id) || common_util.anyOverlaps(limit.source_ids, cfs.variant_ids)) {
                return this.fitCharSpellLimit2(char, obj, limit, log_it);
              }
            }
          }
        } else {
          if (!(obj instanceof Spell)) {
            // limit.source_type !== "Any" && limit.source_ids.length === 0
            if (obj.source_type === limit.source_type) {
              return this.fitCharSpellLimit2(char, obj, limit, log_it);
            }
          }
        }
      }
    }
    return false;
  }

  fitCharSpellLimit2(char: CharacterSheetInterface | undefined, obj: CharacterSpell | CharacterAbility | Spell, limit: SpellLimitation, log_it = false): boolean {
    const spell = obj instanceof Spell ? obj : obj.the_spell;
    if (spell) {
      if (log_it) {
        console.log(limit);
        console.log(spell);
      }
      if (limit.spell_ids.length > 0) {
        if (limit.spell_ids.includes(spell._id) || common_util.anyOverlaps(limit.spell_ids, spell.variant_ids)) {
          return true; 
        } else if (limit.isEmpty(["spell_ids"])) { // Nothing besides spell_ids
          return false;
        }
      } 
      if (limit.excluded_spell_ids.includes(spell._id)) {
        return false;
      }
      let good = true;
      if (limit.list_ids.length > 0) {
        // if (spell.name === "Bless") {
        //   debugger;
        // }
        good = common_util.anyOverlaps(limit.list_ids, spell.spell_list_ids);
      }
      if (good && limit.schools.length > 0) {
        good = limit.schools.includes(obj.school);
      } 
      if (good && limit.levels.length > 0) {
        if (limit.levels.includes(-1)) {
          const min = this.value(limit.min_level, { obj: char });
          good = min <= obj.level;
          if (good) {
            const max = this.value(limit.max_level, { obj: char });
            if (max >= min) { // If this isn't true it means we set a min but no max.
              good = obj.level <= max;
            }
          }
        } else {
          good = limit.levels.includes(obj.level);
        }
      }
      if (log_it) {
        console.log(good);
      }
      if (good && limit.attack_types.length > 0) {
        good = spell.effects.find(o => limit.attack_types.includes(o.attack_type)) !== undefined;
      }
      if (log_it) {
        console.log(good);
      }
      if (good && limit.effect_types.length > 0) {
        good = spell.effects.find(o => limit.effect_types.includes(o.type)) !== undefined;
      }
      if (log_it) {
        console.log(good);
      }
      if (good && limit.damage_types.length > 0) {
        good = common_util.anyOverlaps(limit.damage_types, obj.damage_types);
      }
      if (log_it) {
        console.log(good);
      }
      if (good && (limit.min_duration !== null || limit.max_duration !== null)) {
        const numeric_duration = (DURATION_NUMBER_MAP as any)[obj.duration];
        if (limit.min_duration !== null) {
          if (typeof(numeric_duration) === "number") {
            good = numeric_duration === -1 || numeric_duration > limit.min_duration;
          } else {
            return false;
          }
        }
        if (good && limit.max_duration !== null) {
          if (typeof(numeric_duration) === "number") {
            good = numeric_duration === -1 || numeric_duration < limit.max_duration;
          } else {
            return false;
          }
        }
      }
      if (log_it) {
        console.log(good);
      }
      if (good && (limit.min_range !== null || limit.max_range !== null || limit.touch !== "Ignore" || limit.self !== "Ignore")) {
        const range = obj instanceof Spell ? obj.range : (char ? this.getRangeString({ char_int: char, spell: obj, log_it }) : "");
        if (range === "Self") {
          if (limit.self === "Ignore") {
            if (limit.touch === "Ignore") {
              if (limit.min_range !== null) {
                good = limit.min_range <= 0;
              } // else it has a max_range but not a min_range, so allow it
            } else {
              good = limit.touch === "Yes"; // Self works with Touch
            }
          } else {
            good = limit.self === "Yes";
          }
        } else if (range === "Touch") {
          if (limit.touch === "Ignore") {
            if (limit.min_range !== null) {
              good = limit.min_range <= 0;
            } else if (limit.max_range === null) {
              good = limit.self !== "Yes";
            }
          } else {
            good = limit.touch === "Yes";
          }
        } else {
          const range_num = +range.split(" ")[0];
          if (limit.min_range !== null || limit.max_range !== null) {
            if (limit.min_range !== null) {
              good = range_num >= limit.min_range;
            }
            if (good && limit.max_range !== null) {
              good = range_num <= limit.max_range;
            }
          } else {
            const okay = ["Ignore","No"];
            good = okay.includes(limit.self) && okay.includes(limit.touch);
          }
        }
      }
      if (log_it) {
        console.log(good);
      }
      if (good && limit.casting_times.length > 0) {
        good = common_util.anyOverlaps(limit.casting_times, obj.casting_times);
        if (good && limit.casting_times.includes("Special") && limit.special_casting_time.length > 0) {
          good = limit.special_casting_time === obj.special_casting_time;
        }
      }
      if (log_it) {
        console.log(good);
      }
      if (good && limit.ritual !== "Ignore") {
        good = (limit.ritual === "Yes") === obj.ritual; 
      }
      if (log_it) {
        console.log(good);
      }
      if (good && limit.concentration !== "Ignore") {
        good = (limit.concentration === "Yes") === obj.concentration; 
      }
      if (log_it) {
        console.log(good);
      }
      if (good && limit.target_types.length > 0) {
        good = common_util.anyOverlaps(limit.target_types, spell.target_types);
      }
      if (log_it) {
        console.log(good);
      }
      if (good && limit.area_types.length > 0) {
        good = common_util.anyOverlaps(limit.area_types, spell.area_types);
      }
      if (log_it) {
        console.log(good);
      }
      if (good && limit.twinnable_1dd_ua7 !== "Ignore") {
        good = (limit.twinnable_1dd_ua7 === "Yes") === spell.twinnable_1dd_ua7; 
      }
      if (log_it) {
        console.log(good);
      }
      if (good && limit.disease !== "Ignore") {
        good = (limit.disease === "Yes") === spell.disease; 
      }
      if (log_it) {
        console.log(good);
      }
      if (good && limit.charm !== "Ignore") {
        good = (limit.charm === "Yes") === spell.charm; 
      }
      if (log_it) {
        console.log(good);
        console.log(limit.contaminated);
        console.log(spell.contaminated);
      }
      if (good && limit.contaminated !== "Ignore") {
        good = (limit.contaminated === "Yes") === spell.contaminated; 
      }
      if (good && limit.sight !== "Ignore") {
        good = (limit.sight === "Yes") === spell.sight; 
      }
      if (good && limit.verbal !== "Ignore") {
        good = (limit.verbal === "Yes") === obj.components.includes("V"); 
      }
      if (good && limit.somatic !== "Ignore") {
        good = (limit.somatic === "Yes") === obj.components.includes("S"); 
      }
      if (good && limit.material !== "Ignore") {
        good = (limit.material === "Yes") === obj.components.includes("M"); 
      }
      if (good && limit.m_cost_listed !== "Ignore") {
        good = (limit.m_cost_listed === "Yes") === obj.material_cost_listed; 
      }
      if (good && limit.m_consumed !== "Ignore") {
        good = (limit.m_consumed === "Yes") === obj.material_consumed; 
      }
      if (good && limit.in_spellbook !== "Ignore") {
        if (char instanceof Character) {
          const cfs = char.spirit.classes.find(o => o.spellbook);
          if (cfs && cfs.spellbook) {
            const char_spell = cfs.spellbook.spells.find(o => o.spell_id === obj.spell_id);
            good = (limit.in_spellbook === "Yes") === (char_spell !== undefined); 
          } else {
            good = false;
          }
        } else {
          good = false; 
        }
      }
      return good;
    }
    return false;
  }

  fitCharAbilityLimit(char: CharacterSheetInterface, obj: CharacterAbility, limit: AbilityLimitation, item_id: string, log_it = false): boolean {
    const ability = obj.the_ability;
    if (ability instanceof Ability) {
      let good = true;
      // log_it = ability.name.includes("Shapechanger");
      if (log_it) {
        debugger;
        console.log(limit);
        console.log(ability);
      }
      if (limit.name.length > 0) {
        good = ability.name.includes(limit.name);
      } 
      if (limit.ability_tag.length > 0) {
        good = ability.tags.includes(limit.ability_tag);
      }
      if (log_it) {
        console.log(good);
      }
      if (log_it) {
        console.log(good);
      }
      if (good && limit.source_types.length > 0) {
        // if (limit.source_types.includes("This Item")) {
        //   if (item_id !== "" && item_id === obj.item_id) {

        //   } else {
        //     return false;
        //   }
        // } else 
        if (limit.source_ids.length > 0 && char instanceof Character) {
          const cfs = char.char_feature_sources.find(o => o.true_id === obj.source_true_id);
          if (cfs && cfs.source) {
            if (cfs instanceof CharacterRace) {
              good = common_util.anyOverlaps(limit.source_ids, cfs.variant_ids);
              if (!good) {
                const char_subrace = cfs.sub_char_feature_sources.find(o => o instanceof CharacterSubrace) as CharacterSubrace;
                if (char_subrace) {
                  good = common_util.anyOverlaps(limit.source_ids, char_subrace.variant_ids);
                }
              }
            } else if (cfs instanceof CharacterSubrace) {
              good = common_util.anyOverlaps(limit.source_ids, cfs.variant_ids);
              if (!good) {
                const char_race = char.spirit.race;
                good = common_util.anyOverlaps(limit.source_ids, char_race.variant_ids);
              }
            } else if (cfs instanceof CharacterClass) {
              good = common_util.anyOverlaps(limit.source_ids, cfs.variant_ids);
              if (!good) {
                const char_subclass = cfs.sub_char_feature_sources.find(o => o instanceof CharacterSubclass) as CharacterSubclass;
                if (char_subclass) {
                  good = common_util.anyOverlaps(limit.source_ids, char_subclass.variant_ids);
                }
              }
            } else if (cfs instanceof CharacterSubclass) {
              good = common_util.anyOverlaps(limit.source_ids, cfs.variant_ids);
              if (!good) {
                const char_class = char.spirit.classes.find(o => o.char_subclass && o.char_subclass.true_id === cfs.true_id);
                if (char_class) {
                  good = common_util.anyOverlaps(limit.source_ids, char_class.variant_ids);
                }
              }
            } else {
              good = common_util.anyOverlaps(limit.source_ids, cfs.variant_ids);
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
      if (good && limit.attack_types.length > 0) {
        good = ability.effects.find(o => limit.attack_types.includes(o.attack_type)) !== undefined;
      }
      if (good && limit.attack_mods.length > 0) {
        good = limit.attack_mods.includes(obj.attack.attack_stat);
      }
      if (good && limit.effect_types.length > 0) {
        good = ability.effects.find(o => limit.effect_types.includes(o.type)) !== undefined;
      }
      if (good && limit.damage_types.length > 0) {
        good = ability.effects.find(o => common_util.anyOverlaps(limit.damage_types, o.damage_types)) !== undefined;
      }
      if (good && (limit.min_duration !== null || limit.max_duration !== null)) {
        const numeric_duration = (DURATION_NUMBER_MAP as any)[ability.duration];
        if (limit.min_duration !== null) {
          if (typeof(numeric_duration) === "number") {
            good = numeric_duration === -1 || numeric_duration > limit.min_duration;
          } else {
            return false;
          }
        }
        if (good && limit.max_duration !== null) {
          if (typeof(numeric_duration) === "number") {
            good = numeric_duration === -1 || numeric_duration < limit.max_duration;
          } else {
            return false;
          }
        }
      }
      if (good && (limit.min_range !== null || limit.max_range !== null || limit.touch !== "Ignore" || limit.self !== "Ignore")) {
        const range = ability.range;
        if (range === "Self") {
          if (limit.self === "Ignore") {
            if (limit.touch === "Ignore") {
              if (limit.min_range !== null) {
                good = limit.min_range <= 0;
              } // else it has a max_range but not a min_range, so allow it
            } else {
              good = limit.touch === "Yes"; // Self works with Touch
            }
          } else {
            good = limit.self === "Yes";
          }
        } else if (range === "Touch") {
          if (limit.touch === "Ignore") {
            if (limit.min_range !== null) {
              good = limit.min_range <= 0;
            } else if (limit.max_range === null) {
              good = limit.self !== "Yes";
            }
          } else {
            good = limit.touch === "Yes";
          }
        } else {
          const range_num = +range.split(" ")[0];
          if (limit.min_range !== null || limit.max_range !== null) {
            if (limit.min_range !== null) {
              good = range_num >= limit.min_range;
            }
            if (good && limit.max_range !== null) {
              good = range_num <= limit.max_range;
            }
          } else {
            const okay = ["Ignore","No"];
            good = okay.includes(limit.self) && okay.includes(limit.touch);
          }
        }
      }
      if (good && limit.casting_times.length > 0) {
        good = limit.casting_times.includes(ability.casting_time);
        if (good && limit.casting_times.includes("Special") && limit.special_casting_time.length > 0) {
          good = limit.special_casting_time === ability.special_casting_time;
        }
      }
      if (good && limit.uses_resource.length > 0) {
        good = limit.uses_resource.includes(ability.consumed_resource.resource_consumed);
      }
      // if (good && limit.ritual !== "Ignore") {
      //   good = (limit.ritual === "Yes") === ability.ritual; 
      // }
      if (good && limit.concentration !== "Ignore") {
        good = (limit.concentration === "Yes") === ability.concentration; 
      }
      // if (good && limit.target_types.length > 0) {
      //   good = common_util.any_overlaps(limit.target_types, ability.target_types);
      // }
      // if (good && limit.area_types.length > 0) {
      //   good = common_util.any_overlaps(limit.area_types, ability.area_types);
      // }
      // if (good && limit.twinnable_1dd_ua7 !== "Ignore") {
      //   good = (limit.twinnable_1dd_ua7 === "Yes") === ability.twinnable_1dd_ua7; 
      // }
      // if (good && limit.disease !== "Ignore") {
      //   good = (limit.disease === "Yes") === ability.disease; 
      // }
      // if (good && limit.charm !== "Ignore") {
      //   good = (limit.charm === "Yes") === ability.charm; 
      // }
      // if (good && limit.contaminated !== "Ignore") {
      //   good = (limit.contaminated === "Yes") === ability.contaminated; 
      // }
      if (good && limit.sight !== "Ignore") {
        good = (limit.sight === "Yes") === ability.sight; 
      }
      if (good && limit.verbal !== "Ignore") {
        good = (limit.verbal === "Yes") === ability.components.includes("V"); 
      }
      if (good && limit.somatic !== "Ignore") {
        good = (limit.somatic === "Yes") === ability.components.includes("S"); 
      }
      if (good && limit.material !== "Ignore") {
        good = (limit.material === "Yes") === ability.components.includes("M"); 
      }
      return good;
    }
    return false;
  }

  canEquip(character: Character, char_item: CharacterItem): boolean {
    return this.proficient(character, char_item);
  }

  proficient(character: CharacterSheetInterface, item: CharacterItem | PseudoItem | Item): boolean {
    const no_prof_required_types = ["Ammunition","Potion","Poison","Ring","Rod","Scroll","Dust","Staff","Wand","Wondrous","Gem","Holy Symbol","Arcane Focus","Druidic Focus","Other","Manual"];
    const tool_types = ["Artisan's Tools","Game Set","Musical Instrument","Vehicles"];
    if (item instanceof CharacterItem) {
      const char_item = item;
      if (!char_item.ignore_proficiency_requirements && 
        !char_item.proficiency_override &&
        char_item.base_item) {
        if (!no_prof_required_types.includes(char_item.item_type)) {
          if (char_item instanceof CharacterArmor) {
            const armor = char_item;
            if (armor.proficiency_req_options.length > 0) {
              return common_util.anyOverlaps(armor.proficiency_req_options, character.mind.armor_proficiencies.map(o => o.proficiency_id));
            } else {
              if (armor.require_special_proficiency) {
                return character.mind.armor_proficiencies.filter(o => 
                  (armor.base_item_id !== "" && o.proficiency_id === armor.base_item_id) 
                  // || (armor.magic_item_id !== "" && o.proficiency_id === armor.magic_item_id)
                  ).length > 0;
              } else {
                return character.mind.armor_proficiencies.filter(o => o.proficiency_id === armor.armor_type_id).length > 0 ||
                  character.mind.armor_proficiencies.filter(o => 
                    (armor.base_item_id !== "" && o.proficiency_id === armor.base_item_id) 
                    // || (armor.magic_item_id !== "" && o.proficiency_id === armor.magic_item_id)
                    ).length > 0;
              }
            }
          } else if (char_item instanceof CharacterWeapon) {
            const weapon = char_item.base_item;
            if (weapon.name.includes("Long")) {
              console.log(char_item);
            }
            let proficient = false;
            if (char_item.proficiency_req_options.length > 0) {
              proficient = char_item.proficiency_req_options.includes("None") || 
                common_util.anyOverlaps(char_item.proficiency_req_options, character.mind.weapon_proficiencies.map(o => o.proficiency_id));
            }
            if (!proficient) {
              const weapon_keyword_ids = this.getWeaponKeywordIds(character, char_item);
              if (weapon instanceof Weapon) {
                const weapon_id = weapon._id;
                proficient = character.mind.weapon_proficiencies.filter(o => 
                    weapon_keyword_ids.includes(o.proficiency_id)).length > 0 || 
                  character.mind.weapon_proficiencies.filter(o => 
                    o.proficiency_id === weapon_id).length > 0;
              }
            }
            if (!proficient && char_item.proficiency_as_weapons.length > 0) {
              for (const weapon_id of char_item.proficiency_as_weapons) {
                const weapon2 = data_util.items.find(o => o._id === weapon_id);
                if (weapon2 instanceof Weapon) {
                  const weapon_keyword_ids = weapon2.weapon_keyword_ids;
                  const weapon_id = weapon._id;
                  if (character.mind.weapon_proficiencies.filter(o => 
                      weapon_keyword_ids.includes(o.proficiency_id)).length > 0 || 
                    character.mind.weapon_proficiencies.filter(o => 
                      o.proficiency_id === weapon_id).length > 0
                  ) {
                    proficient = true;
                    break;
                  }
                }
              }
            }
            return proficient;
          } else if (char_item instanceof CharacterBasicItem) {
            // if (char_item.name.includes("Lute")) {
            //   debugger;
            // }
            if (tool_types.includes(char_item.item_type)) {
              const tool_id = (char_item.base_item as BasicItem).tool_id;
              return character.mind.tool_proficiencies.filter(tp => 
                tp.type === "Tool" && 
                tp.proficiency_id === tool_id).length === 1;
            }
          }
        }
      }
    } else {
      // I was going to make it check for miks that remove the need for prof, but apparently I don't have that
      // if (item instanceof PseudoItem) {
      //   const mik = item.magic_item_keywords.find(o => o.feature_bases.find(o2 => o2.features.find(o3 => o3.f)))
      // }
      const use_item = item instanceof PseudoItem ? item.base_item : item;
      if (use_item) {
        if (!use_item.ignore_proficiency_requirements && 
          !no_prof_required_types.includes(use_item.item_type)) {
          if (use_item instanceof Armor) {
            const armor = use_item;
            if (armor) {
              return character.mind.armor_proficiencies.filter(o => o.proficiency_id === armor.armor_type_id).length > 0;
            }
          } else if (use_item instanceof Weapon) {
            const weapon = use_item;
            // if (weapon.name === "Shortsword") {
            //   console.log(weapon);
            //   console.log(character.mind.weapon_proficiencies);
            //   console.log(weapon.weapon_keyword_ids);
            // }
            if (weapon) {
              const weapon_keyword_ids = this.getWeaponKeywordIds(character, weapon);
              const weapon_id = weapon._id;
              return character.mind.weapon_proficiencies.filter(o => 
                  weapon_keyword_ids.includes(o.proficiency_id)).length > 0 || 
                character.mind.special_proficiencies.filter(o => o.proficiency_id === weapon_id).length > 0;
            }
          } else if (use_item instanceof BasicItem) {
            if (tool_types.includes(use_item.item_type)) {
              const tool_id = use_item.tool_id;
              return character.mind.tool_proficiencies.filter(tp => 
                tp.type === "Tool" && 
                tp.proficiency_id === tool_id).length === 1;
            }
          }
        }
      }
    }
    return true;
  }

  getCustomization(customizations: Customization, id: string, type: string) {
    const customization = customizations[id];
    if (customization) {
      const for_type = customization[type];
      if (for_type) {
        return for_type.value;
      }
    }
    return null;
  }

  skillRolls(char_interface: CharacterSheetInterface, skill: Skill): { char_roll?: CharacterRoll, skill_rolls: RollPlus[], bonuses_string: string } {
    const log_it = false; // ["Perception"].includes(skill.name);
    if (log_it) {
      debugger;
    }
    const char_roll_finder = char_interface.mind.skill_checks.find(o => o.skill_id === skill._id);
    if (char_roll_finder) {
      const char_roll = char_roll_finder.skill_check;
      const roll_plus = new RollPlus();
      roll_plus.flat = char_roll.modifier;
      const skill_rolls: RollPlus[] = [roll_plus, ...char_roll.rolls];
      let bonuses_string = "";
      let new_mod = char_roll.modifier;
      for (const bonus of char_roll.rolls) {
        const roll_plus2 = bonus;
        if (roll_plus2) {
          new_mod += roll_plus2.flat;
          if (!["","None","undefined"].includes(roll_plus2.ability_score)) {
            const mod = char_interface.mind.current_ability_scores.getModifier(roll_plus2.ability_score);
            if (mod) {
              new_mod += mod;
            }
          }
          if (roll_plus2.size === 1) {
            new_mod += roll_plus2.count;
          } else if (roll_plus2.size > 1 && roll_plus2.count !== 0) {
            roll_plus2.recalculate_string();
            if (roll_plus2.as_string.length > 0 && roll_plus2.as_string[0] !== "-") {
              bonuses_string += `+${roll_plus2.as_string}`;
            } else {
              bonuses_string += roll_plus2.as_string;
            }
          }
        }
      }
      if (new_mod > 0) {
        bonuses_string = `+${new_mod}${bonuses_string}`;
      } else if (new_mod < 0) {
        bonuses_string = `${new_mod}${bonuses_string}`;
      } else if (bonuses_string === "") {
        bonuses_string = "+0";
      }
      return { char_roll, skill_rolls, bonuses_string };
    }
    return { skill_rolls: [], bonuses_string: "" };
  }

  skillModifier(char: CharacterSheetInterface, skill: Skill) {
    const log_it = false; // ["Perception"].includes(skill.name);
    if (log_it) {
      debugger;
    }
    let proficiency_multiplier = 0;
    let use_ability_score = skill.use_ability_score;
    const override_feature = char.mind.skill_ability_overrides.find(o => o.skill_ids.includes(skill._id));
    if (override_feature) {
      use_ability_score = override_feature.ability_score;
    }
    let modifier = char.mind.current_ability_scores.getModifier(use_ability_score);
    // const override = char.skill_overrides[skill._id];
    // const prof_override = char.proficiency_overrides[skill._id];
    // const override = this.getCustomization(char.skill_customizations, skill._id, "Override");
    // const prof_override = this.getCustomization(char.skill_customizations, skill._id, "Proficiency Override");
    const jack = char.mind.jack_of_all_trades;
    const prof_finder = char.mind.proficiencies.filter(o => o.proficiency_id === skill._id);
    let extra = 0;

    if (log_it) {
      console.log(skill.name);
      // console.log(char.proficiencies.filter(o => o.prof_feature_id === "2d2fd8c9-f597-4a94-8ab4-a6ba92bc9835"));
      console.log(prof_finder);
      // console.log(prof_finder.filter(o => o.prof_feature_id === "2d2fd8c9-f597-4a94-8ab4-a6ba92bc9835"));
      debugger;
    }
    // if (prof_override !== null && prof_override !== undefined) {
    //   proficiency_multiplier = prof_override;
    // } else 
    if (prof_finder.length > 0) {
      extra = prof_finder.map(o => o.extra_bonus).reduce((a, b) => a + b, 0);
      proficiency_multiplier = Math.max.apply(Math, prof_finder.map(o => { return o.proficiency_level; }));
    } else if (jack) {
      proficiency_multiplier = 0.5;
    }
    // if (override !== undefined && override !== null) {
    //   modifier = override;
    // } else 
    if (modifier !== null) {
      // const extra_bonus = this.getCustomization(char.skill_customizations, skill._id, "Modifier");
      // if (extra_bonus) {
      //   modifier += extra_bonus;
      // }
      modifier += Math.floor(char.mind.proficiency_modifier * proficiency_multiplier);
    }
    if (log_it) {
      console.log(prof_finder);
      console.log(proficiency_multiplier);
      console.log(modifier);
      console.log(extra);
    }
    modifier += extra;
    if (!modifier) {
      modifier = 0;
    }
    return { modifier, proficiency_multiplier };
  }

  getAdvantage(char: CharacterSheetInterface, type: string, thing: any) {
    let advantage = char.body.advantage;
    let advantages: CharacterAdvantage[] = [];
    if (char.body.advantage > 0) {
      const fake_adv_feature = new Advantage();
      fake_adv_feature._id = "Advantage Button";
      const char_adv: CharacterAdvantage = {
        true_id: uuidv4().toString(),
        advantage: fake_adv_feature,
        source_id: "Advantage Button",
        source_type: "character",
        source_name: "Advantage Button",
        cfb_id: "Advantage Button",
        cfb_name: "Advantage Button"
      };

      advantages.push(char_adv);
    } else if (char.body.advantage < 0) {
      const fake_adv_feature = new Advantage();
      fake_adv_feature._id = "Advantage Button";
      fake_adv_feature.disadvantage = true;
      const char_adv: CharacterAdvantage = {
        true_id: uuidv4().toString(),
        advantage: fake_adv_feature,
        source_id: "Advantage Button",
        source_type: "character",
        source_name: "Advantage Button",
        cfb_id: "Advantage Button",
        cfb_name: "Advantage Button"
      };

      advantages.push(char_adv);
    }
    let greater_advantages = [...char.mind.greater_advantages];
    // console.log(char);
    // console.log(type);
    // console.log(thing);
    if (type.includes("Ability Check")) {
      if (thing.data_type && thing.data_type === "skill") {
        const skill = thing;
        let use_ability_score = skill.use_ability_score;
        const override_feature = char.mind.skill_ability_overrides.find(o => o.skill_ids.includes(skill._id));
        if (override_feature) {
          use_ability_score = override_feature.ability_score;
        }
        advantages = char.mind.advantages.filter(o => 
          o.advantage.formula === "" &&
          o.advantage.type.includes(type) && 
          (o.advantage.type_details.length === 0 || 
            o.advantage.type_details.includes(skill._id) || 
            o.advantage.type_details.includes(use_ability_score)));
        for (const adv of advantages) {
          advantage += adv.advantage.disadvantage ? -1 : 1;
        }
        if (skill.use_name === "Stealth" && 
          char instanceof Character && char.inventory.equipped_items.filter(o => 
            o instanceof CharacterArmor && 
            !char.mind.ignore_stealth_disadvantage_for_armor_type_ids.includes(o.armor_type_id) &&
            o.stealth_disadvantage).length > 0) {
          advantage += -1;
        }
        greater_advantages = greater_advantages.filter(o => 
          (o.roll_types.length === 0 || o.roll_types.includes("Ability Check") || o.roll_types.includes("Skill Check")) &&
          (o.use_ability_scores.length === 0 || (skill.use_ability_score !== "None" && o.use_ability_scores.includes(skill.use_ability_score)))
        );
      } else if (typeof(thing) === "string") {
        const stat = thing;
        advantages = char.mind.advantages.filter(o => 
          o.advantage.formula === "" &&
          o.advantage.type.includes(type) && 
          (o.advantage.type_details.length === 0 || 
            o.advantage.type_details.includes(stat)));
        for (const adv of advantages) {
          advantage += adv.advantage.disadvantage ? -1 : 1;
        }
        greater_advantages = greater_advantages.filter(o => 
          (o.roll_types.length === 0 || o.roll_types.includes("Ability Check")) &&
          (o.use_ability_scores.length === 0 || (o.use_ability_scores.includes(stat as AbilityScoreType)))
        );
      }
    } else if (type.includes("Initiative")) {
      const stat = "DEX";
      advantages = char.mind.advantages.filter(o => 
        o.advantage.formula === "" &&
        o.advantage.type.includes(type) && 
        (o.advantage.type_details.length === 0 || 
          o.advantage.type_details.includes(stat)));
      for (const adv of advantages) {
        advantage += adv.advantage.disadvantage ? -1 : 1;
      }
      greater_advantages = greater_advantages.filter(o => 
        (o.roll_types.length === 0 || o.roll_types.includes("Ability Check")) &&
        (o.use_ability_scores.length === 0 || (o.use_ability_scores.includes(stat as AbilityScoreType)))
      );
    } else if (type.includes("Saving Throw")) {
      if (typeof(thing) === "string") {
        const stat = thing;
        advantages = char.mind.advantages.filter(o => 
          o.advantage.formula === "" &&
          o.advantage.type.includes(type) && 
          (o.advantage.type_detail === "ALL" || 
            o.advantage.type_detail === stat
          )
        );
        // console.log(advantages);
        for (const adv of advantages) {
          advantage += adv.advantage.disadvantage ? -1 : 1;
        }
        if (char instanceof Character) {
          const additional_advantages = char.mind.advantages.filter(o => 
            o.advantage.formula === "" &&
            o.advantage.type.includes(type) && 
            o.advantage.type_detail === "Selectable");
          for (const adv of additional_advantages) {
            const key = adv.advantage.selectable_key;
            const source = char.char_feature_sources.find(o => o.true_id === adv.source_id);
            if (source) {
              if (source.selectable_hash[key].includes(stat)) {
                advantage += adv.advantage.disadvantage ? -1 : 1;
                advantages.push(adv);
              }
            }
          }
        }
        greater_advantages = greater_advantages.filter(o => 
          (o.roll_types.length === 0 || o.roll_types.includes("Saving Throw")) &&
          (o.use_ability_scores.length === 0 || (o.use_ability_scores.includes(stat as AbilityScoreType)))
        );
      }
    } else if (type.includes("Attack")) {
      if (thing instanceof CharacterAbility) {
        const ability = thing;
        advantages = char.mind.advantages.filter(o => 
          o.advantage.type.includes(type) && 
          ((o.advantage.type_details.length === 0 || 
            common_util.anyOverlaps(o.advantage.type_details, thing.attack_types) || o.advantage.type_details.includes(thing.spellcasting_ability)) // This is for if it's specifying Ability Score to be used for attack mod
          ) &&
          (o.advantage.for_class_id === "" || thing.source_id === o.advantage.for_class_id)
        );
        // console.log(advantages);
        for (const adv of advantages) {
          advantage += adv.advantage.disadvantage ? -1 : 1;
        }
        greater_advantages = greater_advantages.filter(o => 
          (o.roll_types.length === 0 || o.roll_types.includes("Attack")) &&
          (o.use_ability_scores.length === 0 || (o.use_ability_scores.includes(ability.spellcasting_ability as AbilityScoreType)))
        );
      } else if (thing instanceof CharacterSpell) {
        const spell = thing;
        advantages = char.mind.advantages.filter(o => 
          o.advantage.type.includes(type) && 
          ((o.advantage.type_details.length === 0 || 
            common_util.anyOverlaps(o.advantage.type_details,thing.attack_types) || o.advantage.type_details.includes(thing.spellcasting_ability)) // This is for if it's specifying Ability Score to be used for attack mod
          ) &&
          (o.advantage.for_class_id === "" || thing.source_id === o.advantage.for_class_id)
        );
        // console.log(advantages);
        for (const adv of advantages) {
          advantage += adv.advantage.disadvantage ? -1 : 1;
        }
        greater_advantages = greater_advantages.filter(o => 
          (o.roll_types.length === 0 || o.roll_types.includes("Attack")) &&
          (o.use_ability_scores.length === 0 || (o.use_ability_scores.includes(spell.spellcasting_ability as AbilityScoreType)))
        );
      } else if (thing instanceof CharacterWeapon) {
        const weapon = thing;
        advantages = char.mind.advantages.filter(o => 
          o.advantage.type.includes(type) && 
          ((o.advantage.type_details.length === 0 || 
            common_util.anyOverlaps(o.advantage.type_details,thing.attacks.map(o => o.type)) || o.advantage.type_details.includes(thing.attack_stat)) // This is for if it's specifying Ability Score to be used for attack mod
          ) &&
          (o.advantage.for_class_id === "")
        );
        if (weapon.weapon_keywords.filter(o => o.name === "Heavy").length > 0) {
          // debugger;
          if (char instanceof Character) {
            let disadv = false;
            const ignore_heavy_rule_features = char.mind.misc_features.filter(o => 
              o.feature_type === "Ignore Heavy Rule" && (o.use_item_id === "" || o.use_item_id === weapon.true_id));
            if (ignore_heavy_rule_features.length === 0) {
              if (char.c_options.heavy_weapon_rule === "Disadvantage from Ability Score") {
                if (weapon.weapon_keywords.filter(o => o.name.includes("Range")).length > 0) {
                  if (char.mind.current_ability_scores.dexterity < 13) {
                    disadv = true;
                  }
                } else {
                  if (char.mind.current_ability_scores.strength < 13) {
                    disadv = true;
                  }
                }
              } else if (char.c_options.heavy_weapon_rule === "Disadvantage from Size") {
                if (char.mind.use_size < 3) {
                  disadv = true;
                }
              }
              if (disadv) {
                const fake_adv_feature = new Advantage();
                fake_adv_feature._id = "Heavy";
                fake_adv_feature.disadvantage = true;
                const disadv: CharacterAdvantage = {
                  true_id: uuidv4().toString(),
                  advantage: fake_adv_feature,
                  source_id: "Heavy",
                  source_type: "weapon_keyword",
                  source_name: "Heavy",
                  cfb_id: "Heavy",
                  cfb_name: "Heavy"
                };
                advantages.push(disadv);
              }
            }
          }
        }
        // console.log(advantages);
        for (const adv of advantages) {
          advantage += adv.advantage.disadvantage ? -1 : 1;
        }
        greater_advantages = greater_advantages.filter(o => 
          (o.roll_types.length === 0 || o.roll_types.includes("Attack")) &&
          (o.use_ability_scores.length === 0 || (o.use_ability_scores.includes(weapon.attack_stat)))
        );
      } else if (thing instanceof Attack) {
        const attack = thing;
        advantages = char.mind.advantages.filter(o => 
          o.advantage.type.includes(type) && 
          ((o.advantage.type_details.length === 0 || o.advantage.type_details.includes(thing.attack_stat)) // This is for if it's specifying Ability Score to be used for attack mod
          ));
        // console.log(advantages);
        for (const adv of advantages) {
          advantage += adv.advantage.disadvantage ? -1 : 1;
        }
        greater_advantages = greater_advantages.filter(o => 
          (o.roll_types.length === 0 || o.roll_types.includes("Attack")) &&
          (o.use_ability_scores.length === 0 || (attack.attack_stat !== "None" && o.use_ability_scores.includes(attack.attack_stat)))
        );
      } else if (thing === null) {
        advantages = char.mind.advantages.filter(o => o.advantage.type.includes(type) && (o.advantage.type_details.length === 0));
        // console.log(advantages);
        for (const adv of advantages) {
          advantage += adv.advantage.disadvantage ? -1 : 1;
        }
        greater_advantages = [];
      }
    }
    const greater_advantage = greater_advantages.length > 0;
            
    return { advantage, advantages, greater_advantage };
  }

  getRangeString({
    char_int, 
    spell, 
    effect, 
    weapon,
    attack,
    log_it = false
  }: {
    char_int: CharacterSheetInterface | BasicCreatureInstance | SummonInstance, 
    spell?: CharacterSpell | CharacterAbility | CharacterItem | StoredSpell, 
    effect?: AbilityEffect, 
    weapon?: CharacterWeapon,
    attack?: Attack,
    log_it?: boolean
  }): string {
    // log_it = spell instanceof CharacterSpell && spell.name.includes("Burning Hands");
    if (log_it) {
      debugger;
    }
    let range_string = "";
    let ignore_range = false;
    let use_effect = effect;
    if (!use_effect) {
      if (spell instanceof Spell) {
        use_effect = spell.effects[0];
      } else if (spell instanceof CharacterSpell) {
        use_effect = spell.effects[0];
      }
    }
    if (spell && use_effect) {
      let range_bonuses: RangeBonus[] = [];
      if (!(spell instanceof CharacterItem || char_int instanceof BasicCreatureInstance || char_int instanceof SummonInstance || char_int instanceof ComplexCreatureInstance || spell instanceof StoredSpell)) {
        range_bonuses = this.getSpellRangeBonuses(char_int, spell);
      }
      const get_range_with_bonuses = (value: number) => {
        let range = value;
        // "Add" | "Add if > 0" | "Multiply" | "Multiply if > 0" | "Replace" | "Replace if Greater" | "Add Bonus Rolls" (doesn't make sense for Range)
        for (const range_bonus of range_bonuses.filter(o => o.mod_type === "Replace" || o.mod_type === "Replace if Greater")) {
          if (range_bonus.mod_type === "Replace" || range_bonus.amount > 0) {
            range = range_bonus.amount;
          }
        }
        for (const range_bonus of range_bonuses.filter(o => o.mod_type === "Add" || o.mod_type === "Add if > 0")) {
          if (range_bonus.mod_type === "Add" || range_bonus.amount > 0) {
            range += range_bonus.amount;
          }
        }
        for (const range_bonus of range_bonuses.filter(o => o.mod_type === "Multiply" || o.mod_type === "Multiply if > 0")) {
          if (range_bonus.mod_type === "Multiply" || range_bonus.amount > 0) {
            range *= range_bonus.amount;
          }
        }

        return range; 
      };
      const target_int = use_effect.target_int.clone();
      let ancestries: FeatureAncestry[] = [];
      if (spell instanceof CharacterAbility) {
        ancestries = spell.ancestries;
      }
      const range = get_range_with_bonuses(this.value(target_int.range, { obj: char_int, ancestries }));
      ignore_range = range === -1;
      switch (target_int.target_type) {
        case "Self": return "Self";
        case "X Targets": 
          if (range === -1) {
            return "";
          }
          const range2 = target_int.range2.isBlank() ? 0 : get_range_with_bonuses(this.value(target_int.range2, { obj: char_int, ancestries }));
          return range > 0 && range2 > 0 ? `${range} ft./${range2} ft.` : (range > 0 ? `${range} ft.` : (range2 > 0 ? `${range2} ft.` : "Touch"));
        case "Area": 
          if (range > 0) {
            range_string = `${range} ft./`;
          }
          const source_id = spell.source_true_id;
          const area = this.value(target_int.area, { obj: char_int, source_id, ancestries });
          if (target_int.area_type === "Cylinder") {
            const area2 = this.value(target_int.area2, { obj: char_int, source_id, ancestries });
            if (area2 > 0) {
              range_string += `${area} ft. radius ${area2} ft. high Cylinder`;
            } else {
              range_string += `${area} ft. Cylinder`;
            }
          } else if (target_int.area_type === "Line") {
            const area2 = this.value(target_int.area2, { obj: char_int, source_id, ancestries });
            if (area2 > 0) {
              range_string += `${area} ft. long ${area2} ft. wide Line`;
            } else {
              range_string += `${area} ft. Line`;
            }
          } else if (target_int.area_type === "Wall") {
            const area2 = this.value(target_int.area2, { obj: char_int, source_id, ancestries });
            const area3 = this.value(target_int.area3, { obj: char_int, source_id, ancestries });
            const area4 = this.value(target_int.area4, { obj: char_int, source_id, ancestries });
            const area5 = this.value(target_int.area5, { obj: char_int, source_id, ancestries });
            const area6 = this.value(target_int.area6, { obj: char_int, source_id, ancestries });
            if (area > 0) {
              range_string += `${area} ft. long ${area2} ft. tall ${area3} ft. thick Wall`;
              if (area4 > 0) {
                range_string += ` or a ${area4} ft. diameter ${area5} ft. tall ${area6} ft. thick Ringed Wall`;
              }
            } else if (area4 > 0) {
              range_string += `${area4} ft. diameter ${area5} ft. tall ${area6} ft. thick Ringed Wall`;
            }
          } else if (target_int.area_type === "None") {
            range_string += `within ${area} ft.`;
          } else {
            range_string += `${area} ft. ${target_int.area_type}`;
          }
        break;
      }

    } else if (weapon && attack) {
      if (attack.type.includes("Melee")) {
        const reach = weapon.reach;
        if (reach > 0) {
          return `${5 + reach} ft.`;
        }
        return "";
      } else {
        let range = weapon.range;
        let range2 = weapon.range2;
        if (!ignore_range) {
          // It could be getting the range from a weapon keyword upgrade
          const range_wkus = weapon.weapon_keyword_upgrades.filter(o => o.range > 0 || o.range2 > 0);
          for (const wku of range_wkus) {
            if (wku.range > range) {
              range = wku.range;
            }
            if (wku.range2 > range2) {
              range2 = wku.range2;
            }
          }
          const range_wku2s = weapon.weapon_keyword_upgrade2s.filter(o => o.range > 0 || o.range2 > 0);
          for (const wku of range_wku2s) {
            if (wku.range > range) {
              range = wku.range;
            }
            if (wku.range2 > range2) {
              range2 = wku.range2;
            }
          }
          if (!(char_int instanceof BasicCreatureInstance || char_int instanceof SummonInstance)) { 
            const range_bonuses = this.getWeaponRangeBonuses(char_int, weapon, attack.attack_type);
            if (range_bonuses.length > 0) {
              const get_range_with_bonuses = (value: number) => {
                let r = value;
                for (const range_bonus of range_bonuses) {
                  switch(range_bonus.mod_type) {
                    case "Multiply": 
                      r *= range_bonus.amount;
                    break;
                  }
                }
                return r;
              };
              range = get_range_with_bonuses(range);
              range2 = get_range_with_bonuses(range2);
            }
          }
        }
        if (attack.type === "Thrown") {
          const thrown = WEAPON_KEYWORDS.find(o => o.name === "Thrown");
          if (thrown) {
            const thrown_id = thrown._id;
            const range_wkus = weapon.weapon_keyword_upgrades.filter(o => o.base_wk_ids.includes(thrown_id) && o.added_wk_ids.length === 0);
            if (range_wkus.length > 0) {
              range = range2;
            }
          }
        } else if (attack.type === "Ranged" || attack.type === "Range") {
          const range_wk = WEAPON_KEYWORDS.find(o => o.name === "Range");
          if (range_wk) {
            const range_id = range_wk._id;
            const range_wkus = weapon.weapon_keyword_upgrades.filter(o => o.base_wk_ids.includes(range_id) && o.added_wk_ids.length === 0);
            if (range_wkus.length > 0) {
              range = range2;
            }
          }
        }
        ignore_range = range === -1;
        if (range > 0 && range2 > 0 && range !== range2) {
          return `${range} ft./${range2} ft.`;
        } else if (range > 0) {
          return `${range} ft.`;
        } else if (range2 > 0) {
          return `${range2} ft.`;
        } else {
          return "5 ft.";
        }
      }
    } else if (attack) {
      return "5 ft.";
    }
    return ignore_range ? "" : range_string;
  }

  getAttack({
    char_int, 
    spell, 
    effect, 
    weapon,
    action,
    log_it = false
  }: {
    char_int: CharacterSheetInterface | BasicCreatureInstance | SummonInstance, 
    spell?: CharacterSpell | CharacterAbility | StoredSpell, // | CharacterItem, 
    effect: AbilityEffect, 
    weapon?: CharacterWeapon,
    action?: CharacterAction,
    log_it?: boolean
  }): Attack {
    // log_it = spell instanceof CharacterAbility && spell.name.includes("Psychic Blade");
    if (log_it) {
      console.log(action);
    }
    if (action && action.char_effects.length > 0) {
      let char_effect = action.char_effects.find(o => o.effect && o.effect.true_id === effect.true_id);
      if (!char_effect) {
        char_effect = action.char_effects.find(o => !o.effect);
      }
      if (char_effect) {
        return char_effect.attack;
      }
    }
    // I should move all of this to be part of recalc, but not right now. It would require some changes to models.
    const attack = new Attack();
    if (action) {
      let spell_attack = action.attack_mod;
      let spell_dc = action.dc;
      if (spell_attack === 0 && spell_dc === 0) {
        // if (action.name.includes("Crown")) {
        //   debugger;
        // }
        // let saving_throw_ability_score = spell ? spell.saving_throw_ability_score : "";
        if (spell instanceof CharacterAbility) {
          spell_attack = spell.spell_attack;
          spell_dc = spell.spell_dc;
          if (ABILITY_SCORES.includes(spell.spellcasting_ability)) {
            attack.attack_stat = spell.spellcasting_ability as AbilityScoreType;
          }
        } else if (spell) {
          if (spell.spell_dc > 0) {
            spell_dc = spell.spell_dc;
            spell_attack = spell.spell_attack;
          } else if (char_int instanceof Character && !(spell instanceof StoredSpell)) {
            const character = char_int;
            const source_id = spell.source_id;
            const source = character.spirit.classes.find(o => o.source_id === source_id);
            if (source) {
              spell_attack = source.spell_attack;
              spell_dc = source.spell_dc;
              attack.attack_stat = source.spellcasting_ability;
            }
          }
        }
      }
      attack.attack_type = effect.attack_type;
      const base_roll = new RollPlus();
      base_roll.flat = spell_attack;
      attack.attack_rolls.push(base_roll);
      if (effect.use_attack && char_int instanceof Character && !(action.action instanceof StoredSpell)) {
        if (spell instanceof StoredSpell) {
          const roll = new RollPlus();
          roll.flat = spell.spell_mod;
          attack.attack_rolls.push(roll);
        } else {
          const character = char_int;
          const attack_bonuses = character.mind.attack_bonuses.filter(o => 
            this.checkBonusRequirements(character, o, 
              attack //, effect.attack_type, 
              // spell instanceof CharacterSpell ? 
              //   spell.spellcasting_ability : 
              //   (spell && spell.attack.attack_rolls.length > 0 ? spell.attack.attack_rolls[0].ability_score : ""), 
              // {}
            ));
          for (const ab of attack_bonuses) {
            attack.attack_rolls.push(this.toRollPlus(ab.rolls, { obj: character, source_id: spell?.source_true_id??"" }));
          }
        }
      }
      attack.recalc_attack_string(char_int.mind.current_ability_scores);
    }
    return attack;
  }

  getDC({
    char_int, 
    spell, 
    effect, 
    weapon,
    action,
    log_it = false
  }: {
    char_int: CharacterSheetInterface | BasicCreatureInstance | SummonInstance, 
    spell?: CharacterSpell | CharacterAbility | StoredSpell, // | CharacterItem, 
    effect: AbilityEffect, 
    weapon?: CharacterWeapon,
    action?: CharacterAction,
    log_it?: boolean
  }): number {
    // log_it = spell instanceof CharacterAbility && spell.name.includes("Disintegrate");
    if (log_it) {
      debugger;
    }
    if (action && action.char_effects.length > 0) {
      let char_effect = action.char_effects.find(o => o.effect && o.effect.true_id === effect.true_id);
      if (!char_effect) {
        char_effect = action.char_effects.find(o => !o.effect && o.dc !== 0);
      }
      if (char_effect && char_effect.dc > 8) {
        return char_effect.dc;
      }
    }
    if (action) {
      let spell_dc = action.dc;
      if (spell_dc === 0) {
        if (spell instanceof CharacterAbility) {
          if (spell.spell_dc < 9 && spell.the_ability) {
            if (spell.the_ability instanceof Ability) {
              spell.spell_dc = this.value(spell.the_ability.dc, { obj: char_int, source_id: spell.source_id, action, log_it });
            // } else if (spell.the_ability instanceof SpellsFromList) {

            } else {
              if (log_it) {
                console.log(spell);
              }
            }
          }
          spell_dc = spell.spell_dc;
        } else if (spell) {
          if (spell.spell_dc > 0) {
            spell_dc = spell.spell_dc;
          } else if (char_int instanceof Character && !(spell instanceof StoredSpell)) {
            const character = char_int;
            const source_id = spell.source_id;
            const source = character.spirit.classes.find(o => o.source_id === source_id);
            if (source) {
              spell_dc = source.spell_dc;
            }
          }
        }
      }
      return spell_dc;
    }
    return 0;
  }

  getCreatureFilter(char: Character, 
    creature_transform: CreatureTransform, 
    spell: CharacterSpell | StoredSpell | CharacterAbility | CharacterItem | Attack | null = null) {
    // Get Potence
    // if (spell instanceof CharacterSpell && spell.name === "Polymorph") {
    //   debugger;
    // }
    let level = 1;
    if (creature_transform.potence_type === "Character") {
      level = char.mind.character_level;
    } else if (creature_transform.potence_type === "Class") {
      const class_finder = char.spirit.classes.filter(o => o.source_id === creature_transform.potence_class);
      if (class_finder.length === 1) {
        level = class_finder[0].level;
      }
    }
    let potence_finder: CreaturePotence[] = [];
    potence_finder = creature_transform.creature_potences.filter(o => o.level === level);
    if (potence_finder.length === 0) {
      potence_finder = creature_transform.creature_potences.filter(o => o.level < level);
      if (potence_finder.length > 0) {
        const max_level = Math.max(...potence_finder.map(o => { return o.level }));
        potence_finder = creature_transform.creature_potences.filter(o => o.level === max_level);
      }
    } 
    if (potence_finder.length === 1) {
      const potence = potence_finder[0];
      const new_filter: any = {};
      if (potence.creature_type.length > 0) {
        new_filter.creature_type = { "$in": potence.creature_type };
      }
      if (potence.size.length > 0) {
        new_filter.size_num = { "$in": potence.size.map(o => +o) };
      }
      // debugger;
      if (spell instanceof CharacterAbility || spell instanceof CharacterSpell) {
        if (potence.specific_id.length > 0) {
          const ids = potence.specific_id;
          // if (spell && spell.favorite_options.length > 0) {
          //   ids = ids.filter(o => spell.favorite_options.includes(o));
          // }
          new_filter["_id*ObjectIDs"] = ids;
        // } else if (spell && spell.favorite_options.length > 0) {
        //   new_filter["_id*ObjectIDs"] = spell.favorite_options;
        } else if (creature_transform.knowledge_usage_key !== "") {
          new_filter["_id*ObjectIDs"] = char.spirit.knowledge.filter(o => o.usage === creature_transform.knowledge_usage_key).map(o => o.obj_id);
        }
      }
      if (potence.speed.length > 0) {
        new_filter["speed.walk"] = 0;
        new_filter["speed.swim"] = 0;
        new_filter["speed.climb"] = 0;
        new_filter["speed.fly"] = 0;
        new_filter["speed.burrow"] = 0;
        for (const speed of potence.speed) {
          delete new_filter[`speed.${speed}`];
        }
      }
      new_filter.challenge_rating = { "$lte": this.value(potence.max_cr, { obj: char, source_id: creature_transform.potence_class, item_id: "" }) };
      if (potence.age_category && potence.age_category !== "") {
        new_filter.age_category = potence.age_category;
      }
      if (potence.filter_field_from_extra && potence.filter_field_from_extra !== "" && spell instanceof CharacterAbility) {
        const item = char.inventory.items.find(o => o.true_id === spell.item_id);
        if (item && item.extra !== "") {
          new_filter[potence.filter_field_from_extra] = item.extra;
        }
      }
      return new_filter;
    }
    return null;
  }

  getMinimumRoll(char: CharacterSheetInterface, type: string, thing: any, ability: CharacterSpell | CharacterAbility | StoredSpell | null = null) {
    let true_type = "";
    if (type === "Ability Check") {
      if (thing.data_type && thing.data_type === "skill") {
        true_type = "skill";
      } else {
        true_type = "ability";
      }
    } else if (type === "Attack") {
      true_type = "attack";
    } else if (type === "Saving Throw") {
      true_type = "save";
    }
    if (type.includes("Damage")) {
      if (thing instanceof AbilityEffect && ability && !(ability instanceof StoredSpell)) {
        const min_roll_overrides = ability.use_spell_overrides.filter(o => o.minimum_damage_die_roll > 0);

        // const minimum_rolls = char.spell_modifiers.filter(o => o.modifier.modifies === "Minimum Damage" && (o.modifier.damage_types.length === 0 || common_util.any_overlaps(o.modifier.damage_types, thing.damage_types)));
        const minimum_roll = min_roll_overrides.length === 0 ? 0 : Math.max(...min_roll_overrides.map(o => { return +o.minimum_damage_die_roll; }));
        return minimum_roll;
      }
    } else {
      const min_rolls = char.mind.minimum_rolls.filter(o => o.types.includes(true_type));
      if (type.includes("Ability Check")) {
        if (thing.data_type && thing.data_type === "skill") {
          const skill = thing as Skill;
          let use_ability_score = skill.use_ability_score;
          const override_feature = char.mind.skill_ability_overrides.find(o => o.skill_ids.includes(skill._id));
          if (override_feature) {
            use_ability_score = override_feature.ability_score;
          }
          let proficiency_multiplier = 0;
          const prof_finder = char.mind.skill_proficiencies.filter(o => o.proficiency_id === skill._id);
          if (prof_finder.length > 0) {
            proficiency_multiplier = Math.max(...prof_finder.map(o => { return o.proficiency_level; }));
          }
          let minimum_rolls = min_rolls.filter(o => 
            o.ids.length === 0 || 
            o.ids.includes(skill._id) ||
            o.ids.includes(`${use_ability_score} Check`)
          );
          minimum_rolls = minimum_rolls.filter(o => 
            // o.when === "" && // No cases where it's an issue right now
            proficiency_multiplier >= o.proficiency_level);
          const minimum_roll = minimum_rolls.length === 0 ? 0 : Math.max(...minimum_rolls.map(o => { return this.value(o.threshold, { obj: char, item_id: "" }); }));
          return minimum_roll;
        } else if (typeof(thing) === "string") {
          const ability = thing;
          let minimum_rolls = min_rolls.filter(o => 
            o.ids.length === 0 || 
            o.ids.includes(`${ability} Check`)
          );
          minimum_rolls = minimum_rolls.filter(o => 
            // o.when === "" && 
            o.proficiency_level === 0);
          const minimum_roll = minimum_rolls.length === 0 ? 0 : Math.max(...minimum_rolls.map(o => { return this.value(o.threshold, { obj: char, item_id: "" }); }));
          return minimum_roll;
        }
      } else if (type.includes("Saving Throw")) {
        if (typeof(thing) === "string") {
          const ability = thing;
          let minimum_rolls = min_rolls.filter(o => 
            o.ids.length === 0 || 
            o.ids.includes(`${ability} Save`)
          );
          let proficiency_multiplier = 0;
          const prof_finder = char.mind.saving_throw_proficiencies.filter(o => o.proficiency_id === thing);
          if (prof_finder.length > 0) {
            proficiency_multiplier = Math.max(...prof_finder.map(o => { return o.proficiency_level; }));
          }
          minimum_rolls = minimum_rolls.filter(o => o.when === "" && proficiency_multiplier >= o.proficiency_level);
          const minimum_roll = minimum_rolls.length === 0 ? 0 : Math.max(...minimum_rolls.map(o => { return this.value(o.threshold, { obj: char, item_id: "" }); }));
          return minimum_roll;
        }
      } else if (type.includes("Attack")) {
        if (thing instanceof Attack) {
          const attack = thing;
          const minimum_rolls = min_rolls.filter(o => 
            o.attack_types.length === 0 || o.attack_types.includes(attack.type));
          const minimum_roll = minimum_rolls.length === 0 ? 0 : Math.max(...minimum_rolls.map(o => { return this.value(o.threshold, { obj: char, item_id: "" }); }));
          return minimum_roll;
        }
      }
    }
    return 0;
  }

  getMinimumRollsWithConditions(char: CharacterSheetInterface, type: string, thing: any) {
    // if (type.includes("Ability Check")) {
    //   if (thing instanceof Skill) {
    //     const skill = thing;
    //     let proficiency_multiplier = 0;
    //     const prof_finder = char.mind.skill_proficiencies.filter(o => o.proficiency_id === skill._id);
    //     if (prof_finder.length > 0) {
    //       proficiency_multiplier = Math.max(...prof_finder.map(o => { return o.proficiency_level; }));
    //     }
    //     let minimum_rolls = char.mind.minimum_rolls.filter(o => 
    //       o.ids.length === 0 || 
    //       o.ids.includes(skill._id) ||
    //       o.ids.includes(`${skill.use_ability_score} Check`)
    //     );
    //     minimum_rolls = minimum_rolls.filter(o => o.when !== "" && proficiency_multiplier >= o.proficiency_level);
    //     return minimum_rolls;
    //   } else if (typeof(thing) === "string") {
    //     const ability = thing;
    //     let minimum_rolls = char.mind.minimum_rolls.filter(o => 
    //       o.ids.length === 0 || 
    //       o.ids.includes(`${ability} Check`)
    //     );
    //     minimum_rolls = minimum_rolls.filter(o => o.when !== "" && o.proficiency_level === 0);
    //     return minimum_rolls;
    //   }
    // } else 
    if (type.includes("Saving Throw")) {
      if (typeof(thing) === "string") {
        const ability = thing;
        let minimum_rolls = char.mind.minimum_rolls.filter(o => 
          o.ids.length === 0 || 
          o.ids.includes(`${ability} Save`)
        );
        let proficiency_multiplier = 0;
        const prof_finder = char.mind.saving_throw_proficiencies.filter(o => o.proficiency_id === thing);
        if (prof_finder.length > 0) {
          proficiency_multiplier = Math.max(...prof_finder.map(o => { return o.proficiency_level; }));
        }
        minimum_rolls = minimum_rolls.filter(o => o.when !== "" && proficiency_multiplier >= o.proficiency_level);
        return minimum_rolls;
      }
    }
    return [];
  }

  getBonusRolls(char: Character, type: string, thing: any) {
    let bonuses: Bonus[] = [];
    // if (type === "Saving Throw") {
    //   console.log(char);
    //   console.log(type);
    //   console.log(thing);
    //   // console.log(char.mind.check_bonuses);
    //   // console.log(char.mind.attack_bonuses);
    //   // console.log(char.mind.damage_bonuses);
    //   // console.log(char.extra_skill_bonuses);
    //   console.log(char.mind.saving_throw_bonuses);
    // }
    if (type.includes("Ability Check")) {
      if (thing.data_type && thing.data_type === "skill") {
        // const skill = thing;
        bonuses = char.mind.check_bonuses; //.filter(o => 
        console.log(bonuses);
          // o.);
      } else if (typeof(thing) === "string") {
        // bonuses = char.bonus.filter(o => 
        //   o.advantage.formula === "" &&
        //   o.advantage.type.includes(type) && 
        //   (o.advantage.type_details.length === 0 || 
        //     o.advantage.type_details.includes(thing as string)));
      }
    } else if (type.includes("Saving Throw")) {
      if (typeof(thing) === "string") {
        // advantages = char.mind.advantages.filter(o => 
        //   o.advantage.formula === "" &&
        //   o.advantage.type.includes(type) && 
        //   (o.advantage.type_detail === "ALL" || 
        //     o.advantage.type_detail === thing as string));
        // console.log(advantages);
      }
    } else if (type.includes("Attack")) {
      if (thing instanceof CharacterAbility) {
        console.log(thing);
        // const ability = thing;
        // advantages = char.mind.advantages.filter(o => o.advantage.type.includes(type) && (o.advantage.type_details.length === 0));
        // console.log(advantages);
      } else if (thing instanceof CharacterSpell) {
        // const spell = thing;
        // advantages = char.mind.advantages.filter(o => o.advantage.type.includes(type) && (o.advantage.type_details.length === 0));
        // console.log(advantages);
      } else if (thing instanceof CharacterWeapon) {
        // const weapon = thing;
        // advantages = char.mind.advantages.filter(o => o.advantage.type.includes(type) && (o.advantage.type_details.length === 0));
        // console.log(advantages);
      } else if (thing instanceof Attack) {
        // const attack = thing;
        // advantages = char.mind.advantages.filter(o => o.advantage.type.includes(type) && (o.advantage.type_details.length === 0));
        // console.log(advantages);
      } else if (thing === null) {
        // advantages = char.mind.advantages.filter(o => o.advantage.type.includes(type) && (o.advantage.type_details.length === 0));
        // console.log(advantages);
      }
    }
    return bonuses;
  }

  getDamageUpgrades(char: Character, obj: CharacterWeapon, attack_type: string, log_it = false) {
    const upgrades = char.mind.weapon_damage_upgrades.filter(o => 
      this.fitWeaponLimit2(char, obj, o, attack_type, log_it)
    );
    return upgrades;
  }

  getExtraEffects({
    char_int, 
    char, obj, action,
    attack_type = "", 
    log_it = false
  }: {
    char_int: CharacterSheetInterface, 
    char: Character, 
    obj: CharacterWeapon | CharacterAbility | CharacterSpell | StoredSpell | Attack, 
    action?: CharacterAction,
    attack_type?: string, 
    log_it?: boolean
  }) {
    // log_it = obj instanceof CharacterWeapon && obj.name.includes("Wounding");
    // log_it = obj instanceof CharacterAbility && obj.name.includes("Fire Finger");
    if (log_it) {
      debugger;
    }
    // console.log(char_int.mind.extra_effects.filter(o => o.name.includes(log_find_string)));
    let extra_effects: CharacterExtraEffects[] = [];
    if (obj instanceof CharacterWeapon && obj.base_item instanceof Weapon) {
      if (log_it) {
        for (const ee of char_int.mind.extra_effects) {
          console.log(ee);
          console.log(this.fitWeaponLimit2(char, obj, ee, attack_type, log_it));
        }
      }
      extra_effects.push(...char_int.mind.extra_effects.filter(o => 
        this.fitWeaponLimit2(char, obj, o, attack_type)
      ));
    } else if (obj instanceof Attack) {
      // log_it = true;
      extra_effects = char_int.mind.extra_effects.filter(o => 
        this.fitWeaponLimit2(char, obj, o, attack_type, log_it)
      );
    } else if (obj instanceof CharacterAbility && obj.the_ability instanceof Ability) {
      const ability = obj.the_ability;
      let ees = char_int.mind.extra_effects.filter(o => 
        (o.apply_to.includes("Abilities") &&
          this.fitCharAbilityLimit(char, obj, o.ability_limit, o.item_id)
        )
      );
      if (ability.counts_as_weapon !== "") {
        if (ability.counts_as_weapon === "Use Properties") {
          const fake_weapon = new CharacterWeapon();
          if (log_it) {
            debugger;
          }
          fake_weapon.weapon_keywords = WEAPON_KEYWORDS.filter(o => 
            ability.weapon_properties.wk_ids.includes(o._id));
          fake_weapon.changed_weapon_mastery_property_ids = [ability.weapon_properties.wmp_id];
          const weapon_ees = char_int.mind.extra_effects.filter(o => 
            this.fitWeaponLimit2(char, fake_weapon, o, attack_type, log_it)
          );
          ees = [...ees, ...weapon_ees.filter(o => ees.filter(o2 => o2.true_id === o.true_id).length === 0)];
        } else {
          const weapon = data_util.items.find(o => o._id === ability.counts_as_weapon);
          if (weapon) {
            const pseudo_item = new PseudoItem();
            pseudo_item.base_item = weapon;
            const fake_weapon = new CharacterWeapon();
            fake_weapon.copyPseudoItem(char, pseudo_item);
            if (log_it) {
              debugger;
            }
            const weapon_ees = char_int.mind.extra_effects.filter(o => 
              this.fitWeaponLimit2(char, fake_weapon, o, attack_type, log_it)
            );
            ees = [...ees, ...weapon_ees.filter(o => ees.filter(o2 => o2.true_id === o.true_id).length === 0)];
          }
        }
      }
      extra_effects = ees;
    } else if (obj instanceof CharacterSpell && obj.spell instanceof Spell) {
      // const eb = obj instanceof CharacterSpell && obj.name.includes("Eldritch");
      extra_effects.push(...char_int.mind.extra_effects.filter(o => 
        (o.apply_to.includes("Spells") || o.apply_to.includes("From Modifier")) &&
        this.fitCharSpellLimit({ char, obj, limit: o.spell_limit, source_true_id: o.source_true_id, ancestries: o.ancestries, log_it }) // , log_it: eb && o.name.includes("Repelling")
      ));
    } else if (obj instanceof CharacterAbility && 
      (obj.the_ability instanceof SpellsFromList || 
        obj.the_ability instanceof SpellsFromListWithCosts) && 
      obj.the_spell) {
      // const spell = obj.the_spell;
      extra_effects = char_int.mind.extra_effects.filter(o => 
        (o.apply_to.includes("Spells") || o.apply_to.includes("From Modifier")) &&
        this.fitCharSpellLimit({ char, obj, limit: o.spell_limit, source_true_id: o.source_true_id })
      );
      extra_effects.push(...char_int.mind.extra_effects.filter(o => 
        o.apply_to.includes("From List") &&
        o.main_cf.true_id === obj.true_id
      ));
    }
    return extra_effects;
  }

  getCharFeatureSource(char: Character, source_id: string) {
    const char_feature_sources = char.char_feature_sources;
    const cfs_finder = char_feature_sources.filter(o => o.source_id === source_id);
    if (cfs_finder.length === 1) {
      return cfs_finder[0];
    }
    return null;
  }

  suggestionsForSourceLevel(char: Character, source_id: string, level: number): string[] {
    const source_finder = char.char_feature_sources.filter(o => o.true_id === source_id);
    if (source_finder.length === 1) {
      return source_finder[0].suggestions_for_level(level);
    }
    return [];
  }

  suggestionsForSourceLevelAndType(char: Character, source_id: string, level: number, type: string): string[] {
    const source_finder = char.char_feature_sources.filter(o => o.true_id === source_id);
    if (source_finder.length === 1) {
      return source_finder[0].suggestions_for_level_and_type(level, type);
    }
    return [];
  }

  getSpeed(char: CharacterSheetInterface, type: string) {
    let the_speed = (char.speed as any)[type];
    if (!the_speed) {
      the_speed = 0;
    }
    // const customizations = char.speed_customizations[type];
    // if (customizations) {
    //   if (customizations["Override"]) {
    //     return customizations["Override"].value;
    //   } else if (customizations["Modifier"]) {
    //     console.log(the_speed);
    //     console.log(customizations);
    //     return the_speed + customizations["Modifier"].value;
    //   }
    // }
    return the_speed;
  }

  calcWeight(char: Character, container: CharacterContainer, log_it = false) {
    let weight = 0;
    for (const item of char.inventory.items.filter(o => 
      o.item_type !== "Container" &&
      o.in_char_container_id === container.true_id)) {
      if (log_it) {
        console.log(item);
        console.log(item.get_weight(true));
      }
      const item_weight = item.weight;
      if (item_weight > 0) {
        weight += item_weight;
      }
    }
    container.content_weight = weight;
  }

  createResource(char: Character, potence: Potence, amount: number, refresh_only: boolean, up_to_max: number, item_id: string) {
    if (potence.create_resource.resource_type === "Slot") {
      const level = potence.create_resource.level;
      const slot_type = potence.create_resource.slot_type;
      let slots_finder = char.body.resource_holder.slots.filter(o => 
        (level === "Any" || o.level === +level) && 
        (slot_type === "Any" || o.slot_name === slot_type) &&
        (!refresh_only || o.true_used > 0));
      const levels = slots_finder.map(o => { return o.level as number; });
      const level2 = levels.length > 0 ? levels.reduce((a, b) => { return Math.max(a, b); }) : +level;
      slots_finder = slots_finder.filter(o => o.level === level2);
      if (slots_finder.length === 1) {
        const slots = slots_finder[0];
        if (refresh_only) {
          if (slots.used > amount) {
            slots.used -= amount;
          } else {
            slots.used = 0;
          }
        } else {
          slots.created += amount;
        }
      } else {
        if (refresh_only) {
          slots_finder = char.body.resource_holder.slots.filter(o => o.level > level2 && o.true_used > 0);
          if (slots_finder.length > 0) {
            const pact = slots_finder.filter(o => o.slot_name !== "Pact").length === 0;
            const type_id = pact ? "Created (Pact)" : "Created";
            slots_finder = char.body.resource_holder.slots.filter(o => o.level === level2 && o.type_id === type_id);
            if (slots_finder.length === 1) {
              const slots = slots_finder[0];
              slots.created += amount;
            } else {
              const slots = new CharacterSlot();
              slots.type_id = type_id;
              slots.slot_name = type_id;
              slots.level = level2 as SpellLevel;
              slots.created = amount;
              char.body.resource_holder.slots.push(slots);
            }
          }
          // if (slots.used > amount) {
          //   slots.used -= amount;
          // } else {
          //   slots.used = 0;
          // }
        } else {
          const slots = new CharacterSlot();
          slots.type_id = "Created";
          slots.slot_name = "Created";
          slots.level = level2 as SpellLevel;
          slots.created = amount;
          char.body.resource_holder.slots.push(slots);
          // slots.created += amount;
        }
      }
    } else if (potence.create_resource.resource_type === "Charge") {
      // Get the char item, and adjust its charges
      const char_item = char.inventory.items.find(o => o.true_id === item_id);
      if (char_item) {
        // With charges, it's always Refresh Only
        if (char_item.charges_used > amount) {
          char_item.charges_used -= amount;
        } else {
          char_item.charges_used = 0;
        }
      }
    } else if (potence.create_resource.resource_type === "Heroic Inspiration") {
      char.inspiration = true;
    } else {
      const resource_finder = char.body.resource_holder.resources.filter(o => o.type_id === potence.create_resource.resource_type);
      if (resource_finder.length === 1) {
        const resource = resource_finder[0];
        if (refresh_only) {
          if (resource.used > amount) {
            resource.used -= amount;
          } else {
            resource.used = 0;
          }
        } else {
          resource.created += amount;
        }
        if (up_to_max > 0 && resource.available > up_to_max) {
          resource.used = resource.total - up_to_max;
        }
      }
    }
  }

  value(ugn: UpgradableNumber, props: UpgradableNumberValueProps) {
    let value = +ugn.base;
    if (props.obj) {
      // if (ugn.add_slot_mult > 0) {
      //   debugger;
      // }
      const obj = props.obj; 
      const source_id = props.source_id ? props.source_id : "";
      const item_id = props.item_id ? props.item_id : "";
      const base_slot_level = props.base_slot_level ? props.base_slot_level : -1;
      let slot_level = props.slot_level ? props.slot_level : -1;
      const no_upgradable_hash = props.no_upgradable_hash ? props.no_upgradable_hash : false;
      const log_it = props.log_it ? props.log_it : false;
      let root_id = props.root_id ? props.root_id : "";
      if (root_id === "" && props.source_id) {
        root_id = props.source_id;
      }
      let char_level = 1; 
      if (obj instanceof BasicCreatureInstance || obj instanceof ComplexCreatureInstance) {
        char_level = obj.use_challenge_rating;
      } else if (obj instanceof SummonInstance) {
        char_level = obj.challenge_rating;
        slot_level = obj.slot_level;
      } else if (obj instanceof TransformInstance && obj.creature) {
        char_level = obj.creature.challenge_rating;
        slot_level = obj.made_with_slot_level;
      } else {
        char_level = Math.max(obj.character_level, 1);
      }
      if (ugn.add_made_with_slot_level_mult !== 0) {
        let made_with_slot_level = 0;
        if (obj instanceof Character) {
          if (obj.transform) {
            made_with_slot_level = obj.transform.made_with_slot_level;
          }
        } else if (obj instanceof TransformInstance) {
          made_with_slot_level = obj.made_with_slot_level;
        } else if (obj instanceof SummonInstance) {
          made_with_slot_level = obj.slot_level;
        }
        value += ugn.add_made_with_slot_level_mult * made_with_slot_level;
      }
      if (props.log_it) {
        console.log(ugn);
        console.log(value);
        console.log(obj);
        console.log(char_level);
        debugger;
      }
      value += ugn.add_char_level_mult * char_level;
      if ((ugn.item_rarity_mult !== 0 || ugn.selected_rarity_mult !== 0) && obj instanceof Character) {
        const item = props.item_id !== "" ? obj.items.find(o => o.true_id === props.item_id) : obj.items.find(o => o.true_id === props.source_id);
        if (item) {
          value += ugn.item_rarity_mult * item.rarity;
          if (item.use_selected_rarity > -1) {
            value += ugn.selected_rarity_mult * item.use_selected_rarity;
          }
        }
      }
      if (log_it) {
        console.log(value);
        if (obj instanceof Character) {
          console.log(obj.classes);
        }
        console.log(source_id);
        console.log(root_id);
      }
      let source_level = 1;
      let spellcasting_ability = "";
      if (obj instanceof Character) {
        // I'm currently changing this from only working with class, to working with any feature source.
        // That's primarily for use in source level mult, 
        // but if spellcasting stuff is used (spellcasting ability score, spell attack, spell dc)
        // Then it might be included.  
        // I need to add another field that's for class specifically for those if source is something other than class
        const use_source_id = ugn.source_id === "" ? root_id : ugn.source_id;
        let source = obj.char_feature_sources.find(o => o.source_id === use_source_id || o.true_id === use_source_id);
        let cond_level = 0;
        if (!source) {
          // It might be a condition.  If so, we want to get it, and maybe get the source_true_id from it
          cond_level = this.getConditionLevel(obj, use_source_id);
          // obj.condition_hash[use_source_id];
          // if (!char_cond) {
          //   // It might be a situation with an alternate condition.
          //   obj.alternate_condition_features.
          // }
          // if (char_cond) {
          //   cond_level = char_cond.level;
          //   use_source_id = char_cond.source_true_id;
          // }
        }
        if (!source) {
          source = obj.char_feature_sources.find(o => o.source && (o.source._id === use_source_id || o.source.variant_of_id === use_source_id));
        }
        if (!source) {
          source = obj.classes.find(o => 
            o.true_id === use_source_id || o.source_id === use_source_id || 
            (o.char_subclass && o.char_subclass.true_id === use_source_id) || o.subclass_id === use_source_id
          );
        }
        if (!source) {
          source = obj.classes.find(o => 
            (o.source && o.source.variant_of_id === use_source_id) || 
            (o.subclass && o.subclass.variant_of_id === use_source_id)
          );
        }
        if (source) {
          if (cond_level > 0) {
            source_level = cond_level;
          } else {
            source_level = Math.max(source.level, 1);
          }
          value += ugn.add_source_level_mult * source_level;
        // } else {
        //   // It might be a condition.  Those aren't stored with the others.
        //   const condition = data_util.conditions.find(o => o._id === use_source_id);
        //   const char_condition = obj.condition_hash[use_source_id];
        //   if (condition && char_condition) {
        //     source_level = char_condition.level;
        //     value += ugn.add_source_level_mult * source_level;
        //   }
        } else if (cond_level > 0) {
          source_level = cond_level;
          value += ugn.add_source_level_mult * source_level;
        }

        let char_class: CharacterClass | undefined = undefined;
        if (ugn.spellcasting_class_id !== "") {
          char_class = obj.classes.find(o => o.source_id === ugn.spellcasting_class_id);
          if (!char_class) {
            char_class = obj.classes.find(o => 
              (o.source && o.source.variant_of_id === ugn.spellcasting_class_id)
            );
          }
        } else {
          if (source instanceof CharacterClass) {
            char_class = source;
          } else {
            char_class = obj.classes.find(o => 
              o.true_id === root_id || o.source_id === root_id || 
              (o.char_subclass && o.char_subclass.true_id === root_id) || o.subclass_id === root_id
            );
            if (!char_class) {
              char_class = obj.classes.find(o => 
                (o.source && o.source.variant_of_id === root_id) || 
                (o.subclass && o.subclass.variant_of_id === root_id)
              );
            }
          }
        }
        if (char_class) {
          spellcasting_ability = char_class.spellcasting_ability;
          if (ugn.add_spell_save_dc_mult) {
            value += ugn.add_spell_save_dc_mult * char_class.spell_dc;
          }
          if (ugn.add_spell_attack_mult) {
            value += ugn.add_spell_attack_mult * char_class.spell_attack;
          }
        } else if (ugn.add_spell_save_dc_mult || ugn.add_spell_attack_mult) {
          // This means to figure out what class they have with the best one and use that.
          const best_dc = Math.max(...obj.classes.map(o => o.spell_dc), 0);
          let best_classes = obj.classes.filter(o => o.spell_dc === best_dc);
          if (best_classes.length > 1) {
            const best_attack = Math.max(...best_classes.map(o => o.spell_attack), -5);
            best_classes = best_classes.filter(o => o.spell_attack === best_attack);
          }
          if (best_classes.length > 0) {
            char_class = best_classes[0];
            spellcasting_ability = char_class.spellcasting_ability;
            if (ugn.add_spell_save_dc_mult) {
              value += ugn.add_spell_save_dc_mult * char_class.spell_dc;
            }
            if (ugn.add_spell_attack_mult) {
              value += ugn.add_spell_attack_mult * char_class.spell_attack;
            }
          }
        }

        if (props.action && props.action.attack_stat !== "") {
          const mod = obj.current_ability_scores.getModifier(props.action.attack_stat);
          // I know this is wrong, but I'll change it later.  
          // The only places I have it using action.attack_stat for characters I meant add_non_magic_dmg_bonus_mult. So this should work for now.
          if (ugn.add_non_magic_attack_mult) {
            value += ugn.add_non_magic_attack_mult * mod;
          }
          if (ugn.add_non_magic_dmg_bonus_mult) {
            value += ugn.add_non_magic_dmg_bonus_mult * mod;
          }
        } else {
          if (ugn.add_non_magic_attack_mult && props.attack_mod) {
            value += ugn.add_non_magic_attack_mult * props.attack_mod;
          }
          if (ugn.add_non_magic_dmg_bonus_mult && props.attack_mod) {
            value += ugn.add_non_magic_dmg_bonus_mult * props.attack_mod;
          }
        }
      } else if (obj instanceof BasicCreatureInstance) {
        if (log_it) {
          console.log(ugn);
          console.log(value);
          // debugger;
        }
        spellcasting_ability = obj.spellcasting_ability;
        if (ugn.add_spell_save_dc_mult) {
          value += ugn.add_spell_save_dc_mult * this.value(obj.spell_dc, { obj, item_id: "" });
        }
        if (ugn.add_spell_attack_mult) {
          value += ugn.add_spell_attack_mult * this.value(obj.spell_attack, { obj, item_id: "" });
        }
        if (ugn.add_non_magic_attack_mult) {
          value += ugn.add_non_magic_attack_mult * this.value(obj.non_magic_attack, { obj, item_id: "" });
        }
        if (ugn.add_magic_dmg_bonus_mult) {
          value += ugn.add_magic_dmg_bonus_mult * this.value(obj.magic_dmg_bonus, { obj, item_id: "" });
        }
        if (ugn.add_non_magic_dmg_bonus_mult) {
          value += ugn.add_non_magic_dmg_bonus_mult * this.value(obj.non_magic_dmg_bonus, { obj, item_id: "" });
        }
        if (log_it) {
          console.log(value);
          // debugger;
        }
      } else if (obj instanceof TransformInstance) {
        spellcasting_ability = obj.spellcasting_ability;
        if (ugn.add_spell_save_dc_mult) {
          value += ugn.add_spell_save_dc_mult * this.value(obj.spell_dc, { obj, item_id: "" });
        }
        if (ugn.add_spell_attack_mult) {
          value += ugn.add_spell_attack_mult * this.value(obj.spell_attack, { obj, item_id: "" });
        }
        if (ugn.add_non_magic_attack_mult) {
          value += ugn.add_non_magic_attack_mult * this.value(obj.non_magic_attack, { obj, item_id: "" });
        }
        if (ugn.add_magic_dmg_bonus_mult) {
          value += ugn.add_magic_dmg_bonus_mult * this.value(obj.magic_dmg_bonus, { obj, item_id: "" });
        }
        if (ugn.add_non_magic_dmg_bonus_mult) {
          value += ugn.add_non_magic_dmg_bonus_mult * this.value(obj.non_magic_dmg_bonus, { obj, item_id: "" });
        }
        
        if (obj.character) {
          const char = obj.character;
          const use_source_id = ugn.source_id === "" ? root_id : ugn.source_id;
          let source = char.char_feature_sources.find(o => o.source_id === use_source_id || o.true_id === use_source_id);
          if (!source) {
            source = char.char_feature_sources.find(o => o.source && (o.source._id === use_source_id || o.source.variant_of_id === use_source_id));
          }
          if (!source) {
            source = char.spirit.classes.find(o => 
              o.true_id === use_source_id || o.source_id === use_source_id || 
              (o.char_subclass && o.char_subclass.true_id === use_source_id) || o.subclass_id === use_source_id
            );
          }
          if (!source) {
            source = char.spirit.classes.find(o => 
              (o.source && o.source.variant_of_id === use_source_id) || 
              (o.subclass && o.subclass.variant_of_id === use_source_id)
            );
          }
          if (source) {
            source_level = Math.max(source.level, 1);
            value += ugn.add_source_level_mult * source_level;
          } else {
            // It might be a condition.  Those aren't stored with the others.
            const condition = data_util.conditions.find(o => o._id === use_source_id);
            if (condition) {
              let char_condition = obj.conditions.find(o => o.source_id === use_source_id); // obj.condition_hash[use_source_id];
              if (!char_condition) {
                char_condition = char.conditions.find(o => o.source_id === use_source_id); // char.condition_hash[use_source_id];
              }
              if (!char_condition && char.alternate_condition_features.length > 0) {
                // They might have an alternate
                const alternate_condition_feature = char.alternate_condition_features.find(o => o.original_condition_id === use_source_id);
                if (alternate_condition_feature) {
                  char_condition = char.conditions.find(o => o.source_id === alternate_condition_feature.alternate_condition_id); // char.condition_hash[alternate_condition_feature.alternate_condition_id];
                }
              }
              if (char_condition) {
                source_level = char_condition.level;
                value += ugn.add_source_level_mult * source_level;
              }
            }
          }
  
          let char_class: CharacterClass | undefined = undefined;
          if (ugn.spellcasting_class_id !== "") {
            char_class = char.spirit.classes.find(o => o.source_id === ugn.spellcasting_class_id);
            if (!char_class) {
              char_class = char.spirit.classes.find(o => 
                (o.source && o.source.variant_of_id === ugn.spellcasting_class_id)
              );
            }
          } else {
            if (source instanceof CharacterClass) {
              char_class = source;
            } else {
              char_class = char.spirit.classes.find(o => 
                o.true_id === root_id || o.source_id === root_id || 
                (o.char_subclass && o.char_subclass.true_id === root_id) || o.subclass_id === root_id
              );
              if (!char_class) {
                char_class = char.spirit.classes.find(o => 
                  (o.source && o.source.variant_of_id === root_id) || 
                  (o.subclass && o.subclass.variant_of_id === root_id)
                );
              }
            }
          }
          if (char_class) {
            spellcasting_ability = char_class.spellcasting_ability;
            if (ugn.add_spell_save_dc_mult) {
              value += ugn.add_spell_save_dc_mult * char_class.spell_dc;
            }
            if (ugn.add_spell_attack_mult) {
              value += ugn.add_spell_attack_mult * char_class.spell_attack;
            }
          }
        }
      }
      if (log_it) {
        console.log(value);
      }
      value += +ugn.add_prof_bonus_mult * obj.proficiency_modifier;
      if (log_it) {
        console.log(value);
        console.log(slot_level);
      }
      if (slot_level > 0) {
        value += +ugn.add_slot_mult * slot_level;
        if (base_slot_level > 0) {
          value += +ugn.add_upcast_mult * (slot_level - base_slot_level);
        }
      }
      if (log_it) {
        console.log(value);
      }
      if (ugn.add_hp_mult !== 0) {
        const max_hit_points = obj.hp.true_max;
        value += ugn.add_hp_mult * max_hit_points;
      }
      if (ugn.add_walking_speed_mult !== 0) {
        if (obj instanceof BasicCreatureInstance || obj instanceof SummonInstance) {
          value += ugn.add_walking_speed_mult * obj.get_speed("walk");
        } else {
          value += ugn.add_walking_speed_mult * this.getSpeed(obj, "walk");
        }
      }
      if (log_it) {
        console.log(value);
      }
      for (const group of ugn.add_stats_groups) {
        if (group.multiple_type === "And") {
          for (const add_ability_score of group.add_ability_scores) {
            let ability_score = add_ability_score;
            if (ability_score === "Spellcasting") {
              if (spellcasting_ability === "" && obj instanceof Character) {
                // It's probably from an Item that is supposed to use whatever Spellcasting Ability your character has.
                // Check classes, and take the highest one.
                let max = 0;
                let max_ability = "";
                for (const char_class of obj.classes) {
                  if (char_class.spellcasting_ability !== "None") {
                    const score = obj.current_ability_scores.getAbilityScore(char_class.spellcasting_ability);
                    if (score > max) {
                      max = score;
                      max_ability = char_class.spellcasting_ability;
                    }
                  }
                }
                if (max_ability !== "") {
                  spellcasting_ability = max_ability;
                }
              }
              ability_score = spellcasting_ability as AbilityScoreExpandedType;
            // } else if (ability_score === "Spell Save DC") {
            //   ability_score = spellcasting_ability;
            } else if (ability_score === "Same as Feat" && obj instanceof Character) {
              // The Feat should be the source, so look at feats on the char, and find one with that id
              let asi_finder = obj.asi_features.find(o => o.source_true_id === source_id);
              if (!asi_finder) {
                asi_finder = obj.asi_features.find(o => o.use_source_id === source_id);
              }
              if (asi_finder) {
                ability_score = (asi_finder.feature_options[0] as CharacterASIBaseFeature).asi_features[0].selected_option;
              }
            } else if (ability_score === "STR or DEX") {
              if (obj.current_ability_scores.strength > obj.current_ability_scores.dexterity) {
                ability_score = "STR";
              } else {
                ability_score = "DEX";
              }
            }
            if (log_it) {
              console.log(ability_score);
            }
            if (group.mod_or_score === "Score") {
              const score = obj.current_ability_scores.getAbilityScore(ability_score);
              if (score) {
                value += +group.add_mult * score;
              }
            } else {
              let modifier = obj.current_ability_scores.getModifier(ability_score);
              if (add_ability_score === "Spellcasting" && props.action) {
                if (props.action.action instanceof StoredSpell) {
                  modifier = props.action.action.spell_mod;
                }
              }
              if (log_it) {
                console.log(modifier);
              }
              if (modifier) {
                value += +group.add_mult * modifier;
              }
            }
            if (log_it) {
              console.log(value);
            }
          }
        } else {
          let highest = -5;
          let use_ability_score = "";
          for (const add_ability_score of group.add_ability_scores) {
            let ability_score = add_ability_score;
            if (ability_score === "Spellcasting") {
              if (spellcasting_ability === "" && obj instanceof Character) {
                // It's probably from an Item that is supposed to use whatever Spellcasting Ability your character has.
                // Check classes, and take the highest one.
                let max = 0;
                let max_ability = "";
                for (const char_class of obj.classes) {
                  if (char_class.spellcasting_ability !== "None") {
                    const score = obj.current_ability_scores.getAbilityScore(char_class.spellcasting_ability);
                    if (score > max) {
                      max = score;
                      max_ability = char_class.spellcasting_ability;
                    }
                  }
                }
                if (max_ability !== "") {
                  spellcasting_ability = max_ability;
                }
              }
              ability_score = spellcasting_ability as AbilityScoreExpandedType;
            // } else if (ability_score === "Spell Save DC") {
            //   ability_score = spellcasting_ability;
            } else if (ability_score === "Same as Feat" && obj instanceof Character) {
              // The Feat should be the source, so look at feats on the char, and find one with that id
              let asi_finder = obj.asi_features.find(o => o.source_true_id === source_id);
              if (!asi_finder) {
                asi_finder = obj.asi_features.find(o => o.use_source_id === source_id);
              }
              if (asi_finder) {
                ability_score = (asi_finder.feature_options[0] as CharacterASIBaseFeature).asi_features[0].selected_option;
              }
            } else if (ability_score === "STR or DEX") {
              if (obj.current_ability_scores.strength > obj.current_ability_scores.dexterity) {
                ability_score = "STR";
              } else {
                ability_score = "DEX";
              }
            }
            if (log_it) {
              console.log(ability_score);
            }
            if (use_ability_score === "") {
              use_ability_score = ability_score;
              highest = obj.current_ability_scores.getAbilityScore(use_ability_score);
            } else {
              const score = obj.current_ability_scores.getAbilityScore(ability_score);
              if (score > highest) {
                use_ability_score = ability_score;
                highest = score;
              }
            }
          }
          if (use_ability_score !== "") {
            if (group.mod_or_score === "Score") {
              const score = obj.current_ability_scores.getAbilityScore(use_ability_score);
              if (score) {
                value += +group.add_mult * score;
              }
            } else {
              const modifier = obj.current_ability_scores.getModifier(use_ability_score);
              if (log_it) {
                console.log(modifier);
              }
              if (modifier) {
                value += +group.add_mult * modifier;
              }
            }
            if (log_it) {
              console.log(value);
            }
          }
        }
      }
      if (log_it) {
        console.log(value);
        console.log(ugn.table_type);
        console.log(ugn.table_id);
        console.log(ugn.table_field);
      }
      if (ugn.table_type !== "" && ugn.table_id !== "" && ugn.table_field !== "") {
        if (obj instanceof Character) {
          if (ugn.table_type === "Attached") {
            let tables: TableBase[] = [];
            if (props.ancestries) {
              const source_true_ids = props.ancestries.map(o => o.true_id);
              const sources = obj.char_feature_sources.filter(o => source_true_ids.includes(o.true_id));
              tables = sources.map(o => o.table).filter(o => o) as TableBase[];
            } else {
              const use_source_id = ugn.source_id === "" ? root_id : ugn.source_id;
              let source = obj.char_feature_sources.find(o => o.source_id === use_source_id || o.true_id === use_source_id);
              if (!source) {
                source = obj.char_feature_sources.find(o => o.source && (o.source._id === use_source_id || o.source.variant_of_id === use_source_id));
              }
              if (!source) {
                source = obj.classes.find(o => 
                  o.true_id === use_source_id || o.source_id === use_source_id || 
                  (o.char_subclass && o.char_subclass.true_id === use_source_id) || o.subclass_id === use_source_id
                );
              }
              if (!source) {
                source = obj.classes.find(o => 
                  (o.source && o.source.variant_of_id === use_source_id) || 
                  (o.subclass && o.subclass.variant_of_id === use_source_id)
                );
              }
              if (source && source.table) {
                tables.push(source.table);
              }
            }
            value += this.tableValue(ugn, props, source_level, [], tables);
          } else if (ugn.table_type === "game_class") {
            let obj_finder = obj.classes.filter(o => o.source_id === ugn.table_id); 
            if (obj_finder.length === 0) {
              obj_finder = obj.classes.filter(o => o.variant_ids.includes(ugn.table_id));
            }
            if (log_it) {
              console.log(obj_finder);
            }
            if (obj_finder.length === 1) {
              const char_class = obj_finder[0];
              if (log_it) {
                console.log(char_class);
              }
              if (char_class.source && char_class.table) {
                value += this.tableValue(ugn, props, char_class.level, obj.table_modifiers, [char_class.table]);
              }
            } else {
              const table = data_util.tables.find(o => o.for_id === ugn.table_id);
              if (table) {
                value += this.tableValue(ugn, props, 1, obj.table_modifiers, [table]);
              }
              // console.error("Table finding error");
              // console.error(obj_finder);
              // console.error(ugn);
              // debugger;
              // This means it tried to get the value before the class was actually added.  It will be fine the next time it repopulates, which it will before the process is done.
            }
          } else if (ugn.table_type === "subclass") {
            let obj_finder = obj.classes.filter(o => o.subclass_id === ugn.table_id);
            if (obj_finder.length === 0) {
              obj_finder = obj.classes.filter(o => o.subclass && o.subclass.variant_ids.includes(ugn.table_id));
            }
            if (log_it) {
              console.log(obj_finder);
            }
            if (obj_finder.length === 1) {
              const char_class = obj_finder[0];
              if (log_it) {
                console.log(char_class);
              }
              if (char_class.char_subclass && char_class.char_subclass.table) {
                source_level = Math.max(char_class.level, 1);
                value += this.tableValue(ugn, props, source_level, obj.table_modifiers, [char_class.char_subclass.table]);
              }
            } else {
              console.error("Table finding error");
              console.error(obj_finder);
              console.error(ugn);
              debugger;
            }
          } else if (ugn.table_type === "race") {
            if (log_it) {
              console.log(obj.race);
            }
            if (obj.race && obj.race.source && obj.race.table) {
              value += this.tableValue(ugn, props, char_level, obj.table_modifiers, [obj.race.table]);
            }
          } else if (ugn.table_type === "subrace") {
            if (log_it) {
              console.log(obj.race);
            }
            if (obj.race && obj.race.char_subrace && obj.race.char_subrace.source && obj.race.char_subrace.table) {
              value += this.tableValue(ugn, props, char_level, obj.table_modifiers, [obj.race.char_subrace.table]);
            }
          } else if (ugn.table_type === "gift") {
            let obj_finder = obj.gifts.filter(o => o.source_id === ugn.table_id);
            if (obj_finder.length === 0) {
              obj_finder = obj.gifts.filter(o => o.variant_ids.includes(ugn.table_id));
            }
            if (obj_finder.length === 1) {
              const char_gift = obj_finder[0];
              if (log_it) {
                console.log(char_gift);
              }
              if (char_gift.source && char_gift.table) {
                value += this.tableValue(ugn, props, char_level, obj.table_modifiers, [char_gift.table]);
              }
            } else {
              console.error("Table finding error");
              console.error(obj_finder);
              console.error(ugn);
              debugger;
            }
          }
        } else if (obj instanceof BasicCreatureInstance && obj.creature) {
          if (ugn.table_type === "game_class") {
            // TODO: Add ways to mark creatures as having levels of classes
            const gc = data_util.classes.find(o => o._id === ugn.table_id);
            const table = gc ? data_util.tables.find(o => o.for_id === gc._id) : null;
            if (table) {
              value += this.tableValue(ugn, props, char_level, [], [table]);
            }
          } else if (ugn.table_type === "subclass") {
            // TODO: Add ways to mark creatures as having levels of subclasses
            const sc = data_util.subclasses.find(o => o._id === ugn.table_id);
            const table = sc ? data_util.tables.find(o => o.for_id === sc._id) : null;
            if (table) {
              value += this.tableValue(ugn, props, char_level, [], [table]);
            }
          } else if (ugn.table_type === "race") {
            // TODO: Add ways to mark creatures as having a race
            const race = data_util.races.find(o => o._id === ugn.table_id);
            const table = race ? data_util.tables.find(o => o.for_id === race._id) : null;
            if (table) {
              value += this.tableValue(ugn, props, char_level, [], [table]);
            }
          } else if (ugn.table_type === "subrace") {
            // TODO: Add ways to mark creatures as having a subrace
            const subrace = data_util.subraces.find(o => o._id === ugn.table_id);
            const table = subrace ? data_util.tables.find(o => o.for_id === subrace._id) : null;
            if (table) {
              value += this.tableValue(ugn, props, char_level, [], [table]);
            }
          } else if (ugn.table_type === "gift") {
            // TODO: Add ways to mark creatures as having gifts
            const gift = data_util.gifts.find(o => o._id === ugn.table_id);
            const table = gift ? data_util.tables.find(o => o.for_id === gift._id) : null;
            if (table) {
              value += this.tableValue(ugn, props, char_level, [], [table]);
            }
          } else if (ugn.table_type === "Attached") {
            const table = obj.creature.table;
            if (table) {
              value += this.tableValue(ugn, props, char_level, [], [table]);
            }
          }
        }
      }
      if (ugn.max_slot_for !== "" && obj instanceof Character) {
        const slots = obj.slots;
        if (ugn.max_slot_for === "Any") {
          value += Math.max(...slots.map(o => o.level));
        } else {
          const cfs = obj.classes.find(o => o.source_id === ugn.max_slot_for || o.variant_ids.includes(ugn.max_slot_for));
          if (cfs) {
            value += cfs.spell_level_max;
          }
        }
      }
      if (log_it) {
        console.log(value);
        console.log(ugn.formula_key);
      }
      if (ugn.formula_key !== "") {
        if (obj instanceof Character) {
          if (obj.formula_values[ugn.formula_key]) {
            value += +obj.formula_values[ugn.formula_key];
          }
        } else if (obj instanceof TransformInstance) {
          if (obj.upgradable_hash[ugn.formula_key]) {
            try {
              const upg_num = obj.upgradable_hash[ugn.formula_key];
              if (upg_num) {
                // Don't allow nesting of these
                value += this.value(upg_num, { ...props, no_upgradable_hash: true, item_id });
              }
            } catch (ex) {
              console.error(ex);
              console.error("Creature Upgradable Hash Error");
            }
          }
          if (obj.formula_values[ugn.formula_key]) {
            value += +obj.formula_values[ugn.formula_key];
          }
        } else if (obj instanceof BasicCreatureInstance && !no_upgradable_hash) {
          try {
            const upg_num = obj.upgradable_hash[ugn.formula_key];
            if (upg_num) {
              // Don't allow nesting of these
              value += this.value(upg_num, { ...props, no_upgradable_hash: true, item_id });
            }
          } catch (ex) {
            console.error(ex);
            console.error("Creature Upgradable Hash Error");
          }
        }
      }
      if (ugn.resource_dice_size !== "") {
        if (obj instanceof Character) {
          const resource_finder = obj.resource_holder.resources.filter(o => 
            o.type_id === ugn.resource_dice_size);
          if (log_it) {
            console.log(ugn.resource_dice_size);
            console.log(obj.resource_holder.resources);
            console.log(resource_finder);
          }
          if (resource_finder.length === 1) {
            const resource = resource_finder[0];
            value += resource.size;
          }
        } else if (obj instanceof BasicCreatureInstance) {
          const resource_finder = obj.use_resources.filter(o => 
            o.resource_id === ugn.resource_dice_size);
          if (log_it) {
            console.log(ugn.resource_dice_size);
            console.log(obj.use_resources);
            console.log(resource_finder);
          }
          if (resource_finder.length === 1) {
            const resource = resource_finder[0];
            value += resource.size;
          }
        }
      }
      if (ugn.resource_dice_count !== "") {
        if (obj instanceof Character) {
          const resource_finder = obj.resource_holder.resources.filter(o => 
            o.type_id === ugn.resource_dice_count);
          if (resource_finder.length === 1) {
            const resource = resource_finder[0];
            value += resource.total;
          }
        }
      }
      if (ugn.selectable_key !== "" && obj instanceof Character) {
        const selectable_value = this.getSelectable(obj, source_id, ugn.selectable_key);
        if (selectable_value) {
          for (const sel_val of selectable_value) {
            if (sel_val.length > 0) {
              value += +sel_val;
            }
          }
        }
      }
      if (ugn.min !== null) {
        value = Math.max(value, +ugn.min);
      }
      if (ugn.max !== null) {
        value = Math.min(value, ugn.max);
      }
      switch (ugn.rounding) {
        case "Down": value = Math.floor(value); break;
        case "Standard": value = Math.round(value); break;
        case "Up": value = Math.ceil(value); break;
      }
      if (log_it) {
        console.log(value);
      }
    }
    return Math.floor(value);
  }

  tableValue(ugn: UpgradableNumber, props: UpgradableNumberValueProps, 
    level: number, 
    table_modifiers: Modifier[],
    tables: TableBase[] = [],
  ) {
    if (props.log_it) {
      debugger;
    }
    for (const table of tables) {
      let entries = table.entries.filter(o => o.level === level);
      if (entries.length === 0) {
        for (let the_level = level; the_level > 0; --the_level) {
          // Look at lower levels
          entries = table.entries.filter(o => o.level === the_level);
          if (entries.length > 0) {
            break;
          }
        }
      }
      if (props.log_it) {
        console.log(level);
        console.log(entries);
      }
      if (entries.length === 1) {
        const entry = entries[0];
        let value = entry.data[ugn.table_field];
        if (value === undefined) {
          continue;
        }
        // Now look for a table modifier for ugn.
        const tmods = table_modifiers.filter(o => 
          o.modifies_details[0] === ugn.table_type && 
          o.modifies_details[1] === ugn.table_id &&
          o.modifies_details[2] === ugn.table_field
        );
        for (const mod of tmods) {
          // TODO: Change ugn to use other types besides flat
          const mod_amount = this.value(mod.amount_unb, props);
          if (!mod.mod_type.includes("if > 0") || mod_amount > 0) {
            switch (mod.mod_type) {
              case "Add": case "Add if > 0": value += mod_amount; break;
              case "Multiply": case "Multiply if > 0": value *= mod_amount; break;
              case "Replace": value = mod_amount; break;
              case "Replace if Greater": value = Math.max(value, mod_amount); break;
              default: 
                console.error(`Mod Type ${mod.mod_type} not supported for Table Value`);
                debugger;
              break;
            }
          }
        }
        return value;
      }
    }
    return 0;
  }

  getSelectable(char: Character, csf_true_id: string, selectable_key: string) {
    let cfs = char.char_feature_sources.find(o => o.true_id === csf_true_id);
    if (cfs) {
      const hash_response = cfs.selectable_hash[selectable_key];
      if (hash_response) {
        return hash_response;
      } else {
        // const profs_response = cfs.selectable_proficiencies[selectable_key];
        // if (profs_response) {
        //   return profs_response;
        // }
      }
    }
    cfs = char.char_feature_sources.find(o => 
      Object.keys(o.selectable_hash).includes(selectable_key)
    );
    if (cfs) {
      const hash_response = cfs.selectable_hash[selectable_key];
      if (hash_response) {
        return hash_response;
      }
    } else {
      // cfs = char.char_feature_sources.find(o => 
      //   Object.keys(o.selectable_proficiencies).includes(selectable_key)
      // );
      // if (cfs) {
      //   const profs_response = cfs.selectable_proficiencies[selectable_key];
      //   if (profs_response) {
      //     return profs_response;
      //   }
      // }
    }
    return null;
  }

  findLimitation(limitations: Limitations, char: Character, source_true_id: string) {
    let level = 0;
    if (limitations.level_type === "Inherit") {
      const source = char.char_feature_sources.find(o => o.true_id === source_true_id);
      if (source instanceof CharacterClass) {
        level = source.level;
      } else if (source instanceof CharacterSubclass) {
        // debugger;
        level = source.level;
      } else {
        level = char.mind.character_level;
      }
    } else if (limitations.level_type === "Class") {
      if (limitations.for_class_id === "") {
        const source = char.char_feature_sources.find(o => o.true_id === source_true_id);
        if (source instanceof CharacterClass) {
          level = source.level;
        } else if (source instanceof CharacterSubclass) {
          debugger;
          level = source.level;
        }
      } else {
        const source = char.spirit.classes.find(o => o.source_id === limitations.for_class_id);
        if (source instanceof CharacterClass) {
          level = source.level;
        }
      }
    }
    const limit = limitations.limits.sort((a,b) => (a.limit_level < b.limit_level ? 1 : -1)).find(o => o.limit_level <= level);
    if (limit) {
      return limit;
    }
    return null;
  }

  maxRoll(roll: RollPlusUpgradable, props: UpgradableNumberValueProps) {
    const roll_plus = this.toRollPlus(roll, props);
    return roll_plus.size * roll_plus.count + roll_plus.flat;
  }

  minRoll(roll: RollPlusUpgradable, props: UpgradableNumberValueProps) {
    const roll_plus = this.toRollPlus(roll, props);
    return (roll_plus.size > 0 ? 1 : 0) * roll_plus.count + roll_plus.flat;
  }

  avgRoll(roll: RollPlusUpgradable, props: UpgradableNumberValueProps) {
    const roll_plus = this.toRollPlus(roll, props);
    return Math.ceil(((roll_plus.size + 1) / 2) * roll_plus.count)  + roll_plus.flat;
  }

  toAbilityScores(from: AbilityScoresUpgradable,
    { obj, source_id = "", base_slot_level = -1, slot_level = -1 }: 
    { obj: CharacterSheetInterface | BasicCreatureInstance, source_id?: string, base_slot_level?: number, slot_level?: number }): AbilityScores {
    const ability_scores = new AbilityScores();
    ability_scores._strength = this.value(from.strength, { obj, source_id, item_id: "", base_slot_level, slot_level});
    ability_scores._dexterity = this.value(from.dexterity, { obj, source_id, item_id: "", base_slot_level, slot_level});
    ability_scores._constitution = this.value(from.constitution, { obj, source_id, item_id: "", base_slot_level, slot_level});
    ability_scores._intelligence = this.value(from.intelligence, { obj, source_id, item_id: "", base_slot_level, slot_level});
    ability_scores._wisdom = this.value(from.wisdom, { obj, source_id, item_id: "", base_slot_level, slot_level});
    ability_scores._charisma = this.value(from.charisma, { obj, source_id, item_id: "", base_slot_level, slot_level});
    return ability_scores;
  }

  toIStringNumHash(from: AbilityScoresUpgradable,
    { obj, source_id = "", base_slot_level = -1, slot_level = -1 }: 
    { obj: Character | BasicCreatureInstance, source_id?: string, base_slot_level?: number, slot_level?: number }): IStringNumHash {
    const ability_scores: IStringNumHash = {
      STR: this.value(from.strength, { obj, source_id, item_id: "", base_slot_level, slot_level}),
      DEX: this.value(from.dexterity, { obj, source_id, item_id: "", base_slot_level, slot_level}),
      CON: this.value(from.constitution, { obj, source_id, item_id: "", base_slot_level, slot_level}),
      INT: this.value(from.intelligence, { obj, source_id, item_id: "", base_slot_level, slot_level}),
      WIS: this.value(from.wisdom, { obj, source_id, item_id: "", base_slot_level, slot_level}),
      CHA: this.value(from.charisma, { obj, source_id, item_id: "", base_slot_level, slot_level})
    };
    return ability_scores;
  }

  toHitDice(from: HitDiceUpgradable,
    { obj, source_id = "", base_slot_level = -1, slot_level = -1 }: 
    { obj: CharacterSheetInterface | BasicCreatureInstance, source_id?: string, base_slot_level?: number, slot_level?: number }): HitDiceWithUsed {
    const hit_dice = new HitDiceWithUsed();
    hit_dice.count = this.value(from.count, { obj, source_id, item_id: "", base_slot_level, slot_level});
    hit_dice.size = from.size;
    return hit_dice;
  }

  toRollPlus(from: RollPlusUpgradable, props: UpgradableNumberValueProps) {
    const roll_plus = new RollPlus();
    roll_plus.size = this.value(from.size, props);
    roll_plus.count = this.value(from.count, props);
    roll_plus.flat = this.value(from.flat, props);
    roll_plus.ability_score = from.ability_score;
    roll_plus.type = from.type;
    roll_plus.as_string = "";
    return roll_plus;
  }
  
  getPotenceString({
    slot_level, 
    char,
    char_int, 
    spell,
    effect, 
    cfs_id, 
    item_id,
    attack_mod,
    action,
    log_it = false,
    potence
  }: {
    slot_level: SpellLevel, 
    char?: Character,
    char_int: CharacterSheetInterface | BasicCreatureInstance | SummonInstance, 
    spell: CharacterAbility | CharacterSpell | CharacterFeature | Spell | CreatureAbility | StoredSpell,
    effect: AbilityEffect, 
    cfs_id: string, 
    item_id: string,
    attack_mod?: number,
    action?: CharacterAction,
    log_it?: boolean,
    potence?: Potence
  }): string {
    if (effect.type === "Self Condition") {
      return "Apply";
    } else {
      if (log_it) {
        debugger;
      }
      let use_potence = potence;
      const ability_scores = char_int.mind.current_ability_scores;
      let damage_string = "";
      let bonuses = 0;
      // if (spell.name.includes("Cure")) {
      //   console.log(slot_level);
      //   console.log(use_potence);
      // }
      if (!use_potence) {
        if (spell instanceof CharacterAbility || spell instanceof CharacterSpell || spell instanceof Spell) {
          // log_it = spell.name.includes("False Life");
          use_potence = this.getPotence({slot_level, char, char_int, spell, effect, cfs_id, item_id, attack_mod, action, log_it});
          if (log_it) {
            console.log(this);
            console.log(slot_level);
            console.log(char_int);
            console.log(effect);
            console.log(use_potence);
          }
        } else if (spell instanceof CreatureAbility) {
          // let damage_string = "";
          // let bonuses = 0;
          // // log_it = this.name.includes("Bardic");
          // if (log_it) {
          //   debugger;
          // }
          use_potence = effect.potences[0];
          // if (log_it) {
          //   console.log(this);
          //   console.log(slot_level);
          //   console.log(char_int);
          //   console.log(effect);
          //   console.log(potence);
          // }
          // const ability_scores = char_int.mind.current_ability_scores;
          // if (log_it) {
          //   console.log(potence);
          //   console.log(this);
          //   console.log(bonuses);
          //   console.log(damage_string);
          // }
          
          // if (bonuses > 0) {
          //   damage_string += `+${bonuses}`;
          // } else if (bonuses < 0) {
          //   damage_string += `${bonuses}`;
          // } else if (damage_string === "") {
          // }
          // if (log_it) {
          //   console.log(bonuses);
          //   console.log(damage_string);
          // }
          // return damage_string;
        } else {
          // let damage_string = "";
          // let bonuses = 0;
          // // log_it = this.name.includes("Bardic");
          // if (log_it) {
          //   debugger;
          // }
          use_potence = this.getPotence({slot_level, char, char_int, spell, item_id, effect, cfs_id, attack_mod, log_it});
          if (log_it) {
            console.log(this);
            console.log(slot_level);
            console.log(char_int);
            console.log(effect);
            console.log(potence);
          }
          // if (log_it) {
          //   console.log(potence);
          //   console.log(this);
          //   console.log(bonuses);
          //   console.log(damage_string);
          // }
          
          // if (bonuses > 0) {
          //   damage_string += `+${bonuses}`;
          // } else if (bonuses < 0) {
          //   damage_string += `${bonuses}`;
          // } else if (damage_string === "") {
          // }
          // if (log_it) {
          //   console.log(bonuses);
          //   console.log(damage_string);
          // }
          // return damage_string;
        }
      }
      // if (spell.name.includes("False Life")) {
      //   console.log(spell);
      //   console.log(use_potence);
      //   console.log(action);
      // }
      if (use_potence) {
        const ancestries = spell instanceof CharacterAbility ? spell.ancestries : [];
        const source_id = spell instanceof Spell || spell instanceof CreatureAbility || spell instanceof StoredSpell ? "" : spell.source_true_id;
        const base_slot_level = spell instanceof Spell || spell instanceof StoredSpell ? spell.level : (spell instanceof CreatureAbility || spell instanceof CharacterFeature ? 1 : spell.base_slot_level);
        
        let obj = char_int;
        if (spell instanceof CharacterFeature && char) {
          if (spell.floating_feature instanceof MinionAbility) {
            if (char_int instanceof SummonInstance) {
              if (char) {
                obj = char;
              }
            } else if (char_int instanceof ComplexCreatureInstance) {
              if (char_int.owner_char) {
                obj = char_int.owner_char;
              } else if (char) {
                obj = char;
              }
            }
          }
        }

        bonuses += this.value(use_potence.rolls.flat, { obj, source_id, item_id, base_slot_level, attack_mod, action, log_it, ancestries });
        if (ability_scores && !["","None","undefined"].includes(use_potence.rolls.ability_score)) {
          const mod = ability_scores.getModifier(use_potence.rolls.ability_score);
          if (mod) {
            bonuses += mod;
          }
        }
        let size = this.value(use_potence.rolls.size, { obj, source_id, item_id, base_slot_level, attack_mod, action, log_it, ancestries });
        let count = this.value(use_potence.rolls.count, { obj, source_id, item_id, base_slot_level, attack_mod, action, log_it, ancestries });

        if (action && (spell instanceof CharacterSpell || spell instanceof CharacterAbility)) {
          const spell_overrides = spell.use_spell_overrides;
          for (const so of spell_overrides) {
            if (so.maximize_dice_roll) {
              if (action.level === spell.level || so.apply_overrides_on_slot_casting) {
                const maxed = size * count + bonuses;
                bonuses = maxed;
                size = 0;
                count = 0;
              }
            }
          }
        }
        if (size > 1 && count !== 0) {
          damage_string += `${count}d${size}`;
        }

        if (log_it) {
          console.log(use_potence);
          console.log(this);
          console.log(bonuses);
          console.log(damage_string);
        }
        
        if (bonuses > 0) {
          if (damage_string.length > 0) {
            damage_string += "+";
          }
          damage_string += `${bonuses}`;
        } else if (bonuses < 0) {
          damage_string += `${bonuses}`;
        } else if (damage_string === "") {
        }
        if (log_it) {
          console.log(bonuses);
          console.log(damage_string);
        }
        return damage_string;
      } else {
        return "";
      }
    }
  }

  getPotence({
    slot_level, 
    char,
    char_int, 
    spell,
    effect, 
    cfs_id, 
    item_id,
    attack_mod,
    attack_stat,
    action,
    log_it = false
  }: {
    slot_level: number, 
    char?: Character,
    char_int: CharacterSheetInterface | BasicCreatureInstance | SummonInstance, 
    spell: CharacterAbility | CharacterSpell | CharacterFeature | Spell | StoredSpell,
    effect: AbilityEffect, 
    cfs_id: string, 
    item_id: string,
    attack_mod?: number,
    attack_stat?: string,
    action?: CharacterAction,
    log_it?: boolean
  }): Potence | undefined {
    if (log_it) {
      console.log(spell);
      console.log(effect);
      console.log(action);
    }
    // if (spell.name.includes("Enhanced")) {
    //   debugger;
    // }
    if (effect.potences.length === 1) {
      return effect.potences[0];
    }
    if (spell instanceof CharacterFeature) {
      let obj = char_int;
      if (spell.floating_feature instanceof MinionAbility) {
        if (char_int instanceof SummonInstance) {
          if (char) {
            obj = char;
          }
        } else if (char_int instanceof ComplexCreatureInstance) {
          if (char_int.owner_char) {
            obj = char_int.owner_char;
          } else if (char) {
            obj = char;
          }
        }
      }
      const ancestries = spell.ancestries;
      if (spell.floating_feature instanceof ExtraEffectsFeature || 
        spell.floating_feature instanceof ExtraEffectsOfTypeFeature
      ) {
        if (!["Control","Utility"].includes(effect.type) && char && !(char_int instanceof BasicCreatureInstance)) {
          const extra_effects = char.extra_effects.find(o => o.char_features.find(o2 => o2.true_id === spell.true_id));
          if (extra_effects) {
            let level = -1;
            let class_id = (extra_effects.potence_class === "" || extra_effects.potence_class === "Default" ? cfs_id : extra_effects.potence_class);
            let subclass_id = (extra_effects.potence_class === "" || extra_effects.potence_class === "Default" ? cfs_id : extra_effects.potence_class);
            if (effect.potences.length === 1) {
              level = effect.potences[0].level;
            } else if (effect.potence_type === "Slot") {
              if (slot_level < 0) {
                level = 1;
              } else {
                level = slot_level;
              }
            } else if (effect.potence_type === "Character") {
              level = char_int instanceof SummonInstance ? char_int.challenge_rating : char_int.character_level;
            } else if (effect.potence_type === "Source") {
              if (effect.potence_class === "Default") {
                let use_id = cfs_id === "" && spell.source_true_id !== "" ? spell.source_true_id : cfs_id;
                const cfs = char.char_feature_sources.find(o => o.true_id === use_id);
                if (cfs) {
                  level = cfs.level;
                  class_id = cfs.source_id;
                } else {
                  // It's probably a condition
                  let char_cond = char.conditions.find(o => o.source_id === use_id); // char.condition_hash[use_id];
                  if (!char_cond) {
                    use_id = spell.source_id;
                    char_cond = char.conditions.find(o => o.source_id === use_id); // char.condition_hash[use_id];
                  }
                  if (char_cond) {
                    level = char_cond.level;
                    // if (char_cond.source_true_id !== "") {
                    //   cfs_id = char_cond.source_true_id;
                    // }
                  }
                }
              } else {
                const class_finder = char.spirit.classes.filter(o => 
                  o.true_id === class_id || (o.char_subclass && o.char_subclass.true_id === subclass_id) ||
                  o.source_id === class_id || o.variant_ids.includes(class_id) ||
                  o.subclass_id === subclass_id || (o.subclass && o.subclass.variant_ids.includes(subclass_id))
                );
                if (class_finder.length === 1) {
                  level = class_finder[0].level;
                  class_id = class_finder[0].source_id;
                  subclass_id = class_finder[0].subclass_id;
                }
              }
            } else if (effect.potence_type === "None") {
              level = 1;
            }
            if (log_it) {
              console.log(level);
              console.log(effect.potences);
            }
            let potence_finder: Potence[] = [];
            potence_finder = effect.potences.filter(o => o.level === level);
            if (log_it) {
              console.log(potence_finder);
            }
            if (potence_finder.length === 0) {
              potence_finder = effect.potences.filter(o => o.level < level);
              if (log_it) {
                console.log(potence_finder);
              }
              if (potence_finder.length > 0) {
                const max_level = Math.max(...potence_finder.map(o => { return o.level }));
                potence_finder = effect.potences.filter(o => o.level === max_level);
              }
            } 
            if (log_it) {
              console.log(potence_finder);
            }
            if (potence_finder.length === 1) {
              const potence = new Potence(potence_finder[0]);
              potence.rolls.ability_score = "";
              if (log_it) {
                console.log(potence);
                console.log(potence.rolls.flat);
                debugger;
              }
              if (char_int instanceof SummonInstance) {

              } else {
                for (const db of this.getDamageBonuses({ char_int, obj: spell, effect })) {
                  if (!db.rolls.flat.isBlank()) {
                    potence.rolls.flat.base += this.value(db.rolls.flat, { obj, source_id: extra_effects.potence_class, item_id, attack_mod, action, ancestries });
                  }
                  if (log_it) {
                    console.log(db);
                    console.log(potence.rolls.flat);
                  }
                }
              }
              potence.rolls.flat.base += this.value(effect.bonus, { obj, source_id: extra_effects.potence_class, item_id, slot_level, attack_mod, action, log_it, ancestries });
              if (action && action.mod_flat > 0 && potence.rolls.flat.isBasic() && potence.rolls.flat.base > 0) {
                potence.rolls.flat.base += action.mod_flat;
              }
              return potence;
            }
          }
        }
      } else {
        if (!["Control","Utility"].includes(effect.type) && char && !(char_int instanceof BasicCreatureInstance)) {
          let level = -1;
          let class_id = (effect.potence_class === "" || effect.potence_class === "Default" ? cfs_id : effect.potence_class);
          let subclass_id = (effect.potence_class === "" || effect.potence_class === "Default" ? cfs_id : effect.potence_class);
          if (effect.potences.length === 1) {
            level = effect.potences[0].level;
          } else if (effect.potence_type === "Slot") {
            if (slot_level < 0) {
              level = 1;
            } else {
              level = slot_level;
            }
          } else if (effect.potence_type === "Character") {
            level = char_int instanceof SummonInstance ? char_int.challenge_rating : char_int.character_level;
          } else if (effect.potence_type === "Source") {
            if (effect.potence_class === "Default") {
              let use_id = cfs_id === "" && spell.source_true_id !== "" ? spell.source_true_id : cfs_id;
              const cfs = char.char_feature_sources.find(o => o.true_id === use_id);
              if (cfs) {
                level = cfs.level;
                class_id = cfs.source_id;
              } else {
                // It's probably a condition
                let char_cond = char.conditions.find(o => o.source_id === use_id); // char.condition_hash[use_id];
                if (!char_cond) {
                  use_id = spell.source_id;
                  char_cond = char.conditions.find(o => o.source_id === use_id); // char.condition_hash[use_id];
                }
                if (char_cond) {
                  level = char_cond.level;
                  // if (char_cond.source_true_id !== "") {
                  //   cfs_id = char_cond.source_true_id;
                  // }
                }
              }
            } else {
              const class_finder = char.spirit.classes.filter(o => 
                o.true_id === class_id || (o.char_subclass && o.char_subclass.true_id === subclass_id) ||
                o.source_id === class_id || o.variant_ids.includes(class_id) ||
                o.subclass_id === subclass_id || (o.subclass && o.subclass.variant_ids.includes(subclass_id))
              );
              if (class_finder.length === 1) {
                level = class_finder[0].level;
                class_id = class_finder[0].source_id;
                subclass_id = class_finder[0].subclass_id;
              }
            }
          } else if (effect.potence_type === "None") {
            level = 1;
          }
          if (log_it) {
            console.log(level);
            console.log(effect.potences);
          }
          let potence_finder: Potence[] = [];
          potence_finder = effect.potences.filter(o => o.level === level);
          if (log_it) {
            console.log(potence_finder);
          }
          if (potence_finder.length === 0) {
            potence_finder = effect.potences.filter(o => o.level < level);
            if (log_it) {
              console.log(potence_finder);
            }
            if (potence_finder.length > 0) {
              const max_level = Math.max(...potence_finder.map(o => { return o.level }));
              potence_finder = effect.potences.filter(o => o.level === max_level);
            }
          } 
          if (log_it) {
            console.log(potence_finder);
          }
          if (potence_finder.length === 1) {
            const potence = new Potence(potence_finder[0]);
            potence.rolls.ability_score = "";
            if (log_it) {
              console.log(potence);
              console.log(potence.rolls.flat);
              debugger;
            }
            if (char_int instanceof SummonInstance) {

            } else {
              for (const db of this.getDamageBonuses({ char_int, obj: spell, effect })) {
                if (!db.rolls.flat.isBlank()) {
                  potence.rolls.flat.base += this.value(db.rolls.flat, { obj, source_id: effect.potence_class, item_id, attack_mod, action, ancestries });
                }
                if (log_it) {
                  console.log(db);
                  console.log(potence.rolls.flat);
                }
              }
            }
            potence.rolls.flat.base += this.value(effect.bonus, { obj, source_id: effect.potence_class, item_id, slot_level, attack_mod, action, log_it, ancestries });
            if (action && action.mod_flat > 0 && potence.rolls.flat.isBasic() && potence.rolls.flat.base > 0) {
              potence.rolls.flat.base += action.mod_flat;
            }
            return potence;
          }
        }
      }
    } else if (spell instanceof CharacterAbility) {
      const ancestries = spell.ancestries;
      // if (spell.name.includes("Fire")) {
      //   debugger;
      // }
      let class_id = (effect.potence_class === "" ? cfs_id : effect.potence_class);
      const subclass_id = (effect.potence_class === "" ? cfs_id : effect.potence_class);
      if (spell.the_ability && char && !(char_int instanceof BasicCreatureInstance)) {
        if (spell.the_ability instanceof SpellsFromList || 
          spell.the_ability instanceof SpellsFromListWithCosts) {
          if (spell._spell) {
            if (!["Control","Utility"].includes(effect.type)) {
              let level = -1;
              const sfl = spell.the_ability;
              let spellcasting_ability = sfl.spell_overrides.spellcasting_ability;
              // debugger;
              if (sfl.spell_overrides.count_as_class_id === "" || sfl.spell_overrides.count_as_class_id === "None" || sfl.spell_overrides.count_as_class_id === "Don't Override") {
                if (spellcasting_ability === "Spellcasting") {
                  const class_finder = char.spirit.classes.filter(o => o.true_id === spell.source_true_id);
                  if (class_finder.length === 1) {
                    const char_class = class_finder[0];
                    spellcasting_ability = char_class.spellcasting_ability;
                  }
                } else {
                  if (spellcasting_ability === "Same as Feat") {
                    if (!(char_int instanceof SummonInstance)) {
                      const asi_finder = char_int.mind.asi_features.filter(o => o.source_true_id === spell.source_true_id);
                      if (asi_finder.length === 1) {
                        spellcasting_ability = (asi_finder[0].feature_options[0] as CharacterASIBaseFeature).asi_features[0].selected_option as AbilityScoreType;
                      }
                    }
                  } else if (spellcasting_ability === "Selectable") {
                    const source = char.char_feature_sources.find(o => o.true_id === spell.source_true_id);
                    if (source) {
                      if (source.selectable_hash[sfl.spell_overrides.spellcasting_ability_selectable_key] && source.selectable_hash[sfl.spell_overrides.spellcasting_ability_selectable_key].length > 0) {
                        spellcasting_ability = source.selectable_hash[sfl.spell_overrides.spellcasting_ability_selectable_key][0] as AbilityScoreType;
                      }
                    }
                  }
                }
              } else {
                let class_finder = char.spirit.classes.filter(o => o.source_id === sfl.spell_overrides.count_as_class_id);
                if (class_finder.length === 0) {
                  class_finder = char.spirit.classes.filter(o => o.variant_ids.includes(sfl.spell_overrides.count_as_class_id));
                }
                if (class_finder.length === 1) {
                  const char_class = class_finder[0];
                  spellcasting_ability = char_class.spellcasting_ability;
                }
              }
              if (effect.potence_type === "Slot") {
                if (slot_level < 0) {
                  level = 1;
                } else {
                  level = slot_level;
                }
              } else if (effect.potence_type === "Character") {
                level = char_int instanceof SummonInstance ? char_int.challenge_rating : char_int.character_level;
              } else if (effect.potence_type === "Source") {
                if (effect.potence_class === "Default") {
                  let use_id = cfs_id === "" && spell.source_true_id !== "" ? spell.source_true_id : cfs_id;
                  const cfs = char.char_feature_sources.find(o => o.true_id === use_id);
                  if (cfs) {
                    level = cfs.level;
                    class_id = cfs.source_id;
                  } else {
                    // It's probably a condition
                  let char_cond = char.conditions.find(o => o.source_id === use_id); // char.condition_hash[use_id];
                  if (!char_cond) {
                    use_id = spell.source_id;
                    char_cond = char.conditions.find(o => o.source_id === use_id); // char.condition_hash[use_id];
                  }
                    if (char_cond) {
                      level = char_cond.level;
                      // if (char_cond.source_true_id !== "") {
                      //   cfs_id = char_cond.source_true_id;
                      // }
                    }
                  }
                } else {
                  if (spell.source_type === "Class") {
                    const class_finder = char.spirit.classes.filter(o => 
                      o.source_id === class_id || o.variant_ids.includes(class_id) ||
                      o.subclass_id === subclass_id || (o.subclass && o.subclass.variant_ids.includes(subclass_id)));
                    if (class_finder.length === 1) {
                      level = class_finder[0].level;
                      if (!ABILITY_SCORES.includes(spellcasting_ability)) {
                        // This part might be wrong, but I don't currently have an example of when it would come here to test it
                        debugger;
                        spellcasting_ability = class_finder[0].spellcasting_ability;
                      }
                    }
                  }
                }
              }
              let potence_finder: Potence[] = [];
              potence_finder = effect.potences.filter(o => o.level === level);
              if (potence_finder.length === 0) {
                potence_finder = effect.potences.filter(o => o.level < level);
                if (potence_finder.length > 0) {
                  const max_level = Math.max(...potence_finder.map(o => { return o.level }));
                  potence_finder = effect.potences.filter(o => o.level === max_level);
                }
              } 
              if (potence_finder.length === 0) {
                const min_level = Math.min(...effect.potences.map(o => o.level));
                potence_finder = effect.potences.filter(o => o.level === min_level);
              }
              if (potence_finder.length === 1) {
                const potence = potence_finder[0].clone();
                // if (effect.add_modifier.toLowerCase() === "true") {
                //   potence.rolls.ability_score = spell.spellcasting_ability;
                // } else {
                //   potence.rolls.ability_score = "";
                // }
                if (spellcasting_ability !== "None" && spellcasting_ability !== "Don't Override") {
                  for (const group of potence.rolls.size.add_stats_groups) {
                    if (group.add_ability_scores.includes("Spellcasting")) {
                      group.add_ability_scores = group.add_ability_scores.filter(o => o !== "Spellcasting");
                      group.add_ability_scores.push(spellcasting_ability as AbilityScoreExpandedType);
                    }
                  }
                  for (const group of potence.rolls.count.add_stats_groups) {
                    if (group.add_ability_scores.includes("Spellcasting")) {
                      group.add_ability_scores = group.add_ability_scores.filter(o => o !== "Spellcasting");
                      group.add_ability_scores.push(spellcasting_ability as AbilityScoreExpandedType);
                    }
                  }
                  for (const group of potence.rolls.flat.add_stats_groups) {
                    if (group.add_ability_scores.includes("Spellcasting")) {
                      group.add_ability_scores = group.add_ability_scores.filter(o => o !== "Spellcasting");
                      group.add_ability_scores.push(spellcasting_ability as AbilityScoreExpandedType);
                    }
                  }
                }
                if (potence.rolls.ability_score === "Spellcasting") {
                  potence.rolls.ability_score = spellcasting_ability;
                } else if (potence.rolls.ability_score === "Same as Feat") {
                  if (!(char_int instanceof SummonInstance)) {
                    // The Feat should be the source, so look at feats on the char, and find one with that id
                    const asi_finder = char_int.mind.asi_features.filter(o => o.use_source_id === spell.source_id);
                    if (log_it) {
                      console.log(spell.source_id);
                      console.log(asi_finder);
                    }
                    if (asi_finder.length === 1) {
                      potence.rolls.ability_score = (asi_finder[0].feature_options[0] as CharacterASIBaseFeature).asi_features[0].selected_option;
                    }
                  }
                } else if (potence.rolls.ability_score === "STR or DEX") {
                  if (char_int.mind.current_ability_scores.strength > char_int.mind.current_ability_scores.dexterity) {
                    potence.rolls.ability_score = "STR";
                  } else {
                    potence.rolls.ability_score = "DEX";
                  }
                }
                if (log_it) {
                  console.log(potence);
                  console.log(potence.rolls.ability_score);
                  console.log(potence.rolls.flat);
                  debugger;
                }
                if (!(char_int instanceof SummonInstance)) {
                  for (const db of this.getDamageBonuses({ char_int, obj: spell, effect })) {
                    if (!db.rolls.flat.isBlank()) {
                      potence.rolls.flat.base += this.value(db.rolls.flat, { obj: char_int, source_id: spell.source_true_id, item_id, attack_mod, action, ancestries });
                    }
                    if (log_it) {
                      console.log(db);
                      console.log(potence.rolls.flat);
                    }
                  }
                }
                if (action && action.mod_flat > 0 && potence.rolls.flat.isBasic() && potence.rolls.flat.base > 0) {
                  potence.rolls.flat.base += action.mod_flat;
                }
                return potence;
              }
            }
          }
        } else {
          if (log_it) {
            console.log(effect.type);
            console.log(effect.potence_type);
            console.log(effect);
          }
          if (!["Control","Utility"].includes(effect.type)) {
            let level = -1;
            // let class_id = "";
            // let subclass_id = "";
            if (effect.potences.length === 1) {
              level = effect.potences[0].level;
            } else if (effect.potence_type === "Slot") {
              if (slot_level < 0) {
                level = 1;
              } else {
                level = slot_level;
              }
            } else if (effect.potence_type === "Character") {
              level = char_int instanceof SummonInstance ? char_int.challenge_rating : char_int.character_level;
            } else if (effect.potence_type === "Source") {
              if (effect.potence_class === "Default") {
                let use_id = cfs_id === "" && spell.source_true_id !== "" ? spell.source_true_id : cfs_id;
                const cfs = char.char_feature_sources.find(o => o.true_id === use_id);
                if (cfs) {
                  level = cfs.level;
                  class_id = cfs.source_id;
                } else {
                  // It's probably a condition
                  let char_cond = char.conditions.find(o => o.source_id === use_id); // char.condition_hash[use_id];
                  if (!char_cond) {
                    use_id = spell.source_id;
                    char_cond = char.conditions.find(o => o.source_id === use_id); // char.condition_hash[use_id];
                  }
                  if (char_cond) {
                    level = char_cond.level;
                    // if (char_cond.source_true_id !== "") {
                    //   cfs_id = char_cond.source_true_id;
                    // }
                  }
                }
              } else {
                const class_finder = char.spirit.classes.filter(o => 
                  o.true_id === class_id || (o.char_subclass && o.char_subclass.true_id === subclass_id) ||
                  o.source_id === class_id || o.variant_ids.includes(class_id) ||
                  o.subclass_id === subclass_id || (o.subclass && o.subclass.variant_ids.includes(subclass_id)));
                if (class_finder.length === 1) {
                  level = class_finder[0].level;
                  // class_id = class_finder[0].source_id;
                  // subclass_id = class_finder[0].subclass_id;
                }
              }
            } else if (effect.potence_type === "None") {
              level = 1;
            }
            if (log_it) {
              console.log(level);
              console.log(effect.potences);
            }
            let potence_finder: Potence[] = [];
            potence_finder = effect.potences.filter(o => o.level === level);
            if (log_it) {
              console.log(potence_finder);
            }
            if (potence_finder.length === 0) {
              potence_finder = effect.potences.filter(o => o.level < level);
              if (log_it) {
                console.log(potence_finder);
              }
              if (potence_finder.length > 0) {
                const max_level = Math.max(...potence_finder.map(o => { return o.level }));
                potence_finder = effect.potences.filter(o => o.level === max_level);
              }
            } 
            if (log_it) {
              console.log(potence_finder);
            }
            if (potence_finder.length === 1) {
              const potence = potence_finder[0].clone();
              // if (effect.add_modifier.toLowerCase() === "true") {
              //   potence.rolls.ability_score = spell.spellcasting_ability;
              // } else {
              //   potence.rolls.ability_score = "";
              // }
              if (log_it) {
                console.log(potence);
                console.log(potence.rolls.flat);
                if (!(char_int instanceof SummonInstance)) {
                  console.log(char_int.mind.damage_bonuses.filter(o => 
                    (o.weapon_id === "" || 
                    o.weapon_id === spell.source_id || 
                    o.weapon_id === spell.source_id2) // && 
                    // (o.class_id === "" ||
                    // o.class_id === class_id ||
                    // o.class_id === subclass_id) &&
                    // (o.types.includes())
                  ));
                }
              }
              if (!(char_int instanceof SummonInstance)) {
                for (const db of this.getDamageBonuses({ char_int, obj: spell, effect })) {
                  if (!db.rolls.flat.isBlank()) {
                    potence.rolls.flat.base += this.value(db.rolls.flat, { obj: char_int, source_id: spell.source_true_id, item_id, attack_mod, action, ancestries });
                  }
                  if (log_it) {
                    console.log(db);
                    console.log(potence.rolls.flat);
                  }
                }
              }
              if (spell.the_ability && spell.the_ability instanceof Ability) {
                if (log_it) { 
                  console.log(char_int);
                  console.log(spell.base_slot_level);
                  console.log(slot_level);
                  console.log(spell);
                  console.log(effect);
                  console.log(effect.bonus);
                }
                potence.rolls.flat.base += this.value(effect.bonus, { obj: char_int, source_id: spell.source_true_id, item_id, base_slot_level: spell.base_slot_level, slot_level, attack_mod, action, log_it, ancestries });
              }
              if (action && action.mod_flat > 0 && potence.rolls.flat.isBasic() && potence.rolls.flat.base > 0) {
                potence.rolls.flat.base += action.mod_flat;
              }
              return potence;
            } else if (spell.the_ability && spell.the_ability instanceof Ability) {
              if (log_it) { 
                console.log(char_int);
                console.log(spell.base_slot_level);
                console.log(slot_level);
                console.log(spell);
                console.log(effect);
                console.log(effect.bonus);
              }
              const potence = new Potence();
              potence.rolls.flat.base = this.value(effect.bonus, { obj: char_int, source_id: spell.source_true_id, item_id, base_slot_level: spell.base_slot_level, slot_level, attack_mod, action, ancestries });
              if (log_it) {
                console.log(potence);
                console.log(potence.rolls.flat);
                debugger;
              }
              if (!(char_int instanceof SummonInstance)) {
                for (const db of this.getDamageBonuses({ char_int, obj: spell, effect })) {
                  if (!db.rolls.flat.isBlank()) {
                    potence.rolls.flat.base += this.value(db.rolls.flat, { obj: char_int, source_id: spell.source_true_id, item_id, attack_mod, action, ancestries });
                  }
                  if (log_it) {
                    console.log(db);
                    console.log(potence.rolls.flat);
                  }
                }
              }
              if (action && action.mod_flat > 0 && potence.rolls.flat.isBasic() && potence.rolls.flat.base > 0) {
                potence.rolls.flat.base += action.mod_flat;
              }
              return potence;
            }
          }
        }
      } else if (spell instanceof CharacterAbility && spell.sidekick_ability) {
        if (spell._spell && char_int instanceof Character) {
          if (!["Control","Utility"].includes(effect.type)) {
            let level = -1;
            
            const spellcasting_ability = spell.spellcasting_ability;
            if (effect.potence_type === "Slot") {
              if (slot_level < 0) {
                level = 1;
              } else {
                level = slot_level;
              }
            } else if (effect.potence_type === "Character") {
              level = char_int.character_level;
            } else if (effect.potence_type === "Source") {
              if (effect.potence_class === "Default") {
                const use_id = cfs_id === "" && spell.source_true_id !== "" ? spell.source_true_id : cfs_id;
                const cfs = char_int.char_feature_sources.find(o => o.true_id === use_id);
                if (cfs) {
                  level = cfs.level;
                  class_id = cfs.source_id;
                } else {
                  // It's probably a condition
                  const char_cond = char_int.conditions.find(o => o.source_id === cfs_id); // char_int.condition_hash[cfs_id];
                  if (char_cond) {
                    level = char_cond.level;
                    // if (char_cond.source_true_id !== "") {
                    //   cfs_id = char_cond.source_true_id;
                    // }
                  }
                }
              } else {
                const class_finder = char_int.spirit.classes.filter(o => 
                  o.true_id === class_id || (o.char_subclass && o.char_subclass.true_id === subclass_id) ||
                  o.source_id === class_id || o.variant_ids.includes(class_id) ||
                  o.subclass_id === subclass_id || (o.subclass && o.subclass.variant_ids.includes(subclass_id))
                );
                if (class_finder.length === 1) {
                  level = class_finder[0].level;
                  // class_id = class_finder[0].source_id;
                  // subclass_id = class_finder[0].subclass_id;
                }
              }
            }
            let potence_finder: Potence[] = [];
            potence_finder = effect.potences.filter(o => o.level === level);
            if (potence_finder.length === 0) {
              potence_finder = effect.potences.filter(o => o.level < level);
              if (potence_finder.length > 0) {
                const max_level = Math.max(...potence_finder.map(o => { return o.level }));
                potence_finder = effect.potences.filter(o => o.level === max_level);
              }
            } 
            if (potence_finder.length === 0) {
              const min_level = Math.min(...effect.potences.map(o => o.level));
              potence_finder = effect.potences.filter(o => o.level === min_level);
            }
            if (potence_finder.length === 1) {
              const potence = potence_finder[0].clone();
              // if (effect.add_modifier.toLowerCase() === "true") {
              //   potence.rolls.ability_score = spell.spellcasting_ability;
              // } else {
              //   potence.rolls.ability_score = "";
              // }
              if (spellcasting_ability !== "None" && spellcasting_ability !== "Don't Override") {
                for (const group of potence.rolls.size.add_stats_groups) {
                  if (group.add_ability_scores.includes("Spellcasting")) {
                    group.add_ability_scores = group.add_ability_scores.filter(o => o !== "Spellcasting");
                    group.add_ability_scores.push(spellcasting_ability as AbilityScoreExpandedType);
                  }
                }
                for (const group of potence.rolls.count.add_stats_groups) {
                  if (group.add_ability_scores.includes("Spellcasting")) {
                    group.add_ability_scores = group.add_ability_scores.filter(o => o !== "Spellcasting");
                    group.add_ability_scores.push(spellcasting_ability as AbilityScoreExpandedType);
                  }
                }
                for (const group of potence.rolls.flat.add_stats_groups) {
                  if (group.add_ability_scores.includes("Spellcasting")) {
                    group.add_ability_scores = group.add_ability_scores.filter(o => o !== "Spellcasting");
                    group.add_ability_scores.push(spellcasting_ability as AbilityScoreExpandedType);
                  }
                }
              }
              if (spell.use_spellcasting_modifier) { // || (use_spell && the_effect.add_modifier.toLowerCase() === "true")) {
                potence.rolls.ability_score = spell.spellcasting_ability;
              } else {
                potence.rolls.ability_score = "";
              }
              if (potence.rolls.ability_score === "Spellcasting") {
                potence.rolls.ability_score = spellcasting_ability;
              } else if (potence.rolls.ability_score === "Same as Feat") {
                // The Feat should be the source, so look at feats on the char, and find one with that id
                const asi_finder = char_int.mind.asi_features.filter(o => o.use_source_id === spell.source_id);
                if (log_it) {
                  console.log(spell.source_id);
                  console.log(asi_finder);
                }
                if (asi_finder.length === 1) {
                  potence.rolls.ability_score = (asi_finder[0].feature_options[0] as CharacterASIBaseFeature).asi_features[0].selected_option;
                }
              } else if (potence.rolls.ability_score === "STR or DEX") {
                if (char_int.mind.current_ability_scores.strength > char_int.mind.current_ability_scores.dexterity) {
                  potence.rolls.ability_score = "STR";
                } else {
                  potence.rolls.ability_score = "DEX";
                }
              }
              
              if (spell.damage_die_size_override !== -1) {
                potence.rolls.size.makeBasic();
                potence.rolls.size.base = spell.damage_die_size_override;
              }

              if (log_it) {
                console.log(potence);
                console.log(potence.rolls.ability_score);
                console.log(potence.rolls.flat);
                debugger;
              }
              
              for (const db of this.getDamageBonuses({ char_int, obj: spell, effect })) {
                if (!db.rolls.flat.isBlank()) {
                  potence.rolls.flat.base += this.value(db.rolls.flat, { obj: char_int, source_id: spell.source_true_id, item_id, attack_mod, action, ancestries });
                }
                if (log_it) {
                  console.log(db);
                  console.log(potence.rolls.flat);
                }
              }
              if (action && action.mod_flat > 0 && potence.rolls.flat.isBasic() && potence.rolls.flat.base > 0) {
                potence.rolls.flat.base += action.mod_flat;
              }
              return potence;
            }
          }
        }
      }
    } else {
      const ancestries: FeatureAncestry[] = [];
      let class_id = (effect.potence_class === "" || effect.potence_class === "Default" ? cfs_id : effect.potence_class);
      const subclass_id = (effect.potence_class === "" || effect.potence_class === "Default" ? cfs_id : effect.potence_class);
      const use_spell = spell instanceof Spell ? spell : spell.the_spell;
      if (use_spell) {
        if (log_it) {
          console.log(use_spell);
          console.log(effect);
          console.log(action);
        }
        const the_effect = effect; // ? effect : use_spell.effect;
        // if (!["Control","Utility"].includes(the_effect.type)) {
        let level = -1;
        let potence_type = the_effect.potence_type;
        if (slot_level === 0 && potence_type === "Slot") {
          // It's a cantrip, it should actually be Character
          potence_type = "Character";
        }
        if (effect.potences.length === 1) {
          level = effect.potences[0].level;
        } else if (potence_type === "Slot") {
          level = slot_level;
        } else if (potence_type === "Character") {
          level = char_int instanceof BasicCreatureInstance || char_int instanceof SummonInstance ? char_int.challenge_rating : char_int.character_level;
        } else if (potence_type === "Source") {
          if (effect.potence_class === "Default") {
            if (char_int instanceof Character) {
              const cfs = char_int.char_feature_sources.find(o => o.true_id === cfs_id);
              if (cfs) {
                level = cfs.level;
                class_id = cfs.source_id;
              } else {
                // It's probably a condition
                const char_cond = char_int.conditions.find(o => o.source_id === cfs_id); // char_int.condition_hash[cfs_id];
                if (char_cond) {
                  level = char_cond.level;
                  // if (char_cond.source_true_id !== "") {
                  //   cfs_id = char_cond.source_true_id;
                  // }
                }
              }
            }
          } else {
            const class_finder = char_int instanceof Character ? char_int.spirit.classes.filter(o => 
              o.source_id === class_id || o.variant_ids.includes(class_id) ||
              o.subclass_id === subclass_id || (o.subclass && o.subclass.variant_ids.includes(subclass_id))) : [];
            if (class_finder.length === 1) {
              level = class_finder[0].level;
            }
          }
        }
        let potence_finder: Potence[] = [];
        if (level === -1 && the_effect.potences.length === 1) {
          potence_finder = the_effect.potences;
        } else {
          potence_finder = the_effect.potences.filter(o => o.level === level);
        }
        if (potence_finder.length === 0) {
          potence_finder = the_effect.potences.filter(o => o.level < level);
          if (potence_finder.length > 0) {
            const max_level = Math.max(...potence_finder.map(o => { return o.level }));
            potence_finder = the_effect.potences.filter(o => o.level === max_level);
          }
        } 
        if (potence_finder.length === 1) {
          const potence = potence_finder[0].clone();
          if (spell instanceof Spell) {
            
          } else if (spell instanceof StoredSpell) {
            potence.rolls.ability_score = "";
          } else {
            if (spell.use_spellcasting_modifier) { // || (use_spell && the_effect.add_modifier.toLowerCase() === "true")) {
              potence.rolls.ability_score = spell.spellcasting_ability;
            } else {
              potence.rolls.ability_score = "";
            }
            if (spell.damage_die_size_override !== -1) {
              potence.rolls.size.makeBasic();
              potence.rolls.size.base = spell.damage_die_size_override;
            }
          }
          if (log_it) {
            console.log(potence);
            console.log(potence.rolls.flat);
            debugger;
          }
          
          if (!(char_int instanceof BasicCreatureInstance) && !(char_int instanceof SummonInstance) && !(spell instanceof Spell) && !(spell instanceof StoredSpell)) {
            const dbs = this.getDamageBonuses({ char_int, obj: spell, effect, log_it });
            for (const db of dbs) {
              if (!db.rolls.flat.isBlank()) {
                potence.rolls.flat.base += this.value(db.rolls.flat, { obj: char_int, source_id: spell.source_true_id, item_id, attack_mod, action, ancestries });
              }
              if (log_it) {
                console.log(db);
                console.log(potence.rolls.flat);
              }
            }
          }
          if (action && action.mod_flat > 0 && potence.rolls.flat.isBasic() && potence.rolls.flat.base > 0) {
            potence.rolls.flat.base += action.mod_flat;
          }
          return potence;
        }
        // }
      }
    }
    return undefined;
  }

  getDamageBonuses({
    char_int, 
    obj = null,
    attack = null,
    effect = null,
    log_it
  }: {
    char_int: CharacterSheetInterface, 
    obj: CharacterSpell | CharacterAbility | CharacterItem | CharacterFeature | null,
    attack?: Attack | null,
    effect?: AbilityEffect | null,
    log_it?: boolean
  }) {
    if (obj === null) {
      if (attack) {
        // const the_attack = attack;
        // const damage_types = the_attack.damage_rolls.map(o => o.type);
        return char_int.mind.damage_bonuses.filter(o => 
          o.weapon_id === "" && 
          o.apply_to.includes("Weapons") && 
          this.fitCharWeaponLimit(char_int, attack, o.weapon_limit)
          // o.class_id === "" &&
          // (o.damage_types.length === 0 || 
          //   common_util.any_overlaps(o.damage_types, damage_types)) && 
          // o.magic_schools.length === 0 && 
          // o.spell_list_ids.length === 0 &&
          // o.weapon_keywords.length === 0 &&
          // !o.magical_weapons_only 
        );
      } else {
        return [];
      }
    } else if (obj instanceof CharacterItem) {
      if (obj instanceof CharacterWeapon && attack) {
        const weapon = obj;
        // const damage_types = attack.damage_rolls.map(o => o.type);
        // const weapon_keyword_ids = char_int instanceof Character ? this.getWeaponKeywordIds(char_int, obj) : obj.base_weapon_keyword_ids;
        return char_int.mind.damage_bonuses.filter(o => 
          o.weapon_id === weapon.true_id || 
          ((o.weapon_id === "" && 
            o.apply_to.includes("Weapons") && this.fitCharWeaponLimit(char_int, attack, o.weapon_limit))
            // o.class_id === "" &&
            // (o.damage_types.length === 0 || 
            //   common_util.any_overlaps(o.damage_types, damage_types)) && 
            // o.magic_schools.length === 0 &&
            // o.spell_list_ids.length === 0 &&
            // (!o.magical_weapons_only || weapon.magic) && 
            // (o.weapon_keywords.length === 0 || 
            //   common_util.any_overlaps(o.weapon_keywords, weapon_keyword_ids))
          )
        );
      } else {
        return [];
      }
    } else if (effect) {
      // const type = effect.type;
      const damage_bonuses = char_int.mind.damage_bonuses.filter(o => o.weapon_id === "");
      if (obj instanceof CharacterFeature) {
        // TODO: There may be a reason to add this back in, but I'm not sure. Wait and see.
        // let potence_class = "";
        // if (obj.floating_feature instanceof ExtraEffectsFeature || obj.floating_feature instanceof ExtraEffectsOfTypeFeature) {
        //   const extra_effects = char_int.mind.extra_effects.find(o => o.char_features.find(o2 => o2.true_id === obj.true_id));
        //   if (extra_effects) {
        //     potence_class = extra_effects.potence_class;
        //   }
        // }
        // return damage_bonuses.filter(o => 
        //   o.weapon_id === "" && 
        //     o.apply_to.includes("Abilities") && 
        //     this.fitCharAbilityLimit(char_int, attack, o.weapon_limit)
        //   // (o.class_id === "" || o.class_id === potence_class) &&
        //   // (o.damage_types.length === 0 || o.damage_types.includes(type)) && 
        //   // o.levels.length === 0 &&
        //   // o.magic_schools.length === 0 && 
        //   // o.spell_list_ids.length === 0 &&
        //   // o.weapon_keywords.length === 0 &&
        //   // !o.magical_weapons_only 
        // );
      } else { // if (obj instanceof CharacterSpell) 
        if (log_it) {
          console.log(damage_bonuses);
          console.log(obj);
          debugger;
        }
        return damage_bonuses.filter(o => 
            o.apply_to.includes("Spells") && 
            this.fitCharSpellLimit({ char: char_int, obj, limit: o.spell_limit, log_it })
          // (o.class_id === "" || o.class_id === obj.source_id) && // TODO: This probably needs to be true_id
          // (o.damage_types.length === 0 || o.damage_types.includes(type)) && 
          // (o.magic_schools.length === 0 || o.magic_schools.includes("Any") || o.magic_schools.includes(obj.school)) && 
          // (this.spellOnASpellList(obj.spell_id, o.spell_list_ids)) && 
          // o.weapon_keywords.length === 0 && 
          // (o.levels.length === 0 || o.levels.includes(obj.level)) &&
          // !o.magical_weapons_only 
        );
      // } else {
      //   return damage_bonuses.filter(o => 
      //     (o.class_id === "" || o.class_id === obj.source_id || o.class_id === obj.source_true_id) &&
      //     (o.damage_types.length === 0 || o.damage_types.includes(type)) && 
      //     o.levels.length === 0 &&
      //     (o.magic_schools.length === 0 || 
      //       ((obj.the_ability instanceof SpellsFromList) && 
      //         (o.magic_schools.includes("Any") || o.magic_schools.includes(obj.school)) && 
      //         (this.spellOnASpellList(obj.spell_id, o.spell_list_ids)))) && 
      //     o.weapon_keywords.length === 0 &&
      //     !o.magical_weapons_only 
      //   );
      }
    }
    return [];
  }

  getSpellStuff({
    character, 
    char_class, 
    char_spellbook, 
    spell
  }: {
    character: Character, 
    char_class: CharacterClass, 
    char_spellbook?: CharacterSpellbook, 
    spell: Spell | CharacterSpell
  }) {
    // if (spell.name.includes("Booming")) {
    //   debugger;
    // }
    const this_spell: CharacterSpell | CharacterAbility | undefined = character.mind.spells.find(o => 
      o.source_true_id === char_class.true_id && 
      (o.spell_id === spell.spell_id));
    
    let other_spell: CharacterSpell | CharacterAbility | undefined = character.mind.spells.find(o => 
      o.source_true_id !== char_class.true_id && 
      (o.spell_id === spell.spell_id));
    if (!other_spell) {
      other_spell = character.mind.spell_as_abilities.find(o => 
        o.source_true_id !== char_class.true_id && 
        (o.spell_id === spell.spell_id) &&
        (o.the_ability instanceof SpellsFromList) && ["Don't Override","At Will","Or Special Resource"].includes(o.the_ability.spell_overrides.slot_override));
    }
    if (!other_spell) {
      // It could also be from a SpellsFromListWithCosts, but that we check these differently
      other_spell = character.mind.spell_as_abilities.find(o => 
        o.source_true_id === char_class.true_id && 
        (o.spell_id === spell.spell_id) &&
        (o.the_ability instanceof SpellsFromListWithCosts) && 
        o.the_ability.spells.some(o2 => 
          o2.spell_id === spell.spell_id && 
          ["Don't Override","At Will","Or Special Resource"].includes(o2.cost_override.slot_override)
        )
      );
    }
    let variant_char_spell: CharacterSpell | CharacterAbility | undefined = character.mind.spells.find(o => 
      o.spell_id !== spell.spell_id &&
      o.variant_group_id === spell.variant_group_id
    );
    if (!variant_char_spell) {
      variant_char_spell = character.mind.spell_as_abilities.find(o => 
        (o.spell_id !== spell.spell_id &&
          o.variant_group_id === spell.variant_group_id) &&
        (o.the_ability instanceof SpellsFromList) && 
        ["Don't Override","At Will","Or Special Resource"].includes(o.the_ability.spell_overrides.slot_override));
    }
    if (!variant_char_spell) {
      variant_char_spell = character.mind.spell_as_abilities.find(o => 
        (o.spell_id !== spell.spell_id &&
          o.variant_group_id === spell.variant_group_id) &&
          (o.the_ability instanceof SpellsFromListWithCosts) && 
          o.the_ability.spells.some(o2 => 
            o2.spell_id === spell.spell_id && 
            ["Don't Override","At Will","Or Special Resource"].includes(o2.cost_override.slot_override)
          )
      );
    }
    if (!variant_char_spell && char_spellbook) {
      variant_char_spell = char_spellbook.spells.find(o => 
        o.spell_id !== spell.spell_id &&
        o.variant_group_id === spell.variant_group_id
      );
    }
    
    const known_from_this_source = this_spell !== undefined;
    const known_from_other_source = other_spell !== undefined;
    const known_variant = variant_char_spell !== undefined;
    other_spell = character.mind.spell_as_abilities.find(o => 
      o.source_true_id === char_class.true_id && 
      (o.spell_id === spell.spell_id) &&
      (o.the_ability instanceof SpellsFromList) && 
      ["Don't Override","At Will","Or Special Resource"].includes(o.the_ability.spell_overrides.slot_override)
    );
    if (!other_spell) {
      // It could also be from a SpellsFromListWithCosts, but that we check these differently
      other_spell = character.mind.spell_as_abilities.find(o => 
        o.source_true_id === char_class.true_id && 
        (o.spell_id === spell.spell_id) &&
        (o.the_ability instanceof SpellsFromListWithCosts) && 
        o.the_ability.spells.some(o2 => 
          o2.spell_id === spell.spell_id && 
          ["Don't Override","At Will","Or Special Resource"].includes(o2.cost_override.slot_override)
        )
      );
    }
    const basically_always_known = other_spell !== undefined;

    return { known_from_this_source, known_from_other_source, known_variant, basically_always_known };
  }

  rollD20({
    char_interface, 
    rolls = [], 
    type, 
    advantage = 0, 
    greater_advantage = false,
    minimum_roll = 0, 
    rerolls = [],
    use_ability_score = "None"
  } : {
    char_interface?: CharacterSheetInterface | BasicCreatureInstance | SummonInstance, 
    rolls?: RollPlus[], 
    type: string, 
    advantage?: number, 
    greater_advantage?: boolean,
    minimum_roll?: number, 
    rerolls?: Reroll[],
    use_ability_score?: AbilityScoreType | "None"
  }) {
    const rolled_values: RolledValue[] = [];
    if (true) {
      const roll_values: RollValue[] = [];
      let value = common_util.get_random(20);
      const values = [value];
      const rerolled = false;
      const reroll_value: number | undefined = undefined;
      let minrolled = false;
      let minroll_value: number | undefined = undefined;
      if (advantage > 0) {
        values.push(common_util.get_random(20));
        if (greater_advantage) {
          values.push(common_util.get_random(20));
        }
        value = Math.max(...values);
      } else if (advantage < 0) { 
        values.push(common_util.get_random(20));
        value = Math.min(...values);
      } else {
        value = values[0];
      }
      if (value < minimum_roll) {
        minrolled = true;
        minroll_value = minimum_roll;
      }
      roll_values.push({ main_values: values, rerolled, reroll_value, minrolled, minroll_value });
      rolled_values.push({ type, count: 1, size: 20, flat: 0, advantage, roll_values });
    }
    for (const dr of rolls) {
      let flat = 0;
      if (dr.flat !== 0) {
        flat += dr.flat;
      }
      if (char_interface && dr.ability_score !== "") {
        const mod = char_interface.mind.current_ability_scores.getModifier(dr.ability_score);
        if (mod) {
          flat += mod;
        }
      }
      if (dr.size === 1) {
        if (dr.count > 0) {
          flat += dr.count;
          rolled_values.push({ type, count: 0, size: 0, flat, advantage, roll_values: [] });
        }
      } else if (dr.count !== 0) {
        let count = dr.count;
        // let reverse = false;
        if (count < 0) {
          count *= -1;
          // reverse = true;
        }
        let reroll_threshold = 0;
        for (const r of rerolls) {
          if (r.allowed_damage_types.includes("ALL") || r.allowed_damage_types.includes(dr.type)) {
            reroll_threshold = Math.max(reroll_threshold, r.threshold);
          }
        }
        const roll_values: RollValue[] = [];
        for (let i = 0; i < count; ++i) {
          let rerolled = false;
          const minrolled = false;
          const value = Math.ceil(common_util.get_random(dr.size));
          const values = [value];
          if (value <= reroll_threshold) {
            rerolled = true;
            values.push(Math.ceil(common_util.get_random(dr.size)));
          }
          roll_values.push({ main_values: values, rerolled, minrolled });
        }
        rolled_values.push({ type: dr.type, count: dr.count, size: dr.size, flat, advantage: 0, roll_values });
      } else if (flat !== 0) {
        rolled_values.push({ type, count: 0, size: 0, flat, advantage, roll_values: [] });
      }
    }
    return rolled_values;
  }

  rollOther({
    char_interface, 
    rolls, 
    type, 
    advantage = 0, 
    minimum_roll = 0, 
    rerolls = []
  } : {
    char_interface?: CharacterSheetInterface | BasicCreatureInstance | SummonInstance, 
    rolls: RollPlus[], 
    type: string, 
    advantage?: number, 
    minimum_roll?: number, 
    rerolls?: Reroll[]
  }) {
    const rolled_values: RolledValue[] = [];
    
    for (const dr of rolls) {
      let flat = 0;
      if (dr.flat !== 0) {
        flat += dr.flat;
      }
      if (char_interface && dr.ability_score !== "") {
        const mod = char_interface.mind.current_ability_scores.getModifier(dr.ability_score);
        if (mod) {
          flat += mod;
        }
      }
      if (dr.size === 1) {
        if (dr.count > 0) {
          flat += dr.count;
          rolled_values.push({ type, count: 0, size: 0, flat, advantage, roll_values: [] });
        }
      } else if (dr.count !== 0) {
        let count = dr.count;
        // let reverse = false;
        if (count < 0) {
          count *= -1;
          // reverse = true;
        }
        let reroll_threshold = 0;
        for (const r of rerolls) {
          if (r.allowed_damage_types.includes("ALL") || r.allowed_damage_types.includes(dr.type)) {
            reroll_threshold = Math.max(reroll_threshold, r.threshold);
          }
        }
        const roll_values: RollValue[] = [];
        for (let i = 0; i < count; ++i) {
          let rerolled = false;
          const minrolled = false;
          const value = Math.ceil(common_util.get_random(dr.size));
          const values = [value];
          if (value <= reroll_threshold) {
            rerolled = true;
            values.push(Math.ceil(common_util.get_random(dr.size)));
          }
          roll_values.push({ main_values: values, rerolled, minrolled });
        }
        rolled_values.push({ type: dr.type, count: dr.count, size: dr.size, flat, advantage: 0, roll_values });
      } else if (flat !== 0) {
        rolled_values.push({ type, count: 0, size: 0, flat, advantage, roll_values: [] });
      }
    }
    return rolled_values;
  }

  applyOverridableNumber(char: Character, overridable: OverridableNumber, current: number, creature: number) {
    let value = 0;
    switch (overridable.override_mode) {
      case "Creature": value = creature; break;
      case "Override": value = this.value(overridable.value, { obj: char, item_id: "" }); break;
      case "Merge": value = current + this.value(overridable.value, { obj: char, item_id: "" }); break;
      case "Creature Merge": value = creature + this.value(overridable.value, { obj: char, item_id: "" }); break;
      case "Creature if Greater": 
        value = Math.max(current, creature);
      break;
      case "Override if Greater":
        value = Math.max(current, this.value(overridable.value, { obj: char, item_id: "" }));
      break;
      default: value = current; break; // case "Copy": case "Share": case "Inherit":
    }
    return value;
  }

  applyOverridableAbilityScores(char: Character, overridable: OverridableAbilityScores, current: AbilityScores, creature_as: AbilityScores | null = null) {
    const value = new AbilityScores();
    for (const ability of ABILITY_SCORES) {
      const curr_ability_score = current.getAbilityScore(ability);
      const override = overridable.getAbilityScore(ability);
      const creature = creature_as?.getAbilityScore(ability)??0;
      if (override) {
        value.setAbilityScore(ability, this.applyOverridableNumber(char, override, curr_ability_score, creature));
      }
    }
    return value;
  }

  applyTransformToInstance = async (char: Character, transform_instance: TransformInstance) => {
    let maybe_transform = transform_instance ? transform_instance.transform : undefined;
    if (transform_instance && !maybe_transform) {
      const res = await api.getFullObject("transform", transform_instance.transform_id);
      if (res instanceof Transform) {
        maybe_transform = res;
      }
    }
    if (transform_instance && transform_instance.creature_id !== "") {
      const res = await api.getFullObject("creature", transform_instance.creature_id);
      if (res instanceof Creature) {
        transform_instance.creature = res;
        const ci = new BasicCreatureInstance();
        await ci.copyCreature(res, res.challenge_rating);
        transform_instance.creature_instance = ci;
      }
    }
    if (transform_instance && maybe_transform) {
      transform_instance.character = char;
      const transform = maybe_transform;
      const creature = transform_instance.creature;
      
      transform_instance.advantage = char.body.advantage;
      transform_instance.inspiration = char.inspiration;

      if (!transform_instance.transform) {
        transform_instance.transform = transform;
        transform_instance.image_url = transform.image_url_overridable.override_mode === "Override" ? transform.image_url_overridable.value : char.image_url;
        
        if (transform.size.use_options && transform.size.options) {
          // Transform presents options
          if (transform.size.options.length === 1 || 
            (transform.size.options.length > 0 && !transform.size.options.includes(char.base_size))) {
            transform_instance.base_size = transform.size.options[0] as SizeType; // There is either only one option, or the current base_size isn't one of them
          } else {  
            transform_instance.base_size = char.base_size;
          }
        } else if (transform.size.overridable) {
          const new_size = this.applyOverridableNumber(char, transform.size.overridable, char.base_size, creature ? creature.size_num : 0);
          if (new_size > 0 && new_size < 7) {
            transform_instance.base_size = new_size as SizeType;
          } else {
            transform_instance.base_size = char.base_size;
          }
        }

        transform_instance.display_speed = char.display_speed;
        transform_instance.proficiency_modifier = char.mind.proficiency_modifier;

        let ci: BasicCreatureInstance | undefined;
        if (transform_instance.creature_id !== "" && !transform_instance.creature_instance) {
          const res = await api.getFullObject("creature", transform_instance.creature_id);
          if (res instanceof Creature) {
            transform_instance.creature = res;
            ci = new BasicCreatureInstance();
            await ci.copyCreature(res, res.challenge_rating);
            transform_instance.creature_instance = ci;
          }
        } else {
          ci = transform_instance.creature_instance;
        }
        const creature_as = ci ? ci.current_ability_scores : null; // creature ? this.toAbilityScores(creature.ability_scores, { obj: transform_instance }) : null;
        transform_instance.current_ability_scores = this.applyOverridableAbilityScores(char, transform.current_ability_scores, char.mind.current_ability_scores, creature_as);
        transform_instance.max_ability_scores = this.applyOverridableAbilityScores(char, transform.max_ability_scores, char.max_ability_scores, creature_as);

        console.log(transform_instance.current_ability_scores.clone());
        if (creature) {
          // debugger;
          const c = creature;
          let hit_dice = c.hit_dice.map(o => this.toHitDice(o, { obj: transform_instance }));
          if (hit_dice.length === 1) {
            hit_dice[0].size = HIT_DICE_SIZE_MAP[transform_instance.base_size];
          }
          const hit_dice_bonus = transform_instance.current_ability_scores.CON;
          let current_hit_points = Math.floor(hit_dice.map(o => {
            return o.count * (((o.size + 1) / 2) + hit_dice_bonus);
          }).reduce((a,b) => a + b, 0));
          
          // Creatures never come with temp_hp, but some transform effects give temp_hp based on their max_hp
          transform_instance.hp.temp = this.applyOverridableNumber(char, transform.temp_hit_points, char.hp.temp, creature.max_hp_for_cr(creature.challenge_rating));
          if (transform.temp_hit_points.share) {
            char.hp.temp = transform_instance.hp.temp;
          }
          if (transform.calc_max_hp) {
            let hd_count = hit_dice.map(o => o.count).reduce((a,b) => a + b, 0);
            let hd_size = hit_dice.map(o => o.size).reduce((a,b) => a + b, 0);
            hd_count = this.applyOverridableNumber(char, transform.hit_dice_count, hd_count, hd_count);
            hd_size = this.applyOverridableNumber(char, transform.hit_dice_size, hd_size, hd_size);
            const hd = new HitDiceWithUsed();
            hd.count = hd_count;
            hd.size = hd_size;
            hit_dice = [hd];
            current_hit_points = Math.floor(hit_dice.map(o => {
              return o.count * (((o.size + 1) / 2) + hit_dice_bonus);
            }).reduce((a,b) => a + b, 0));
            
            transform_instance.hp.current = current_hit_points; // this.applyOverridableNumber(char, transform.current_hit_points, char.current_hit_points, current_hit_points);
            transform_instance.hp.max = current_hit_points;
            transform_instance.resource_holder.hit_dice = hit_dice;
          } else {
            transform_instance.hp.current = this.applyOverridableNumber(char, transform.current_hit_points, char.hp.current, current_hit_points);
            transform_instance.hp.max = this.applyOverridableNumber(char, transform.max_hit_points, char.hp.max, current_hit_points);
          }
        } else {
          transform_instance.hp.temp = this.applyOverridableNumber(char, transform.temp_hit_points, char.hp.temp, 0);
          if (transform.calc_max_hp) {
            const hd_count = this.applyOverridableNumber(char, transform.hit_dice_count, 0, 0);
            const hd_size = this.applyOverridableNumber(char, transform.hit_dice_size, 0, 0);
            const hd = new HitDiceWithUsed();
            hd.count = hd_count;
            hd.size = hd_size;
            const hit_dice = [hd];
            const hit_dice_bonus = transform_instance.current_ability_scores.CON;
            const current_hit_points = Math.floor(hit_dice.map(o => {
              return o.count * (((o.size + 1) / 2) + hit_dice_bonus);
            }).reduce((a,b) => a + b, 0));
            
            transform_instance.hp.current = this.applyOverridableNumber(char, transform.current_hit_points, char.hp.current, current_hit_points);
            transform_instance.hp.max = current_hit_points;
            transform_instance.resource_holder.hit_dice = hit_dice;
          } else {
            transform_instance.hp.current = this.applyOverridableNumber(char, transform.current_hit_points, char.hp.current, 0);
            transform_instance.hp.max = this.applyOverridableNumber(char, transform.max_hit_points, char.hp.max, 0);
          }
        }
        
        this.applyTransformResources(char, transform);
      }
      // debugger;
      if (transform.slots.includes("All")) {
        transform_instance.resource_holder.slots = char.body.use_slots.map(o => o.clone());
      } else if (transform.slots.length > 0) {
        transform_instance.resource_holder.slots = char.body.use_slots.filter(o => transform.slots.includes(o.type_id)).map(o => o.clone());
      }

      transform_instance.initiative_modifier = transform_instance.current_ability_scores.DEX;
      
      // debugger;
      transform_instance.armor_class = this.applyOverridableNumber(char, transform.armor_class, char.armor_class, creature ? this.value(creature.armor_class, { obj: transform_instance, item_id: "" }) : 0);
      transform_instance.proficiency_modifier = this.applyOverridableNumber(char, transform.prof_bonus, char.mind.proficiency_modifier, creature ? creature.proficiency_modifier : 0);
      transform_instance.formula_values = char.formula_values;
      
      const ci = new BasicCreatureInstance();
      if (creature) {
        await ci.copyCreature(creature, creature.challenge_rating);
        transform_instance.creature_instance = ci;
      }

      const default_senses = transform.senses["Default"];
      if (default_senses) {
        const sense_default = default_senses.clone();
        // debugger;
        for (const sense of SENSES) {
          // Override Common Features
          let override: OverridableNumber = transform.senses[sense._id];
          if (!override) {
            override = sense_default.clone();
          }
          let creature_sense = 0;
          if (creature) {
            if (ci.senses[sense._id]) {
              creature_sense = ci.senses[sense._id];
            } else if (ci.senses[sense.name]) {
              creature_sense = ci.senses[sense.name];
            }
          }
          let char_sense: CharacterSense | undefined = undefined;
          switch (override.override_mode) {
            case "Copy": 
              char_sense = char.mind.senses.find(o => o.sense_id === sense._id);
            break;
            case "Override":
              if (override.value) {
                const value = this.value(override.value, { obj: char, item_id: "" });
                if (value > 0) {
                  char_sense = new CharacterSense();
                  char_sense.sense_id = sense._id;
                  char_sense.name = sense.name;
                  char_sense.range = value;
                }
              }
            break;
            case "Creature":
              if (creature_sense > 0) {
                char_sense = new CharacterSense();
                char_sense.sense_id = sense._id;
                char_sense.name = sense.name;
                char_sense.range = creature_sense;
              }
            break;
            case "Merge":
              if (true) {
                const old_char_sense = char.mind.senses.find(o => o.sense_id === sense._id);
                let merge_value = 0;
                if (override.value) {
                  merge_value = this.value(override.value, { obj: char, item_id: "" });
                }
                merge_value = Math.max(merge_value, creature_sense);

                if (merge_value > 0) {
                  char_sense = new CharacterSense();
                  char_sense.sense_id = sense._id;
                  char_sense.name = sense.name;
                  char_sense.range = (old_char_sense ? old_char_sense.range : 0) + merge_value;
                }
              }
            break;
            case "Creature Merge":
              if (true) {
                const old_char_sense = char.mind.senses.find(o => o.sense_id === sense._id);
                let merge_value = 0;
                if (override.value) {
                  merge_value = this.value(override.value, { obj: char, item_id: "" });
                }
                merge_value = Math.max(merge_value, creature_sense);

                if (merge_value > 0) {
                  char_sense = new CharacterSense();
                  char_sense.sense_id = sense._id;
                  char_sense.name = sense.name;
                  char_sense.range = (old_char_sense ? old_char_sense.range : 0) + merge_value;
                }
              }
            break;
          }
          if (char_sense && char_sense.range > 0) {
            transform_instance.senses.push(char_sense);
          }
        }
      }

      const default_speed = transform.speed["Default"];
      if (default_speed) {
        // console.log(transform.speed);
        const speed_default = default_speed.clone();
        // debugger;
        for (const speed of Object.keys(SPEED_MAP)) {
          // Override Common Features
          let override: OverridableNumber = transform.speed[speed];
          if (!override) {
            override = speed_default.clone();
          }
          let char_speed: number | undefined = undefined;
          const creature_speed = ci?.speed[speed]??0;

          switch (override.override_mode) {
            case "Copy": 
              char_speed = (char.speed as any)[speed];
            break;
            case "Override":
              if (override.value) {
                char_speed = this.value(override.value, { obj: char, item_id: "" });
              }
            break;
            case "Override if Greater":
              if (override.value) {
                char_speed = (char.speed as any)[speed];
                const override_value = this.value(override.value, { obj: char, item_id: "" });
                if (char_speed === undefined || override_value > char_speed) {
                  char_speed = override_value;
                }
              }
            break;
            case "Creature":
              char_speed = creature_speed;
            break;
            case "Merge":
              if (true) {
                char_speed = (char.speed as any)[speed];
                if (!char_speed) {
                  char_speed = 0;
                }
                let merge_value = 0;
                if (override.value) {
                  merge_value = this.value(override.value, { obj: char, item_id: "" });
                }
                merge_value = Math.max(merge_value, creature_speed);
                if (merge_value > 0) {
                  char_speed += merge_value;
                }
              }
            break;
            case "Creature Merge":
              if (true) {
                char_speed = creature_speed;
                if (!char_speed) {
                  char_speed = 0;
                }
                let merge_value = 0;
                if (override.value) {
                  merge_value = this.value(override.value, { obj: char, item_id: "" });
                }
                merge_value = Math.max(merge_value, creature_speed);
                if (merge_value > 0) {
                  char_speed += merge_value;
                }
              }
            break;
          }
          if (char_speed && char_speed > 0) {
            (transform_instance.speed as any)[speed] = char_speed;
          }
        }
      }

      const feature_filters = {...transform.feature_filters};
      const default_filter = feature_filters["Default"];
      // transform_instance.advantages = [];
      // transform_instance.damage_multipliers = [];
      // transform_instance.extra_attacks = 0;
      // // TODO: Change how I handle abilities and spell_as_abilities to preserve special resources
      // transform_instance.abilities = [];
      // transform_instance.spell_as_abilities = [];
      // transform_instance.spells = [];
      transform_instance.features = [];
      for (const feature_type of TRANSFORM_FEATURE_TYPES) {
        // Override Common Features
        let filter = feature_filters[feature_type];
        if (!filter) {
          filter = {...default_filter};
        } else {
          filter = {...filter};
        }
        // debugger;
        if (!filter.block_all) {
          delete filter.block_all;
          const features: CharacterFeature[] = api.filter("", char.mind.features.filter(o => o.feature_type === feature_type), filter);
          transform_instance.features = [...transform_instance.features, ...features];
        }
      }
 
      // debugger;
      for (const feature of transform.features) {
        const cf = new CharacterFeature();
        cf.copyFeature(feature, char);
        transform_instance.features.push(cf);
      }
      // debugger;
      if (creature) {
        for (const fb of creature.fbs) {
          for (const feature of fb.features) {
            const cf = new CharacterFeature();
            cf.copyFeature(feature, char);
            transform_instance.features.push(cf);
          }
        }
      }

      // debugger;
      // It needs to figure actions out based on the stuff above
      transform_instance.actions = [];
      transform_instance.spells = [];
      if (!transform.spell_limit.isEmpty()) {
        // Empty means block all
        for (const spell of char.mind.spells) {
          if (transform_instance.spells.filter(o => o.true_id === spell.true_id).length === 0 && 
            this.fitCharSpellLimit2(char, spell, transform.spell_limit)) {
            transform_instance.spells.push(spell);
          }
        }
        for (const spell_as_ability of char.spell_as_abilities) {
          if (transform_instance.spell_as_abilities.filter(o => o.true_id === spell_as_ability.true_id).length === 0 && 
            this.fitCharSpellLimit2(char, spell_as_ability, transform.spell_limit)) {
            transform_instance.spell_as_abilities.push(spell_as_ability);
          }
        }
      }
      // for (const other_adapt_inst of transform_instance.adaptations) {
      //   if (other_adapt_inst.adaptation) {
      //     const adaptation = other_adapt_inst.adaptation;
      //     if (!adaptation.spell_limit.isEmpty()) {
      //       // Empty means block all
      //       for (const spell of char.mind.spells) {
      //         if (transform_instance.spells.filter(o => o.true_id === spell.true_id).length === 0 && 
      //           this.fitCharSpellLimit2(char, spell, adaptation.spell_limit)) {
      //           transform_instance.spells.push(spell);
      //         }
      //       }
      //       for (const spell_as_ability of char.spell_as_abilities) {
      //         if (transform_instance.spell_as_abilities.filter(o => o.true_id === spell_as_ability.true_id).length === 0 && 
      //           this.fitCharSpellLimit2(char, spell_as_ability, adaptation.spell_limit)) {
      //           transform_instance.spell_as_abilities.push(spell_as_ability);
      //         }
      //       }
      //     }
      //   }
      // }
      // debugger;
      if (char.spirit.transform && char.spirit.transform.transform) {
        const transform = char.spirit.transform.transform;

        const transform_upgrades = char.mind.transform_upgrades.filter(o => 
          o.floating_feature instanceof TransformUpgradeFeature &&
          api.filter("", [transform], o.floating_feature.transform_filter).length > 0
        );
        for (const cf of transform_upgrades) {
          await this.applyTransformUpgradeToInstance(char, cf);
        }
      }
      // if (transform_instance.adaptations.length > 0) {
      //   const adaptations = await this.getAdaptations();
      //   for (const tui of transform_instance.adaptations.filter(o => o.cf_id === "")) {
      //     if (!tui.adaptation) {
      //       const adaptation = adaptations.find(o => o._id === tui.adaptation_id);
      //       if (adaptation) {
      //         tui.adaptation = adaptation;
      //       }
      //     }
      //     this.applyAdaptationInstance(char, transform_instance, tui);
      //   }
      // }

      // this.recalc_checks_and_throws(transform_instance);
    }
    // console.log(transform_instance.current_ability_scores.clone());
  }

  /**
   * This is like the one above, 
   * but it handles things a little differently.
   * 
   * First is that this frequently has Inherit, 
   * which just makes it stay how it already is.
   * 
   * Similarly anything that is a boolean that is false also leaves it.
   */
  applyTransformUpgradeToInstance = async (char: Character, cf: CharacterFeature) => {
    const tuf = cf.floating_feature;
    if (tuf instanceof TransformUpgradeFeature) {
      // const adaptations = await this.getAdaptations();
      // let maybe_adaptation: Adaptation | null = null;
      // const res = adaptations.find(o => o._id === tuf.adaptation_id);
      // if (res instanceof Adaptation) {
      //   maybe_adaptation = res;
      // }
      // const transform_instance = char.spirit.transform;
      // if (transform_instance && maybe_adaptation) {
      //   let tui = transform_instance.adaptations.find(o => o.cf_id === cf.true_id);
      //   if (!tui) {
      //     tui = new AdaptationInstance();
      //     tui.cf_id = cf.true_id;
      //     tui.transform_upgrade_feature_id = tuf._id;
      //   }
      //   tui.adaptation = maybe_adaptation;
      //   this.applyAdaptationInstance(char, transform_instance, tui);
      // }
    }
  }
  
  applyTransformResources(char: Character, transform: TransformInterface) {
    const transform_instance = char.spirit.transform;
    if (transform_instance && transform) {
      const resource_default = transform.resources["Default"].clone();
      const resources: CharacterResourceWithUsed[] = [];
      const current_resources = [...transform_instance.resource_holder.resources];
      // debugger;
      for (const resource of data_util.resources) {
        // Override Common Features
        const current_resource = current_resources.find(o => o.type_id === resource._id);
        if (current_resource) {
          resources.push(current_resource);
        } else {
          let override = transform.resources[resource._id];
          if (!override) {
            override = resource_default.clone();
          }
          let char_resource: CharacterResourceWithUsed | undefined = undefined;
          switch (override.override_mode) {
            case "Inherit":
              char_resource = current_resource;
            break;
            case "Copy":  
              char_resource = char.body.resource_holder.resources.find(o => o.type_id === resource._id);
            break;
            case "Override":
              if (override.value) {
                const value = this.value(override.value, { obj: char, item_id: "" });
                if (value > 0) {
                  char_resource = new CharacterResourceWithUsed();
                  char_resource.type_id = resource._id;
                  char_resource.name = resource.name;
                  debugger;
                  char_resource.total = value; // TODO: make it support size as well for dice pool resources
                }
              }
            break;
            case "Merge": case "Creature Merge":
              const old_resource = char.body.resource_holder.resources.find(o => o.type_id === resource._id);
              let merge_value = 0;
              if (override.value) {
                merge_value = this.value(override.value, { obj: char, item_id: "" });
              }
              if (merge_value > 0) {
                char_resource = new CharacterResourceWithUsed();
                char_resource.type_id = resource._id;
                char_resource.name = resource.name;
                char_resource.total = (old_resource ? old_resource.total : 0) + merge_value;
              }
            break;
          }
          if (char_resource && char_resource.total > 0) {
            resources.push(char_resource);
          }
        }
      }
      transform_instance.resource_holder.resources = resources;
    }
  }

  createTransformInstance = async (char: Character, transform: Transform, made_with_slot_level: number, creature: Creature | null = null) => {
    // debugger;
    const transform_instance = new TransformInstance();
    transform_instance.transform_id = transform._id;
    transform_instance.made_with_slot_level = made_with_slot_level;
    if (creature && transform instanceof CreatureTransform) {
      transform_instance.creature_id = creature._id;
      transform_instance.creature = creature;
      const ci = new BasicCreatureInstance();
      await ci.copyCreature(creature, creature.challenge_rating);
      transform_instance.creature_instance = ci;
    }
    char.spirit.transform = transform_instance;
    char.spirit.transform.character = char;
    char.use_transform = true;
    await this.repopulateCharFeatureBases(char);
    // await this.applyTransformToInstance(char, char.spirit.transform);
    char.changed();
    char.subscription_holder.transformed();
  }
  
  summonMinions = async ({
    character, 
    spell, 
    level, 
    selected_option,
  }: {
    character: Character, 
    spell: CharacterAbility | CharacterSpell | StoredSpell | Spell | CreatureAbility | MinionAbility | CharacterFeature, 
    level: SpellLevel, 
    selected_option: SummonOption2,
  }) => {
    const item_id = spell instanceof CharacterAbility || spell instanceof CharacterFeature ? spell.item_id : (spell instanceof CharacterSpell ? spell.source_true_id : "");
    // const source_id = spell instanceof Spell || spell instanceof CreatureAbility || spell instanceof MinionAbility ? "" : spell.source_id;
    const source_true_id = spell instanceof Spell || spell instanceof CreatureAbility || spell instanceof MinionAbility || spell instanceof CharacterFeature ? "" : spell.source_true_id;
    // debugger;
    const upgrades = character.summon_upgrade_features.filter(o => {
      if (o.floating_feature instanceof SummonUpgradeFeature) {
        return api.fitCreatureLimit(selected_option, o.floating_feature.limits);
      }
      return false;
    });
    let use_old_version = upgrades.length === 0 && !selected_option.transform;
    if (selected_option.creature) {
      const creature = selected_option.creature;
      await api.loadObject(creature);
      for (let i = 0; i < selected_option.count; ++i) {
        if (use_old_version) {
          // Old version
          const minion = new BasicCreatureInstance();
          await minion.copyCreature(creature);
          minion.subscription_holder.feedTo = character.subscription_holder;
          character.spirit.minions.push(minion);
        } else {
          let minion = new ComplexCreatureInstance();
          minion.owner_char = character;
          minion.name = creature.name;
          minion.challenge_rating = creature.challenge_rating;
          minion.current_ability_scores = creature.current_ability_scores.clone();
          minion.creature_id = creature._id;
          minion.hit_dice = [];
          let max_hit_points = 0;
          let max_hp_bonuses = 0;
          let extra_from_first_die = 0;
          for (const hd_upg of creature.hit_dice) {
            const hd = this.toHitDice(hd_upg, { obj: minion });
            max_hit_points += hd.size * 0.5 * hd.count;
            max_hp_bonuses += hd.count * minion.current_ability_scores.CON;
            if (extra_from_first_die === 0) {
              extra_from_first_die = hd.size * 0.5;
            }
            minion.hit_dice.push(hd);
          }
          const transform = selected_option.transform;
          if (transform) {
            minion.transform_id = transform._id;
          } 
          minion.upgrade_char_features = upgrades;
          minion.hp.max = extra_from_first_die + max_hit_points + max_hp_bonuses;
          minion.hp.current = minion.hp.max;
          await this.repopulateCharFeatureBases(minion);
          minion.subscription_holder.feedTo = character.subscription_holder;
          character.spirit.minions.push(minion);
        }
      }
    } else if (selected_option.custom_stat_block) {
      // TODO: Still need to get CCI working with this kind of summon
      let char_feature: CharacterFeature | undefined;
      if (spell instanceof CharacterAbility && spell.char_feature) {
        char_feature = spell.char_feature;
      } else if (spell instanceof CharacterFeature) {
        char_feature = spell;
      }
      for (let i = 0; i < selected_option.count; ++i) {
        let minion: SummonInstance | ComplexCreatureInstance = new SummonInstance();
        this.copySummon({
          si: minion,
          copyMe: selected_option.custom_stat_block, 
          char: character, 
          item_id,
          spell,
          base_slot_level: spell instanceof CreatureAbility || spell instanceof MinionAbility || spell instanceof CharacterFeature ? 0 : spell.level, 
          slot_level: level,
          source_true_id,
          char_feature
        });
        if (!minion.name.includes(spell.name)) {
          minion.name = spell.name + " - " + minion.name;
        }
        if (selected_option.custom_stat_block.built_in_gift_ids.length > 0 || upgrades.length > 0) {
          const cci = new ComplexCreatureInstance();
          cci.owner_char = character;
          cci.copySI(minion);
          minion = cci;
          if (selected_option.custom_stat_block.built_in_gift_ids.length > 0) {
            const gifts = await data_util.getCreatureGifts();
            for (const id of selected_option.custom_stat_block.built_in_gift_ids) {
              const cg = gifts.find(o => o._id === id);
              if (cg) {
                const cci_source = new CCIFeatureSource();
                cci_source.copyCCISource({ feature_source: cg, char: minion });
                minion.creature_gift_cfss.push(cci_source);
              }
            }
          }
          minion.upgrade_char_features = upgrades;
          await this.repopulateCharFeatureBases(minion);
        }
        minion.subscription_holder.feedTo = character.subscription_holder;
        character.spirit.minions.push(minion);
      }
    }
    character.changed();
    character.subscription_holder.minionsChanged();
  }
  
  createMinion = async (
    character: Character, 
    spell: CharacterAbility | CharacterSpell | StoredSpell | Spell | CreatureAbility | MinionAbility | CharacterFeature, 
    level: SpellLevel, 
    selected_option: SummonOption2,
    char_feature?: CharacterFeature
  ) => {
    console.log(selected_option);
    const item_id = spell instanceof CharacterAbility || spell instanceof CharacterFeature ? spell.item_id : (spell instanceof CharacterSpell ? spell.source_true_id : "");
    // const source_id = spell instanceof Spell || spell instanceof CreatureAbility || spell instanceof MinionAbility ? "" : spell.source_id;
    const source_true_id = spell instanceof Spell || spell instanceof CreatureAbility || spell instanceof MinionAbility || spell instanceof CharacterFeature ? "" : spell.source_true_id;
    // debugger;
    const upgrades = character.summon_upgrade_features.filter(o => {
      if (o.floating_feature instanceof SummonUpgradeFeature) {
        return api.fitCreatureLimit(selected_option, o.floating_feature.limits);
      }
      return false;
    });
    if (selected_option.creature) {
      const creature = selected_option.creature;
      let minion: BasicCreatureInstance | TransformInstance | ComplexCreatureInstance = new BasicCreatureInstance();
      const transform = selected_option.transform;
      if (transform) {
        const transform_instance = new TransformInstance();
        // transform_instance.transform = transform;
        transform_instance.transform_id = transform._id;
        transform_instance.creature = creature;
        transform_instance.creature_id = creature._id;
        const ci = new BasicCreatureInstance();
        await ci.copyCreature(creature, creature.challenge_rating);
        transform_instance.creature_instance = ci;
        await this.applyTransformToInstance(character, transform_instance);
        minion = transform_instance;
      } else {
        await minion.copyCreature(creature);
        // if (!creature_instance.name.includes(spell.name)) {
        //   creature_instance.name = spell.name + " - " + creature_instance.name;
        // }
      }
      if (upgrades.length > 0) {
        if (minion instanceof BasicCreatureInstance) {
          const cci = new ComplexCreatureInstance();
          cci.owner_char = character;
          cci.copyCI(minion);
          minion = cci;
        } else if (minion instanceof TransformInstance) {
          const cci = new ComplexCreatureInstance();
          cci.owner_char = character;
          cci.copyTI(minion);
          minion = cci;
        }
        minion.upgrade_char_features = upgrades;
      }
      return minion;
    } else if (selected_option.custom_stat_block) {
      if (spell instanceof CharacterAbility && spell.char_feature) {
        char_feature = spell.char_feature;
      } else if (spell instanceof CharacterFeature) {
        char_feature = spell;
      }
      let minion: SummonInstance | ComplexCreatureInstance = new SummonInstance();
      this.copySummon({
        si: minion,
        copyMe: selected_option.custom_stat_block, 
        char: character, 
        item_id,
        spell,
        base_slot_level: spell instanceof CreatureAbility || spell instanceof MinionAbility || spell instanceof CharacterFeature ? 0 : spell.level, 
        slot_level: level,
        source_true_id,
        char_feature
      });
      if (!minion.name.includes(spell.name)) {
        minion.name = spell.name + " - " + minion.name;
      }
      if (upgrades.length > 0 || selected_option.custom_stat_block.built_in_gift_ids.length > 0) {
        if (minion instanceof SummonInstance) {
          const cci = new ComplexCreatureInstance();
          cci.owner_char = character;
          cci.copySI(minion);
          minion = cci;
        } 
        minion.upgrade_char_features = upgrades;
        if (selected_option.custom_stat_block.built_in_gift_ids.length > 0) {
          const gifts = await data_util.getCreatureGifts();
          for (const id of selected_option.custom_stat_block.built_in_gift_ids) {
            const cg = gifts.find(o => o._id === id);
            if (cg) {
              const cci_source = new CCIFeatureSource();
              cci_source.copyCCISource({ feature_source: cg, char: minion });
              minion.creature_gift_cfss.push(cci_source);
            }
          }
        }
      }
      return minion;
    }
  }

  copySummon({
    si,
    copyMe, 
    char, 
    item_id,
    spell,
    base_slot_level, 
    slot_level,
    char_feature,
    source_true_id
  }: {
    si: SummonInstance,
    copyMe: Summon, 
    char: Character, 
    item_id: string,
    spell: CharacterAbility | CharacterSpell | StoredSpell | Spell | CreatureAbility | MinionAbility | CharacterFeature, 
    base_slot_level: SpellLevel, 
    slot_level: SpellLevel,
    char_feature?: CharacterFeature,
    source_true_id: string
  }): void {
    si.source_true_id = source_true_id;
    si.summon = copyMe;
    if (spell instanceof Spell) {
      si.spell_id = spell._id;
    } else if (spell instanceof CharacterSpell || spell instanceof StoredSpell) {
      si.spell_id = spell.spell_id;
      si.spell_true_id = spell.true_id;
    } else if (spell instanceof CharacterAbility) {
      // debugger;
      si.spell_id = spell.spell_id;
    } else if (spell instanceof CharacterFeature) {
      if (spell.floating_feature instanceof SpellsFromList) {
        debugger;
      }
    }
    if (char_feature) {
      si.cf_true_id = char_feature.true_id;
      si.source_name = char_feature.source_name;
      si.source_type = char_feature.source_type;
      si.root_id = char_feature.root_id;
      si.root_name = char_feature.root_name;
      si.root_type = char_feature.root_type;
    }
    if (si.is_new) {
      si.name = copyMe.name;
      si.description = copyMe.description;
      si.stat_block_id = copyMe.true_id;
      si.base_slot_level = base_slot_level;
      si.slot_level = slot_level;
      si.creature_type = copyMe.creature_type;
      si.subtypes = [...copyMe.subtypes];
      si.swarm = copyMe.swarm;
      si.current_ability_scores = this.toAbilityScores(copyMe.ability_scores, { obj: char, source_id: source_true_id, base_slot_level, slot_level });
      si.ability_scores = si.current_ability_scores.clone();
      si.image_url = copyMe.image_url;
      si.resource_holder.hit_dice = [];
      si.spirit.base_size = copyMe.size_num;
      const hd = new HitDiceWithUsed();
      const size = copyMe.hd_size_from_size ? HIT_DICE_SIZE_MAP[si.spirit.base_size] : this.value(copyMe.hit_dice_size, { obj: char, source_id: source_true_id, item_id, base_slot_level, slot_level });
      hd.size = size;
      hd.count = this.value(copyMe.hit_dice_count, { obj: char, source_id: source_true_id, item_id, base_slot_level, slot_level });
      si.hit_dice.push(hd);
      si.use_your_pb = copyMe.use_your_pb;
      if (si.use_your_pb) {
        si.your_pb = char.mind.proficiency_modifier;
      }
      si.challenge_rating = this.value(copyMe.challenge_rating, { obj: char, source_id: source_true_id, item_id, base_slot_level, slot_level });
      
      // si.current_hit_points = this.value(copyMe.max_hit_points, { obj: char, source_id, item_id, base_slot_level, slot_level });
      // si.max_hit_points = this.value(copyMe.max_hit_points, { obj: char, source_id, item_id, base_slot_level, slot_level });
      // si.temp_hit_points = this.value(copyMe.temp_hit_points, { obj: char, source_id, item_id, base_slot_level, slot_level });
      if (copyMe.calc_max_hp) {
        let max_hit_points = 0;
        let max_hp_bonuses = 0;
        let extra_from_first_die = 0;
        for (const hd of si.hit_dice) {
          max_hit_points += hd.size * 0.5 * hd.count;
          max_hp_bonuses += hd.count * si.current_ability_scores.CON;
          if (extra_from_first_die === 0) {
            extra_from_first_die = hd.size * 0.5;
          }
        }
        si.hp.max = extra_from_first_die + max_hit_points + max_hp_bonuses;
      } else {
        si.hp.max = this.value(copyMe.max_hit_points, { obj: char, source_id: source_true_id, item_id, base_slot_level, slot_level });
      }
      si.hp.current = si.hp.max;
      si.hp.temp = this.value(copyMe.temp_hit_points, { obj: char, source_id: source_true_id, item_id, base_slot_level, slot_level });

      si.current_speed = {...copyMe.speed};
      si.speed = {...copyMe.speed};
      si.saving_throws = {
        STR: si.current_ability_scores.STR + (copyMe.attributes.save_profs.includes("STR") ? si.proficiency_modifier : 0),
        DEX: si.current_ability_scores.DEX + (copyMe.attributes.save_profs.includes("STR") ? si.proficiency_modifier : 0),
        CON: si.current_ability_scores.CON + (copyMe.attributes.save_profs.includes("CON") ? si.proficiency_modifier : 0),
        INT: si.current_ability_scores.INT + (copyMe.attributes.save_profs.includes("INT") ? si.proficiency_modifier : 0),
        WIS: si.current_ability_scores.WIS + (copyMe.attributes.save_profs.includes("WIS") ? si.proficiency_modifier : 0),
        CHA: si.current_ability_scores.CHA + (copyMe.attributes.save_profs.includes("CHA") ? si.proficiency_modifier : 0),
      };
      si.skill_proficiencies2 = []; 
      for (const skill_id of Object.keys(copyMe.attributes.skill_profs)) {
        const skill = SKILLS.find(o => skill_id);
        if (skill) {
          const skill_name = skill.name;
          const prof_level = copyMe.attributes.skill_profs[skill_id]
          let modifier = si.current_ability_scores.getModifier(skill.use_ability_score);
          modifier += si.proficiency_modifier * prof_level;
          si.skill_proficiencies2.push({ skill_id, skill_name, modifier, prof_level });
        }
      }
      si.tool_proficiencies = [...copyMe.attributes.tool_profs];
      if (copyMe.share_initiative) {
        si.share_initiative = true;
      } else {
        si.initiative_modifier = this.value(copyMe.initiative_modifier, { obj: char, source_id: source_true_id, item_id, base_slot_level, slot_level });
        if (copyMe.initiative_modifier.isBlank()) {
          si.initiative_modifier = si.ability_scores.DEX;
        }
      }
      si.armor_class = this.value(copyMe.armor_class, { obj: char, source_id: source_true_id, item_id, base_slot_level, slot_level });
      si.alignment = copyMe.alignment;
      
      si.favorite_conditions = [];
      // si.condition_hash = {};
      si.conditions = [];
      si.condition_immunities = [...copyMe.condition_immunities];
      si.damage_multipliers = [];
      if (copyMe.attributes.damage_immunities.length > 0) {
        const dm = new DamageMultiplier();
        dm.multiplier = 0;
        dm.the_damage_types = [...copyMe.attributes.damage_immunities];
        si.damage_multipliers.push(dm);
      }
      if (copyMe.attributes.damage_resistances.length > 0) {
        const dm = new DamageMultiplier();
        dm.multiplier = 0.5;
        dm.the_damage_types = [...copyMe.attributes.damage_resistances];
        si.damage_multipliers.push(dm);
      }
      if (copyMe.attributes.damage_vulnerabilities.length > 0) {
        const dm = new DamageMultiplier();
        dm.multiplier = 2;
        dm.the_damage_types = [...copyMe.attributes.damage_vulnerabilities];
        si.damage_multipliers.push(dm);
      }
      
      si.languages = copyMe.attributes.languages;
      si.senses = { ...copyMe.senses };
      si.current_senses = { ...copyMe.senses };
    }
    si.actions = [];
    if (copyMe.actions && copyMe.actions.length > 0) {
      // debugger;
      for (const o of copyMe.actions) {
        const cf = new SummonFeature();
        cf.copyFeature(o, null, si);
        si.actions.push(cf);
      }
    }
    si.legendary_actions = [];
    if (copyMe.legendary_actions && copyMe.legendary_actions.length > 0) {
      for (const o of copyMe.legendary_actions) {
        const cf = new CharacterFeature();
        cf.copyFeature(o, null, si);
        si.legendary_actions.push(cf);
      }
    }
    si.traits = [];
    if (copyMe.traits && copyMe.traits.length > 0) {
      for (const o of copyMe.traits) {
        const cf = new CharacterFeature();
        cf.copyFeature(o, null, si);
        si.traits.push(cf);
      }
    }
    si.is_new = false;
    si.connected = true;
  }
  
  getStringWithReplacements = (clean_me: string, 
    obj: CharacterFeatureSource | BasicCreatureInstance | SummonInstance | CharacterSheetInterface
  ) => {
    return this.getStringWithReplacementsWithObject({ clean_me, obj });
  }

  getStringWithReplacementsWithObject = ({
    clean_me, 
    backup = "", 
    obj,
    // api,
    constants,
    spellcasting_ability
  }: {
    clean_me: string, 
    backup?: string, 
    obj?: UpsertableBase | CharacterFeatureSource | BasicCreatureInstance | SummonInstance | CharacterSpell | StoredSpell | CharacterAbility | PseudoItem | SummonOption2 | CharacterSheetInterface,
    // api?: APIClass,
    constants?: any,
    spellcasting_ability?: AbilityScoreType
  }) => {
    // if (clean_me.includes("{attack_string")) {
    //   console.log(clean_me);
    // }
    const getValue = (field: any) => {
      if (obj) {
        if (field instanceof UpgradableNumber) {
          if (obj instanceof Character || obj instanceof TransformInstance || obj instanceof BasicCreatureInstance || obj instanceof SummonInstance || obj instanceof ComplexCreatureInstance) {
            return this.value(field, { obj });
          } else {
            return field.base;
          }
        } else if (typeof field === "number") {
          return field;
        }
        const value = (obj as any)[field];
        if (value !== undefined && value !== null) {
          if (value instanceof UpgradableNumber) {
            if (obj instanceof Character || obj instanceof TransformInstance || obj instanceof BasicCreatureInstance || obj instanceof SummonInstance || obj instanceof ComplexCreatureInstance) {
              return this.value(value, { obj });
            } else {
              return value.base;
            }
          }
          return value;
        }
      }
      // console.error("get_string_with_replacements_model_base error");
      // debugger;
      return "VALUE NOT FOUND!";
    }
    const getFieldValue = (field: string) => {
      const value = (obj as any)[field];
      if (value !== undefined && value !== null) {
        return value;
        // return getValue(value);
      } else {
        if (field.includes("[")) {
          let index = field.indexOf("[");
          const field_1 = field.substring(0, index);
          let field_2 = field.substring(index + 1);
          index = field_2.indexOf("]");
          field_2 = field_2.substring(0, index);
          field_2 = common_util.replaceAll(field_2, "\"", "");
          const value_1 = (obj as any)[field_1];
          if (value_1 !== undefined) {
            const value_2 = value_1[field_2];
            if (value_2 !== undefined) {
              return getValue(value_2);
            }
          }
        } else if (field.includes(".")) {
          const pieces = field.split(".");
          let value2: any = null;
          if (pieces.length === 2 && pieces[1] === "Spellcasting") {
            if (obj instanceof BasicCreatureInstance) {
              pieces[1] = obj.spellcasting_ability;
            } else if (obj instanceof CharacterFeatureSource) {
              pieces[1] = obj.spellcasting.spellcasting_ability;
            }
          }
          for (const piece of pieces) {
            if (value2 && typeof value2 === "object") {
              value2 = value2[piece];
            } else {
              value2 = (obj as any)[piece];
            }
          }
          if (value2 !== undefined && value !== null) {
            return getValue(value2);
          }
        }
        if (obj instanceof CharacterSpell || obj instanceof CharacterAbility || obj instanceof StoredSpell || obj instanceof FloatingFeature) {

        } else {
          console.error("get_string_with_replacements error");
          debugger;
        }
        return "VALUE NOT FOUND!";
      }
    }
    const clean_it = (cleaning: string) => {
      if (spellcasting_ability) {
        while (cleaning.includes("{cfs.spell_dc}")) {
          // {cfs.spell_dc} => {dc_string.Spellcasting}
          cleaning = common_util.replaceAll(cleaning, `{cfs.spell_dc}`, `{dc_string.${spellcasting_ability}}`);
        }
      }
      if (obj instanceof BasicCreatureInstance) {
        const use_name = obj.creature ? (obj.creature.small_name === "" ? obj.get_use_name() : obj.creature.small_name) : obj.get_use_name(); 
        if (cleaning.includes("{feature_source}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source}", use_name);
        }
        if (cleaning.includes("{feature_source.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source.name}", use_name);
        }
        if (cleaning.includes("{cfs}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs}", use_name);
        }
        if (cleaning.includes("{cfs.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs.name}", use_name);
        }
        if (cleaning.includes("{name}")) {
          cleaning = common_util.replaceAll(cleaning, "{name}", use_name);
        }
      } else if (obj instanceof CharacterFeatureSource || 
        obj instanceof SummonInstance) {
        if (cleaning.includes("{feature_source}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source}", obj.get_use_name());
        }
        if (cleaning.includes("{feature_source.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source.name}", obj.get_use_name());
        }
        if (cleaning.includes("{cfs}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs}", obj.get_use_name());
        }
        if (cleaning.includes("{cfs.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs.name}", obj.get_use_name());
        }
        if (cleaning.includes("{name}")) {
          cleaning = common_util.replaceAll(cleaning, "{name}", obj.get_use_name());
        }
      } else {
        if (obj instanceof Character) {
          if (cleaning.includes("{name}")) {
            cleaning = common_util.replaceAll(cleaning, "{name}", obj.name);
          }
        } else if (obj instanceof TransformInstance) {
          if (cleaning.includes("{name}") && obj.transform) {
            cleaning = common_util.replaceAll(cleaning, "{name}", obj.transform.name);
          }
        }
        while (cleaning.includes("{ugn=")) {
          // {ugn={formula_key="Bestial Strike Die",min=4}}
          // There's something besides the name that needs replacing.
          let index = cleaning.indexOf("{ugn={");
          const after = cleaning.substring(index + 6);
          index = after.indexOf("}}");
          const ugn_str = after.substring(0, index);
          // debugger;
          const ugn_obj = JSON.parse(`{${ugn_str}}`);
          const ugn = new UpgradableNumber(ugn_obj);
          let value = 0;
          if (obj instanceof Character || obj instanceof TransformInstance || obj instanceof BasicCreatureInstance || obj instanceof SummonInstance || obj instanceof ComplexCreatureInstance) {
            value = this.value(ugn, { obj });
          } else {
            value = ugn.base;
          }
          cleaning = common_util.replaceAll(cleaning, `{ugn={${ugn_str}}}`, `${value}`);
        }
      }
      if (obj) {
        while (cleaning.includes("{attack_string.")) {
          // {attack_string.STAT.z} => +{sum({cfs.proficiency_modifier},{cfs.current_ability_scores.STAT},z)} if z === 0 then leave it out
          let index = cleaning.indexOf("{attack_string.");
          const after = cleaning.substring(index + 15);
          index = after.indexOf("}");
          let value = "";
          const str = after.substring(0, index);
          const pieces = str.split(".");
          const stat = pieces[0];
          const flat = pieces[1] === undefined || pieces[1].length === 0 ? 0 : +pieces[1];
          if (ABILITY_SCORES.includes(stat) && !isNaN(flat)) {
            if (flat === 0) {
              value = `+?{sum({cfs.proficiency_modifier},{cfs.current_ability_scores.${stat}})}`;
            } else {
              value = `+?{sum({cfs.proficiency_modifier},{cfs.current_ability_scores.${stat}},${flat})}`;
            }
          }
          cleaning = common_util.replaceAll(cleaning, `{attack_string.${str}}`, `${value}`);
        }
        while (cleaning.includes("{dc_string.")) {
          // console.log(cleaning);
          // {dc_string.STAT.z} => {sum(8,{cfs.proficiency_modifier},{cfs.current_ability_scores.STAT},z)} if z === 0 then leave it out
          let index = cleaning.indexOf("{dc_string.");
          const after = cleaning.substring(index + 11);
          index = after.indexOf("}");
          let value = "";
          const str = after.substring(0, index);
          const pieces = str.split(".");
          // console.log(pieces);
          const stat = pieces[0];
          const flat = pieces[1] === undefined || pieces[1].length === 0 ? 0 : +pieces[1];
          if ((ABILITY_SCORES.includes(stat) || stat === "None") && !isNaN(flat)) {
            if (flat === 0) {
              if (stat === "None") {
                value = `{sum(8,{cfs.proficiency_modifier})}`;
              } else {
                value = `{sum(8,{cfs.proficiency_modifier},{cfs.current_ability_scores.${stat}})}`;
              }
            } else {
              if (stat === "None") {
                value = `{sum(8,{cfs.proficiency_modifier},${flat})}`;
              } else {
                value = `{sum(8,{cfs.proficiency_modifier},{cfs.current_ability_scores.${stat}},${flat})}`;
              }
            }
          }
          cleaning = common_util.replaceAll(cleaning, `{dc_string.${str}}`, `DC ${value}`);
        }
        while (cleaning.includes("{obj.")) {
          // There's something besides the name that needs replacing.
          let index = cleaning.indexOf("{obj.");
          const after = cleaning.substring(index + 5);
          index = after.indexOf("}");
          const field = after.substring(0, index);
          const value = getFieldValue(field); 
          cleaning = common_util.replaceAll(cleaning, `{obj.${field}}`, `${value}`);
        }
        while (cleaning.includes("{feature_source.")) {
          // There's something besides the name that needs replacing.
          let index = cleaning.indexOf("{feature_source.");
          const after = cleaning.substring(index + 16);
          index = after.indexOf("}");
          const field = after.substring(0, index);
          const value = getFieldValue(field); 
          cleaning = common_util.replaceAll(cleaning, `{feature_source.${field}}`, `${value}`);
        }
        while (cleaning.includes("{cfs.")) {
          // There's something besides the name that needs replacing.
          // debugger;
          let index = cleaning.indexOf("{cfs.");
          const after = cleaning.substring(index + 5);
          index = after.indexOf("}");
          const field = after.substring(0, index);
          const value = getFieldValue(field);
          cleaning = common_util.replaceAll(cleaning, `{cfs.${field}}`, `${value}`);
        }
        if (cleaning.includes("{extra")) {
          // It has to be an item (for now)
          if (obj instanceof CharacterItem || 
            obj instanceof CharacterMagicItemKeyword) {
            if (obj.extra_spell) {
              cleaning = common_util.replaceAll(cleaning, "{extra}", obj.extra_spell.name);
              cleaning = common_util.replaceAll(cleaning, "{extra.name}", obj.extra_spell.name);
              cleaning = common_util.replaceAll(cleaning, "{extra.description}", obj.extra_spell.description);
            } else {
              cleaning = common_util.replaceAll(cleaning, "{extra}", obj.extra);
            }
          } else {
            console.error("Not Implemented");
            // debugger;
          }
        }
      } 
      while (cleaning.includes("{potence_string.")) {
        // {potence_string.x.y.z} => {avg(xdy+z)} (xdy + z), if z === 0 then leave it out
        let index = cleaning.indexOf("{potence_string.");
        const after = cleaning.substring(index + 16);
        index = after.indexOf("}");
        let value = "";
        const str = after.substring(0, index);
        const pieces = str.split(".");
        const count = +pieces[0];
        const size = +pieces[1];
        let flat = pieces[2] === undefined || pieces[2].length === 0 ? 0 : +pieces[2];
        if (isNaN(flat)) {
          if (obj instanceof BasicCreatureInstance || obj instanceof Character || obj instanceof Creature) {
            switch (pieces[2]) {
              case "STR": flat = obj.current_ability_scores.STR; break;
              case "DEX": flat = obj.current_ability_scores.DEX; break;
              case "CON": flat = obj.current_ability_scores.CON; break;
              case "INT": flat = obj.current_ability_scores.INT; break;
              case "WIS": flat = obj.current_ability_scores.WIS; break;
              case "CHA": flat = obj.current_ability_scores.CHA; break;
            }
          }
        }
        let drop_curly = false;
        if (!isNaN(count) && !isNaN(size) && !isNaN(flat)) {
          if (flat === 0) {
            value = `{avg(${count}d${size})} (${count}d${size})`;
          } else if (flat < 0) {
            value = `{avg(${count}d${size}-${flat})} (${count}d${size} - ${flat})`;
          } else {
            value = `{avg(${count}d${size}+${flat})} (${count}d${size} + ${flat})`;
          }
        } else if (!isNaN(count) && !isNaN(size) && pieces[2] === "{cfs" && pieces[4]) {
          // console.log(pieces);
          // console.log(str);
          // pieces[2]-pieces[4] probably was something like {cfs.current_ability_scores.STR
          value = `${count}d${size} + ${pieces[4]}`;
          drop_curly = true;
        }
        cleaning = common_util.replaceAll(cleaning, `{potence_string.${str}${drop_curly ? "}" : ""}}`, `${value}`);
      }
      cleaning = api.getStringWithReplacementsSimple({ clean_me: cleaning, constants });
      return cleaning;
    }
    let cleaned = clean_it(clean_me); 
    if (cleaned.includes("VALUE NOT FOUND!") || cleaned === "") {
      if (clean_me === backup && cleaned !== "") {
        cleaned = clean_it("{obj.name}");
      } else if (backup !== "") {
        cleaned = clean_it(backup); 
      }
    }
    
    // console.log(cleaned);

    return api.linkifyURLs(cleaned);
  }
  
  getStringWithReplacementsAsync = async (clean_me: string, 
    obj: CharacterFeatureSource | BasicCreatureInstance | SummonInstance | CharacterSheetInterface
  ) => {
    return await this.getStringWithReplacementsWithObjectAsync({ clean_me, obj });
  }

  getStringWithReplacementsWithObjectAsync = async ({
    clean_me, 
    backup = "", 
    obj,
    // api,
    constants,
    spellcasting_ability
  }: {
    clean_me: string, 
    backup?: string, 
    obj?: UpsertableBase | CharacterFeatureSource | BasicCreatureInstance | SummonInstance | CharacterSpell | StoredSpell | CharacterAbility | PseudoItem | SummonOption2 | CharacterSheetInterface,
    // api?: APIClass,
    constants?: any,
    spellcasting_ability?: AbilityScoreType
  }) => {
    // if (clean_me.includes("{attack_string")) {
    //   console.log(clean_me);
    // }
    const getValue = (field: any) => {
      if (obj) {
        if (field instanceof UpgradableNumber) {
          if (obj instanceof Character || obj instanceof TransformInstance || obj instanceof BasicCreatureInstance || obj instanceof SummonInstance || obj instanceof ComplexCreatureInstance) {
            return this.value(field, { obj });
          } else {
            return field.base;
          }
        } else if (typeof field === "number") {
          return field;
        }
        const value = (obj as any)[field];
        if (value !== undefined && value !== null) {
          if (value instanceof UpgradableNumber) {
            if (obj instanceof Character || obj instanceof TransformInstance || obj instanceof BasicCreatureInstance || obj instanceof SummonInstance || obj instanceof ComplexCreatureInstance) {
              return this.value(value, { obj });
            } else {
              return value.base;
            }
          }
          return value;
        }
      }
      // console.error("get_string_with_replacements_model_base error");
      // debugger;
      return "VALUE NOT FOUND!";
    }
    const getFieldValue = (field: string) => {
      const value = (obj as any)[field];
      if (value !== undefined && value !== null) {
        return value;
        // return getValue(value);
      } else {
        if (field.includes("[")) {
          let index = field.indexOf("[");
          const field_1 = field.substring(0, index);
          let field_2 = field.substring(index + 1);
          index = field_2.indexOf("]");
          field_2 = field_2.substring(0, index);
          field_2 = common_util.replaceAll(field_2, "\"", "");
          const value_1 = (obj as any)[field_1];
          if (value_1 !== undefined) {
            const value_2 = value_1[field_2];
            if (value_2 !== undefined) {
              return getValue(value_2);
            }
          }
        } else if (field.includes(".")) {
          const pieces = field.split(".");
          let value2: any = null;
          if (pieces.length === 2 && pieces[1] === "Spellcasting") {
            if (obj instanceof BasicCreatureInstance) {
              pieces[1] = obj.spellcasting_ability;
            } else if (obj instanceof CharacterFeatureSource) {
              pieces[1] = obj.spellcasting.spellcasting_ability;
            }
          }
          for (const piece of pieces) {
            if (value2 && typeof value2 === "object") {
              value2 = value2[piece];
            } else {
              value2 = (obj as any)[piece];
            }
          }
          if (value2 !== undefined && value !== null) {
            return getValue(value2);
          }
        }
        console.error("get_string_with_replacements error");
        debugger;
        return "VALUE NOT FOUND!";
      }
    }
    const clean_it = async (cleaning: string) => {
      if (spellcasting_ability) {
        while (cleaning.includes("{cfs.spell_dc}")) {
          // {cfs.spell_dc} => {dc_string.Spellcasting}
          cleaning = common_util.replaceAll(cleaning, `{cfs.spell_dc}`, `{dc_string.${spellcasting_ability}}`);
        }
      }
      if (obj instanceof BasicCreatureInstance) {
        const use_name = obj.creature ? (obj.creature.small_name === "" ? obj.get_use_name() : obj.creature.small_name) : obj.get_use_name(); 
        if (cleaning.includes("{feature_source}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source}", use_name);
        }
        if (cleaning.includes("{feature_source.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source.name}", use_name);
        }
        if (cleaning.includes("{cfs}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs}", use_name);
        }
        if (cleaning.includes("{cfs.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs.name}", use_name);
        }
        if (cleaning.includes("{name}")) {
          cleaning = common_util.replaceAll(cleaning, "{name}", use_name);
        }
      } else if (obj instanceof CharacterFeatureSource || 
        obj instanceof SummonInstance) {
        if (cleaning.includes("{feature_source}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source}", obj.get_use_name());
        }
        if (cleaning.includes("{feature_source.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source.name}", obj.get_use_name());
        }
        if (cleaning.includes("{cfs}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs}", obj.get_use_name());
        }
        if (cleaning.includes("{cfs.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs.name}", obj.get_use_name());
        }
        if (cleaning.includes("{name}")) {
          cleaning = common_util.replaceAll(cleaning, "{name}", obj.get_use_name());
        }
      } else {
        if (obj instanceof Character) {
          if (cleaning.includes("{name}")) {
            cleaning = common_util.replaceAll(cleaning, "{name}", obj.name);
          }
        } else if (obj instanceof TransformInstance) {
          if (cleaning.includes("{name}") && obj.transform) {
            cleaning = common_util.replaceAll(cleaning, "{name}", obj.transform.name);
          }
        }
        while (cleaning.includes("{ugn=")) {
          // {ugn={formula_key="Bestial Strike Die",min=4}}
          // There's something besides the name that needs replacing.
          let index = cleaning.indexOf("{ugn={");
          const after = cleaning.substring(index + 6);
          index = after.indexOf("}}");
          const ugn_str = after.substring(0, index);
          // debugger;
          const ugn_obj = JSON.parse(`{${ugn_str}}`);
          const ugn = new UpgradableNumber(ugn_obj);
          let value = 0;
          if (obj instanceof Character || obj instanceof TransformInstance || obj instanceof BasicCreatureInstance || obj instanceof SummonInstance || obj instanceof ComplexCreatureInstance) {
            value = this.value(ugn, { obj });
          } else {
            value = ugn.base;
          }
          cleaning = common_util.replaceAll(cleaning, `{ugn={${ugn_str}}}`, `${value}`);
        }
      }
      if (obj) {
        while (cleaning.includes("{attack_string.")) {
          // {attack_string.STAT.z} => +{sum({cfs.proficiency_modifier},{cfs.current_ability_scores.STAT},z)} if z === 0 then leave it out
          let index = cleaning.indexOf("{attack_string.");
          const after = cleaning.substring(index + 15);
          index = after.indexOf("}");
          let value = "";
          const str = after.substring(0, index);
          const pieces = str.split(".");
          const stat = pieces[0];
          const flat = pieces[1] === undefined || pieces[1].length === 0 ? 0 : +pieces[1];
          if (ABILITY_SCORES.includes(stat) && !isNaN(flat)) {
            if (flat === 0) {
              value = `+?{sum({cfs.proficiency_modifier},{cfs.current_ability_scores.${stat}})}`;
            } else {
              value = `+?{sum({cfs.proficiency_modifier},{cfs.current_ability_scores.${stat}},${flat})}`;
            }
          }
          cleaning = common_util.replaceAll(cleaning, `{attack_string.${str}}`, `${value}`);
        }
        while (cleaning.includes("{dc_string.")) {
          // console.log(cleaning);
          // {dc_string.STAT.z} => {sum(8,{cfs.proficiency_modifier},{cfs.current_ability_scores.STAT},z)} if z === 0 then leave it out
          let index = cleaning.indexOf("{dc_string.");
          const after = cleaning.substring(index + 11);
          index = after.indexOf("}");
          let value = "";
          const str = after.substring(0, index);
          const pieces = str.split(".");
          // console.log(pieces);
          const stat = pieces[0];
          const flat = pieces[1] === undefined || pieces[1].length === 0 ? 0 : +pieces[1];
          if ((ABILITY_SCORES.includes(stat) || stat === "None") && !isNaN(flat)) {
            if (flat === 0) {
              if (stat === "None") {
                value = `{sum(8,{cfs.proficiency_modifier})}`;
              } else {
                value = `{sum(8,{cfs.proficiency_modifier},{cfs.current_ability_scores.${stat}})}`;
              }
            } else {
              if (stat === "None") {
                value = `{sum(8,{cfs.proficiency_modifier},${flat})}`;
              } else {
                value = `{sum(8,{cfs.proficiency_modifier},{cfs.current_ability_scores.${stat}},${flat})}`;
              }
            }
          }
          cleaning = common_util.replaceAll(cleaning, `{dc_string.${str}}`, `DC ${value}`);
        }
        while (cleaning.includes("{obj.")) {
          // There's something besides the name that needs replacing.
          let index = cleaning.indexOf("{obj.");
          const after = cleaning.substring(index + 5);
          index = after.indexOf("}");
          const field = after.substring(0, index);
          const value = getFieldValue(field); 
          cleaning = common_util.replaceAll(cleaning, `{obj.${field}}`, `${value}`);
        }
        while (cleaning.includes("{feature_source.")) {
          // There's something besides the name that needs replacing.
          let index = cleaning.indexOf("{feature_source.");
          const after = cleaning.substring(index + 16);
          index = after.indexOf("}");
          const field = after.substring(0, index);
          const value = getFieldValue(field); 
          cleaning = common_util.replaceAll(cleaning, `{feature_source.${field}}`, `${value}`);
        }
        while (cleaning.includes("{cfs.")) {
          // There's something besides the name that needs replacing.
          // debugger;
          let index = cleaning.indexOf("{cfs.");
          const after = cleaning.substring(index + 5);
          index = after.indexOf("}");
          const field = after.substring(0, index);
          const value = getFieldValue(field);
          cleaning = common_util.replaceAll(cleaning, `{cfs.${field}}`, `${value}`);
        }
        if (cleaning.includes("{extra")) {
          // It has to be an item (for now)
          if (obj instanceof CharacterItem || 
            obj instanceof CharacterMagicItemKeyword) {
            if (obj.extra_spell) {
              cleaning = common_util.replaceAll(cleaning, "{extra}", obj.extra_spell.name);
              cleaning = common_util.replaceAll(cleaning, "{extra.name}", obj.extra_spell.name);
              cleaning = common_util.replaceAll(cleaning, "{extra.description}", obj.extra_spell.description);
            } else {
              cleaning = common_util.replaceAll(cleaning, "{extra}", obj.extra);
            }
          } else {
            console.error("Not Implemented");
            debugger;
          }
        }
      } 
      while (cleaning.includes("{potence_string.")) {
        // {potence_string.x.y.z} => {avg(xdy+z)} (xdy + z), if z === 0 then leave it out
        let index = cleaning.indexOf("{potence_string.");
        const after = cleaning.substring(index + 16);
        index = after.indexOf("}");
        let value = "";
        const str = after.substring(0, index);
        const pieces = str.split(".");
        const count = +pieces[0];
        const size = +pieces[1];
        let flat = pieces[2] === undefined || pieces[2].length === 0 ? 0 : +pieces[2];
        if (isNaN(flat)) {
          if (obj instanceof BasicCreatureInstance || obj instanceof Character || obj instanceof Creature) {
            switch (pieces[2]) {
              case "STR": flat = obj.current_ability_scores.STR; break;
              case "DEX": flat = obj.current_ability_scores.DEX; break;
              case "CON": flat = obj.current_ability_scores.CON; break;
              case "INT": flat = obj.current_ability_scores.INT; break;
              case "WIS": flat = obj.current_ability_scores.WIS; break;
              case "CHA": flat = obj.current_ability_scores.CHA; break;
            }
          }
        }
        let drop_curly = false;
        if (!isNaN(count) && !isNaN(size) && !isNaN(flat)) {
          if (flat === 0) {
            value = `{avg(${count}d${size})} (${count}d${size})`;
          } else if (flat < 0) {
            value = `{avg(${count}d${size}-${flat})} (${count}d${size} - ${flat})`;
          } else {
            value = `{avg(${count}d${size}+${flat})} (${count}d${size} + ${flat})`;
          }
        } else if (!isNaN(count) && !isNaN(size) && pieces[2] === "{cfs" && pieces[4]) {
          // console.log(pieces);
          // console.log(str);
          // pieces[2]-pieces[4] probably was something like {cfs.current_ability_scores.STR
          value = `${count}d${size} + ${pieces[4]}`;
          drop_curly = true;
        }
        cleaning = common_util.replaceAll(cleaning, `{potence_string.${str}${drop_curly ? "}" : ""}}`, `${value}`);
      }
      cleaning = await api.getStringWithReplacementsSimpleAsync({ clean_me: cleaning, constants });
      return cleaning;
    }
    let cleaned = await clean_it(clean_me); 
    if (cleaned.includes("VALUE NOT FOUND!") || cleaned === "") {
      if (clean_me === backup && cleaned !== "") {
        cleaned = await clean_it("{obj.name}");
      } else if (backup !== "") {
        cleaned = await clean_it(backup); 
      }
    }
    
    // console.log(cleaned);

    return api.linkifyURLs(cleaned);
  }

  getStringAndCFSWithReplacementsWithObjectAsync = async ({
    clean_me, 
    backup = "", 
    obj,
    // api,
    constants,
    spellcasting_ability
  }: {
    clean_me: string, 
    backup?: string, 
    obj?: UpsertableBase | CharacterFeatureSource | BasicCreatureInstance | SummonInstance | CharacterSpell | StoredSpell | CharacterAbility | PseudoItem | SummonOption2 | CharacterSheetInterface,
    // api?: APIClass,
    constants?: any,
    spellcasting_ability?: AbilityScoreType
  }) => {
    let cfs: Creature | null = null;
    // if (clean_me.includes("{attack_string")) {
    //   console.log(clean_me);
    // }
    const getValue = (field: any) => {
      if (obj) {
        if (field instanceof UpgradableNumber) {
          if (obj instanceof Character || obj instanceof TransformInstance || obj instanceof BasicCreatureInstance || obj instanceof SummonInstance || obj instanceof ComplexCreatureInstance) {
            return this.value(field, { obj });
          } else {
            return field.base;
          }
        } else if (typeof field === "number") {
          return field;
        }
        const value = (obj as any)[field];
        if (value !== undefined && value !== null) {
          if (value instanceof UpgradableNumber) {
            if (obj instanceof Character || obj instanceof TransformInstance || obj instanceof BasicCreatureInstance || obj instanceof SummonInstance || obj instanceof ComplexCreatureInstance) {
              return this.value(value, { obj });
            } else {
              return value.base;
            }
          }
          return value;
        }
      }
      // console.error("get_string_with_replacements_model_base error");
      // debugger;
      return "VALUE NOT FOUND!";
    }
    const getFieldValue = (field: string) => {
      if (field.includes("MOD")) {
        // MOD([STR,DEX]) OR MAX_MOD([STR,DEX])
        let sub = field.substring(field.indexOf("[") + 1);
        sub = sub.substring(0, sub.indexOf("]") - 1);
        const stats = sub.split(",");
        const o = obj as any;
        const curr = o.current_ability_scores;
        if (curr instanceof AbilityScores) {
          if (field.includes("MAX_MOD")) {
            let value = -5;
            for (const stat of stats) {
              const new_value = curr.getModifier(stat);
              if (typeof new_value === "number" && !isNaN(new_value) && new_value > value) {
                value = new_value;
              }
            }
            return value;
          } else {
            let value = 0;
            for (const stat of stats) {
              const new_value = curr.getModifier(stat);
              if (typeof new_value === "number" && !isNaN(new_value) && new_value > value) {
                value += new_value;
              }
            }
            return value;
          }
        }
      } else if (field.includes("SCORE")) {
        // SCORE([STR,DEX]) OR MAX_SCORE([STR,DEX])
        let sub = field.substring(field.indexOf("[") + 1);
        sub = sub.substring(0, sub.indexOf("]") - 1);
        const stats = sub.split(",");
        const o = obj as any;
        const curr = o.current_ability_scores;
        if (curr instanceof AbilityScores) {
          if (field.includes("MAX_SCORE")) {
            let value = -5;
            for (const stat of stats) {
              const new_value = curr.getAbilityScore(stat);
              if (typeof new_value === "number" && !isNaN(new_value) && new_value > value) {
                value = new_value;
              }
            }
            return value;
          } else {
            let value = 0;
            for (const stat of stats) {
              const new_value = curr.getAbilityScore(stat);
              if (typeof new_value === "number" && !isNaN(new_value) && new_value > value) {
                value += new_value;
              }
            }
            return value;
          }
        }
      } else {
        const value = (obj as any)[field];
        if (value !== undefined && value !== null) {
          if (value instanceof UpgradableNumber) {
            if (obj instanceof Character || obj instanceof TransformInstance || obj instanceof BasicCreatureInstance || obj instanceof SummonInstance || obj instanceof ComplexCreatureInstance) {
              return this.value(value, { obj });
            } else {
              return value.base;
            }
          }
          return value;
          // return getValue(value);
        } else {
          if (field.includes("[")) {
            let index = field.indexOf("[");
            const field_1 = field.substring(0, index);
            let field_2 = field.substring(index + 1);
            index = field_2.indexOf("]");
            field_2 = field_2.substring(0, index);
            field_2 = common_util.replaceAll(field_2, "\"", "");
            const value_1 = (obj as any)[field_1];
            if (value_1 !== undefined) {
              const value_2 = value_1[field_2];
              if (value_2 !== undefined) {
                return getValue(value_2);
              }
            }
          } else if (field.includes(".")) {
            const pieces = field.split(".");
            let value2: any = null;
            if (pieces.length === 2 && pieces[1] === "Spellcasting") {
              if (obj instanceof BasicCreatureInstance) {
                pieces[1] = obj.spellcasting_ability;
              } else if (obj instanceof CharacterFeatureSource) {
                pieces[1] = obj.spellcasting.spellcasting_ability;
              }
            }
            for (const piece of pieces) {
              if (value2 && typeof value2 === "object") {
                value2 = value2[piece];
              } else {
                value2 = (obj as any)[piece];
              }
            }
            if (value2 !== undefined && value !== null) {
              return getValue(value2);
            }
          }
          console.error("get_string_with_replacements error");
          debugger;
          return "VALUE NOT FOUND!";
        }
      }
    }
    const clean_it = async (cleaning: string) => {
      if (spellcasting_ability) {
        while (cleaning.includes("{cfs.spell_dc}")) {
          // {cfs.spell_dc} => {dc_string.Spellcasting}
          cleaning = common_util.replaceAll(cleaning, `{cfs.spell_dc}`, `{dc_string.${spellcasting_ability}}`);
        }
      }
      if (obj instanceof CharacterFeatureSource || 
        obj instanceof SummonInstance) {
        if (cleaning.includes("{feature_source}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source}", obj.get_use_name());
        }
        if (cleaning.includes("{feature_source.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source.name}", obj.get_use_name());
        }
        if (cleaning.includes("{cfs}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs}", obj.get_use_name());
        }
        if (cleaning.includes("{cfs.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs.name}", obj.get_use_name());
        }
        if (cleaning.includes("{name}")) {
          cleaning = common_util.replaceAll(cleaning, "{name}", obj.get_use_name());
        }
      } else if (obj instanceof BasicCreatureInstance) {
        const use_name = obj.creature ? (obj.creature.small_name === "" ? obj.get_use_name() : obj.creature.small_name) : obj.get_use_name(); 
        if (cleaning.includes("{feature_source}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source}", use_name);
        }
        if (cleaning.includes("{feature_source.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source.name}", use_name);
        }
        if (cleaning.includes("{cfs}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs}", use_name);
        }
        if (cleaning.includes("{cfs.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs.name}", use_name);
        }
        if (cleaning.includes("{name}")) {
          cleaning = common_util.replaceAll(cleaning, "{name}", use_name);
        }
      } else if (obj instanceof Creature) {
        const use_name = obj.small_name === "" ? obj.get_use_name() : obj.small_name; 
        if (cleaning.includes("{feature_source}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source}", use_name);
        }
        if (cleaning.includes("{feature_source.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source.name}", use_name);
        }
        if (cleaning.includes("{cfs}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs}", use_name);
        }
        if (cleaning.includes("{cfs.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs.name}", use_name);
        }
        if (cleaning.includes("{name}")) {
          cleaning = common_util.replaceAll(cleaning, "{name}", use_name);
        }
      } else if (obj instanceof FeatureSource) {
        const use_name = obj.get_use_name(); 
        if (cleaning.includes("{feature_source}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source}", use_name);
        }
        if (cleaning.includes("{feature_source.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{feature_source.name}", use_name);
        }
        if (cleaning.includes("{cfs}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs}", use_name);
        }
        if (cleaning.includes("{cfs.name}")) {
          cleaning = common_util.replaceAll(cleaning, "{cfs.name}", use_name);
        }
        if (cleaning.includes("{name}")) {
          cleaning = common_util.replaceAll(cleaning, "{name}", use_name);
        }
      } else {
        if (obj instanceof TransformInstance) {
          if (cleaning.includes("{name}") && obj.transform) {
            cleaning = common_util.replaceAll(cleaning, "{name}", obj.transform.name);
          }
        } else if (obj) {
          if (cleaning.includes("{name}")) {
            cleaning = common_util.replaceAll(cleaning, "{name}", obj.name);
          }
        } 
        while (cleaning.includes("{ugn=")) {
          // {ugn={formula_key="Bestial Strike Die",min=4}}
          // There's something besides the name that needs replacing.
          let index = cleaning.indexOf("{ugn={");
          const after = cleaning.substring(index + 6);
          index = after.indexOf("}}");
          const ugn_str = after.substring(0, index);
          // debugger;
          const ugn_obj = JSON.parse(`{${ugn_str}}`);
          const ugn = new UpgradableNumber(ugn_obj);
          let value = 0;
          if (obj instanceof Character || obj instanceof TransformInstance || obj instanceof BasicCreatureInstance || obj instanceof SummonInstance || obj instanceof ComplexCreatureInstance) {
            value = this.value(ugn, { obj });
          } else {
            value = ugn.base;
          }
          cleaning = common_util.replaceAll(cleaning, `{ugn={${ugn_str}}}`, `${value}`);
        }
      }
      if (obj) {
        while (cleaning.includes("{attack_string.")) {
          // {attack_string.STAT.z} => +{sum({cfs.proficiency_modifier},{cfs.current_ability_scores.STAT},z)} if z === 0 then leave it out
          let index = cleaning.indexOf("{attack_string.");
          const after = cleaning.substring(index + 15);
          index = after.indexOf("}");
          let value = "";
          const str = after.substring(0, index);
          const pieces = str.split(".");
          const stat = pieces[0];
          const flat = pieces[1] === undefined || pieces[1].length === 0 ? 0 : +pieces[1];
          if (ABILITY_SCORES.includes(stat) && !isNaN(flat)) {
            if (flat === 0) {
              value = `+?{sum({cfs.proficiency_modifier},{cfs.current_ability_scores.${stat}})}`;
            } else {
              value = `+?{sum({cfs.proficiency_modifier},{cfs.current_ability_scores.${stat}},${flat})}`;
            }
          }
          cleaning = common_util.replaceAll(cleaning, `{attack_string.${str}}`, `${value}`);
        }
        while (cleaning.includes("{dc_string.")) {
          // console.log(cleaning);
          // {dc_string.STAT.z} => {sum(8,{cfs.proficiency_modifier},{cfs.current_ability_scores.STAT},z)} if z === 0 then leave it out
          let index = cleaning.indexOf("{dc_string.");
          const after = cleaning.substring(index + 11);
          index = after.indexOf("}");
          let value = "";
          const str = after.substring(0, index);
          const pieces = str.split(".");
          // console.log(pieces);
          const stat = pieces[0];
          const flat = pieces[1] === undefined || pieces[1].length === 0 ? 0 : +pieces[1];
          if ((ABILITY_SCORES.includes(stat) || stat === "None") && !isNaN(flat)) {
            if (flat === 0) {
              if (stat === "None") {
                value = `{sum(8,{cfs.proficiency_modifier})}`;
              } else {
                value = `{sum(8,{cfs.proficiency_modifier},{cfs.current_ability_scores.${stat}})}`;
              }
            } else {
              if (stat === "None") {
                value = `{sum(8,{cfs.proficiency_modifier},${flat})}`;
              } else {
                value = `{sum(8,{cfs.proficiency_modifier},{cfs.current_ability_scores.${stat}},${flat})}`;
              }
            }
          }
          cleaning = common_util.replaceAll(cleaning, `{dc_string.${str}}`, `DC ${value}`);
        }
        while (cleaning.includes("{obj.")) {
          // There's something besides the name that needs replacing.
          let index = cleaning.indexOf("{obj.");
          const after = cleaning.substring(index + 5);
          index = after.indexOf("}");
          const field = after.substring(0, index);
          const value = getFieldValue(field); 
          cleaning = common_util.replaceAll(cleaning, `{obj.${field}}`, `${value}`);
        }
        while (cleaning.includes("{feature_source.")) {
          // There's something besides the name that needs replacing.
          let index = cleaning.indexOf("{feature_source.");
          const after = cleaning.substring(index + 16);
          index = after.indexOf("}");
          const field = after.substring(0, index);
          const value = getFieldValue(field); 
          cleaning = common_util.replaceAll(cleaning, `{feature_source.${field}}`, `${value}`);
        }
        while (cleaning.includes("{cfs.")) {
          // There's something besides the name that needs replacing.
          // debugger;
          let index = cleaning.indexOf("{cfs.");
          const after = cleaning.substring(index + 5);
          index = after.indexOf("}");
          const field = after.substring(0, index);
          const value = getFieldValue(field);
          cleaning = common_util.replaceAll(cleaning, `{cfs.${field}}`, `${value}`);
        }
        if (cleaning.includes("{extra")) {
          // It has to be an item (for now)
          if (obj instanceof CharacterItem || 
            obj instanceof CharacterMagicItemKeyword) {
            if (obj.extra_spell) {
              cleaning = common_util.replaceAll(cleaning, "{extra}", obj.extra_spell.name);
              cleaning = common_util.replaceAll(cleaning, "{extra.name}", obj.extra_spell.name);
              cleaning = common_util.replaceAll(cleaning, "{extra.description}", obj.extra_spell.description);
            } else {
              cleaning = common_util.replaceAll(cleaning, "{extra}", obj.extra);
            }
          } else {
            console.error("Not Implemented");
            debugger;
          }
        }
      } 
      while (cleaning.includes("{potence_string.")) {
        // {potence_string.x.y.z} => {avg(xdy+z)} (xdy + z), if z === 0 then leave it out
        let index = cleaning.indexOf("{potence_string.");
        const after = cleaning.substring(index + 16);
        index = after.indexOf("}");
        let value = "";
        const str = after.substring(0, index);
        const pieces = str.split(".");
        const count = +pieces[0];
        const size = +pieces[1];
        let flat = pieces[2] === undefined || pieces[2].length === 0 ? 0 : +pieces[2];
        if (isNaN(flat)) {
          if (obj instanceof BasicCreatureInstance || obj instanceof Character || obj instanceof Creature) {
            switch (pieces[2]) {
              case "STR": flat = obj.current_ability_scores.STR; break;
              case "DEX": flat = obj.current_ability_scores.DEX; break;
              case "CON": flat = obj.current_ability_scores.CON; break;
              case "INT": flat = obj.current_ability_scores.INT; break;
              case "WIS": flat = obj.current_ability_scores.WIS; break;
              case "CHA": flat = obj.current_ability_scores.CHA; break;
            }
          }
        }
        let drop_curly = false;
        if (!isNaN(count) && !isNaN(size) && !isNaN(flat)) {
          if (flat === 0) {
            value = `{avg(${count}d${size})} (${count}d${size})`;
          } else if (flat < 0) {
            value = `{avg(${count}d${size}-${flat})} (${count}d${size} - ${flat})`;
          } else {
            value = `{avg(${count}d${size}+${flat})} (${count}d${size} + ${flat})`;
          }
        } else if (!isNaN(count) && !isNaN(size) && pieces[2] === "{cfs" && pieces[4]) {
          // console.log(pieces);
          // console.log(str);
          // pieces[2]-pieces[4] probably was something like {cfs.current_ability_scores.STR
          value = `${count}d${size} + ${pieces[4]}`;
          drop_curly = true;
        }
        cleaning = common_util.replaceAll(cleaning, `{potence_string.${str}${drop_curly ? "}" : ""}}`, `${value}`);
      }
      const res = await api.getStringAndCFSWithReplacementsSimpleAsync({ clean_me: cleaning, constants }); 
      cleaning = res.cleaned;
      if (res.cfs) {
        cfs = res.cfs;
      }
      return cleaning;
    }
    let cleaned = await clean_it(clean_me); 
    if (cleaned.includes("VALUE NOT FOUND!") || cleaned === "") {
      if (clean_me === backup && cleaned !== "") {
        cleaned = await clean_it("{obj.name}");
      } else if (backup !== "") {
        cleaned = await clean_it(backup); 
      }
    }
    
    cleaned = api.linkifyURLs(cleaned);
    
    // console.log(cleaned);

    return { cleaned, cfs };
  }

  getDisplayStringsAsync = async (use_string: string, cfs?: CharacterSheetInterface | BasicCreatureInstance | SummonInstance | CharacterFeatureSource | Creature | FeatureSource) => {
    const responses: string[] = [];
    // let key = 0;
    // debugger;
    while (use_string.includes("[Replacer:")) {
      let index = use_string.indexOf("[Replacer:");
      const before = use_string.substring(0, index);
      if (before.length > 0) {
        responses.push(...(await this.getDisplayStringsAsync(before))); // put the before stuff into responses 
        // responses.push("&nbsp;");
      }
      const after = use_string.substring(index + 10);
      index = after.indexOf("]");
      use_string = after.substring(index + 1); // trim use_string down to just the things after this for next go round
      const stuff = after.substring(0, index);
      index = stuff.indexOf(";");
      const data_type = stuff.substring(0, index);
      index = stuff.indexOf("(");
      const name_stuff = stuff.substring(index + 1);
      index = name_stuff.indexOf(")");
      const address_str = name_stuff.substring(0, index);
      const address = address_str.split(",");
      try {
        if (api.smart_hash[data_type]) {
          const obj2 = api.smart_hash[data_type].find(o => address.includes(o._id));
          if (obj2 instanceof ReusableString) {
            responses.push(`${obj2.label} ${await this.getDisplayStringsAsync(obj2.content)}`);
          } else if (obj2 instanceof ModelBase) {
            responses.push(`${obj2.use_name} ${ await this.getDisplayStringsAsync(obj2.description) } `);
          }
        }
      } catch (ex) {}
    }
    if (use_string.length > 0) {
      responses.push(await this.getStringWithReplacementsWithObjectAsync({ clean_me: use_string, obj: cfs })); // add anything left over
    }
    return responses.map(o => api.linkifyURLs(o));
  }

  /**
   * This does the same as the one above except that it's designed to work with a single replacer.
   * Some replacers are designed to work together and will have other replacers inside them, 
   * or the replacement they make has another replacer. 
   * Those ones are generally not a big deal though. 
   * That's like ones for getting an attack roll, etc, not a {creature_stat_block}, {deity_table}, or [Replacer].
   * 
   * So for this one with the big replacers we can assume that it starts at use_string[0].
   * Most little replacers will also be there, but we don't need to worry about them.
   * 
   * Because the big replacers will definitely not be nested inside something else if it's coming here,
   * we can do things that we otherwise couldn't. 
   * In particular for things like {creature_stat_block} and {deity_table}, 
   * we can use it to get it and use it as the cfs.
   */
  getDisplayStringAsync = async (use_string: string, cfs?: CharacterSheetInterface | BasicCreatureInstance | SummonInstance | CharacterFeatureSource | Creature | FeatureSource) => {
    let response = "";
    // let key = 0;
    // debugger;
    if (use_string.startsWith("[Replacer:")) {
      let index = use_string.indexOf("[Replacer:");
      const after = use_string.substring(index + 10);
      index = after.indexOf("]");
      use_string = after.substring(index + 1); // trim use_string down to just the things after this for next go round
      const stuff = after.substring(0, index);
      index = stuff.indexOf(";");
      const data_type = stuff.substring(0, index);
      index = stuff.indexOf("(");
      const name_stuff = stuff.substring(index + 1);
      index = name_stuff.indexOf(")");
      const address_str = name_stuff.substring(0, index);
      const address = address_str.split(",");
      try {
        if (api.smart_hash[data_type]) {
          const obj2 = api.smart_hash[data_type].find(o => address.includes(o._id));
          if (obj2 instanceof ReusableString) {
            response = `${obj2.label} ${await this.getDisplayStringsAsync(obj2.content)}`;
          } else if (obj2 instanceof ModelBase) {
            response = `${obj2.use_name} ${ await this.getDisplayStringsAsync(obj2.description) } `;
          }
        }
      } catch (ex) {}
    } else if (use_string.length > 0) {
      const res = await this.getStringAndCFSWithReplacementsWithObjectAsync({ clean_me: use_string, obj: cfs }); // add anything left over
      response = res.cleaned;
      if (res.cfs) {
        cfs = res.cfs;
      }
    }
    response = api.linkifyURLs(common_util.cleanLineBreaks(response));
    return { response, cfs };
  }

  getDisplayStrings = (use_string: string, cfs?: CharacterSheetInterface | BasicCreatureInstance | SummonInstance | CharacterFeatureSource) => {
    const responses: string[] = [];
    // let key = 0;
    // debugger;
    while (use_string.includes("[Replacer:")) {
      let index = use_string.indexOf("[Replacer:");
      const before = use_string.substring(0, index);
      if (before.length > 0) {
        responses.push(...(this.getDisplayStrings(before))); // put the before stuff into responses 
        // responses.push("&nbsp;");
      }
      const after = use_string.substring(index + 10);
      index = after.indexOf("]");
      use_string = after.substring(index + 1); // trim use_string down to just the things after this for next go round
      const stuff = after.substring(0, index);
      index = stuff.indexOf(";");
      const data_type = stuff.substring(0, index);
      index = stuff.indexOf("(");
      const name_stuff = stuff.substring(index + 1);
      index = name_stuff.indexOf(")");
      const address_str = name_stuff.substring(0, index);
      const address = address_str.split(",");
      try {
        if (api.smart_hash[data_type]) {
          const obj2 = api.smart_hash[data_type].find(o => address.includes(o._id));
          if (obj2 instanceof ReusableString) {
            responses.push(`${obj2.label} ${this.getDisplayStrings(obj2.content)}`);
          } else if (obj2 instanceof ModelBase) {
            responses.push(`${obj2.use_name} ${ this.getDisplayStrings(obj2.description) } `);
          }
        }
      } catch (ex) {}
    }
    if (use_string.length > 0) {
      responses.push(this.getStringWithReplacementsWithObject({ clean_me: use_string, obj: cfs })); // add anything left over
    }
    return responses.map(o => api.linkifyURLs(o));
  }

  getDisplayObjects = (use_string: string) => {
    const responses: string[] = [];
    while (use_string.includes("[Replacer:")) {
      let index = use_string.indexOf("[Replacer:");
      const before = use_string.substring(0, index);
      if (before.length > 0) {
        responses.push(`<div>${ this.getDisplayObjects(before) }</div><div>&nbsp;</div>`);
      }
      const after = use_string.substring(index + 10);
      index = after.indexOf("]");
      use_string = after.substring(index + 1); // trim use_string down to just the things after this for next go round
      const stuff = after.substring(0, index);
      index = stuff.indexOf(";");
      const data_type = stuff.substring(0, index);
      index = stuff.indexOf("(");
      const name_stuff = stuff.substring(index + 1);
      index = name_stuff.indexOf(")");
      const address_str = name_stuff.substring(0, index);
      const address = address_str.split(",");
      try {
        if (api.smart_hash[data_type]) {
          const obj2 = api.smart_hash[data_type].find(o => address.includes(o._id));
          if (obj2 instanceof ReusableString) {
            responses.push(
              `<div>
                <div className="header">{obj2.label}</div><div>&nbsp;</div>
                <div>${ this.getDisplayObjects(obj2.content) }</div><div>&nbsp;</div>
              </div>`
            );
          } else if (obj2 instanceof ModelBase) {
            responses.push(
              `<div>
                <div className="header">{obj2.use_name}</div><div>&nbsp;</div>
                <div>${ this.getDisplayObjects(obj2.description) }</div><div>&nbsp;</div>
              </div>`
            );
          }
        }
      } catch (ex) {}
    }
    if (use_string.length > 0) {
      responses.push(common_util.cleanLineBreaks(this.getStringWithReplacementsWithObject({ clean_me: use_string }))); // add anything left over
    }
    return responses.join();
  }

  getUseName(obj: ModelBase | CharacterFeatureSource | CharacterSpell | SummonOption2 | PseudoItem | null): string {
    if (obj instanceof ModelBase) {
      if (data_util.variant_of_name(obj) === "") {
        return obj.name;
      } else {
        return data_util.variant_of_name(obj);
      }
    } else if (obj) {
      if (obj instanceof CharacterSpell) {
        return this.getUseName(obj.spell);
      } else if (obj instanceof CharacterClass) {
        if (obj.source) {
          const name_bonuses = obj.name_bonuses.length > 0 ? obj.name_bonuses.join(" ") + " " : "";
          if (obj.char_subclass && obj.char_subclass.source) {
            const subclass_name = this.getUseName(obj.char_subclass.source);
            const class_name = this.getUseName(obj.source);
            if (name_bonuses.includes(subclass_name)) {
              return `${name_bonuses}${class_name}`;
            } else {
              return `${name_bonuses}${subclass_name} ${class_name}`;
            }
          } else {
            return `${name_bonuses}${this.getUseName(obj.source)}`;
          }
        } else {
          return obj.get_use_name();
        }
      } else if (obj instanceof CharacterRace) {
        if (obj.source) {
          const name_bonuses = obj.name_bonuses.length > 0 ? obj.name_bonuses.join(" ") + " " : "";
          if (obj.char_subrace && obj.char_subrace.source) {
            return `${name_bonuses}${this.getUseName(obj.char_subrace.source)} ${this.getUseName(obj.source)}`;
          } else {
            return `${name_bonuses}${this.getUseName(obj.source)}`;
          }
        } else {
          return obj.get_use_name();
        }
      } else if (obj instanceof PseudoItem) {
        return obj.name;
      } else if (obj instanceof SummonOption2) {
        return `${obj.name}${ this.renderChallengeRating(obj.challenge_rating) }${ obj.count > 1 ? " x " + obj.count : "" }`;
      } else if (obj instanceof CharacterFeatureSource) {
        if (obj.source instanceof ModelBase) {
          return this.getUseName(obj.source);
        }
      } 
    }
    return "";
  }

  renderChallengeRating(challenge_rating: number) {
    if (challenge_rating > 0) {
      if (challenge_rating >= 1) {
        return ` (CR: ${challenge_rating})`;
      } else if (challenge_rating === 0.125) {
        return ` (CR: 1/8)`;
      } else if (challenge_rating === 0.25) {
        return ` (CR: 1/4)`;
      } else if (challenge_rating === 0.5) {
        return ` (CR: 1/2)`;
      }
    }
    return "";
  }
  
  get_optional_features = async (fs: FeatureSource | StandardFeatures | CharacterFeatureSource | null, log_it = false) => {
    if (log_it) {
      console.log(fs);
    }
    if (fs instanceof FeatureSource) {
      const ofbs = await data_util.optional_feature_bases();
      if (log_it) {
        console.log(ofbs);
        console.log(ofbs.map(o => o.name));
        console.log(ofbs.filter(o => o.name.includes(log_find_string)));
        console.log(ofbs.filter(o => o.feature_source_id === fs._id));
      }
      return ofbs.filter(o => o.feature_source_id === fs._id);
    } else if (fs instanceof CharacterFeatureSource) {
      const ofbs: OptionalFeatureBase[] = await this.get_optional_features(fs.source, log_it);
      if (log_it) {
        console.log(ofbs);
      }
      for (const sub_cfs of fs.sub_char_feature_sources) {
        const new_ofbs = await this.get_optional_features(sub_cfs.source, log_it); //  || sub_cfs.source instanceof Feat
        if (log_it) {
          console.log(ofbs);
        }
        ofbs.push(...new_ofbs);
      }
      return ofbs;
    } else {
      return [] as OptionalFeatureBase[];
    }
  }

  getColors({
    char, 
    user, 
    for_id,
    source
  }: {
    char?: Character | BasicCreatureInstance, 
    user: User | null, 
    for_id: string,
    source?: DandDFeatureSource
  }) {
    let backgroundColor = "";
    let color: undefined | string = PALETTE.secondary.light;
    if (PALETTE.secondary) {
      if (for_id === "Attacks") {
        backgroundColor = PALETTE.attack.main;
        color = PALETTE.attack.light;
      } else {
        backgroundColor = PALETTE.secondary.main;
        color = PALETTE.secondary.light;
      }
      const use_for_id = for_id;

      const cfs = char instanceof Character ? char.char_feature_sources.find(o => o.source_id === use_for_id) : undefined;
      if (cfs && char instanceof Character) {
        // if (char.colors_for[use_for_id]) {
        //   const colors = char.colors_for[use_for_id];
        //   if (colors.backgroundColor !== "") {
        //     backgroundColor = colors.backgroundColor + "80";
        //   }
        //   if (colors.color && colors.color !== "") {
        //     color = colors.color;
        //   }
        // }
        if (user && user.colors_for[use_for_id]) {
          const colors = user.colors_for[use_for_id];
          if (backgroundColor === PALETTE.secondary.main && colors.backgroundColor !== "") {
            backgroundColor = colors.backgroundColor + "80";
          }
          if (colors.color && color === PALETTE.secondary.light && colors.color !== "") {
            color = colors.color;
          }
        }
        if (cfs.source instanceof DandDFeatureSource) {
          const colors = cfs.source.colors;
          if (backgroundColor === PALETTE.secondary.main) {
            if (colors.backgroundColor !== "") {
              backgroundColor = colors.backgroundColor + "80";
            } else {
              if (cfs instanceof CharacterBackground && PALETTE.game_background) {
                backgroundColor = PALETTE.game_background.main;
              } else {
                const p_as_any = (PALETTE as any);
                if (p_as_any[cfs.source.data_type]) {
                  backgroundColor = p_as_any[cfs.source.data_type].main;
                }
              }
            }
          }
          if (color === PALETTE.secondary.light) {
            if (colors.color && colors.color !== "" && colors.color !== "Default") {
              color = colors.color;
            } else {
              if (cfs instanceof CharacterBackground && PALETTE.game_background) {
                color = PALETTE.game_background.light;
              } else {
                const p_as_any = (PALETTE as any);
                if (p_as_any[cfs.source.data_type]) {
                  color = p_as_any[cfs.source.data_type].light;
                }
              }
            }
          }
        }
      } else if (source) {
        const colors = source.colors;
        if (backgroundColor === PALETTE.secondary.main) {
          if (colors.backgroundColor !== "") {
            backgroundColor = colors.backgroundColor + "80";
          } else {
            if (source instanceof Background && PALETTE.game_background) {
              backgroundColor = PALETTE.game_background.main;
            } else {
              const p_as_any = (PALETTE as any);
              if (p_as_any[source.data_type]) {
                backgroundColor = p_as_any[source.data_type].main;
              }
            }
          }
        }
        if (color === PALETTE.secondary.light) {
          if (colors.color && colors.color !== "" && colors.color !== "Default") {
            color = colors.color;
          } else {
            if (source instanceof Background && PALETTE.game_background) {
              color = PALETTE.game_background.light;
            } else {
              const p_as_any = (PALETTE as any);
              if (p_as_any[source.data_type]) {
                color = p_as_any[source.data_type].light;
              }
            }
          }
        }
      } else {
        // It's Default or Attacks
        // if (char instanceof Character && char.colors_for[use_for_id]) {
        //   const colors = char.colors_for[use_for_id];
        //   if (colors.backgroundColor !== "") {
        //     backgroundColor = colors.backgroundColor + "80";
        //   }
        //   if (colors.color && colors.color !== "") {
        //     color = colors.color;
        //   }
        // }
        if (user && user.colors_for[use_for_id]) {
          const colors = user.colors_for[use_for_id];
          if (backgroundColor === PALETTE.secondary.main && colors.backgroundColor !== "") {
            backgroundColor = colors.backgroundColor + "80";
          }
          if (colors.color && color === PALETTE.secondary.light && colors.color !== "") {
            color = colors.color;
          }
        }
      }
    }
    return {
      backgroundColor,
      color
    }
  }

  getCFSForCF(char: Character, dingus: CharacterFeature | CharacterFeatureBase | CharacterAbility | CharacterAction) {
    let cf: CharacterFeature | CharacterFeatureBase | CharacterAbility | undefined = undefined;
    if (dingus instanceof CharacterAction) {
      if (dingus.action instanceof CharacterAbility) {
        cf = dingus.action;
      } else if (dingus.action instanceof CharacterSpell) {
        const source_true_id = dingus.action.source_true_id;
        if (dingus.action.cf_id !== "") {
          const cf_id = dingus.action.cf_id;
          cf = char.mind.spellcasting_features.find(o => o.true_id === cf_id);
        }
        if (!cf) {
          return char.char_feature_sources.find(o => o.true_id === source_true_id);
        }
      }
    } else {
      cf = dingus;
    }
    if (cf) {
      const use_cf = cf;
      let cfs2s = char.mind.char_feature_sources.filter(o => 
        use_cf.ancestries.some(o2 => o2.true_id === o.true_id)
        // && !(o instanceof CharacterSpecialFeature)
      );
      let attempts = 0;
      while (cfs2s.length > 1 && attempts < 5) {
        const sub_ids = cfs2s.flatMap(o => o.sub_char_feature_sources.map(o => o.true_id));
        cfs2s = cfs2s.filter(o => sub_ids.includes(o.true_id));
        attempts++;
      }
      return cfs2s[0];
    }
    return undefined;
  }

  getCFSSForCF(char: Character, dingus: CharacterFeature | CharacterFeatureBase | CharacterAbility | CharacterAction) {
    let cf: CharacterFeature | CharacterFeatureBase | CharacterAbility | undefined = undefined;
    if (dingus instanceof CharacterAction) {
      if (dingus.action instanceof CharacterAbility) {
        cf = dingus.action;
      } else if (dingus.action instanceof CharacterSpell) {
        const source_true_id = dingus.action.source_true_id;
        if (dingus.action.cf_id !== "") {
          const cf_id = dingus.action.cf_id;
          cf = char.mind.spellcasting_features.find(o => o.true_id === cf_id);
        }
        if (!cf) {
          return char.char_feature_sources.filter(o => o.true_id === source_true_id);
        }
      }
    } else {
      cf = dingus;
    }
    if (cf) {
      const use_cf = cf;
      return char.char_feature_sources.filter(o => 
        use_cf.ancestries.filter(o2 => o2.true_id === o.true_id).length > 0 &&
        !(o instanceof CharacterSpecialFeature)
      );
    }
    return [];
  }
}
